import './index.css';
import { g as de, r as ks, c as gr, d as Ss, e as pr, f as _s, h as As, i as jt, j as Ts, s as Cs, k as Fr, l as Ps, m as Is, n as Os, o as mr, p as Ms, q as Ds, a as $s, t as va, u as ya, v as js, b as Xt } from "./getPropertyByString-d03c07a0.mjs";
import { h as n, defineComponent as D, ref as y, computed as C, onMounted as X, watch as G, Teleport as Ee, Transition as _e, toRefs as $e, capitalize as Fe, nextTick as ne, getCurrentInstance as xa, useAttrs as Es, resolveDirective as lt, withDirectives as Ke, openBlock as wa, createElementBlock as Bs, mergeProps as Ls, unref as Ge, defineAsyncComponent as br, onBeforeMount as vr, onBeforeUnmount as qe, inject as ee, watchEffect as ve, cloneVNode as Rs, Fragment as Be, provide as se, onUnmounted as xe, reactive as ka, toRaw as Q, shallowRef as Ns, resolveComponent as Vs, createBlock as Fs, createVNode as R, TransitionGroup as Gs, createApp as zs } from "vue";
import { R as it, a as V, c as Gr } from "./CalendarDates-0a4b71d3.mjs";
import { RouterLink as me, useRoute as Hs } from "vue-router";
const Ue = (e, t) => n(
  "svg",
  {
    class: ["h-5", "w-5", e],
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  },
  t
), We = (e) => n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: e
}), Lo = D({
  name: "AtAlert",
  emits: ["close"],
  props: {
    title: { type: String, default: "" },
    type: {
      type: String,
      default: "gray",
      validator: (e) => e in {
        gray: !0,
        success: !0,
        info: !0,
        warning: !0,
        danger: !0
      }
    },
    dismissible: { type: Boolean, default: !1 }
  },
  setup(e) {
    let t = y(!1), r = C(() => {
      switch (e.type) {
        case "success":
          return Ue("text-green-400", [
            We(
              "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            )
          ]);
        case "info":
          return Ue("text-blue-400", [
            We(
              "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
            )
          ]);
        case "warning":
          return Ue("text-yellow-400", [
            We(
              "M12.395 2.553a1 1 0 00-1.45-.385c-.345.23-.614.558-.822.88-.214.33-.403.713-.57 1.116-.334.804-.614 1.768-.84 2.734a31.365 31.365 0 00-.613 3.58 2.64 2.64 0 01-.945-1.067c-.328-.68-.398-1.534-.398-2.654A1 1 0 005.05 6.05 6.981 6.981 0 003 11a7 7 0 1011.95-4.95c-.592-.591-.98-.985-1.348-1.467-.363-.476-.724-1.063-1.207-2.03zM12.12 15.12A3 3 0 017 13s.879.5 2.5.5c0-1 .5-4 1.25-4.5.5 1 .786 1.293 1.371 1.879A2.99 2.99 0 0113 13a2.99 2.99 0 01-.879 2.121z"
            )
          ]);
        case "danger":
          return Ue("text-red-400", [
            We(
              "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
            )
          ]);
        default:
          return Ue("text-gray-400", [
            We(
              "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
            )
          ]);
      }
    }), a = C(() => {
      switch (e.type) {
        case "success":
          return {
            title: "text-green-800 dark:text-green-300",
            inner: "text-green-700 dark:text-green-400",
            bg: "bg-green-50 dark:bg-green-500 dark:bg-opacity-20",
            button: "text-green-500 hover:bg-green-100 focus:bg-green-100 dark:text-white dark:hover:bg-green-400 dark:focus:bg-green-400 dark:hover:bg-opacity-20 dark:focus:bg-opacity-20"
          };
        case "info":
          return {
            title: "text-blue-800 dark:text-blue-300",
            inner: "text-blue-700 dark:text-blue-400",
            bg: "bg-blue-50 dark:bg-blue-500 dark:bg-opacity-20",
            button: "text-blue-500 hover:bg-blue-100 focus:bg-blue-100 dark:text-white dark:hover:bg-blue-400 dark:focus:bg-blue-400 dark:hover:bg-opacity-20 dark:focus:bg-opacity-20"
          };
        case "warning":
          return {
            title: "text-yellow-800 dark:text-yellow-300",
            inner: "text-yellow-700 dark:text-yellow-400",
            bg: "bg-yellow-50 dark:bg-yellow-500 dark:bg-opacity-20",
            button: "text-yellow-500 hover:bg-yellow-100 focus:bg-yellow-100 dark:text-white dark:hover:bg-yellow-400 dark:focus:bg-yellow-400 dark:hover:bg-opacity-20 dark:focus:bg-opacity-20"
          };
        case "danger":
          return {
            title: "text-red-800 dark:text-red-300",
            inner: "text-red-700 dark:text-red-400",
            bg: "bg-red-50 dark:bg-red-500 dark:bg-opacity-20",
            button: "text-red-500 hover:bg-red-100 focus:bg-red-100 dark:text-white dark:hover:bg-red-400 dark:focus:bg-red-400 dark:hover:bg-opacity-20 dark:focus:bg-opacity-20"
          };
        default:
          return {
            title: "text-gray-800 dark:text-white",
            inner: "text-gray-700 dark:text-gray-300",
            bg: "bg-gray-50 dark:bg-gray-100 dark:bg-opacity-10",
            button: "text-gray-500 hover:bg-gray-100 focus:bg-gray-100 dark:text-white dark:hover:bg-gray-400 dark:focus:bg-gray-400 dark:hover:bg-opacity-20 dark:focus:bg-opacity-20"
          };
      }
    }), s = C(() => e.title ? n("h3", {
      class: ["text-sm leading-5 font-medium", a.value.title],
      innerHTML: e.title
    }) : null);
    return {
      closed: t,
      colorClass: a,
      iconElement: r,
      titleElement: s
    };
  },
  render() {
    return this.closed ? null : n(
      "div",
      {
        class: ["rounded-md p-4", this.colorClass.bg]
      },
      [
        n("div", { class: "flex" }, [
          n("div", { class: "flex-shrink-0" }, [this.iconElement]),
          n("div", { class: "ml-3" }, [
            this.titleElement,
            "default" in this.$slots ? n(
              "div",
              {
                class: [
                  "text-sm leading-5",
                  this.colorClass.inner,
                  {
                    "mt-1": "default" in this.$slots && this.title
                  }
                ]
              },
              "default" in this.$slots ? this.$slots.default() : null
            ) : null
          ]),
          this.dismissible ? n("div", { class: "ml-auto pl-3" }, [
            n("div", { class: "-mx-1.5 -my-1.5" }, [
              n(
                "button",
                {
                  class: [
                    "inline-flex rounded-md p-1.5 focus:outline-none transition ease-in-out duration-150",
                    this.colorClass.button
                  ],
                  attrs: { "aria-label": "Dismiss" },
                  onClick: (e) => {
                    e.stopPropagation(), this.closed = !0, this.$emit("close", !0);
                  }
                },
                [
                  Ue("", [
                    We(
                      "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    )
                  ])
                ]
              )
            ])
          ]) : null
        ])
      ]
    );
  }
}), Us = (e, t, r) => {
  const a = [
    e ? "rounded-full" : t ? "rounded-md" : "rounded",
    t ? e ? "px-3 text-sm leading-5" : "px-2.5 text-sm leading-5" : e ? "px-2.5 text-xs leading-4" : "px-2 text-xs leading-4"
  ];
  switch (r) {
    case "red":
      a.push("bg-red-100 text-red-800 dark:bg-red-500 dark:bg-opacity-20 dark:text-red-400");
      break;
    case "yellow":
      a.push("bg-yellow-100 text-yellow-800 dark:bg-yellow-500 dark:bg-opacity-20 dark:text-yellow-400");
      break;
    case "green":
      a.push("bg-green-100 text-green-800 dark:bg-green-500 dark:bg-opacity-20 dark:text-green-400");
      break;
    case "blue":
      a.push("bg-blue-100 text-blue-800 dark:bg-blue-500 dark:bg-opacity-20 dark:text-blue-400");
      break;
    case "indigo":
      a.push("bg-indigo-100 text-indigo-800 dark:bg-indigo-500 dark:bg-opacity-20 dark:text-indigo-400");
      break;
    case "purple":
      a.push("bg-purple-100 text-purple-800 dark:bg-purple-500 dark:bg-opacity-20 dark:text-purple-400");
      break;
    case "pink":
      a.push("bg-pink-100 text-pink-800 dark:bg-pink-500 dark:bg-opacity-20 dark:text-pink-400");
      break;
    case "orange":
      a.push("bg-orange-100 text-orange-800 dark:bg-orange-500 dark:bg-opacity-20 dark:text-orange-400");
      break;
    default:
      a.push("bg-gray-100 text-gray-800 dark:bg-gray-100 dark:bg-opacity-10 dark:text-white");
  }
  return a;
}, Sa = (e, t) => n(
  "div",
  Object.assign({}, t.attrs, {
    class: ["inline-flex"].concat(
      "class" in t.attrs ? t.attrs.class : "",
      "staticClass" in t.attrs ? t.attrs.staticClass : ""
    )
  }),
  [
    n(
      "span",
      {
        class: ["inline-flex items-center py-0.5 font-medium", Us(e.rounded, e.large, e.color)]
      },
      [
        e.icon ? n(de(e.icon).Icon, {
          class: ["mr-1", e.large ? "h-4" : "h-3.5"]
        }) : null,
        "default" in t.slots ? t.slots.default() : "Badge"
      ]
    )
  ]
);
Sa.props = {
  color: { type: String, default: "" },
  large: { type: Boolean, default: !1 },
  rounded: { type: Boolean, default: !1 },
  icon: { type: [String, Object], default: () => "" }
};
const ir = Sa, _a = (e) => n("nav", { class: "flex" }, [
  n("ol", { class: "flex items-center space-x-4" }, [
    n("li", [
      n("div", [
        n(
          me,
          {
            to: "/",
            class: ["text-gray-400 dark:text-gray-300", "hover:text-primary-600", "dark:hover:text-white"]
          },
          {
            default: () => n(ks, {
              class: "flex-shrink-0 h-5 w-5",
              "aria-hidden": !0
            })
          }
        )
      ])
    ]),
    e.items.length ? e.items.map((t) => n("li", [
      n("div", { class: "flex items-center" }, [
        n(gr, {
          class: "flex-shrink-0 h-5 w-5 text-gray-400 dark:text-gray-300",
          "aria-hidden": !0
        }),
        t.current ? n(
          "span",
          {
            class: ["ml-4 text-sm font-medium text-gray-800 dark:text-white mt-0.5"],
            "aria-current": "page"
          },
          t.title
        ) : n(
          me,
          {
            to: t.to,
            class: [
              "ml-4 text-sm font-medium text-gray-500 dark:text-gray-400 mt-0.5",
              "hover:text-primary-700",
              "dark:hover:text-white"
            ],
            "aria-current": void 0
          },
          { default: () => t.title }
        )
      ])
    ])) : null
  ])
]);
_a.props = {
  items: {
    type: Array,
    required: !0,
    validator: (e) => Array.isArray(e) && e.every((t) => Object.prototype.toString.call(t) !== "[object Object]" || !("title" in t) || Object.prototype.toString.call(t.title) !== "[object String]" ? !1 : "to" in t ? it(t.to) : !0)
  }
};
const Ro = _a, Aa = (e, t = !1, r = !1) => {
  switch (e) {
    case "primary":
      return `border-transparent text-white ${t || r ? "bg-primary-400 text-opacity-90" : "bg-primary-600 hover:bg-primary-500 focus:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:bg-primary-500 dark:focus:bg-primary-600 dark:hover:bg-primary-600 dark:focus:ring-offset-gray-900"}`;
    case "secondary":
      return `border-transparent  ${t || r ? "text-primary-400 bg-primary-50 dark:bg-primary-400 dark:bg-opacity-20" : "text-primary-700 bg-primary-100 hover:bg-primary-50 focus:bg-primary-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 dark:text-primary-300 dark:bg-primary-500 dark:bg-opacity-20 dark:hover:bg-primary-600 dark:hover:bg-opacity-50 dark:focus:bg-primary-400 dark:focus:bg-opacity-20 dark:focus:ring-offset-gray-900"}`;
    case "danger":
      return `border-transparent text-white ${t || r ? "bg-red-400" : "bg-red-500 hover:bg-red-400 focus:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-400 dark:focus:ring-offset-gray-900"}`;
    case "success":
      return `border-transparent text-white ${t || r ? "bg-green-400" : "bg-green-500 hover:bg-green-400 focus:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-400 dark:focus:ring-offset-gray-900"}`;
    case "warning":
      return `border-transparent ${t || r ? "text-gray-500 bg-yellow-200" : "text-black bg-yellow-300 hover:bg-yellow-200 focus:bg-yellow-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-200 dark:focus:ring-offset-gray-900"}`;
    case "white":
      return `border-gray-300 ${t || r ? "text-gray-400 bg-gray-50" : "text-gray-700 bg-white hover:text-gray-500 focus:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-600 dark:focus:ring-offset-gray-900"}`;
    default:
      return `border-gray-300 dark:border-gray-600 ${t || r ? "text-gray-400 dark:text-gray-200 bg-gray-50 dark:bg-gray-600" : "text-gray-700 bg-white hover:text-gray-500 focus:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 dark:text-white dark:bg-gray-700 dark:hover:text-gray-200 dark:hover:bg-opacity-50 dark:focus:bg-opacity-60 dark:focus:ring-offset-gray-900"}`;
  }
}, Ta = (e) => {
  switch (e) {
    case "xs":
      return "px-2.5 py-1.5 text-xs leading-4";
    case "sm":
      return "px-3 py-2 text-sm leading-4";
    case "md":
      return "px-4 py-2 text-sm leading-5";
    case "lg":
      return "px-4 py-2 text-base leading-6";
    default:
      return "px-4 py-2 text-sm leading-5";
  }
}, Ws = (e, t) => {
  let r, a = "h-5 w-5";
  switch (e) {
    case "primary":
    case "success":
    case "danger":
      r = "text-white";
      break;
    case "secondary":
      r = "text-primary-700";
      break;
    case "warning":
      r = "text-black";
      break;
    default:
      r = "text-gray-700 dark:text-primary-400";
      break;
  }
  return (t === "xs" || t === "sm") && (a = "h-4 w-4 "), r + " " + a;
}, Ca = (e, t) => n(
  "svg",
  {
    class: [Ws(e.color, e.size), "inline-flex animate-spin"].concat(
      "class" in t.attrs ? t.attrs.class : ""
    ),
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  },
  [
    n("circle", {
      class: "opacity-25",
      cx: "12",
      cy: "12",
      r: "10",
      stroke: "currentColor",
      "stroke-width": 4
    }),
    n("path", {
      class: "opacity-75",
      fill: "currentColor",
      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    })
  ]
);
Ca.props = {
  color: { type: String, default: "" },
  size: { type: String, default: "md" }
};
const nt = Ca, Zs = (e, t) => e.forEach(t), E = (e, t, r) => {
  if (V(t, "array")) {
    const a = t.reduce((s, i) => s == null ? void 0 : s[i], e);
    return a ?? r;
  }
  return V(e, "object") && V(t, "string") && Object.prototype.hasOwnProperty.call(e, t) ? !0 : r;
}, Ys = (e, t) => {
  const r = [];
  for (const a in e)
    E(e, a) && (r.push([a, e[a]]), V(t, "function") && t(e[a], a));
  return r;
}, Xs = (e, t) => {
  if (e.length !== t.length)
    return !1;
  let r = !0;
  for (let a = 0; r && a < e.length; a++)
    r = Et(e[a], t[a]);
  return r;
}, Et = (e, t) => {
  if (e === t)
    return !0;
  let r = V(e, "date"), a = V(t, "date");
  if (r && a)
    return e.getTime() === t.getTime();
  if (r = V(e, "array"), a = V(t, "array"), r && a)
    return Xs(e, t);
  if (r = V(e, "object"), a = V(t, "object"), r && a) {
    if (Object.keys(e).length !== Object.keys(t).length)
      return !1;
    if (Object.is(e, t))
      return !0;
    for (const s in e) {
      const i = E(e, s, !1), l = E(t, s, !1);
      if (i && !l || !i && l || !Et(e[s], t[s]))
        return !1;
    }
  }
  return String(e) === String(t);
}, zr = (e) => {
  let t = Number.MAX_SAFE_INTEGER, r = "";
  const a = (u, c) => {
    const f = u / 1e3;
    return f < t && f >= 1 && (t = f, r = c), f;
  }, s = a(e, "kilobyte"), i = a(s, "megabyte"), l = a(i, "gigabyte"), o = a(l, "terabyte");
  return {
    bytes: e,
    kilobyte: s,
    megabyte: i,
    gigabyte: l,
    terabyte: o,
    key: r
  };
}, Hr = (e) => e ? new Date(e).toLocaleDateString("ru", {
  day: "numeric",
  month: "short",
  year: "numeric"
}) : "", Pa = (e, t) => {
  let r;
  return function() {
    const a = () => {
      e.apply(this, arguments);
    };
    clearTimeout(r), r = setTimeout(a, t);
  };
}, Ye = (e) => {
  const t = Object.prototype.toString, r = t.call(e) === "[object Array]" ? [] : t.call(e) === "[object Object]" ? {} : void 0;
  if (r !== void 0) {
    for (const a in e)
      Object.prototype.hasOwnProperty.call(e, a) && (r[a] = Ye(e[a]));
    return r;
  }
  return e;
}, re = (e) => e + Math.floor(Date.now() * Math.random()).toString(16), Ur = (e, t = (/* @__PURE__ */ new Date()).getFullYear()) => {
  if (!e)
    return null;
  const r = e * 6 - 6;
  return {
    single: new Date(t, r, 1),
    range: [new Date(t, r, 1), new Date(t, r + 6, 0)]
  };
}, Wr = (e, t = (/* @__PURE__ */ new Date()).getFullYear()) => {
  if (!e)
    return null;
  const r = (e - 1) * 3;
  return {
    single: new Date(t, r, 1),
    range: [new Date(t, r, 1), new Date(t, r + 3, 0)]
  };
}, Jt = {
  types: {
    "application/mp4": "MP4",
    "application/atom+xml": "ATOM",
    "application/json": "JSON",
    "application/javascript": "JS",
    "application/ogg": "OGG, OGV, OGA, OGX, SPX, OPUS, OGM",
    "application/pdf": "PDF",
    "application/postscript": "PS",
    "application/font-woff": "WOFF",
    "application/xhtml+xml": "XHTML, XHT, XML, HTML, HTM",
    "application/zip": "ZIP, ZIPX",
    "application/gzip": "GZIP",
    "application/xml": "XML",
    "application/msword": "DOC, DOCX, RTF",
    "application/vnd.oasis.opendocument.text": "ODT",
    "application/vnd.oasis.opendocument.spreadsheet": "ODS",
    "application/vnd.oasis.opendocument.presentation": "ODP",
    "application/vnd.oasis.opendocument.graphics": "ODG",
    "application/vnd.ms-excel": "OOXML, DOCX, XLSX, PPTX, DBT, FPT, IDX, NTX, CDX, MDX, CSV",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "OOXML, DOCX, XLSX, PPTX, DBT, FPT, IDX, NTX, CDX, MDX, CSV",
    "application/vnd.ms-excel.sheet.macroEnabled.12": "PPTX",
    "application/vnd.ms-powerpoint": "PPTX",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": "PPTX",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "DOC, DOCX, RTF",
    "application/vnd.google-earth.kml+xml": "KML, KMZ",
    "application/x-dvi": "DVI",
    "application/x-font-ttf": "TTF, TTE, DFONT",
    "application/x-shockwave-flash": "FLV, FLA",
    "application/x-rar-compressed": "RAR",
    "application/x-tar": "TAR",
    "application/*": "ATOM, JSON, JS, OGG, OGV, OGA, OGX, SPX, OPUS, OGM, PDF, PS, WOFF, XHTML, XHT, XML, HTML, HTM, ZIP, ZIPX, GZIP, XML, DOC, DOCX, RTF, ODT, ODS, ODP, ODG, OOXML, DOCX, XLSX, PPTX, DBT, FPT, IDX, NTX, CDX, MDX, CSV, PPTX, KML, KMZ, DVI, TTF, TTE, DFONT, FLV, FLA, RAR, TAR"
  },
  expansion: {
    ".atom": "ATOM",
    ".json": "JSON",
    ".js": "JS",
    ".ogg": "OGG",
    ".ogv": "OGV",
    ".oga": "OGA",
    ".ogx": "OGX",
    ".spx": "SPX",
    ".opus": "OPUS",
    ".ogm": "OGM",
    ".pdf": "PDF",
    ".ps": "PS",
    ".woff": "WOFF",
    ".xhtml": "XHTML",
    ".xht": "XHT",
    ".xml": "XML",
    ".html": "HTML",
    ".htm": "HTM",
    ".zip": "ZIP",
    ".zipx": "ZIPX",
    ".gzip": "GZIP",
    ".doc": "DOC",
    ".docx": "DOCX",
    ".rtf": "RTF",
    ".odt": "ODT",
    ".ods": "ODS",
    ".odp": "ODP",
    ".odg": "ODG",
    ".ooxml": "OOXML",
    ".xlsx": "XLSX",
    ".pptx": "PPTX",
    ".dbt": "DBT",
    ".fpt": "FPT",
    ".idx": "IDX",
    ".ntx": "NTX",
    ".cdx": "CDX",
    ".mdx": "MDX",
    ".csv": "CSV",
    ".kml": "KML",
    ".kmz": "KMZ",
    ".dvi": "DVI",
    ".ttf": "TTF",
    ".tte": "TTE",
    ".dfont": "DFONT",
    ".flv": "FLV",
    ".fla": "FLA",
    ".rar": "RAR",
    ".tar": "TRA"
  }
}, Kt = {
  types: {
    "audio/mp4": "MP4",
    "audio/aac": "AAC, M4A, M4P, M4B, MP4, 3GP",
    "audio/aacp": "AAC, M4A, M4P, M4B, MP4, 3GP",
    "audio/3gpp": "AAC, M4A, M4P, M4B, MP4, 3GP",
    "audio/3gpp2": "AAC, M4A, M4P, M4B, MP4, 3GP",
    "audio/mp4a-latm": "AAC, M4A, M4P, M4B, MP4, 3GP",
    "audio/mpeg4-generic": "AAC, M4A, M4P, M4B, MP4, 3GP",
    "audio/x-aac": "AAC, M4A, M4P, M4B, MP4, 3GP",
    "audio/x-m4a": "AAC, M4A, M4P, M4B, MP4, 3GP",
    "audio/x-m4p": "AAC, M4A, M4P, M4B, MP4, 3GP",
    "audio/x-m4b": "AAC, M4A, M4P, M4B, MP4, 3GP",
    "audio/mp4a": "AAC, M4A, M4P, M4B, MP4, 3GP",
    "audio/mpga": "AAC, M4A, M4P, M4B, MP4, 3GP",
    "audio/mpeg": "MP3",
    "audio/ogg": "OGG, OGV, OGA, OGX, SPX, OPUS, OGM, SB0, SPX, FLAC",
    "audio/vorbis": "OGG, OGA, SB0",
    "audio/x-ms-wma": "WMA",
    "audio/x-ms-wax": "WMA",
    "audio/vnd.rn-realaudio": "RM",
    "audio/vnd.wave": "WAV",
    "audio/webm": "WEBM",
    "audio/*": "MP4, AAC, M4A, M4P, M4B, MP4, 3GP, MP3, OGG, OGV, OGA, OGX, SPX, OPUS, OGM, SB0, SPX, FLAC, WMA, RM, WAV, WEBM"
  },
  expansion: {
    ".mp4": "MP4",
    ".acc": "AAC",
    ".m4a": "M4A",
    ".m4p": "M4P",
    ".m4b": "M4B",
    ".3gp": "3GP",
    ".mp3": "MP3",
    ".ogg": "OGG",
    ".ogv": "OGV",
    ".oga": "OGA",
    ".ogx": "OGX",
    ".spx": "SPX",
    ".opus": "OPUS",
    ".ogm": "OGM",
    ".sb0": "SB0",
    ".flac": "FLAC",
    ".wma": "WMA",
    ".rm": "RM",
    ".wav": "WAV",
    ".webm": "WEBM"
  }
}, qt = {
  types: {
    "image/gif": "GIF",
    "image/jpeg": "JPG, JPEG",
    "image/pjpeg": "JPG, JPEG",
    "image/png": "PNG",
    "image/svg+xml": "SVG, SVGZ",
    "image/tiff": "TIF, TIFF",
    "image/vnd.microsoft.icon": "ICO",
    "image/vnd.wap.wbmp": "WBMP",
    "image/webp": "WEBP",
    "image/*": "GIF, JPG, JPEG, PNG, SVG, SVGZ, TIF, TIFF, ICO, WBMP, WEBP"
  },
  expansion: {
    ".gif": "GIF",
    ".jpg": "JPG",
    ".JPG": "JPG",
    ".jpeg": "JPEG",
    ".JPEG": "JPEG",
    ".png": "PNG",
    ".svg": "SVG",
    ".svgz": "SVGZ",
    ".tif": "TIF",
    ".tiff": "TIFF",
    ".ico": "ICO",
    ".wbmp": "WBMP",
    ".webp": "WEBP"
  }
}, Qt = {
  types: {
    "text/css": "CSS",
    "text/csv": "CSV",
    "text/html": "HTML, HTM",
    "text/javascript": "JS",
    "text/php": "PHP",
    "text/xml": "XML",
    "text/*": "CSS, CSV, HTML, HTM, JS, PHP, XML"
  },
  expansion: {
    ".css": "CSS",
    ".csv": "CSV",
    ".html": "HTML",
    ".htm": "HTM",
    ".js": "JS",
    ".php": "PHP",
    ".xml": "XML"
  }
}, er = {
  types: {
    "video/mpeg": "MPG, MPEG, MP1, MP2, MP3, M1V, MPV, M1A, M2A, MPA",
    "video/mp4": "MP4",
    "video/ogg": "OGG, OGV, OGA, OGX, SPX, OPUS, OGM",
    "video/webm": "WEBM",
    "video/x-ms-wmv": "WMV",
    "video/x-flv": "FLV",
    "video/3gpp": "3GPP, 3GP",
    "video/3gpp2": "3GPP2, 3G2",
    "video/*": "MPG, MPEG, MP1, MP2, MP3, M1V, MPV, M1A, M2A, MPA, MP4, OGG, OGV, OGA, OGX, SPX, OPUS, OGM, WEBM, WMV, FLV, 3GPP, 3GP, 3GPP2, 3G2"
  },
  expansion: {
    ".mpg": "MPG",
    ".mpeg": "MPEG",
    ".mp1": "MP1",
    ".mp2": "MP2",
    ".mp3": "MP3",
    ".m1v": "M1V",
    ".mpv": "MPV",
    ".m1a": "M1A",
    ".m2a": "M2A",
    ".mpa": "MPA",
    ".mp4": "MP4",
    ".ogg": "OGG",
    ".ogv": "OGV",
    ".oga": "OGA",
    ".ogx": "OGX",
    ".spx": "SPX",
    ".opus": "OPUS",
    ".ogm": "OGM",
    ".webm": "WEBM",
    ".wmv": "WMV",
    ".flv": "FLV",
    ".3gpp": "3GPP",
    ".3gp": "3GP",
    ".3gpp2": "3GPP2",
    ".3g2": "3G2"
  }
}, vt = {
  types: {
    ...Jt.types,
    ...Kt.types,
    ...qt.types,
    ...Qt.types,
    ...er.types
  },
  expansion: {
    ...Jt.expansion,
    ...Kt.expansion,
    ...qt.expansion,
    ...Qt.expansion,
    ...er.expansion
  },
  default: {
    application: Jt.expansion,
    audio: Kt.expansion,
    image: qt.expansion,
    text: Qt.expansion,
    video: er.expansion
  }
}, Zr = (e) => {
  const t = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), a = (i, l, o) => {
    V(i, "string") && i.split(",").forEach((u) => {
      const c = u.trim();
      switch (c.includes("/") ? "type" : c.includes(".") ? "expansion" : "") {
        case "type":
          E(vt.types, c) && (l.add(vt.types[c]), o.add(c));
          break;
        case "expansion":
          E(vt.expansion, c) && (l.add(vt.expansion[c]), o.add(c));
      }
    }), V(i, "array") && Zs(i, (u) => a(u, l)), V(i, "object") && Ys(
      i,
      (u, c) => u ? a(c, l) : null
    );
  };
  a(e, t, r);
  const s = Array.from(t).join(", ");
  return {
    text: Array.from(t).join(", "),
    mime: Array.from(r).join(", "),
    hash: s.split(", ").reduce((i, l) => (i[l] = !0, i), {})
  };
}, wt = (e) => Math.floor((new Date(e).getMonth() + 6) / 6), kt = (e) => Math.floor((new Date(e).getMonth() + 3) / 3);
function Yr(e) {
  return typeof HTMLElement == "object" ? e instanceof HTMLElement : e && typeof e == "object" && e !== null && e.nodeType === 1 && typeof e.nodeName == "string";
}
const F = (e) => V(e, "string") ? e === "true" : V(e, "number") ? !!e : V(e, "boolean") ? e : !1, Ia = (e, t) => {
  var i;
  const r = e.loading || F(t.attrs.disabled), a = e.icon && !("default" in t.slots), s = {
    ...t.attrs,
    class: [
      "justify-center items-center border font-medium focus:outline-none transition ease-in-out duration-150",
      { "pointer-events-none": e.loading },
      Aa(e.color, e.loading, F(t.attrs.disabled)),
      e.rounded ? "rounded-full" : "rounded-md",
      e.block ? "flex w-full" : "inline-flex",
      a ? "p-2" : Ta(e.size)
    ].concat(["class" in t.attrs ? t.attrs.class : ""], {
      "cursor-default": ((i = t.attrs) == null ? void 0 : i.disabled) ?? !1
    })
  };
  return e.to && (s.to = e.to), r && (s.disabled = r), n(e.to ? me : "button", s, {
    default: () => [
      e.loading ? n(nt, {
        color: e.color,
        size: e.size,
        class: [{ "mr-3": !a }]
      }) : null,
      e.icon && !e.loading ? n(
        "span",
        {
          class: [
            "inline-block align-middle",
            e.icon.color,
            {
              "mr-1": (e.size === "xs" || e.size === "sm") && !a,
              "mr-2": e.size !== "xs" && e.size !== "sm" && !a
            }
          ]
        },
        [
          n(de(e.icon).Icon, {
            class: [e.size === "xs" ? "h-3.5" : e.size === "md" || e.size === "lg" ? "h-5" : "h-4"]
          })
        ]
      ) : null,
      n(
        "span",
        { class: "align-middle" },
        "default" in t.slots ? t.slots.default() : a ? null : "Button"
      )
    ]
  });
};
Ia.props = {
  to: {
    type: [Object, String],
    validator: (e) => it(e),
    default: ""
  },
  color: { type: String, default: "" },
  size: { type: String, default: "md" },
  loading: { type: Boolean, default: !1 },
  block: { type: Boolean, default: !1 },
  icon: { type: [String, Object], default: () => "" },
  rounded: { type: Boolean, default: !1 }
};
const Bt = Ia, Js = {
  dates: {
    months: {
      full: [
        "yanvar",
        "fevral",
        "mart",
        "aprel",
        "may",
        "iyun",
        "iyul",
        "avgust",
        "sentabr",
        "oktabr",
        "noyabr",
        "dekabr"
      ],
      short: ["yan.", "fev.", "mar.", "apr.", "may", "iyun", "iyul", "avg.", "sen.", "okt.", "noy.", "dek."]
    },
    weeks: {
      short: ["du.", "se.", "ch.", "pa.", "ju.", "sh.", "ya."],
      full: ["dushanba", "seshanba", "chorshanba", "payshanba", "juma", "shanba", "yakshanba"]
    },
    quarters: {
      short: {
        1: "1 ch.",
        2: "2 ch.",
        3: "3 ch.",
        4: "4 ch."
      },
      full: { 1: "1 chorak", 2: "2 chorak", 3: "3 chorak", 4: "4 chorak" }
    },
    halfYears: {
      short: {
        1: "1/2",
        2: "2/2"
      },
      full: {
        1: "Birinchi yarim yillik",
        2: "Ikinchi yarim yillik"
      }
    }
  }
}, Ks = {
  dates: {
    months: {
      full: [
        "январь",
        "февраль",
        "март",
        "апрель",
        "май",
        "июнь",
        "июль",
        "август",
        "сентябрь",
        "октябрь",
        "ноябрь",
        "декабрь"
      ],
      short: ["янв.", "фев.", "мар.", "апр.", "май", "июнь", "июль", "авг.", "сен.", "окт.", "ноя.", "дек."]
    },
    weeks: {
      short: ["пн.", "вт.", "ср.", "чт.", "пт.", "сб.", "вс."],
      full: ["понедельник", "вторник", "среда", "чеверг", "пятница", "суббота", "воскресенье"]
    },
    quarters: {
      short: {
        1: "1 кв.",
        2: "2 кв.",
        3: "3 кв.",
        4: "4 кв."
      },
      full: { 1: "1 квартал", 2: "2 квартал", 3: "3 квартал", 4: "4 квартал" }
    },
    halfYears: {
      short: {
        1: "1/2",
        2: "2/2"
      },
      full: {
        1: "Первое полугодие",
        2: "Второе полугодие"
      }
    }
  }
}, Oa = {
  props: {
    range: { type: Boolean, default: !1 },
    disabledDates: {
      type: [Array, Object],
      validator: Gr,
      default: void 0
    },
    allowedDates: {
      type: [Array, Object],
      validator: Gr,
      default: void 0
    },
    type: {
      type: String,
      default: "date",
      validator: (e) => e === "date" || e === "month" || e === "year" || e === "quarter" || e === "half-year"
    },
    startYear: {
      type: [Number, String],
      default: 1900
    },
    endYear: {
      type: [Number, String],
      default: 2100
    },
    highlights: {
      type: Array,
      default: () => []
    },
    locales: {
      type: Object,
      default: () => ({ ru: Ks.dates, uz: Js.dates })
    },
    locale: {
      type: String,
      default: "ru"
    }
  }
}, ke = {
  left: "left",
  right: "right",
  bottom: "bottom",
  top: "top"
}, Xr = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, ye = {
  start: "start",
  end: "end",
  center: "center"
}, qs = {
  placement: "bottom",
  alignment: null,
  autoFloating: !0,
  offset: [0, 0],
  getFloatingDomElement: null,
  getReferenceDomElement: null
};
function Qs(e, t, r) {
  const a = e == null ? void 0 : e.getBoundingClientRect(), s = t == null ? void 0 : t.getBoundingClientRect(), i = document.documentElement.scrollTop || document.body.scrollTop, l = i + window.innerHeight, [o, u] = r;
  return {
    left: (a == null ? void 0 : a.x) - (s == null ? void 0 : s.width) - o,
    right: document.body.clientWidth - ((a == null ? void 0 : a.x) + (a == null ? void 0 : a.width) + (s == null ? void 0 : s.width) + o),
    top: (a == null ? void 0 : a.y) - (s == null ? void 0 : s.height) - u,
    bottom: l - (i + (a == null ? void 0 : a.y) + (a == null ? void 0 : a.height) + (s == null ? void 0 : s.height) + u)
  };
}
function el(e, t, r, a) {
  if ([ke.bottom, ke.top].includes(r)) {
    let s = 0, i = 0;
    const l = e.getBoundingClientRect(), o = t.getBoundingClientRect();
    if (a === ye.start)
      i = (l == null ? void 0 : l.x) + (l == null ? void 0 : l.width) + Math.abs((l == null ? void 0 : l.width) - (o == null ? void 0 : o.width));
    else if (a === ye.end)
      s = l.x - Math.abs(l.width - o.width);
    else if (a === ye.center) {
      const u = l.width < o.width ? Math.abs(l.width - o.width) / 2 : 0;
      s = l.x - u, i = l.x + l.width + u;
    }
    if (s < 0)
      return ye.start;
    if (i > document.body.clientWidth)
      return ye.end;
  }
}
function tl(e, t, r, a) {
  const s = {
    x: 0,
    y: 0
  }, i = r.value, l = a.value;
  if ([ke.left, ke.right].includes(l))
    switch (i) {
      case ye.start:
        break;
      case ye.end:
        s.y = e.height - t.height;
        break;
      case ye.center:
        s.y = e.height / 2 - t.height / 2;
        break;
    }
  else if ([ke.top, ke.bottom].includes(l))
    switch (i) {
      case ye.start:
        break;
      case ye.end:
        s.x = e.width - t.width;
        break;
      case ye.center:
        s.x = e.width / 2 - t.width / 2;
        break;
    }
  return s;
}
function Jr(e) {
  const r = e.offsetParent.getBoundingClientRect(), a = e.getBoundingClientRect();
  return {
    x: a.left,
    y: a.top,
    width: a.width,
    height: a.height,
    parent: {
      x: r.left,
      y: r.top
    }
  };
}
function Qe(e, t, r = qs) {
  const {
    placement: a,
    alignment: s,
    autoFloating: i,
    offset: l,
    getFloatingDomElement: o,
    getReferenceDomElement: u
  } = r, c = y(null), f = y(null), h = y(a || null), d = y(s || null), g = () => {
    const p = u ? u(e) : e.value, x = o ? o(t) : t.value;
    if (!Yr(p) || !Yr(x))
      return;
    const m = Jr(p), b = Jr(x), w = Qs(p, x, l);
    h.value = w[r.placement] < 0 && w[Xr[r.placement]] >= 0 ? Xr[r.placement] : r.placement, d.value = el(p, x, a, s) || s;
    const k = tl(m, b, d, h), [S, v] = l;
    switch (h.value) {
      case ke.left:
        c.value = m.x - b.parent.x - b.width - S, f.value = m.y - b.parent.y + k.y + v;
        break;
      case ke.right:
        c.value = m.x - b.parent.x + m.width + S, f.value = m.y - b.parent.y + k.y + v;
        break;
      case ke.top:
        c.value = m.x - b.parent.x + k.x - S, f.value = m.y - b.parent.y - b.height - v;
        break;
      case ke.bottom:
        c.value = m.x - b.parent.x + k.x + S, f.value = m.y - b.parent.y + m.height + v;
        break;
    }
  };
  return i && (window.addEventListener("scroll", g, {
    passive: !0
  }), window.addEventListener("resize", g)), {
    x: c,
    y: f,
    updatePosition: g,
    destroyAutoFloating: () => {
      window.removeEventListener("scroll", g), window.removeEventListener("resize", g);
    }
  };
}
const Ae = {
  low: 1e3,
  medium: 1001,
  high: 1002
}, tr = D({
  name: "AtTooltip",
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    body: {
      type: String,
      default: ""
    },
    trigger: {
      type: String,
      default: "hover",
      validator: (e) => e === "hover" || e === "click" || e === "focus" || e === "none"
    },
    offset: {
      type: Array,
      default: () => [0, 0]
    },
    placement: {
      type: String,
      default: "bottom",
      validator: (e) => e && ["bottom", "top", "left", "right"].includes(e)
    },
    alignment: {
      type: String,
      default: "center",
      validator: (e) => e && ["start", "center", "end"].includes(e)
    },
    teleport: { type: Boolean, default: !1 },
    teleportToRef: { type: Object, default: null },
    teleportToSelector: { type: String, default: "body" },
    duration: { type: Number, default: null }
  },
  setup(e) {
    const t = y(!1), r = y(null), a = y(null), s = y(null), { x: i, y: l, updatePosition: o } = Qe(a, s, {
      placement: e.placement,
      alignment: e.alignment,
      offset: e.offset
    });
    X(o), G([() => s.value, () => a.value], o);
    const u = (f) => {
      e.disabled || (t.value = f, f && e.duration && (clearTimeout(r.value), r.value = setTimeout(() => u(!1), e.duration)));
    }, c = {
      click: {
        onClick: () => u(!t.value)
      },
      hover: {
        onMouseenter: () => u(!0),
        onMouseleave: () => u(!1)
      },
      focus: {
        onFocus: () => u(!0),
        onBlur: () => u(!1)
      }
    };
    return G(
      () => e.disabled,
      (f) => {
        !f && t.value && (t.value = f);
      }
    ), {
      triggerEvents: c,
      show: t,
      referenceRef: a,
      floatingRef: s,
      x: i,
      y: l,
      toggle: u
    };
  },
  render() {
    var e;
    return n("div", { ...this.triggerEvents[this.trigger] }, [
      n("div", { ref: "referenceRef" }, "default" in this.$slots ? this.$slots.default({ toggle: this.toggle }) : null),
      n(
        Ee,
        {
          to: (e = this.teleportToRef) != null && e.value ? this.teleportToRef.value : this.teleportToSelector,
          disabled: !this.teleport
        },
        n(
          _e,
          {
            enterActiveClass: "transition transition-opacity duration-200",
            enterFromClass: "opacity-0",
            enterToClass: "opacity-100",
            leaveActiveClass: "transition transition-opacity duration-200",
            leaveFromClass: "opacity-100",
            leaveToClass: "opacity-0"
          },
          () => this.show && !this.disabled ? n(
            "div",
            {
              ref: "floatingRef",
              class: [
                "bg-gray-900",
                "dark:bg-gray-600",
                "text-white",
                "bg-opacity-80",
                "rounded-md",
                "px-4 py-2",
                "absolute",
                "transition-opacity",
                "duration-75",
                "ease-out",
                "max-w-xs",
                "top-0",
                "left-0",
                "text-sm"
              ],
              style: {
                width: "max-content",
                transform: `translate(${this.x}px, ${this.y}px)`,
                zIndex: Ae.low
              }
            },
            ["body" in this.$slots ? this.$slots.body() : this.body]
          ) : null
        )
      )
    ]);
  }
}), rl = D({
  name: "AtCalendar",
  emits: ["update:modelValue", "scroll"],
  props: {
    ...Oa.props,
    modelValue: { type: [String, Date, Array], default: /* @__PURE__ */ new Date() }
  },
  setup(e, { emit: t }) {
    let r = y((/* @__PURE__ */ new Date()).getMonth() + 1), a = y((/* @__PURE__ */ new Date()).getMonth() + 1), s = y((/* @__PURE__ */ new Date()).getFullYear()), i = y((/* @__PURE__ */ new Date()).getFullYear()), l = y(kt(/* @__PURE__ */ new Date())), o = y(wt(/* @__PURE__ */ new Date())), u = y([]), c = y(!1), f = y(null), h = $e(e).modelValue, d = y([]), g = $e(e).startYear, p = $e(e).endYear, x = y(null);
    const m = "after:w-6/12 after:h-full after:absolute after:right-0 after:bg-primary-100 dark:after:bg-primary-500 dark:after:bg-opacity-30", b = "before:content-[attr(before-content)] before:rounded-full before:bg-orange-400 before:absolute before:left-6 before:w-5 before:text-xs before:h-5 before:items-center before:bottom-3 before:text-white before:flex before:justify-center", w = {
      placement: "top",
      offset: [0, 4],
      trigger: "hover",
      teleport: !0,
      teleportToRef: x
    };
    G(
      [h, () => e.range],
      () => {
        h.value && !e.range ? (r.value = new Date(e.modelValue).getMonth() + 1, a.value = new Date(e.modelValue).getMonth() + 1, s.value = new Date(e.modelValue).getFullYear(), i.value = new Date(e.modelValue).getFullYear(), f.value = new Date(e.modelValue).getDate(), l.value = Math.floor(kt(new Date(e.modelValue))), o.value = Math.floor(wt(new Date(e.modelValue)))) : e.range && Array.isArray(h.value) && h.value.length === 2 && (d.value = h.value, l.value = Math.floor(kt(new Date(d.value[0]))), o.value = Math.floor(wt(new Date(d.value[0]))), i.value = new Date(d.value[0]).getFullYear(), s.value = new Date(d.value[0]).getFullYear(), a.value = new Date(d.value[0]).getMonth() + 1, r.value = new Date(d.value[0]).getMonth() + 1);
      },
      {
        immediate: !0
      }
    );
    const k = C(() => {
      var I;
      return e.range && ((I = d.value) == null ? void 0 : I.length) === 2;
    }), S = C(() => {
      const I = [];
      for (let _ = g.value; _ <= p.value; _++)
        I.push(_);
      return I;
    }), v = C(() => {
      let I = [];
      const _ = new Date(i.value, r.value - 1, 0).getDate();
      for (let A = 0; A < u.value[0].weekDay - 1; A++) {
        const B = _ - A;
        let N = r.value - 1, ge = i.value;
        N === 0 && (ge -= 1, N = 12);
        const pe = /* @__PURE__ */ new Date(`${ge}-${N}-${B}`), ae = e.highlights.find((Ne) => he(Ne == null ? void 0 : Ne.date, pe));
        I.unshift({
          number: B,
          date: pe,
          highlightClasses: (ae == null ? void 0 : ae.class) || null,
          tooltipText: (ae == null ? void 0 : ae.tooltipText) || null,
          notificationText: (ae == null ? void 0 : ae.notificationText) ?? null,
          isSelected: e.range ? d.value.some(
            (Ne) => he(`${Ne.getFullYear()}-${Ne.getMonth() + 1}-${Ne.getDate()}`, pe)
          ) : B === f.value && N === a.value && ge === i.value
        });
      }
      return I.map((A) => {
        const B = W(new Date(i.value, (r.value - 2) % 12, A.number)), N = n(
          "div",
          {
            class: ["relative transition duration-150 w-auto text-center text-gray-900 z-10"],
            onClick: () => {
              if (A.allowed) {
                if (e.range) {
                  Ut(A.number, r.value - 1, i.value);
                  return;
                }
                mt(A.number);
              }
            }
          },
          n(
            "div",
            {
              class: [
                "h-8 w-8 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full flex items-center justify-center z-10",
                (A == null ? void 0 : A.notificationText) && b,
                A == null ? void 0 : A.highlightClasses
              ],
              style: {
                minWidth: "2rem"
              },
              "before-content": A == null ? void 0 : A.notificationText
            },
            n(
              "div",
              {
                class: [
                  "w-full h-full flex items-center justify-center rounded-full min-w-full",
                  A.isSelected && "bg-primary-600 dark:bg-primary-500 text-white"
                ]
              },
              n("span", null, A.number)
            )
          )
        );
        return n(
          "button",
          {
            class: [
              "h-8 m-auto w-min text-center flex items-center justify-center opacity-50 scale-100",
              !B && "cursor-not-allowed text-gray-300 dark:text-gray-600",
              k.value && Wt(A.date) && "bg-primary-100 dark:bg-primary-500 dark:bg-opacity-30",
              k.value && !he(d.value[0], d.value[1]) && (he(d.value[0], A.date) && `${m} after:right-0` || he(d.value[1], A.date) && `${m} after:left-0`)
            ],
            type: "button",
            disabled: !B,
            onClick: () => {
              Z(A.number), !e.range && Zt();
            }
          },
          A.tooltipText ? n(
            tr,
            {
              ...w,
              body: A.tooltipText
            },
            {
              default: () => N
            }
          ) : N
        );
      });
    }), P = C(() => {
      let I = [];
      for (let _ = 0; _ < 7 - u.value[u.value.length - 1].weekDay; _++) {
        const A = _ + 1;
        let B = r.value + 1, N = i.value;
        B > 12 && (N += 1, B = 1);
        const ge = /* @__PURE__ */ new Date(`${N}-${B}-${A}`), pe = e.highlights.find((ae) => he(ae == null ? void 0 : ae.date, ge));
        I.push({
          number: A,
          date: /* @__PURE__ */ new Date(`${N}-${B}-${A}`),
          highlightClasses: (pe == null ? void 0 : pe.class) || null,
          tooltipText: (pe == null ? void 0 : pe.tooltipText) || null,
          notificationText: (pe == null ? void 0 : pe.notificationText) ?? null,
          isSelected: e.range ? d.value.some(
            (ae) => he(`${ae.getFullYear()}-${ae.getMonth() + 1}-${ae.getDate()}`, ge)
          ) : A === f.value && B === a.value && N === i.value
        });
      }
      return I.map((_) => {
        let A = r.value, B = i.value;
        A > 12 && (B++, A = 1);
        const N = W(new Date(B, A, _.number)), ge = n(
          "div",
          {
            class: ["relative transition duration-150 w-auto text-center text-gray-900 z-10"],
            onClick: () => {
              if (_.allowed) {
                if (e.range) {
                  Ut(_.number, r.value - 1, i.value);
                  return;
                }
                mt(_.number);
              }
            }
          },
          n(
            "div",
            {
              class: [
                "h-8 w-8 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full flex items-center justify-center z-10",
                (_ == null ? void 0 : _.notificationText) && b,
                _ == null ? void 0 : _.highlightClasses
              ],
              style: {
                minWidth: "2rem"
              },
              "before-content": _ == null ? void 0 : _.notificationText
            },
            n(
              "div",
              {
                class: [
                  "w-full h-full flex items-center justify-center rounded-full min-w-full",
                  _.isSelected && "bg-primary-600 dark:bg-primary-500 text-white"
                ]
              },
              n("span", null, _.number)
            )
          )
        );
        return n(
          "button",
          {
            class: [
              "h-8 m-auto w-min text-center flex items-center justify-center opacity-50 scale-100",
              !N && "cursor-not-allowed text-gray-300 dark:text-gray-600",
              k.value && Wt(_.date) && "bg-primary-100 dark:bg-primary-500 dark:bg-opacity-30",
              k.value && !he(d.value[0], d.value[1]) && (he(d.value[0], _.date) && `${m} after:right-0` || he(d.value[1], _.date) && `${m} after:left-0`)
            ],
            type: "button",
            disabled: !N,
            onClick: () => {
              le(_.number), !e.range && Zt();
            }
          },
          _.tooltipText ? n(
            tr,
            {
              ...w,
              body: _.tooltipText
            },
            {
              default: () => ge
            }
          ) : ge
        );
      });
    }), O = C(() => {
      var _;
      const I = ((_ = e.locales[e.locale]) == null ? void 0 : _.months.full[r.value - 1]) ?? "";
      return `${Fe(I)} ${i.value}`;
    }), $ = (I) => {
      const _ = new Date(I);
      return _.setHours(0, 0, 0, 0), _;
    }, W = (I) => {
      if (e.allowedDates) {
        if (V(e.allowedDates, "array"))
          return e.allowedDates.some(
            (_) => $(I).getTime() === $(_).getTime()
          );
        if (V(e.allowedDates, "object"))
          return $(e.allowedDates.from).getTime() <= $(I).getTime() && $(e.allowedDates.to).getTime() >= $(I).getTime();
      }
      if (e.disabledDates) {
        if (V(e.disabledDates, "array"))
          return !e.disabledDates.some((_) => $(I).getTime() === $(_).getTime());
        if (V(e.disabledDates, "object"))
          return $(e.disabledDates.from).getTime() > $(I).getTime() && $(e.disabledDates.to).getTime() < $(I).getTime();
      }
      return !0;
    };
    e.range && G(
      d,
      () => {
        d.value.length === 2 && (new Date(d.value[0]) > new Date(d.value[1]) && (d.value = d.value.reverse()), t("update:modelValue", d.value));
      },
      { deep: !0 }
    ), G(
      () => e.highlights,
      () => {
        fe();
      }
    );
    const ce = (I) => new Date(i.value, r.value - 1, I).getDay() || 7, fe = () => {
      let I = new Date(i.value, r.value, 0).getDate(), _ = [];
      for (let A = 1; A <= I; A++) {
        const B = /* @__PURE__ */ new Date(`${i.value}-${r.value}-${A}`), N = e.highlights.find(
          (ge) => new Date(ge == null ? void 0 : ge.date).setHours(0, 0, 0, 0) === (/* @__PURE__ */ new Date(`${r.value}-${A}-${i.value}`)).setHours(0, 0, 0, 0)
        );
        _.push({
          weekDay: ce(A),
          number: A,
          date: B,
          allowed: W(new Date(i.value, r.value - 1, A)),
          highlightClasses: (N == null ? void 0 : N.class) || null,
          tooltipText: (N == null ? void 0 : N.tooltipText) || null,
          notificationText: (N == null ? void 0 : N.notificationText) ?? null
        });
      }
      u.value = _;
    }, et = () => {
      const I = [], _ = i.value;
      for (let A = -4; A < 5; A++) {
        const B = _ + A, N = W(new Date(B, r.value - 1, 1));
        I.push({ value: B, allowed: N });
      }
      return I;
    }, Te = () => {
      var _;
      const I = [];
      for (let A = 1; A <= 4; A++) {
        const { range: B } = Wr(A, i.value), N = W(B[0]) && W(B[1]);
        I.push({ value: A, title: (_ = e.locales[e.locale]) == null ? void 0 : _.quarters.full[A], allowed: N });
      }
      return I;
    }, Re = () => {
      var _;
      const I = [];
      for (let A = 1; A <= 2; A++) {
        const { range: B } = Ur(A, i.value), N = W(B[0]) && W(B[1]);
        I.push({ value: A, title: (_ = e.locales[e.locale]) == null ? void 0 : _.halfYears.full[A], allowed: N });
      }
      return I;
    }, M = (I) => I ? "bg-primary-600 dark:bg-primary-500 text-white" : "text-gray-700 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-800 active:bg-gray-300 dark:active:bg-gray-900", Z = (I = f.value) => {
      r.value - 1 === 0 ? (r.value = 12, i.value--) : r.value--, f.value = I, t("scroll", new Date(i.value, r.value - 1, 1)), fe();
    }, le = (I = f.value) => {
      r.value + 1 === 13 ? (r.value = 1, i.value++) : r.value++, f.value = I, t("scroll", new Date(i.value, r.value - 1, 1)), fe();
    }, tt = (I, _ = !0) => {
      (r.value !== I + 1 || s.value !== i.value) && (r.value = I + 1, a.value = I + 1, c.value = !1, e.type === "date" && fe(), _ && (e.range ? t("update:modelValue", [
        $(new Date(i.value, r.value - 1, 1)),
        $(new Date(i.value, r.value, 0))
      ]) : t("update:modelValue", new Date(i.value, r.value - 1, f.value))), t("scroll", new Date(i.value, r.value - 1, 1)));
    }, Vr = (I, _ = !0) => {
      (s.value !== I || i.value !== I) && (i.value = I, c.value = !1, e.type === "date" && fe(), _ && (e.range ? t("update:modelValue", [
        $(new Date(i.value, 0, 1)),
        $(new Date(i.value, 11 + 1, 0))
      ]) : t("update:modelValue", new Date(i.value, r.value - 1, f.value))), t("scroll", new Date(i.value, r.value - 1, 1)));
    }, ys = (I, _ = !0) => {
      l.value = I;
      const { single: A, range: B } = Wr(I, i.value);
      _ && (e.range ? t("update:modelValue", [$(B[0]), $(B[1])]) : t("update:modelValue", $(A)));
    }, xs = (I, _ = !0) => {
      o.value = I;
      const { single: A, range: B } = Ur(I, i.value);
      _ && (e.range ? t("update:modelValue", [$(B[0]), $(B[1])]) : t("update:modelValue", $(A)));
    }, mt = (I) => {
      a.value = r.value, f.value = I;
    }, Ut = (I, _, A) => {
      d.value[0] && d.value[1] && (d.value = []), !d.value[0] && !d.value[1] ? d.value[0] = new Date(A, _, I) : d.value[0] && !d.value[1] && (d.value[1] = new Date(A, _, I));
    }, Wt = (I) => {
      const _ = new Date(new Date(I).setHours(0, 0, 0, 0)), A = new Date(new Date(d.value[0]).setHours(0, 0, 0, 0)), B = new Date(new Date(d.value[1]).setHours(0, 0, 0, 0));
      return _ > A && _ < B;
    }, he = (I, _) => new Date(I).setHours(0, 0, 0, 0) === new Date(_).setHours(0, 0, 0, 0), Zt = () => {
      const I = new Date(i.value, r.value - 1, f.value);
      t("update:modelValue", I);
    }, ws = () => {
      var I;
      if (e.type === "date")
        return n("div", { class: "grid grid-cols-7 gap-1 overflow-hidden" }, [
          v.value,
          u.value.map((_) => {
            const A = e.range ? d.value.some(
              (N) => he(`${N.getFullYear()}-${N.getMonth() + 1}-${N.getDate()}`, _.date)
            ) : _.number === f.value && a.value === r.value && i.value === s.value, B = n(
              "div",
              {
                class: ["relative transition duration-150 w-auto text-center text-gray-900 z-10"],
                onClick: () => {
                  if (_.allowed) {
                    if (e.range) {
                      Ut(_.number, r.value - 1, i.value);
                      return;
                    }
                    mt(_.number);
                  }
                }
              },
              n(
                "div",
                {
                  class: [
                    "h-8 w-8 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full flex items-center justify-center z-10 hover:text-gray-900",
                    (_ == null ? void 0 : _.notificationText) && b,
                    _ == null ? void 0 : _.highlightClasses
                  ],
                  style: {
                    minWidth: "2rem"
                  },
                  "before-content": _ == null ? void 0 : _.notificationText
                },
                n(
                  "div",
                  {
                    class: [
                      "w-full h-full flex items-center justify-center rounded-full min-w-full",
                      A && "bg-primary-600 dark:bg-primary-500 text-white"
                    ]
                  },
                  n("span", null, _.number)
                )
              )
            );
            return n(
              "button",
              {
                class: [
                  "m-auto w-min justify-items-center h-8 flex items-center justify-center scale-100",
                  !_.allowed && "cursor-not-allowed opacity-40",
                  k.value && Wt(_.date) && "bg-primary-100 dark:bg-primary-500 dark:bg-opacity-30",
                  k.value && !he(d.value[0], d.value[1]) && (he(d.value[0], _.date) && `${m} after:right-0` || he(d.value[1], _.date) && `${m} after:left-0`)
                ],
                type: "button",
                disabled: !_.allowed,
                onClick: () => {
                  !e.range && Zt();
                }
              },
              _.tooltipText ? n(
                tr,
                {
                  ...w,
                  body: _.tooltipText
                },
                {
                  default: () => B
                }
              ) : B
            );
          }),
          P.value
        ]);
      if (e.type === "month")
        return n("div", { class: "grid grid-cols-3 gap-1" }, [
          (I = e.locales[e.locale]) == null ? void 0 : I.months.full.map((_, A) => {
            const B = W(new Date(i.value, A, 1));
            return n(
              "button",
              {
                class: [
                  "transition duration-150 p-1 w-auto text-center rounded-md",
                  B ? M(
                    A + 1 === r.value && i.value === s.value
                  ) : "cursor-not-allowed text-gray-200 dark:text-gray-500"
                ],
                type: "button",
                onClick: () => B ? tt(A) : null
              },
              Fe(_)
            );
          })
        ]);
      if (e.type === "year") {
        const _ = et();
        return n("div", { class: "grid grid-cols-3 gap-1" }, [
          _.map((A) => n(
            "button",
            {
              class: [
                "transition duration-150 p-1 w-auto text-center rounded-md",
                A.allowed ? M(A.value === s.value) : "cursor-not-allowed text-gray-200 dark:text-gray-500"
              ],
              type: "button",
              onClick: () => A.allowed ? Vr(A.value) : null
            },
            A.value
          ))
        ]);
      }
      if (e.type === "quarter") {
        const _ = Te();
        return n("div", { class: "grid grid-cols-2 gap-1" }, [
          _.map((A) => n(
            "button",
            {
              class: [
                "transition duration-150 p-1 w-auto text-center rounded-full",
                A.allowed ? M(
                  A.value === l.value && s.value === i.value
                ) : "cursor-not-allowed text-gray-200 dark:text-gray-500"
              ],
              type: "button",
              onClick: () => A.allowed ? ys(A.value) : null
            },
            Fe(A.title)
          ))
        ]);
      }
      if (e.type === "half-year") {
        const _ = Re();
        return n("div", { class: "grid grid-cols-2 gap-1" }, [
          _.map((A) => n(
            "button",
            {
              class: [
                "transition duration-150 p-1 w-auto text-center rounded-full",
                A.allowed ? M(
                  A.value === o.value && s.value === i.value
                ) : "cursor-not-allowed text-gray-200 dark:text-gray-500"
              ],
              type: "button",
              onClick: () => A.allowed ? xs(A.value) : null
            },
            Fe(A.title)
          ))
        ]);
      }
    };
    e.type === "date" && fe();
    const bt = y(null), Yt = y(null);
    return {
      monthDays: u,
      selectedDay: f,
      selectedYear: i,
      currentYear: s,
      currentMonth: r,
      headerTitle: O,
      showMonthYearDropdown: c,
      yearsToSelect: S,
      dateRange: d,
      setMonth: tt,
      setYear: Vr,
      setPrevMonthDate: Z,
      setNextMonthDate: le,
      renderPickerTemplateByType: ws,
      daysBeforeCurrentMonthDays: v,
      daysAfterCurrentMonthDays: P,
      setCurrentDateDay: mt,
      yearsDropdownRef: bt,
      currentYearRef: Yt,
      toggleMonthYearDropdown: () => {
        c.value = !c.value, ne(() => {
          bt.value && c.value && Yt.value && (bt.value.scrollTop = Yt.value.offsetTop - bt.value.clientHeight / 2);
        });
      },
      rootRefEl: x
    };
  },
  render() {
    var e;
    return n("div", { ref: "rootRefEl", class: "block w-full h-full bg-white dark:bg-gray-700 relative" }, [
      n(
        "div",
        {
          class: "flex justify-between items-center h-12 border-b-2 border-gray-200 dark:border-gray-500 dark:border-opacity-30 mb-1"
        },
        [
          n(
            "button",
            {
              class: "p-2 transition duration-150 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800",
              onClick: () => {
                this.type === "year" && this.setYear(this.selectedYear - 3, !1), (this.type === "month" || this.type === "quarter" || this.type === "half-year") && this.setYear(this.selectedYear - 1, !1), this.type === "date" && this.setPrevMonthDate();
              },
              type: "button"
            },
            [n(Ss, { class: "h-5 w-5 text-gray-700 dark:text-gray-300" })]
          ),
          this.type === "date" ? n("div", { class: "relative" }, [
            n(
              "button",
              {
                class: "transition duration-150 font-semibold hover:bg-gray-100 p-1 px-3 rounded-md dark:text-white dark:hover:bg-gray-800",
                type: "button",
                onClick: () => this.toggleMonthYearDropdown()
              },
              [
                n("span", { class: "flex items-center" }, [
                  this.headerTitle,
                  n(pr, {
                    class: [
                      "transform ease-in-out duration-150 w-5 h-5 ml-1",
                      {
                        "rotate-180": this.showMonthYearDropdown
                      }
                    ]
                  })
                ])
              ]
            ),
            n(
              _e,
              {
                enterActiveClass: "transition ease-out duration-100",
                enterFromClass: "transform opacity-0 scale-95",
                enterToClass: "transform opacity-100 scale-100",
                leaveActiveClass: "transition ease-in duration-75",
                leaveFromClass: "transform opacity-100 scale-100",
                leaveToClass: "transform opacity-0 scale-95"
              },
              {
                default: () => {
                  var t;
                  return this.showMonthYearDropdown ? n(
                    "div",
                    {
                      class: "transition duration-150 w-full absolute flex justify-center mt-1 py-2 border-2 border-gray-200 dark:border-gray-500 rounded-md bg-white dark:bg-gray-700 shadow-lg mx-auto z-20"
                    },
                    [
                      n("div", { class: "grid grid-cols-2 items-center justify-center" }, [
                        n(
                          "div",
                          {
                            class: "max-h-48 overflow-x-hidden overflow-y-auto border-r-2 border-gray-200 dark:border-gray-500 px-2"
                          },
                          [
                            (t = this.locales[this.locale]) == null ? void 0 : t.months.short.map(
                              (r, a) => n(
                                "button",
                                {
                                  class: [
                                    "p-0.5",
                                    a + 1 === this.currentMonth ? "text-primary-600 dark:text-primary-400 font-bold" : "text-gray-700 hover:text-gray-900 dark:text-gray-300 dark:hover:text-gray-100"
                                  ],
                                  type: "button",
                                  onClick: () => this.setMonth(a, !1)
                                },
                                Fe(r)
                              )
                            )
                          ]
                        ),
                        n(
                          "div",
                          {
                            class: "max-h-48 overflow-x-hidden overflow-y-auto px-2",
                            ref: "yearsDropdownRef"
                          },
                          [
                            this.yearsToSelect.map(
                              (r) => n(
                                "button",
                                {
                                  ref: r === this.currentYear ? "currentYearRef" : null,
                                  class: [
                                    "p-0.5",
                                    r === this.selectedYear ? "text-primary-600 dark:text-primary-400 font-bold" : "text-gray-700 hover:text-gray-900 dark:text-gray-300 dark:hover:text-gray-100"
                                  ],
                                  type: "button",
                                  onClick: () => this.setYear(r, !1)
                                },
                                r
                              )
                            )
                          ]
                        )
                      ])
                    ]
                  ) : null;
                }
              }
            )
          ]) : n(
            "span",
            { class: "font-semibold p-1 px-3 rounded-md dark:text-white" },
            this.type === "year" ? this.currentYear : this.selectedYear
          ),
          n(
            "button",
            {
              class: "p-2 transition duration-150 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800",
              type: "button",
              onClick: () => {
                this.type === "year" && this.setYear(this.selectedYear + 3, !1), (this.type === "month" || this.type === "quarter" || this.type === "half-year") && this.setYear(this.selectedYear + 1, !1), this.type === "date" && this.setNextMonthDate();
              }
            },
            [n(_s, { class: "h-5 w-5 text-gray-700 dark:text-gray-300" })]
          )
        ]
      ),
      this.type === "date" ? n("div", { class: "grid grid-cols-7 gap-1" }, [
        (e = this.locales[this.locale]) == null ? void 0 : e.weeks.short.map(
          (t) => n("span", { class: "text-gray-400 dark:text-gray-300 p-2 w-auto text-center" }, t)
        )
      ]) : null,
      this.renderPickerTemplateByType()
    ]);
  }
});
const Oe = {
  props: {
    id: {
      type: String,
      default: () => re("at-datepicker-")
    },
    label: { type: String, default: "" },
    disabled: { type: [Boolean, Number, String], default: !1 },
    error: { type: [Boolean, Number, String, Array], default: !1 },
    success: { type: [Boolean, Number, String], default: !1 },
    clearable: { type: Boolean, default: !1 }
  }
}, Ma = (e, t) => "default" in t.slots ? n(
  e.tag,
  Object.assign({}, t.attrs, {
    class: [
      "text-sm dark:text-white",
      e.mt,
      {
        "text-red-600 dark:text-red-500": e.type === "error",
        "text-green-500 dark:text-green-400": e.type === "success",
        "text-gray-600 dark:text-white": e.type === "muted"
      }
    ].concat("class" in t.attrs ? t.attrs.class : "")
  }),
  t.slots.default()
) : null;
Ma.props = {
  tag: { type: String, default: "p" },
  type: {
    type: String,
    default: "muted",
    validator: (e) => e === "normal" || e === "error" || e === "success" || e === "muted"
  },
  mt: { type: [String, Number], default: "mt-1" }
};
const Le = Ma, Da = (e, t) => "default" in t.slots ? n(
  "div",
  Object.assign({}, t.attrs, {
    class: [
      "text-sm leading-5 flex-grow",
      {
        "ml-3": e.position === "left",
        "mr-3": e.position === "right"
      }
    ].concat("class" in t.attrs ? t.attrs.class : "")
  }),
  [
    n(
      "label",
      {
        class: [
          "font-medium text-gray-700 dark:text-white",
          {
            "cursor-pointer": !e.disabled,
            "cursor-not-allowed": e.disabled
          }
        ],
        for: e.id
      },
      [n(Le, { mt: 0 }, { default: () => t.slots.default() })]
    )
  ]
) : null;
Da.props = {
  id: { type: String, default: () => re("at-switch-") },
  position: {
    type: String,
    default: "left",
    validator: (e) => e === "left" || e === "right"
  },
  disabled: { type: [Boolean, Number, String], default: !1 }
};
const al = Da, ot = (e, t) => e ? [
  "border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500",
  "dark:border-red-500 dark:text-red-500 dark:placeholder-red-400 dark:focus:ring-red-600 dark:focus:border-red-600"
] : t ? [
  "border-green-300 text-green-900 placeholder-green-300 focus:ring-green-500 focus:border-green-500",
  "dark:border-green-500 dark:text-green-500 dark:placeholder-green-400 dark:focus:ring-green-600 dark:focus:border-green-600"
] : [
  "text-gray-700 placeholder-gray-600 focus:ring-primary-500 focus:border-primary-500 border-gray-300",
  "dark:text-white dark:placeholder-gray-400 dark:focus:ring-primary-600 dark:focus:border-primary-600 dark:border-gray-600"
], He = (e, t) => e ? "error" : t ? "success" : "muted", $a = (e, t) => {
  const r = F(e.disabled);
  return n(
    "div",
    {
      class: ["block w-full"].concat("class" in t.attrs ? t.attrs.class : {})
    },
    [
      n(
        "div",
        {
          class: ["relative flex items-start", { "cursor-not-allowed": r }]
        },
        [
          n("div", { class: "flex items-center h-5" }, [
            n("input", {
              class: [
                "border-gray-300 rounded h-4 w-4 transition duration-150 ease-in-out",
                !e.error && !e.success ? [
                  "text-primary-600",
                  "focus:ring",
                  "focus:ring-primary-500",
                  "focus:border-primary-300",
                  "dark:text-primary-500",
                  "dark:focus:ring-offset-gray-900",
                  "dark:focus:ring-primary-600",
                  "dark:focus:border-primary-400"
                ] : "",
                {
                  "cursor-pointer": !r,
                  "cursor-not-allowed": r,
                  "border-red-300 text-red-500 focus:ring-red-500 dark:border-red-500 dark:text-red-500 dark:focus:ring-red-400 dark:focus:ring-offset-gray-900": e.error,
                  "border-green-500 text-green-500 focus:ring-green-500 dark:border-green-500 dark:text-green-500 dark:focus:ring-green-400 dark:focus:ring-offset-gray-900": e.success
                }
              ],
              type: "checkbox",
              checked: F(e.modelValue),
              disabled: r,
              id: e.id,
              onInput: (a) => {
                a.stopPropagation(), "target" in a && Object.prototype.toString.call(a.target) === "[object HTMLInputElement]" && "checked" in a.target && t.emit("update:modelValue", a.target.checked);
              }
            })
          ]),
          e.label || "default" in t.slots ? n(
            al,
            { id: e.id, disabled: r },
            {
              default: () => [
                e.label,
                "default" in t.slots ? n(
                  "span",
                  {
                    class: "text-gray-500 block font-normal dark:text-gray-300"
                  },
                  t.slots.default()
                ) : null
              ]
            }
          ) : null
        ]
      ),
      e.error ? n(
        Le,
        { type: He(e.error, e.success), mt: null },
        { default: () => e.error }
      ) : null
    ]
  );
};
$a.props = {
  ...Oe.props,
  id: { type: String, default: () => re("at-checkbox-") },
  modelValue: { type: [Boolean, String, Number], default: !1 }
};
const nl = $a, ja = (e, t) => n(
  e.tag,
  Object.assign({}, t.attrs, {
    class: ["cursor-pointer inline-block"].concat("class" in t.attrs ? t.attrs.class : [""]),
    onClick: (r) => {
      if (r.stopPropagation(), typeof document < "u" && "createElement" in document && "execCommand" in document) {
        const a = document.createElement("textarea");
        a.style.listStyle = "position:absolute;left:-999999px;top:-999999px", a.innerText = e.value, document.body.appendChild(a), "select" in a && (a.select(), "setSelectionRange" in a && a.setSelectionRange(0, e.value.length), document.execCommand("copy"), t.emit("copy")), document.body.removeChild(a);
      }
    }
  }),
  "default" in t.slots ? t.slots.default() : null
);
ja.props = {
  tag: { type: String, default: "div" },
  value: { type: String, required: !0 }
};
const No = ja, Kr = (e, t = "left") => {
  const { Icon: r } = de(e);
  return n(
    "div",
    {
      class: [
        "absolute inset-y-0 flex items-center pointer-events-none",
        t === "left" ? "left-0 pl-3" : "right-0 pr-3"
      ]
    },
    [n(r, { class: "h-5 w-5 text-gray-400 dark:text-white", "aria-hidden": !0 })]
  );
}, Ea = (e, { slots: t }) => {
  var a, s, i, l;
  const r = "default" in t ? (l = (i = (s = (a = t.default) == null ? void 0 : a.call(t)) == null ? void 0 : s[0]) == null ? void 0 : i.type) == null ? void 0 : l.name : "";
  return n(
    "div",
    {
      class: [
        {
          "border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700": r !== "AtButton"
        },
        "inline-flex items-center sm:text-sm",
        e.side === "left" ? "rounded-l-md border-r-0" : "rounded-r-md border-l-0",
        { "px-3": r !== "AtButton" && !e.select }
      ]
    },
    t.default()
  );
};
Ea.props = {
  select: { type: Boolean, default: !1 },
  side: {
    type: String,
    default: "left",
    validator: (e) => e === "left" || e === "right"
  }
};
const or = Ea, sl = [
  "focus",
  "focusin",
  "focusout",
  "blur",
  "input",
  "change",
  "select",
  "search",
  "cut",
  "paste",
  "copy"
], rr = (e, t) => {
  const r = {};
  for (const a of sl) {
    const s = `on${a.toString().substr(0, 1).toUpperCase()}${a.toString().substr(1)}`;
    t && s in t && (r[s] = (...i) => e(a, ...i));
  }
  return r;
};
var ll = Object.defineProperty, il = (e, t, r) => t in e ? ll(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, qr = (e, t, r) => (il(e, typeof t != "symbol" ? t + "" : t, r), r);
const ie = {
  debug: !1,
  masked: !1,
  prefix: "",
  suffix: "",
  thousands: ",",
  decimal: ".",
  precision: 2,
  disableNegative: !1,
  disabled: !1,
  min: null,
  max: null,
  allowBlank: !1,
  minimumNumberOfCharacters: 0,
  modelModifiers: {
    number: !1
  },
  shouldRound: !0,
  focusOnRight: !1
}, Ba = ["+", "-"], La = ["decimal", "thousands", "prefix", "suffix"];
function Ce(e) {
  return Math.max(0, Math.min(e, 1e3));
}
function At(e, t) {
  return e = e.padStart(t + 1, "0"), t === 0 ? e : `${e.slice(0, -t)}.${e.slice(-t)}`;
}
function Ra(e) {
  return e = e ? e.toString() : "", e.replace(/\D+/g, "") || "0";
}
function ol(e, t) {
  return e.replace(/(\d)(?=(?:\d{3})+\b)/gm, `$1${t}`);
}
function ul(e, t, r) {
  return t ? e + r + t : e;
}
function rt(e, t) {
  return Ba.includes(e) ? (console.warn(`v-money3 "${t}" property don't accept "${e}" as a value.`), !1) : /\d/g.test(e) ? (console.warn(`v-money3 "${t}" property don't accept "${e}" (any number) as a value.`), !1) : !0;
}
function dl(e) {
  for (const t of La)
    if (!rt(e[t], t))
      return !1;
  return !0;
}
function Tt(e) {
  for (const t of La) {
    e[t] = e[t].replace(/\d+/g, "");
    for (const r of Ba)
      e[t] = e[t].replaceAll(r, "");
  }
  return e;
}
function Na(e) {
  const t = e.length, r = e.indexOf(".");
  return t - (r + 1);
}
function Qr(e) {
  return e.replace(/^(-?)0+(?!\.)(.+)/, "$1$2");
}
function Va(e) {
  return /^-?[\d]+$/g.test(e);
}
function Fa(e) {
  return /^-?[\d]+(\.[\d]+)$/g.test(e);
}
function ea(e, t, r) {
  return t > e.length - 1 ? e : e.substring(0, t) + r + e.substring(t + 1);
}
function Ga(e, t) {
  const r = t - Na(e);
  if (r >= 0)
    return e;
  let a = e.slice(0, r);
  const s = e.slice(r);
  if (a.charAt(a.length - 1) === "." && (a = a.slice(0, -1)), parseInt(s.charAt(0), 10) >= 5) {
    for (let i = a.length - 1; i >= 0; i -= 1) {
      const l = a.charAt(i);
      if (l !== "." && l !== "-") {
        const o = parseInt(l, 10) + 1;
        if (o < 10)
          return ea(a, i, o);
        a = ea(a, i, "0");
      }
    }
    return `1${a}`;
  }
  return a;
}
function za(e, t) {
  const r = () => {
    e.setSelectionRange(t, t);
  };
  e === document.activeElement && (r(), setTimeout(r, 1));
}
function Ha(e) {
  return new Event(e, { bubbles: !0, cancelable: !1 });
}
function L({ debug: e = !1 }, ...t) {
  e && console.log(...t);
}
let Ua = class Wa {
  constructor(t) {
    qr(this, "number", 0n), qr(this, "decimal", 0), this.setNumber(t);
  }
  getNumber() {
    return this.number;
  }
  getDecimalPrecision() {
    return this.decimal;
  }
  setNumber(t) {
    this.decimal = 0, typeof t == "bigint" ? this.number = t : typeof t == "number" ? this.setupString(t.toString()) : this.setupString(t);
  }
  toFixed(t = 0, r = !0) {
    let a = this.toString();
    const s = t - this.getDecimalPrecision();
    return s > 0 ? (a.includes(".") || (a += "."), a.padEnd(a.length + s, "0")) : s < 0 ? r ? Ga(a, t) : a.slice(0, s) : a;
  }
  toString() {
    let t = this.number.toString();
    if (this.decimal) {
      let r = !1;
      return t.charAt(0) === "-" && (t = t.substring(1), r = !0), t = t.padStart(t.length + this.decimal, "0"), t = `${t.slice(0, -this.decimal)}.${t.slice(-this.decimal)}`, t = Qr(t), (r ? "-" : "") + t;
    }
    return t;
  }
  lessThan(t) {
    const [r, a] = this.adjustComparisonNumbers(t);
    return r < a;
  }
  biggerThan(t) {
    const [r, a] = this.adjustComparisonNumbers(t);
    return r > a;
  }
  isEqual(t) {
    const [r, a] = this.adjustComparisonNumbers(t);
    return r === a;
  }
  setupString(t) {
    if (t = Qr(t), Va(t))
      this.number = BigInt(t);
    else if (Fa(t))
      this.decimal = Na(t), this.number = BigInt(t.replace(".", ""));
    else
      throw new Error(`BigNumber has received and invalid format for the constructor: ${t}`);
  }
  adjustComparisonNumbers(t) {
    let r;
    t.constructor.name !== "BigNumber" ? r = new Wa(t) : r = t;
    const a = this.getDecimalPrecision() - r.getDecimalPrecision();
    let s = this.getNumber(), i = r.getNumber();
    return a > 0 ? i = r.getNumber() * 10n ** BigInt(a) : a < 0 && (s = this.getNumber() * 10n ** BigInt(a * -1)), [s, i];
  }
};
function ur(e, t = ie, r = "") {
  if (L(t, "utils format() - caller", r), L(t, "utils format() - input1", e), e == null)
    e = "";
  else if (typeof e == "number")
    t.shouldRound ? e = e.toFixed(Ce(t.precision)) : e = e.toFixed(Ce(t.precision) + 1).slice(0, -1);
  else if (t.modelModifiers && t.modelModifiers.number && Va(e))
    e = Number(e).toFixed(Ce(t.precision));
  else if (!t.disableNegative && e === "-")
    return e;
  L(t, "utils format() - input2", e);
  const a = t.disableNegative ? "" : e.indexOf("-") >= 0 ? "-" : "";
  let s = e.replace(t.prefix, "").replace(t.suffix, "");
  L(t, "utils format() - filtered", s), !t.precision && t.thousands !== "." && Fa(s) && (s = Ga(s, 0), L(t, "utils format() - !opt.precision && isValidFloat()", s));
  const i = Ra(s);
  L(t, "utils format() - numbers", i), L(t, "utils format() - numbersToCurrency", a + At(i, t.precision));
  const l = new Ua(a + At(i, t.precision));
  L(t, "utils format() - bigNumber1", l.toString()), t.max && l.biggerThan(t.max) && l.setNumber(t.max), t.min && l.lessThan(t.min) && l.setNumber(t.min);
  const o = l.toFixed(Ce(t.precision), t.shouldRound);
  if (L(t, "utils format() - bigNumber2", l.toFixed(Ce(t.precision))), /^0(\.0+)?$/g.test(o) && t.allowBlank)
    return "";
  let [u, c] = o.split(".");
  const f = c !== void 0 ? c.length : 0;
  u = u.padStart(t.minimumNumberOfCharacters - f, "0"), u = ol(u, t.thousands);
  const h = t.prefix + ul(u, c, t.decimal) + t.suffix;
  return L(t, "utils format() - output", h), h;
}
function dr(e, t = ie, r = "") {
  if (L(t, "utils unformat() - caller", r), L(t, "utils unformat() - input", e), !t.disableNegative && e === "-")
    return L(t, "utils unformat() - return netagive symbol", e), e;
  const a = t.disableNegative ? "" : e.indexOf("-") >= 0 ? "-" : "", s = e.replace(t.prefix, "").replace(t.suffix, "");
  L(t, "utils unformat() - filtered", s);
  const i = Ra(s);
  L(t, "utils unformat() - numbers", i);
  const l = new Ua(a + At(i, t.precision));
  L(t, "utils unformat() - bigNumber1", i.toString()), t.max && l.biggerThan(t.max) && l.setNumber(t.max), t.min && l.lessThan(t.min) && l.setNumber(t.min);
  let o = l.toFixed(Ce(t.precision), t.shouldRound);
  return t.modelModifiers && t.modelModifiers.number && (o = parseFloat(o)), L(t, "utils unformat() - output", o), o;
}
const cr = (e, t, r) => {
  if (L(t, "directive setValue() - caller", r), !dl(t)) {
    L(t, "directive setValue() - validateRestrictedOptions() return false. Stopping here...", e.value);
    return;
  }
  let a = e.value.length - (e.selectionEnd || 0);
  e.value = ur(e.value, t, r), a = Math.max(a, t.suffix.length), a = e.value.length - a, a = Math.max(a, t.prefix.length), za(e, a), e.dispatchEvent(Ha("change"));
}, ta = (e, t) => {
  const r = e.currentTarget, a = e.code === "Backspace" || e.code === "Delete", s = r.value.length - (r.selectionEnd || 0) === 0;
  if (L(t, "directive onkeydown() - el.value", r.value), L(t, "directive onkeydown() - backspacePressed", a), L(t, "directive onkeydown() - isAtEndPosition", s), t.allowBlank && a && s && dr(r.value, t, "directive onkeydown allowBlank") === 0 && (L(t, 'directive onkeydown() - set el.value = ""', r.value), r.value = "", r.dispatchEvent(Ha("change"))), L(t, "directive onkeydown() - e.key", e.key), e.key === "+") {
    L(t, "directive onkeydown() - unformat el.value", r.value);
    let i = dr(r.value, t, "directive onkeydown +");
    typeof i == "string" && (i = parseFloat(i)), i < 0 && (r.value = String(i * -1));
  }
}, ra = (e, t) => {
  const r = e.currentTarget;
  L(t, "directive oninput()", r.value), /^[1-9]$/.test(r.value) && (r.value = At(r.value, Ce(t.precision)), L(t, "directive oninput() - is 1-9", r.value)), cr(r, t, "directive oninput");
}, aa = (e, t) => {
  const r = e.currentTarget;
  L(t, "directive onFocus()", r.value), t.focusOnRight && za(r, r.value.length - t.suffix.length);
}, cl = {
  mounted(e, t) {
    if (!t.value)
      return;
    const r = Tt({ ...ie, ...t.value });
    if (L(r, "directive mounted() - opt", r), e.tagName.toLocaleUpperCase() !== "INPUT") {
      const a = e.getElementsByTagName("input");
      a.length !== 1 || (e = a[0]);
    }
    e.onkeydown = (a) => {
      ta(a, r);
    }, e.oninput = (a) => {
      ra(a, r);
    }, e.onfocus = (a) => {
      aa(a, r);
    }, L(r, "directive mounted() - el.value", e.value), cr(e, r, "directive mounted");
  },
  updated(e, t) {
    if (!t.value)
      return;
    const r = Tt({ ...ie, ...t.value });
    e.onkeydown = (a) => {
      ta(a, r);
    }, e.oninput = (a) => {
      ra(a, r);
    }, e.onfocus = (a) => {
      aa(a, r);
    }, L(r, "directive updated() - el.value", e.value), L(r, "directive updated() - opt", r), cr(e, r, "directive updated");
  },
  beforeUnmount(e) {
    e.onkeydown = null, e.oninput = null, e.onfocus = null;
  }
}, fl = ["id", "value", "disabled"], hl = {
  inheritAttrs: !1,
  name: "Money3",
  directives: {
    money3: cl
  }
}, gl = /* @__PURE__ */ D({
  ...hl,
  props: {
    debug: {
      required: !1,
      type: Boolean,
      default: !1
    },
    id: {
      required: !1,
      type: [Number, String],
      default: () => {
        const e = xa();
        return e ? e.uid : null;
      }
    },
    modelValue: {
      required: !0,
      type: [Number, String]
    },
    modelModifiers: {
      required: !1,
      type: Object,
      default: () => ({ number: !1 })
    },
    masked: {
      type: Boolean,
      default: !1
    },
    precision: {
      type: Number,
      default: () => ie.precision
    },
    decimal: {
      type: String,
      default: () => ie.decimal,
      validator(e) {
        return rt(e, "decimal");
      }
    },
    thousands: {
      type: String,
      default: () => ie.thousands,
      validator(e) {
        return rt(e, "thousands");
      }
    },
    prefix: {
      type: String,
      default: () => ie.prefix,
      validator(e) {
        return rt(e, "prefix");
      }
    },
    suffix: {
      type: String,
      default: () => ie.suffix,
      validator(e) {
        return rt(e, "suffix");
      }
    },
    disableNegative: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    max: {
      type: [Number, String],
      default: () => ie.max
    },
    min: {
      type: [Number, String],
      default: () => ie.min
    },
    allowBlank: {
      type: Boolean,
      default: () => ie.allowBlank
    },
    minimumNumberOfCharacters: {
      type: Number,
      default: () => ie.minimumNumberOfCharacters
    },
    shouldRound: {
      type: Boolean,
      default: () => ie.shouldRound
    },
    focusOnRight: {
      type: Boolean,
      default: () => ie.focusOnRight
    }
  },
  emits: ["update:model-value"],
  setup(e, { emit: t }) {
    const r = e, { modelValue: a, modelModifiers: s, masked: i, precision: l, shouldRound: o, focusOnRight: u } = $e(r);
    L(r, "component setup()", r);
    let c = a.value;
    (r.disableNegative || c !== "-") && s.value && s.value.number && (o.value ? c = Number(a.value).toFixed(Ce(l.value)) : c = Number(a.value).toFixed(Ce(l.value) + 1).slice(0, -1));
    const f = y(ur(c, r, "component setup"));
    L(r, "component setup() - data.formattedValue", f.value), G(a, h);
    function h(m) {
      L(r, "component watch() -> value", m);
      const b = ur(
        m,
        Tt({ ...r }),
        "component watch"
      );
      b !== f.value && (L(r, "component watch() changed -> formatted", b), f.value = b);
    }
    let d = null;
    function g(m) {
      let b = m.target.value;
      L(r, "component change() -> evt.target.value", b), i.value && !s.value.number || (b = dr(
        b,
        Tt({ ...r }),
        "component change"
      )), b !== d && (d = b, L(r, "component change() -> update:model-value", b), t("update:model-value", b));
    }
    const p = Es(), x = C(() => {
      const m = {
        ...p
      };
      return delete m["onUpdate:modelValue"], m;
    });
    return (m, b) => {
      const w = lt("money3");
      return Ke((wa(), Bs("input", Ls({
        id: `${e.id}`
      }, Ge(x), {
        type: "tel",
        class: "v-money3",
        value: f.value,
        disabled: r.disabled,
        onChange: g
      }), null, 16, fl)), [
        [w, {
          precision: Ge(l),
          decimal: r.decimal,
          thousands: r.thousands,
          prefix: r.prefix,
          suffix: r.suffix,
          disableNegative: r.disableNegative,
          min: r.min,
          max: r.max,
          allowBlank: r.allowBlank,
          minimumNumberOfCharacters: r.minimumNumberOfCharacters,
          debug: r.debug,
          modelModifiers: Ge(s),
          shouldRound: Ge(o),
          focusOnRight: Ge(u)
        }]
      ]);
    };
  }
}), pl = br(() => import("./InputMask-114c9b4c.mjs")), ml = br(() => Promise.resolve().then(() => $n)), st = D({
  name: "AtInput",
  props: {
    ...Oe.props,
    id: { type: String, default: () => re("at-input-") },
    modelValue: { type: [String, Number, Date], default: "" },
    label: { type: String, default: "" },
    type: { type: String, default: "text" },
    name: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    helpText: { type: String, default: "" },
    hint: { type: String, default: "" },
    addOn: { type: String, default: "" },
    addOnBeforeSelect: { type: Boolean, default: !1 },
    addOnAfterSelect: { type: Boolean, default: !1 },
    iconBefore: { type: [String, Object], default: () => "" },
    iconAfter: { type: [String, Object], default: () => "" },
    mask: { type: [String, Array], default: "" },
    masked: { type: Boolean, default: !1 },
    pattern: { type: String, default: null },
    money: { type: Object, default: null }
  },
  setup(e, { slots: t }) {
    const r = y(null), a = "addOnBefore" in t, s = "addOnAfter" in t, i = "trailingButton" in t;
    return {
      addOnRef: r,
      addOnBeforeExist: a,
      addOnAfterExist: s,
      trailingButtonExist: i
    };
  },
  render() {
    var a, s;
    const e = F(this.disabled), t = {
      class: [
        "transition duration-200 shadow-sm block w-full sm:text-sm placeholder-opacity-100 placeholder-gray-600",
        "dark:text-white dark:placeholder-gray-400",
        ot(this.error, this.success),
        {
          "rounded-md": !this.addOnBeforeExist && !this.addOnAfterExist && !this.trailingButtonExist,
          "rounded-none rounded-r-md": this.addOnBeforeExist && !this.addOnAfterExist && !this.trailingButtonExist,
          "rounded-none rounded-l-md": (this.addOnAfterExist || this.trailingButtonExist) && !this.addOnBeforeExist,
          "pl-10": this.iconBefore,
          "pr-10": this.iconAfter || this.clearable,
          "pr-14": this.modelValue && this.iconAfter && this.clearable,
          "dark:bg-gray-700": !e,
          "bg-gray-50 dark:bg-gray-600 cursor-not-allowed": e
        }
      ],
      pattern: this.pattern,
      style: this.addOnRef ? `padding-left: ${this.addOnRef.clientWidth + 4 || 16}px` : void 0,
      name: this.name,
      placeholder: this.placeholder,
      id: this.id,
      type: this.type,
      disabled: e
    }, r = this.mask ? n(
      pl,
      Object.assign({}, t, rr(this.$emit, this.$attrs), {
        modelValue: this.modelValue,
        mask: this.mask,
        masked: this.masked,
        "onUpdate:modelValue": (i) => this.$emit("update:modelValue", i)
      })
    ) : this.money ? n(
      gl,
      Object.assign({}, t, { ...this.money }, rr(this.$emit, this.$attrs), {
        modelValue: this.modelValue,
        "onUpdate:modelValue": (i) => this.$emit("update:modelValue", i)
      })
    ) : n(
      "input",
      Object.assign({}, t, rr(this.$emit, this.$attrs), {
        value: this.modelValue,
        onInput: (i) => this.$emit("update:modelValue", i.target.value)
      })
    );
    return n("div", [
      n("div", { class: "flex justify-between items-center" }, [
        // Input label
        "label" in this.$slots ? this.$slots.label() : this.label ? n(ml, null, { default: () => this.label }) : null,
        // Hint
        this.hint ? n(
          "span",
          {
            class: "text-sm text-gray-500 dark:text-gray-300",
            id: `${this.id}-optional`
          },
          this.hint
        ) : null
      ]),
      n(
        "div",
        {
          class: [
            {
              "relative rounded-md shadow-sm": this.error || this.iconAfter || this.clearable || this.iconBefore || this.addOn,
              flex: this.addOnBeforeExist || this.trailingButtonExist || this.addOnAfterExist
            }
          ]
        },
        [
          // Icon before input
          this.iconBefore ? Kr(this.iconBefore, "left") : null,
          // Inline addOn
          this.addOn ? n(
            "div",
            {
              class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none",
              ref: this.addOnRef
            },
            [n("span", { class: "text-gray-500 dark:text-gray-300 sm:text-sm" }, this.addOn)]
          ) : null,
          // AddOn on left side
          this.addOnBeforeExist ? n(or, { select: this.addOnBeforeSelect }, { default: () => this.$slots.addOnBefore() }) : null,
          // Input element
          n("div", { class: "relative w-full" }, [
            r,
            this.error ? n(
              "div",
              {
                class: ["absolute inset-y-0 right-0 flex items-center pointer-events-none pr-3"]
              },
              [n(As, { class: "h-5 w-5 text-red-500", "aria-hidden": !0 })]
            ) : null
          ]),
          this.trailingButtonExist ? n(
            "button",
            {
              type: "button",
              class: [
                "-ml-px relative inline-flex items-center space-x-2 px-4 py-2 text-sm font-medium rounded-r-md ",
                "border border-gray-300 text-gray-700",
                "dark:border-gray-600 dark:text-white",
                {
                  "bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-900 dark:hover:bg-gray-800 dark:focus:ring-primary-400 dark:focus:border-primary-400": !e,
                  "bg-gray-100 dark:bg-gray-800 cursor-not-allowed": e
                }
              ],
              onClick: () => e ? null : this.$emit("trailingButtonClick")
            },
            (s = (a = this.$slots).trailingButton) == null ? void 0 : s.call(a)
          ) : null,
          // AddOn after input
          this.addOnAfterExist ? n(
            or,
            { select: this.addOnAfterSelect, side: "right" },
            { default: () => this.$slots.addOnAfter() }
          ) : null,
          // Icon after input
          this.iconAfter && !this.error ? Kr(this.iconAfter, "right") : null,
          this.modelValue && this.clearable ? n(
            "button",
            {
              type: "button",
              disabled: !this.modelValue,
              class: this.iconAfter && this.modelValue ? "absolute right-9" : "absolute right-3",
              onClick: (i) => {
                i.preventDefault(), i.stopPropagation(), this.$emit("update:modelValue", null), this.$emit("clear");
              },
              style: "bottom: 9px"
            },
            n(jt, { class: "w-5 h-5 text-gray-400" })
          ) : null
        ]
      ),
      // Error message and help text printing
      this.error || this.helpText ? n(
        Le,
        { type: He(this.error, this.success) },
        { default: () => this.helpText || this.error }
      ) : null
    ]);
  }
}), ut = {
  "click-outside": {
    beforeMount: (e, t) => {
      e.clickOutsideEvent = (r) => {
        ne(() => {
          if (e !== void 0) {
            const a = (r == null ? void 0 : r.path) || (r != null && r.composedPath ? r == null ? void 0 : r.composedPath() : void 0);
            (a ? a.indexOf(e) < 0 : !e.contains(r.target)) && t.value(r);
          }
        });
      }, document.addEventListener("click", e.clickOutsideEvent);
    },
    unmounted: (e) => {
      document.removeEventListener("click", e.clickOutsideEvent);
    }
  }
}, Za = (e) => {
  const t = y(0);
  return {
    scrollPercent: t,
    listener: (a) => {
      if (a != null && a.target) {
        const s = a.target, i = s.clientHeight, l = s.scrollHeight, o = s.scrollTop;
        t.value = (o + i) / l * 100, e(t);
      }
    }
  };
}, bl = 95, na = D({
  name: "AtDataList",
  emits: ["update:modelValue", "search", "scrollToBottom", "open", "close", "create"],
  props: {
    ...Oe.props,
    data: { type: Array, default: () => [] },
    modelValue: { type: [String, Number], default: "" },
    valueType: { type: [String, Number], default: "value" },
    valueToPrint: { type: [String, Number], default: "title" },
    iconBefore: { type: [String, Object], default: null },
    iconAfter: { type: [String, Object], default: null },
    noDataText: { type: String, default: "Ничего не найдено" },
    label: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    loading: { type: Boolean, default: !1 },
    externalSearch: { type: Boolean, default: !1 },
    clearable: { type: Boolean, default: !1 },
    createButtonText: { type: String, default: "Добавить вариант" },
    creatable: { type: Boolean, default: !1 }
  },
  directives: { ...ut },
  setup(e, { emit: t, attrs: r }) {
    const a = lt("click-outside"), s = () => {
      d.value.trim() !== "" && (t("create", d.value.trim()), d.value = "");
    }, i = () => {
      var v, P;
      l.value && (l.value = !1, d.value !== ((v = u.value) == null ? void 0 : v[e.valueToPrint]) && (d.value = ((P = u.value) == null ? void 0 : P[e.valueToPrint]) || e.modelValue), h.value && (h.value = !1, t("search", "")));
    }, l = y(!1), o = () => {
      l.value = !0;
    }, u = y({}), c = C(() => {
      let v = e.data;
      return h.value && !e.externalSearch && (v = e.data.filter(
        (P) => {
          var O, $;
          return ($ = P == null ? void 0 : P[e.valueToPrint]) == null ? void 0 : $.toLowerCase().includes((O = d.value) == null ? void 0 : O.toLowerCase());
        }
      )), v;
    }), f = (v) => {
      u.value = v, t("update:modelValue", v[e.valueType]), h.value && (h.value = !1, t("search", ""));
    }, h = y(!1), d = y(null), g = C(() => e.externalSearch ? 500 : 0), p = (v) => {
      d.value = v, b.value = !1, x(v);
    }, x = Pa((v) => {
      h.value = !!v, t("search", v), r.onOnSearch && t("onSearch", v);
    }, g.value), m = () => {
      var v, P;
      ((v = u.value) == null ? void 0 : v[e.valueType]) != e.modelValue && (u.value = (P = e.data) == null ? void 0 : P.find((O) => (O == null ? void 0 : O[e.valueType]) == e.modelValue));
    }, b = y(!1), w = (v) => {
      v.value >= bl ? !e.loading && !b.value && (b.value = !0, t("scrollToBottom", {
        query: h.value ? d.value : null
      })) : e.loading || (b.value = !1);
    }, { listener: k } = Za(w), S = () => {
      t("update:modelValue", null), d.value = null;
    };
    return G(
      u,
      (v) => {
        d.value = (v == null ? void 0 : v[e.valueToPrint]) || e.modelValue;
      },
      { immediate: !0 }
    ), G([() => e.loading, () => e.data], ([v]) => {
      !v && b.value && (b.value = !1), v || m();
    }), G(() => e.modelValue, m, { immediate: !0 }), G(l, (v) => {
      t(v ? "open" : "close");
    }), vr(() => {
      r.onOnSearch && console.error(
        "[AtUI]: Событие `@onSearch` вскоре не будет поддерживаться, вместо этого используйте событие `@search`"
      );
    }), {
      showDataList: l,
      clickOutsideHandler: i,
      clickOutside: a,
      onFocus: o,
      options: c,
      inputValue: d,
      onInput: p,
      selectOption: f,
      selectedOption: u,
      inSearch: h,
      scrolledToBottom: b,
      listener: k,
      handleClear: S,
      create: s
    };
  },
  render() {
    return n("div", { class: "relative border-0 p-0" }, [
      n("div", { class: "relative flex" }, [
        Ke(
          n(st, {
            class: ["w-full"],
            modelValue: this.inputValue,
            label: this.label,
            type: "text",
            placeholder: this.placeholder,
            disabled: !!this.disabled,
            error: this.error,
            iconBefore: this.iconBefore,
            iconAfter: this.iconAfter,
            success: this.success,
            onFocus: this.onFocus,
            clearable: this.clearable,
            createButtonText: this.createButtonText,
            creatable: this.creatable,
            "onUpdate:modelValue": this.onInput,
            onClear: this.handleClear
          }),
          [[this.clickOutside, this.clickOutsideHandler]]
        )
      ]),
      this.showDataList ? n(
        "div",
        {
          class: "absolute w-full mt-2 py-2 border-2 border-gray-200 rounded-md bg-white max-h-80 overflow-y-auto shadow-lg dark:bg-gray-700 dark:border-gray-600",
          style: {
            zIndex: Ae.low
          },
          onScroll: this.listener
        },
        [
          n(
            "ul",
            {
              class: "divide-y divide-gray-200 dark:divide-gray-600"
            },
            this.options.length && (!this.loading || this.scrolledToBottom) ? this.options.map(
              (e) => n(
                "li",
                {
                  class: [
                    "block px-4 py-2 text-sm text-gray-700 cursor-pointer hover:text-gray-900 hover:bg-gray-100 dark:text-white dark:hover:text-white dark:hover:bg-gray-800"
                  ],
                  onClick: () => this.selectOption(e)
                },
                "option" in this.$slots ? this.$slots.option({ option: e }) : e[this.valueToPrint]
              )
            ) : null
          ),
          !this.loading && !this.options.length ? [
            n("div", { class: "py-2 block text-center text-sm" }, [this.noDataText]),
            this.creatable ? n("div", { class: "flex items-center px-2" }, [
              n(
                Bt,
                {
                  class: "w-full",
                  color: "primary",
                  onClick: this.create
                },
                {
                  default: () => this.createButtonText
                }
              )
            ]) : null
          ] : null,
          "loading" in this.$slots ? this.$slots.loading() : this.loading && n("div", { class: "flex justify-center items-center py-3" }, n(nt))
        ]
      ) : null
    ]);
  }
}), vl = {
  1: "1 квартал",
  2: "2 квартал",
  3: "3 квартал",
  4: "4 квартал"
}, yl = {
  1: "Первое полугодие",
  2: "Второе полугодие"
}, Vo = D({
  name: "AtDatepicker",
  emits: ["update:modelValue"],
  props: {
    ...Oe.props,
    ...Oa.props,
    format: { type: String, default: "dd-mmm-yyyy" },
    id: { type: String, default: () => re("at-datepicker-") },
    modelValue: { type: [String, Date, Array], default: /* @__PURE__ */ new Date() },
    label: { type: String, default: "" },
    placeholder: { type: String, default: "Выберите дату" },
    helpText: { type: String, default: "" },
    position: { type: String, default: "left", validator: (e) => e === "left" || e === "right" },
    valueFormat: { type: String, default: void 0 },
    hint: { type: String, default: "" },
    teleport: { type: Boolean, default: !1 },
    teleportToRef: { type: Object, default: null },
    teleportToSelector: { type: String, default: "body" },
    offset: {
      type: Array,
      default: () => [0, 0]
    },
    placement: {
      type: String,
      default: "bottom",
      validator: (e) => e && ["bottom", "top", "left", "right"].includes(e)
    },
    alignment: {
      type: String,
      default: "start",
      validator: (e) => e && ["start", "center", "end"].includes(e)
    }
  },
  directives: { ...ut },
  setup(e, { emit: t }) {
    const r = y(!1), a = $e(e).modelValue;
    let s = y("");
    const i = y(null), l = lt("click-outside"), o = y(null), u = y(null), { x: c, y: f, updatePosition: h, destroyAutoFloating: d } = Qe(o, u, {
      autoFloating: !0,
      placement: e.placement,
      alignment: e.alignment,
      offset: e.offset
    });
    X(() => {
      h();
    }), G([() => u.value, () => o.value], () => {
      h();
    }), qe(() => {
      d();
    }), G(
      a,
      (m) => {
        if (s.value = "", m)
          if (!e.range)
            s.value = "", s.value = g(e.modelValue);
          else {
            const b = e.modelValue[0] ? g(e.modelValue[0]) : g(/* @__PURE__ */ new Date()), w = e.modelValue[1] ? g(e.modelValue[1]) : g(/* @__PURE__ */ new Date());
            e.type === "date" ? e.modelValue.length === 2 && (s.value = `${b} – ${w}`) : s.value = b;
          }
      },
      { deep: e.range, immediate: !0 }
    );
    function g(m) {
      let b = "";
      const w = e.format.match(/\w+/g), k = e.format.match(/\W+/g);
      if (e.type === "month")
        b = Fe(Ts[new Date(m).getMonth()]);
      else if (e.type === "year")
        b = new Date(m).getFullYear().toString();
      else if (e.type === "quarter")
        b = `${vl[kt(new Date(m))]} - ${new Date(m).getFullYear()}`;
      else if (e.type === "half-year")
        b = `${yl[wt(new Date(m))]} - ${new Date(m).getFullYear()}`;
      else
        for (let S of w)
          if (S.toLowerCase().includes("d")) {
            if (S.length <= 2) {
              let v = new Date(m).getDate();
              v < 10 && (v = `0${v}`), b += `${v}${k[w.indexOf(S)] || ""}`;
            }
          } else if (S.toLowerCase().includes("m"))
            if (S.length <= 2) {
              let v = new Date(m).getMonth() + 1;
              v < 10 && (v = `0${v}`), b += `${v}${k[w.indexOf(S)] || ""}`;
            } else {
              let v = Fe(Cs[new Date(m).getMonth()]);
              b += `${v}${k[w.indexOf(S)] || ""}`;
            }
          else if (S.toLowerCase().includes("y") && S.length <= 4) {
            let v = new Date(m).getFullYear();
            b += `${v}${k[w.indexOf(S)] || ""}`;
          }
      return b;
    }
    function p() {
      r.value = !1;
    }
    function x(m) {
      p(), t("update:modelValue", m);
    }
    return {
      value: s,
      showCalendar: r,
      clickOutside: l,
      calendarRef: i,
      updateModelValue: x,
      clickOutsideHandler: p,
      referenceRef: o,
      floatingRef: u,
      x: c,
      y: f
    };
  },
  render() {
    return Ke(
      n("div", [
        n(
          "div",
          {
            ref: "referenceRef"
          },
          n(st, {
            id: this.id,
            modelValue: this.value,
            label: this.label,
            disabled: this.disabled,
            helpText: this.helpText,
            hint: this.hint,
            iconAfter: { name: "calendar", type: "outline" },
            placeholder: this.placeholder,
            error: this.error,
            success: this.success,
            clearable: this.clearable,
            onClear: () => this.$emit("update:modelValue", null),
            onFocus: () => this.showCalendar = !0
          })
        ),
        n(
          Ee,
          {
            to: this.teleportToRef ? this.teleportToRef : this.teleportToSelector,
            disabled: !this.teleport
          },
          n(
            _e,
            {
              leaveActiveClass: "transition ease-in duration-100",
              leaveFromClass: "opacity-100",
              leaveToClass: "opacity-0"
            },
            {
              default: () => {
                var e;
                return this.showCalendar ? n(
                  "div",
                  {
                    class: [
                      "absolute top-0 left-0 origin-top bg-white dark:bg-gray-700 p-3 mt-2 min-w-80 rounded-md shadow-lg ring-1 ring-black dark:ring-gray-700 ring-opacity-5 focus:outline-none z-50"
                    ],
                    ref: "floatingRef",
                    style: {
                      width: `${(e = this.referenceRef) == null ? void 0 : e.clientWidth}px`,
                      transform: `translate(${this.x}px, ${this.y}px)`,
                      zIndex: Ae.low
                    }
                  },
                  [
                    n(rl, {
                      type: this.type,
                      range: this.range,
                      disabledDates: this.disabledDates,
                      allowedDates: this.allowedDates,
                      startYear: this.startYear,
                      endYear: this.endYear,
                      modelValue: this.modelValue,
                      highlights: this.highlights,
                      locales: this.locales,
                      locale: this.locale,
                      "onUpdate:modelValue": (t) => {
                        this.updateModelValue(t);
                      }
                    })
                  ]
                ) : null;
              }
            }
          )
        )
      ]),
      [[this.clickOutside, this.clickOutsideHandler]]
    );
  }
}), xl = (e, t) => "default" in t.slots ? n(
  "div",
  Object.assign({}, t.attrs, {
    class: ["py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 px-4"].concat(
      "class" in t.attrs ? t.attrs.class : ""
    )
  }),
  t.slots.default().reduce(
    (r, a) => {
      const s = Object.prototype.toString.call(a) === "[object Object]";
      return (s && "children" in a && a.children && a.children.trim() !== "" || s && "type" in a && a.type !== void 0) && (r.list.push(
        n(
          r.lastIndex === 0 ? "dt" : "dd",
          r.lastIndex === 1 ? { class: "sm:mt-0 sm:col-span-2" } : r.lastIndex === 0 ? { class: "font-medium text-gray-500" } : {},
          [a]
        )
      ), r.lastIndex++), r;
    },
    { list: [], lastIndex: 0 }
  ).list
) : null, Fo = xl, Ya = (e, t) => "default" in t.slots ? n(
  "dl",
  Object.assign({}, t.attrs, {
    class: [
      "at-description-group at-panel-no-padding",
      e.type === "stripped" ? "sm:divide-y sm:divide-gray-200" : ""
    ].concat("class" in t.attrs ? t.attrs.class : "")
  }),
  e.type === "normal" ? t.slots.default().reduce(
    (r, a, s, i) => (Object.prototype.toString.call(a) === "[object Object]" && "children" in a && a.children !== void 0 && (r.list.push(
      n(
        "dl",
        {
          class: (r.lastIndex % 2 === 0 ? "bg-white" : "bg-gray-50") + (i.length - 1 === s ? " rounded-br-lg rounded-bl-lg" : "")
        },
        [a]
      )
    ), r.lastIndex++), r),
    { list: [], lastIndex: 0 }
  ).list : t.slots.default()
) : null;
Ya.props = { type: { type: String, default: "normal" } };
const Go = Ya;
function yr(e, t, r) {
  let a = y(r == null ? void 0 : r.value), s = C(() => e.value !== void 0);
  return [C(() => s.value ? e.value : a.value), function(i) {
    return s.value || (a.value = i), t == null ? void 0 : t(i);
  }];
}
let wl = Symbol("headlessui.useid"), kl = 0;
function K() {
  return ee(wl, () => `${++kl}`)();
}
function T(e) {
  var t;
  if (e == null || e.value == null)
    return null;
  let r = (t = e.value.$el) != null ? t : e.value;
  return r instanceof Node ? r : null;
}
function q(e, t, ...r) {
  if (e in t) {
    let s = t[e];
    return typeof s == "function" ? s(...r) : s;
  }
  let a = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((s) => `"${s}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(a, q), a;
}
var Sl = Object.defineProperty, _l = (e, t, r) => t in e ? Sl(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, sa = (e, t, r) => (_l(e, typeof t != "symbol" ? t + "" : t, r), r);
let Al = class {
  constructor() {
    sa(this, "current", this.detect()), sa(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}, Lt = new Al();
function be(e) {
  if (Lt.isServer)
    return null;
  if (e instanceof Node)
    return e.ownerDocument;
  if (e != null && e.hasOwnProperty("value")) {
    let t = T(e);
    if (t)
      return t.ownerDocument;
  }
  return document;
}
let fr = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var ue = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(ue || {}), Je = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(Je || {}), Tl = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(Tl || {});
function dt(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(fr)).sort((t, r) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var ct = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(ct || {});
function ft(e, t = 0) {
  var r;
  return e === ((r = be(e)) == null ? void 0 : r.body) ? !1 : q(t, { 0() {
    return e.matches(fr);
  }, 1() {
    let a = e;
    for (; a !== null; ) {
      if (a.matches(fr))
        return !0;
      a = a.parentElement;
    }
    return !1;
  } });
}
function Xa(e) {
  let t = be(e);
  ne(() => {
    t && !ft(t.activeElement, 0) && Pl(e);
  });
}
var Cl = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(Cl || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function Pl(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let Il = ["textarea", "input"].join(",");
function Ol(e) {
  var t, r;
  return (r = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, Il)) != null ? r : !1;
}
function Rt(e, t = (r) => r) {
  return e.slice().sort((r, a) => {
    let s = t(r), i = t(a);
    if (s === null || i === null)
      return 0;
    let l = s.compareDocumentPosition(i);
    return l & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : l & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function Ml(e, t) {
  return Se(dt(), t, { relativeTo: e });
}
function Se(e, t, { sorted: r = !0, relativeTo: a = null, skipElements: s = [] } = {}) {
  var i;
  let l = (i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e == null ? void 0 : e.ownerDocument) != null ? i : document, o = Array.isArray(e) ? r ? Rt(e) : e : dt(e);
  s.length > 0 && o.length > 1 && (o = o.filter((p) => !s.includes(p))), a = a ?? l.activeElement;
  let u = (() => {
    if (t & 5)
      return 1;
    if (t & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), c = (() => {
    if (t & 1)
      return 0;
    if (t & 2)
      return Math.max(0, o.indexOf(a)) - 1;
    if (t & 4)
      return Math.max(0, o.indexOf(a)) + 1;
    if (t & 8)
      return o.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), f = t & 32 ? { preventScroll: !0 } : {}, h = 0, d = o.length, g;
  do {
    if (h >= d || h + d <= 0)
      return 0;
    let p = c + h;
    if (t & 16)
      p = (p + d) % d;
    else {
      if (p < 0)
        return 3;
      if (p >= d)
        return 1;
    }
    g = o[p], g == null || g.focus(f), h += u;
  } while (g !== l.activeElement);
  return t & 6 && Ol(g) && g.select(), 2;
}
function Dl() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function $l() {
  return /Android/gi.test(window.navigator.userAgent);
}
function jl() {
  return Dl() || $l();
}
function yt(e, t, r) {
  Lt.isServer || ve((a) => {
    document.addEventListener(e, t, r), a(() => document.removeEventListener(e, t, r));
  });
}
function Ja(e, t, r) {
  Lt.isServer || ve((a) => {
    window.addEventListener(e, t, r), a(() => window.removeEventListener(e, t, r));
  });
}
function xr(e, t, r = C(() => !0)) {
  function a(i, l) {
    if (!r.value || i.defaultPrevented)
      return;
    let o = l(i);
    if (o === null || !o.getRootNode().contains(o))
      return;
    let u = function c(f) {
      return typeof f == "function" ? c(f()) : Array.isArray(f) || f instanceof Set ? f : [f];
    }(e);
    for (let c of u) {
      if (c === null)
        continue;
      let f = c instanceof HTMLElement ? c : T(c);
      if (f != null && f.contains(o) || i.composed && i.composedPath().includes(f))
        return;
    }
    return !ft(o, ct.Loose) && o.tabIndex !== -1 && i.preventDefault(), t(i, o);
  }
  let s = y(null);
  yt("pointerdown", (i) => {
    var l, o;
    r.value && (s.value = ((o = (l = i.composedPath) == null ? void 0 : l.call(i)) == null ? void 0 : o[0]) || i.target);
  }, !0), yt("mousedown", (i) => {
    var l, o;
    r.value && (s.value = ((o = (l = i.composedPath) == null ? void 0 : l.call(i)) == null ? void 0 : o[0]) || i.target);
  }, !0), yt("click", (i) => {
    jl() || s.value && (a(i, () => s.value), s.value = null);
  }, !0), yt("touchend", (i) => a(i, () => i.target instanceof HTMLElement ? i.target : null), !0), Ja("blur", (i) => a(i, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function la(e, t) {
  if (e)
    return e;
  let r = t ?? "button";
  if (typeof r == "string" && r.toLowerCase() === "button")
    return "button";
}
function ht(e, t) {
  let r = y(la(e.value.type, e.value.as));
  return X(() => {
    r.value = la(e.value.type, e.value.as);
  }), ve(() => {
    var a;
    r.value || T(t) && T(t) instanceof HTMLButtonElement && !((a = T(t)) != null && a.hasAttribute("type")) && (r.value = "button");
  }), r;
}
function ia(e) {
  return [e.screenX, e.screenY];
}
function Ka() {
  let e = y([-1, -1]);
  return { wasMoved(t) {
    let r = ia(t);
    return e.value[0] === r[0] && e.value[1] === r[1] ? !1 : (e.value = r, !0);
  }, update(t) {
    e.value = ia(t);
  } };
}
function qa({ container: e, accept: t, walk: r, enabled: a }) {
  ve(() => {
    let s = e.value;
    if (!s || a !== void 0 && !a.value)
      return;
    let i = be(e);
    if (!i)
      return;
    let l = Object.assign((u) => t(u), { acceptNode: t }), o = i.createTreeWalker(s, NodeFilter.SHOW_ELEMENT, l, !1);
    for (; o.nextNode(); )
      r(o.currentNode);
  });
}
var we = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(we || {}), El = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(El || {});
function U({ visible: e = !0, features: t = 0, ourProps: r, theirProps: a, ...s }) {
  var i;
  let l = en(a, r), o = Object.assign(s, { props: l });
  if (e || t & 2 && l.static)
    return ar(o);
  if (t & 1) {
    let u = (i = l.unmount) == null || i ? 0 : 1;
    return q(u, { 0() {
      return null;
    }, 1() {
      return ar({ ...s, props: { ...l, hidden: !0, style: { display: "none" } } });
    } });
  }
  return ar(o);
}
function ar({ props: e, attrs: t, slots: r, slot: a, name: s }) {
  var i, l;
  let { as: o, ...u } = Nt(e, ["unmount", "static"]), c = (i = r.default) == null ? void 0 : i.call(r, a), f = {};
  if (a) {
    let h = !1, d = [];
    for (let [g, p] of Object.entries(a))
      typeof p == "boolean" && (h = !0), p === !0 && d.push(g);
    h && (f["data-headlessui-state"] = d.join(" "));
  }
  if (o === "template") {
    if (c = Qa(c ?? []), Object.keys(u).length > 0 || Object.keys(t).length > 0) {
      let [h, ...d] = c ?? [];
      if (!Bl(h) || d.length > 0)
        throw new Error(['Passing props on "template"!', "", `The current component <${s} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(u).concat(Object.keys(t)).map((x) => x.trim()).filter((x, m, b) => b.indexOf(x) === m).sort((x, m) => x.localeCompare(m)).map((x) => `  - ${x}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((x) => `  - ${x}`).join(`
`)].join(`
`));
      let g = en((l = h.props) != null ? l : {}, u, f), p = Rs(h, g, !0);
      for (let x in g)
        x.startsWith("on") && (p.props || (p.props = {}), p.props[x] = g[x]);
      return p;
    }
    return Array.isArray(c) && c.length === 1 ? c[0] : c;
  }
  return n(o, Object.assign({}, u, f), { default: () => c });
}
function Qa(e) {
  return e.flatMap((t) => t.type === Be ? Qa(t.children) : [t]);
}
function en(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let t = {}, r = {};
  for (let a of e)
    for (let s in a)
      s.startsWith("on") && typeof a[s] == "function" ? (r[s] != null || (r[s] = []), r[s].push(a[s])) : t[s] = a[s];
  if (t.disabled || t["aria-disabled"])
    return Object.assign(t, Object.fromEntries(Object.keys(r).map((a) => [a, void 0])));
  for (let a in r)
    Object.assign(t, { [a](s, ...i) {
      let l = r[a];
      for (let o of l) {
        if (s instanceof Event && s.defaultPrevented)
          return;
        o(s, ...i);
      }
    } });
  return t;
}
function wr(e) {
  let t = Object.assign({}, e);
  for (let r in t)
    t[r] === void 0 && delete t[r];
  return t;
}
function Nt(e, t = []) {
  let r = Object.assign({}, e);
  for (let a of t)
    a in r && delete r[a];
  return r;
}
function Bl(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
var Ie = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(Ie || {});
let je = D({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(e, { slots: t, attrs: r }) {
  return () => {
    var a;
    let { features: s, ...i } = e, l = { "aria-hidden": (s & 2) === 2 ? !0 : (a = i["aria-hidden"]) != null ? a : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(s & 4) === 4 && (s & 2) !== 2 && { display: "none" } } };
    return U({ ourProps: l, theirProps: i, slot: {}, attrs: r, slots: t, name: "Hidden" });
  };
} }), tn = Symbol("Context");
var te = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(te || {});
function gt() {
  return ee(tn, null);
}
function Vt(e) {
  se(tn, e);
}
var j = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(j || {});
function Ll(e) {
  throw new Error("Unexpected object: " + e);
}
var H = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(H || {});
function rn(e, t) {
  let r = t.resolveItems();
  if (r.length <= 0)
    return null;
  let a = t.resolveActiveIndex(), s = a ?? -1;
  switch (e.focus) {
    case 0: {
      for (let i = 0; i < r.length; ++i)
        if (!t.resolveDisabled(r[i], i, r))
          return i;
      return a;
    }
    case 1: {
      s === -1 && (s = r.length);
      for (let i = s - 1; i >= 0; --i)
        if (!t.resolveDisabled(r[i], i, r))
          return i;
      return a;
    }
    case 2: {
      for (let i = s + 1; i < r.length; ++i)
        if (!t.resolveDisabled(r[i], i, r))
          return i;
      return a;
    }
    case 3: {
      for (let i = r.length - 1; i >= 0; --i)
        if (!t.resolveDisabled(r[i], i, r))
          return i;
      return a;
    }
    case 4: {
      for (let i = 0; i < r.length; ++i)
        if (t.resolveId(r[i], i, r) === e.id)
          return i;
      return a;
    }
    case 5:
      return null;
    default:
      Ll(e);
  }
}
function kr(e = {}, t = null, r = []) {
  for (let [a, s] of Object.entries(e))
    nn(r, an(t, a), s);
  return r;
}
function an(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function nn(e, t, r) {
  if (Array.isArray(r))
    for (let [a, s] of r.entries())
      nn(e, an(t, a.toString()), s);
  else
    r instanceof Date ? e.push([t, r.toISOString()]) : typeof r == "boolean" ? e.push([t, r ? "1" : "0"]) : typeof r == "string" ? e.push([t, r]) : typeof r == "number" ? e.push([t, `${r}`]) : r == null ? e.push([t, ""]) : kr(r, t, e);
}
function sn(e) {
  var t, r;
  let a = (t = e == null ? void 0 : e.form) != null ? t : e.closest("form");
  if (a) {
    for (let s of a.elements)
      if (s !== e && (s.tagName === "INPUT" && s.type === "submit" || s.tagName === "BUTTON" && s.type === "submit" || s.nodeName === "INPUT" && s.type === "image")) {
        s.click();
        return;
      }
    (r = a.requestSubmit) == null || r.call(a);
  }
}
function Rl(e, t, r, a) {
  Lt.isServer || ve((s) => {
    e = e ?? window, e.addEventListener(t, r, a), s(() => e.removeEventListener(t, r, a));
  });
}
var Pe = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(Pe || {});
function ln() {
  let e = y(0);
  return Ja("keydown", (t) => {
    t.key === "Tab" && (e.value = t.shiftKey ? 1 : 0);
  }), e;
}
function Nl({ defaultContainers: e = [], portals: t, mainTreeNodeRef: r } = {}) {
  let a = y(null), s = be(a);
  function i() {
    var l, o, u;
    let c = [];
    for (let f of e)
      f !== null && (f instanceof HTMLElement ? c.push(f) : "value" in f && f.value instanceof HTMLElement && c.push(f.value));
    if (t != null && t.value)
      for (let f of t.value)
        c.push(f);
    for (let f of (l = s == null ? void 0 : s.querySelectorAll("html > *, body > *")) != null ? l : [])
      f !== document.body && f !== document.head && f instanceof HTMLElement && f.id !== "headlessui-portal-root" && (f.contains(T(a)) || f.contains((u = (o = T(a)) == null ? void 0 : o.getRootNode()) == null ? void 0 : u.host) || c.some((h) => f.contains(h)) || c.push(f));
    return c;
  }
  return { resolveContainers: i, contains(l) {
    return i().some((o) => o.contains(l));
  }, mainTreeNodeRef: a, MainTreeNode() {
    return r != null ? null : n(je, { features: Ie.Hidden, ref: a });
  } };
}
function Vl() {
  let e = y(null);
  return { mainTreeNodeRef: e, MainTreeNode() {
    return n(je, { features: Ie.Hidden, ref: e });
  } };
}
let on = Symbol("ForcePortalRootContext");
function Fl() {
  return ee(on, !1);
}
D({ name: "ForcePortalRoot", props: { as: { type: [Object, String], default: "template" }, force: { type: Boolean, default: !1 } }, setup(e, { slots: t, attrs: r }) {
  return se(on, e.force), () => {
    let { force: a, ...s } = e;
    return U({ theirProps: s, ourProps: {}, slot: {}, slots: t, attrs: r, name: "ForcePortalRoot" });
  };
} });
let un = Symbol("DescriptionContext");
function Gl() {
  let e = ee(un, null);
  if (e === null)
    throw new Error("Missing parent");
  return e;
}
function Sr({ slot: e = y({}), name: t = "Description", props: r = {} } = {}) {
  let a = y([]);
  function s(i) {
    return a.value.push(i), () => {
      let l = a.value.indexOf(i);
      l !== -1 && a.value.splice(l, 1);
    };
  }
  return se(un, { register: s, slot: e, name: t, props: r }), C(() => a.value.length > 0 ? a.value.join(" ") : void 0);
}
let dn = D({ name: "Description", props: { as: { type: [Object, String], default: "p" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r }) {
  var a;
  let s = (a = e.id) != null ? a : `headlessui-description-${K()}`, i = Gl();
  return X(() => xe(i.register(s))), () => {
    let { name: l = "Description", slot: o = y({}), props: u = {} } = i, { ...c } = e, f = { ...Object.entries(u).reduce((h, [d, g]) => Object.assign(h, { [d]: Ge(g) }), {}), id: s };
    return U({ ourProps: f, theirProps: c, slot: o.value, attrs: t, slots: r, name: l });
  };
} });
function zl(e) {
  let t = be(e);
  if (!t) {
    if (e === null)
      return null;
    throw new Error(`[Headless UI]: Cannot find ownerDocument for contextElement: ${e}`);
  }
  let r = t.getElementById("headlessui-portal-root");
  if (r)
    return r;
  let a = t.createElement("div");
  return a.setAttribute("id", "headlessui-portal-root"), t.body.appendChild(a);
}
D({ name: "Portal", props: { as: { type: [Object, String], default: "div" } }, setup(e, { slots: t, attrs: r }) {
  let a = y(null), s = C(() => be(a)), i = Fl(), l = ee(cn, null), o = y(i === !0 || l == null ? zl(a.value) : l.resolveTarget()), u = y(!1);
  X(() => {
    u.value = !0;
  }), ve(() => {
    i || l != null && (o.value = l.resolveTarget());
  });
  let c = ee(hr, null), f = !1, h = xa();
  return G(a, () => {
    if (f || !c)
      return;
    let d = T(a);
    d && (xe(c.register(d), h), f = !0);
  }), xe(() => {
    var d, g;
    let p = (d = s.value) == null ? void 0 : d.getElementById("headlessui-portal-root");
    p && o.value === p && o.value.children.length <= 0 && ((g = o.value.parentElement) == null || g.removeChild(o.value));
  }), () => {
    if (!u.value || o.value === null)
      return null;
    let d = { ref: a, "data-headlessui-portal": "" };
    return n(Ee, { to: o.value }, U({ ourProps: d, theirProps: e, slot: {}, attrs: r, slots: t, name: "Portal" }));
  };
} });
let hr = Symbol("PortalParentContext");
function Hl() {
  let e = ee(hr, null), t = y([]);
  function r(i) {
    return t.value.push(i), e && e.register(i), () => a(i);
  }
  function a(i) {
    let l = t.value.indexOf(i);
    l !== -1 && t.value.splice(l, 1), e && e.unregister(i);
  }
  let s = { register: r, unregister: a, portals: t };
  return [t, D({ name: "PortalWrapper", setup(i, { slots: l }) {
    return se(hr, s), () => {
      var o;
      return (o = l.default) == null ? void 0 : o.call(l);
    };
  } })];
}
let cn = Symbol("PortalGroupContext");
D({ name: "PortalGroup", props: { as: { type: [Object, String], default: "template" }, target: { type: Object, default: null } }, setup(e, { attrs: t, slots: r }) {
  let a = ka({ resolveTarget() {
    return e.target;
  } });
  return se(cn, a), () => {
    let { target: s, ...i } = e;
    return U({ theirProps: i, ourProps: {}, slot: {}, attrs: t, slots: r, name: "PortalGroup" });
  };
} });
var Ul = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Ul || {});
let fn = Symbol("DisclosureContext");
function _r(e) {
  let t = ee(fn, null);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, _r), r;
  }
  return t;
}
let hn = Symbol("DisclosurePanelContext");
function Wl() {
  return ee(hn, null);
}
let Zl = D({ name: "Disclosure", props: { as: { type: [Object, String], default: "template" }, defaultOpen: { type: [Boolean], default: !1 } }, setup(e, { slots: t, attrs: r }) {
  let a = y(e.defaultOpen ? 0 : 1), s = y(null), i = y(null), l = { buttonId: y(`headlessui-disclosure-button-${K()}`), panelId: y(`headlessui-disclosure-panel-${K()}`), disclosureState: a, panel: s, button: i, toggleDisclosure() {
    a.value = q(a.value, { 0: 1, 1: 0 });
  }, closeDisclosure() {
    a.value !== 1 && (a.value = 1);
  }, close(o) {
    l.closeDisclosure();
    let u = (() => o ? o instanceof HTMLElement ? o : o.value instanceof HTMLElement ? T(o) : T(l.button) : T(l.button))();
    u == null || u.focus();
  } };
  return se(fn, l), Vt(C(() => q(a.value, { 0: te.Open, 1: te.Closed }))), () => {
    let { defaultOpen: o, ...u } = e, c = { open: a.value === 0, close: l.close };
    return U({ theirProps: u, ourProps: {}, slot: c, slots: t, attrs: r, name: "Disclosure" });
  };
} }), Yl = D({ name: "DisclosureButton", props: { as: { type: [Object, String], default: "button" }, disabled: { type: [Boolean], default: !1 }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r, expose: a }) {
  let s = _r("DisclosureButton"), i = Wl(), l = C(() => i === null ? !1 : i.value === s.panelId.value);
  X(() => {
    l.value || e.id !== null && (s.buttonId.value = e.id);
  }), xe(() => {
    l.value || (s.buttonId.value = null);
  });
  let o = y(null);
  a({ el: o, $el: o }), l.value || ve(() => {
    s.button.value = o.value;
  });
  let u = ht(C(() => ({ as: e.as, type: t.type })), o);
  function c() {
    var d;
    e.disabled || (l.value ? (s.toggleDisclosure(), (d = T(s.button)) == null || d.focus()) : s.toggleDisclosure());
  }
  function f(d) {
    var g;
    if (!e.disabled)
      if (l.value)
        switch (d.key) {
          case j.Space:
          case j.Enter:
            d.preventDefault(), d.stopPropagation(), s.toggleDisclosure(), (g = T(s.button)) == null || g.focus();
            break;
        }
      else
        switch (d.key) {
          case j.Space:
          case j.Enter:
            d.preventDefault(), d.stopPropagation(), s.toggleDisclosure();
            break;
        }
  }
  function h(d) {
    switch (d.key) {
      case j.Space:
        d.preventDefault();
        break;
    }
  }
  return () => {
    var d;
    let g = { open: s.disclosureState.value === 0 }, { id: p, ...x } = e, m = l.value ? { ref: o, type: u.value, onClick: c, onKeydown: f } : { id: (d = s.buttonId.value) != null ? d : p, ref: o, type: u.value, "aria-expanded": s.disclosureState.value === 0, "aria-controls": s.disclosureState.value === 0 || T(s.panel) ? s.panelId.value : void 0, disabled: e.disabled ? !0 : void 0, onClick: c, onKeydown: f, onKeyup: h };
    return U({ ourProps: m, theirProps: x, slot: g, attrs: t, slots: r, name: "DisclosureButton" });
  };
} }), Xl = D({ name: "DisclosurePanel", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r, expose: a }) {
  let s = _r("DisclosurePanel");
  X(() => {
    e.id !== null && (s.panelId.value = e.id);
  }), xe(() => {
    s.panelId.value = null;
  }), a({ el: s.panel, $el: s.panel }), se(hn, s.panelId);
  let i = gt(), l = C(() => i !== null ? (i.value & te.Open) === te.Open : s.disclosureState.value === 0);
  return () => {
    var o;
    let u = { open: s.disclosureState.value === 0, close: s.close }, { id: c, ...f } = e, h = { id: (o = s.panelId.value) != null ? o : c, ref: s.panel };
    return U({ ourProps: h, theirProps: f, slot: u, attrs: t, slots: r, features: we.RenderStrategy | we.Static, visible: l.value, name: "DisclosurePanel" });
  };
} }), oa = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function ua(e) {
  var t, r;
  let a = (t = e.innerText) != null ? t : "", s = e.cloneNode(!0);
  if (!(s instanceof HTMLElement))
    return a;
  let i = !1;
  for (let o of s.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))
    o.remove(), i = !0;
  let l = i ? (r = s.innerText) != null ? r : "" : a;
  return oa.test(l) && (l = l.replace(oa, "")), l;
}
function Jl(e) {
  let t = e.getAttribute("aria-label");
  if (typeof t == "string")
    return t.trim();
  let r = e.getAttribute("aria-labelledby");
  if (r) {
    let a = r.split(" ").map((s) => {
      let i = document.getElementById(s);
      if (i) {
        let l = i.getAttribute("aria-label");
        return typeof l == "string" ? l.trim() : ua(i).trim();
      }
      return null;
    }).filter(Boolean);
    if (a.length > 0)
      return a.join(", ");
  }
  return ua(e).trim();
}
function gn(e) {
  let t = y(""), r = y("");
  return () => {
    let a = T(e);
    if (!a)
      return "";
    let s = a.innerText;
    if (t.value === s)
      return r.value;
    let i = Jl(a).trim().toLowerCase();
    return t.value = s, r.value = i, i;
  };
}
function Kl(e, t) {
  return e === t;
}
var ql = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(ql || {}), Ql = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(Ql || {}), ei = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(ei || {});
function ti(e) {
  requestAnimationFrame(() => requestAnimationFrame(e));
}
let pn = Symbol("ListboxContext");
function pt(e) {
  let t = ee(pn, null);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, pt), r;
  }
  return t;
}
let ri = D({ name: "Listbox", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => Kl }, horizontal: { type: [Boolean], default: !1 }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, multiple: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(e, { slots: t, attrs: r, emit: a }) {
  let s = y(1), i = y(null), l = y(null), o = y(null), u = y([]), c = y(""), f = y(null), h = y(1);
  function d(k = (S) => S) {
    let S = f.value !== null ? u.value[f.value] : null, v = Rt(k(u.value.slice()), (O) => T(O.dataRef.domRef)), P = S ? v.indexOf(S) : null;
    return P === -1 && (P = null), { options: v, activeOptionIndex: P };
  }
  let g = C(() => e.multiple ? 1 : 0), [p, x] = yr(C(() => e.modelValue), (k) => a("update:modelValue", k), C(() => e.defaultValue)), m = C(() => p.value === void 0 ? q(g.value, { 1: [], 0: void 0 }) : p.value), b = { listboxState: s, value: m, mode: g, compare(k, S) {
    if (typeof e.by == "string") {
      let v = e.by;
      return (k == null ? void 0 : k[v]) === (S == null ? void 0 : S[v]);
    }
    return e.by(k, S);
  }, orientation: C(() => e.horizontal ? "horizontal" : "vertical"), labelRef: i, buttonRef: l, optionsRef: o, disabled: C(() => e.disabled), options: u, searchQuery: c, activeOptionIndex: f, activationTrigger: h, closeListbox() {
    e.disabled || s.value !== 1 && (s.value = 1, f.value = null);
  }, openListbox() {
    e.disabled || s.value !== 0 && (s.value = 0);
  }, goToOption(k, S, v) {
    if (e.disabled || s.value === 1)
      return;
    let P = d(), O = rn(k === H.Specific ? { focus: H.Specific, id: S } : { focus: k }, { resolveItems: () => P.options, resolveActiveIndex: () => P.activeOptionIndex, resolveId: ($) => $.id, resolveDisabled: ($) => $.dataRef.disabled });
    c.value = "", f.value = O, h.value = v ?? 1, u.value = P.options;
  }, search(k) {
    if (e.disabled || s.value === 1)
      return;
    let S = c.value !== "" ? 0 : 1;
    c.value += k.toLowerCase();
    let v = (f.value !== null ? u.value.slice(f.value + S).concat(u.value.slice(0, f.value + S)) : u.value).find((O) => O.dataRef.textValue.startsWith(c.value) && !O.dataRef.disabled), P = v ? u.value.indexOf(v) : -1;
    P === -1 || P === f.value || (f.value = P, h.value = 1);
  }, clearSearch() {
    e.disabled || s.value !== 1 && c.value !== "" && (c.value = "");
  }, registerOption(k, S) {
    let v = d((P) => [...P, { id: k, dataRef: S }]);
    u.value = v.options, f.value = v.activeOptionIndex;
  }, unregisterOption(k) {
    let S = d((v) => {
      let P = v.findIndex((O) => O.id === k);
      return P !== -1 && v.splice(P, 1), v;
    });
    u.value = S.options, f.value = S.activeOptionIndex, h.value = 1;
  }, theirOnChange(k) {
    e.disabled || x(k);
  }, select(k) {
    e.disabled || x(q(g.value, { 0: () => k, 1: () => {
      let S = Q(b.value.value).slice(), v = Q(k), P = S.findIndex((O) => b.compare(v, Q(O)));
      return P === -1 ? S.push(v) : S.splice(P, 1), S;
    } }));
  } };
  xr([l, o], (k, S) => {
    var v;
    b.closeListbox(), ft(S, ct.Loose) || (k.preventDefault(), (v = T(l)) == null || v.focus());
  }, C(() => s.value === 0)), se(pn, b), Vt(C(() => q(s.value, { 0: te.Open, 1: te.Closed })));
  let w = C(() => {
    var k;
    return (k = T(l)) == null ? void 0 : k.closest("form");
  });
  return X(() => {
    G([w], () => {
      if (!w.value || e.defaultValue === void 0)
        return;
      function k() {
        b.theirOnChange(e.defaultValue);
      }
      return w.value.addEventListener("reset", k), () => {
        var S;
        (S = w.value) == null || S.removeEventListener("reset", k);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: k, modelValue: S, disabled: v, form: P, ...O } = e, $ = { open: s.value === 0, disabled: v, value: m.value };
    return n(Be, [...k != null && m.value != null ? kr({ [k]: m.value }).map(([W, ce]) => n(je, wr({ features: Ie.Hidden, key: W, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: P, name: W, value: ce }))) : [], U({ ourProps: {}, theirProps: { ...r, ...Nt(O, ["defaultValue", "onUpdate:modelValue", "horizontal", "multiple", "by"]) }, slot: $, slots: t, attrs: r, name: "Listbox" })]);
  };
} }), ai = D({ name: "ListboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r }) {
  var a;
  let s = (a = e.id) != null ? a : `headlessui-listbox-label-${K()}`, i = pt("ListboxLabel");
  function l() {
    var o;
    (o = T(i.buttonRef)) == null || o.focus({ preventScroll: !0 });
  }
  return () => {
    let o = { open: i.listboxState.value === 0, disabled: i.disabled.value }, { ...u } = e, c = { id: s, ref: i.labelRef, onClick: l };
    return U({ ourProps: c, theirProps: u, slot: o, attrs: t, slots: r, name: "ListboxLabel" });
  };
} }), mn = D({ name: "ListboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r, expose: a }) {
  var s;
  let i = (s = e.id) != null ? s : `headlessui-listbox-button-${K()}`, l = pt("ListboxButton");
  a({ el: l.buttonRef, $el: l.buttonRef });
  function o(h) {
    switch (h.key) {
      case j.Space:
      case j.Enter:
      case j.ArrowDown:
        h.preventDefault(), l.openListbox(), ne(() => {
          var d;
          (d = T(l.optionsRef)) == null || d.focus({ preventScroll: !0 }), l.value.value || l.goToOption(H.First);
        });
        break;
      case j.ArrowUp:
        h.preventDefault(), l.openListbox(), ne(() => {
          var d;
          (d = T(l.optionsRef)) == null || d.focus({ preventScroll: !0 }), l.value.value || l.goToOption(H.Last);
        });
        break;
    }
  }
  function u(h) {
    switch (h.key) {
      case j.Space:
        h.preventDefault();
        break;
    }
  }
  function c(h) {
    l.disabled.value || (l.listboxState.value === 0 ? (l.closeListbox(), ne(() => {
      var d;
      return (d = T(l.buttonRef)) == null ? void 0 : d.focus({ preventScroll: !0 });
    })) : (h.preventDefault(), l.openListbox(), ti(() => {
      var d;
      return (d = T(l.optionsRef)) == null ? void 0 : d.focus({ preventScroll: !0 });
    })));
  }
  let f = ht(C(() => ({ as: e.as, type: t.type })), l.buttonRef);
  return () => {
    var h, d;
    let g = { open: l.listboxState.value === 0, disabled: l.disabled.value, value: l.value.value }, { ...p } = e, x = { ref: l.buttonRef, id: i, type: f.value, "aria-haspopup": "listbox", "aria-controls": (h = T(l.optionsRef)) == null ? void 0 : h.id, "aria-expanded": l.listboxState.value === 0, "aria-labelledby": l.labelRef.value ? [(d = T(l.labelRef)) == null ? void 0 : d.id, i].join(" ") : void 0, disabled: l.disabled.value === !0 ? !0 : void 0, onKeydown: o, onKeyup: u, onClick: c };
    return U({ ourProps: x, theirProps: p, slot: g, attrs: t, slots: r, name: "ListboxButton" });
  };
} }), ni = D({ name: "ListboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r, expose: a }) {
  var s;
  let i = (s = e.id) != null ? s : `headlessui-listbox-options-${K()}`, l = pt("ListboxOptions"), o = y(null);
  a({ el: l.optionsRef, $el: l.optionsRef });
  function u(h) {
    switch (o.value && clearTimeout(o.value), h.key) {
      case j.Space:
        if (l.searchQuery.value !== "")
          return h.preventDefault(), h.stopPropagation(), l.search(h.key);
      case j.Enter:
        if (h.preventDefault(), h.stopPropagation(), l.activeOptionIndex.value !== null) {
          let d = l.options.value[l.activeOptionIndex.value];
          l.select(d.dataRef.value);
        }
        l.mode.value === 0 && (l.closeListbox(), ne(() => {
          var d;
          return (d = T(l.buttonRef)) == null ? void 0 : d.focus({ preventScroll: !0 });
        }));
        break;
      case q(l.orientation.value, { vertical: j.ArrowDown, horizontal: j.ArrowRight }):
        return h.preventDefault(), h.stopPropagation(), l.goToOption(H.Next);
      case q(l.orientation.value, { vertical: j.ArrowUp, horizontal: j.ArrowLeft }):
        return h.preventDefault(), h.stopPropagation(), l.goToOption(H.Previous);
      case j.Home:
      case j.PageUp:
        return h.preventDefault(), h.stopPropagation(), l.goToOption(H.First);
      case j.End:
      case j.PageDown:
        return h.preventDefault(), h.stopPropagation(), l.goToOption(H.Last);
      case j.Escape:
        h.preventDefault(), h.stopPropagation(), l.closeListbox(), ne(() => {
          var d;
          return (d = T(l.buttonRef)) == null ? void 0 : d.focus({ preventScroll: !0 });
        });
        break;
      case j.Tab:
        h.preventDefault(), h.stopPropagation();
        break;
      default:
        h.key.length === 1 && (l.search(h.key), o.value = setTimeout(() => l.clearSearch(), 350));
        break;
    }
  }
  let c = gt(), f = C(() => c !== null ? (c.value & te.Open) === te.Open : l.listboxState.value === 0);
  return () => {
    var h, d;
    let g = { open: l.listboxState.value === 0 }, { ...p } = e, x = { "aria-activedescendant": l.activeOptionIndex.value === null || (h = l.options.value[l.activeOptionIndex.value]) == null ? void 0 : h.id, "aria-multiselectable": l.mode.value === 1 ? !0 : void 0, "aria-labelledby": (d = T(l.buttonRef)) == null ? void 0 : d.id, "aria-orientation": l.orientation.value, id: i, onKeydown: u, role: "listbox", tabIndex: 0, ref: l.optionsRef };
    return U({ ourProps: x, theirProps: p, slot: g, attrs: t, slots: r, features: we.RenderStrategy | we.Static, visible: f.value, name: "ListboxOptions" });
  };
} }), si = D({ name: "ListboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(e, { slots: t, attrs: r, expose: a }) {
  var s;
  let i = (s = e.id) != null ? s : `headlessui-listbox-option-${K()}`, l = pt("ListboxOption"), o = y(null);
  a({ el: o, $el: o });
  let u = C(() => l.activeOptionIndex.value !== null ? l.options.value[l.activeOptionIndex.value].id === i : !1), c = C(() => q(l.mode.value, { 0: () => l.compare(Q(l.value.value), Q(e.value)), 1: () => Q(l.value.value).some((k) => l.compare(Q(k), Q(e.value))) })), f = C(() => q(l.mode.value, { 1: () => {
    var k;
    let S = Q(l.value.value);
    return ((k = l.options.value.find((v) => S.some((P) => l.compare(Q(P), Q(v.dataRef.value))))) == null ? void 0 : k.id) === i;
  }, 0: () => c.value })), h = gn(o), d = C(() => ({ disabled: e.disabled, value: e.value, get textValue() {
    return h();
  }, domRef: o }));
  X(() => l.registerOption(i, d)), xe(() => l.unregisterOption(i)), X(() => {
    G([l.listboxState, c], () => {
      l.listboxState.value === 0 && c.value && q(l.mode.value, { 1: () => {
        f.value && l.goToOption(H.Specific, i);
      }, 0: () => {
        l.goToOption(H.Specific, i);
      } });
    }, { immediate: !0 });
  }), ve(() => {
    l.listboxState.value === 0 && u.value && l.activationTrigger.value !== 0 && ne(() => {
      var k, S;
      return (S = (k = T(o)) == null ? void 0 : k.scrollIntoView) == null ? void 0 : S.call(k, { block: "nearest" });
    });
  });
  function g(k) {
    if (e.disabled)
      return k.preventDefault();
    l.select(e.value), l.mode.value === 0 && (l.closeListbox(), ne(() => {
      var S;
      return (S = T(l.buttonRef)) == null ? void 0 : S.focus({ preventScroll: !0 });
    }));
  }
  function p() {
    if (e.disabled)
      return l.goToOption(H.Nothing);
    l.goToOption(H.Specific, i);
  }
  let x = Ka();
  function m(k) {
    x.update(k);
  }
  function b(k) {
    x.wasMoved(k) && (e.disabled || u.value || l.goToOption(H.Specific, i, 0));
  }
  function w(k) {
    x.wasMoved(k) && (e.disabled || u.value && l.goToOption(H.Nothing));
  }
  return () => {
    let { disabled: k } = e, S = { active: u.value, selected: c.value, disabled: k }, { value: v, disabled: P, ...O } = e, $ = { id: i, ref: o, role: "option", tabIndex: k === !0 ? void 0 : -1, "aria-disabled": k === !0 ? !0 : void 0, "aria-selected": c.value, disabled: void 0, onClick: g, onFocus: p, onPointerenter: m, onMouseenter: m, onPointermove: b, onMousemove: b, onPointerleave: w, onMouseleave: w };
    return U({ ourProps: $, theirProps: O, slot: S, attrs: r, slots: t, name: "ListboxOption" });
  };
} });
var li = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(li || {}), ii = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(ii || {});
function oi(e) {
  requestAnimationFrame(() => requestAnimationFrame(e));
}
let bn = Symbol("MenuContext");
function Ft(e) {
  let t = ee(bn, null);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Ft), r;
  }
  return t;
}
let Ar = D({ name: "Menu", props: { as: { type: [Object, String], default: "template" } }, setup(e, { slots: t, attrs: r }) {
  let a = y(1), s = y(null), i = y(null), l = y([]), o = y(""), u = y(null), c = y(1);
  function f(d = (g) => g) {
    let g = u.value !== null ? l.value[u.value] : null, p = Rt(d(l.value.slice()), (m) => T(m.dataRef.domRef)), x = g ? p.indexOf(g) : null;
    return x === -1 && (x = null), { items: p, activeItemIndex: x };
  }
  let h = { menuState: a, buttonRef: s, itemsRef: i, items: l, searchQuery: o, activeItemIndex: u, activationTrigger: c, closeMenu: () => {
    a.value = 1, u.value = null;
  }, openMenu: () => a.value = 0, goToItem(d, g, p) {
    let x = f(), m = rn(d === H.Specific ? { focus: H.Specific, id: g } : { focus: d }, { resolveItems: () => x.items, resolveActiveIndex: () => x.activeItemIndex, resolveId: (b) => b.id, resolveDisabled: (b) => b.dataRef.disabled });
    o.value = "", u.value = m, c.value = p ?? 1, l.value = x.items;
  }, search(d) {
    let g = o.value !== "" ? 0 : 1;
    o.value += d.toLowerCase();
    let p = (u.value !== null ? l.value.slice(u.value + g).concat(l.value.slice(0, u.value + g)) : l.value).find((m) => m.dataRef.textValue.startsWith(o.value) && !m.dataRef.disabled), x = p ? l.value.indexOf(p) : -1;
    x === -1 || x === u.value || (u.value = x, c.value = 1);
  }, clearSearch() {
    o.value = "";
  }, registerItem(d, g) {
    let p = f((x) => [...x, { id: d, dataRef: g }]);
    l.value = p.items, u.value = p.activeItemIndex, c.value = 1;
  }, unregisterItem(d) {
    let g = f((p) => {
      let x = p.findIndex((m) => m.id === d);
      return x !== -1 && p.splice(x, 1), p;
    });
    l.value = g.items, u.value = g.activeItemIndex, c.value = 1;
  } };
  return xr([s, i], (d, g) => {
    var p;
    h.closeMenu(), ft(g, ct.Loose) || (d.preventDefault(), (p = T(s)) == null || p.focus());
  }, C(() => a.value === 0)), se(bn, h), Vt(C(() => q(a.value, { 0: te.Open, 1: te.Closed }))), () => {
    let d = { open: a.value === 0, close: h.closeMenu };
    return U({ ourProps: {}, theirProps: e, slot: d, slots: t, attrs: r, name: "Menu" });
  };
} }), Gt = D({ name: "MenuButton", props: { disabled: { type: Boolean, default: !1 }, as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r, expose: a }) {
  var s;
  let i = (s = e.id) != null ? s : `headlessui-menu-button-${K()}`, l = Ft("MenuButton");
  a({ el: l.buttonRef, $el: l.buttonRef });
  function o(h) {
    switch (h.key) {
      case j.Space:
      case j.Enter:
      case j.ArrowDown:
        h.preventDefault(), h.stopPropagation(), l.openMenu(), ne(() => {
          var d;
          (d = T(l.itemsRef)) == null || d.focus({ preventScroll: !0 }), l.goToItem(H.First);
        });
        break;
      case j.ArrowUp:
        h.preventDefault(), h.stopPropagation(), l.openMenu(), ne(() => {
          var d;
          (d = T(l.itemsRef)) == null || d.focus({ preventScroll: !0 }), l.goToItem(H.Last);
        });
        break;
    }
  }
  function u(h) {
    switch (h.key) {
      case j.Space:
        h.preventDefault();
        break;
    }
  }
  function c(h) {
    e.disabled || (l.menuState.value === 0 ? (l.closeMenu(), ne(() => {
      var d;
      return (d = T(l.buttonRef)) == null ? void 0 : d.focus({ preventScroll: !0 });
    })) : (h.preventDefault(), l.openMenu(), oi(() => {
      var d;
      return (d = T(l.itemsRef)) == null ? void 0 : d.focus({ preventScroll: !0 });
    })));
  }
  let f = ht(C(() => ({ as: e.as, type: t.type })), l.buttonRef);
  return () => {
    var h;
    let d = { open: l.menuState.value === 0 }, { ...g } = e, p = { ref: l.buttonRef, id: i, type: f.value, "aria-haspopup": "menu", "aria-controls": (h = T(l.itemsRef)) == null ? void 0 : h.id, "aria-expanded": l.menuState.value === 0, onKeydown: o, onKeyup: u, onClick: c };
    return U({ ourProps: p, theirProps: g, slot: d, attrs: t, slots: r, name: "MenuButton" });
  };
} }), Tr = D({ name: "MenuItems", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r, expose: a }) {
  var s;
  let i = (s = e.id) != null ? s : `headlessui-menu-items-${K()}`, l = Ft("MenuItems"), o = y(null);
  a({ el: l.itemsRef, $el: l.itemsRef }), qa({ container: C(() => T(l.itemsRef)), enabled: C(() => l.menuState.value === 0), accept(d) {
    return d.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : d.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(d) {
    d.setAttribute("role", "none");
  } });
  function u(d) {
    var g;
    switch (o.value && clearTimeout(o.value), d.key) {
      case j.Space:
        if (l.searchQuery.value !== "")
          return d.preventDefault(), d.stopPropagation(), l.search(d.key);
      case j.Enter:
        if (d.preventDefault(), d.stopPropagation(), l.activeItemIndex.value !== null) {
          let p = l.items.value[l.activeItemIndex.value];
          (g = T(p.dataRef.domRef)) == null || g.click();
        }
        l.closeMenu(), Xa(T(l.buttonRef));
        break;
      case j.ArrowDown:
        return d.preventDefault(), d.stopPropagation(), l.goToItem(H.Next);
      case j.ArrowUp:
        return d.preventDefault(), d.stopPropagation(), l.goToItem(H.Previous);
      case j.Home:
      case j.PageUp:
        return d.preventDefault(), d.stopPropagation(), l.goToItem(H.First);
      case j.End:
      case j.PageDown:
        return d.preventDefault(), d.stopPropagation(), l.goToItem(H.Last);
      case j.Escape:
        d.preventDefault(), d.stopPropagation(), l.closeMenu(), ne(() => {
          var p;
          return (p = T(l.buttonRef)) == null ? void 0 : p.focus({ preventScroll: !0 });
        });
        break;
      case j.Tab:
        d.preventDefault(), d.stopPropagation(), l.closeMenu(), ne(() => Ml(T(l.buttonRef), d.shiftKey ? ue.Previous : ue.Next));
        break;
      default:
        d.key.length === 1 && (l.search(d.key), o.value = setTimeout(() => l.clearSearch(), 350));
        break;
    }
  }
  function c(d) {
    switch (d.key) {
      case j.Space:
        d.preventDefault();
        break;
    }
  }
  let f = gt(), h = C(() => f !== null ? (f.value & te.Open) === te.Open : l.menuState.value === 0);
  return () => {
    var d, g;
    let p = { open: l.menuState.value === 0 }, { ...x } = e, m = { "aria-activedescendant": l.activeItemIndex.value === null || (d = l.items.value[l.activeItemIndex.value]) == null ? void 0 : d.id, "aria-labelledby": (g = T(l.buttonRef)) == null ? void 0 : g.id, id: i, onKeydown: u, onKeyup: c, role: "menu", tabIndex: 0, ref: l.itemsRef };
    return U({ ourProps: m, theirProps: x, slot: p, attrs: t, slots: r, features: we.RenderStrategy | we.Static, visible: h.value, name: "MenuItems" });
  };
} }), vn = D({ name: "MenuItem", inheritAttrs: !1, props: { as: { type: [Object, String], default: "template" }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(e, { slots: t, attrs: r, expose: a }) {
  var s;
  let i = (s = e.id) != null ? s : `headlessui-menu-item-${K()}`, l = Ft("MenuItem"), o = y(null);
  a({ el: o, $el: o });
  let u = C(() => l.activeItemIndex.value !== null ? l.items.value[l.activeItemIndex.value].id === i : !1), c = gn(o), f = C(() => ({ disabled: e.disabled, get textValue() {
    return c();
  }, domRef: o }));
  X(() => l.registerItem(i, f)), xe(() => l.unregisterItem(i)), ve(() => {
    l.menuState.value === 0 && u.value && l.activationTrigger.value !== 0 && ne(() => {
      var b, w;
      return (w = (b = T(o)) == null ? void 0 : b.scrollIntoView) == null ? void 0 : w.call(b, { block: "nearest" });
    });
  });
  function h(b) {
    if (e.disabled)
      return b.preventDefault();
    l.closeMenu(), Xa(T(l.buttonRef));
  }
  function d() {
    if (e.disabled)
      return l.goToItem(H.Nothing);
    l.goToItem(H.Specific, i);
  }
  let g = Ka();
  function p(b) {
    g.update(b);
  }
  function x(b) {
    g.wasMoved(b) && (e.disabled || u.value || l.goToItem(H.Specific, i, 0));
  }
  function m(b) {
    g.wasMoved(b) && (e.disabled || u.value && l.goToItem(H.Nothing));
  }
  return () => {
    let { disabled: b } = e, w = { active: u.value, disabled: b, close: l.closeMenu }, { ...k } = e;
    return U({ ourProps: { id: i, ref: o, role: "menuitem", tabIndex: b === !0 ? void 0 : -1, "aria-disabled": b === !0 ? !0 : void 0, disabled: void 0, onClick: h, onFocus: d, onPointerenter: p, onMouseenter: p, onPointermove: x, onMousemove: x, onPointerleave: m, onMouseleave: m }, theirProps: { ...r, ...k }, slot: w, attrs: r, slots: t, name: "MenuItem" });
  };
} });
var ui = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(ui || {});
let yn = Symbol("PopoverContext");
function zt(e) {
  let t = ee(yn, null);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <${Sn.name} /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, zt), r;
  }
  return t;
}
let xn = Symbol("PopoverGroupContext");
function wn() {
  return ee(xn, null);
}
let kn = Symbol("PopoverPanelContext");
function di() {
  return ee(kn, null);
}
let Sn = D({ name: "Popover", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" } }, setup(e, { slots: t, attrs: r, expose: a }) {
  var s;
  let i = y(null);
  a({ el: i, $el: i });
  let l = y(1), o = y(null), u = y(null), c = y(null), f = y(null), h = C(() => be(i)), d = C(() => {
    var v, P;
    if (!T(o) || !T(f))
      return !1;
    for (let Te of document.querySelectorAll("body > *"))
      if (Number(Te == null ? void 0 : Te.contains(T(o))) ^ Number(Te == null ? void 0 : Te.contains(T(f))))
        return !0;
    let O = dt(), $ = O.indexOf(T(o)), W = ($ + O.length - 1) % O.length, ce = ($ + 1) % O.length, fe = O[W], et = O[ce];
    return !((v = T(f)) != null && v.contains(fe)) && !((P = T(f)) != null && P.contains(et));
  }), g = { popoverState: l, buttonId: y(null), panelId: y(null), panel: f, button: o, isPortalled: d, beforePanelSentinel: u, afterPanelSentinel: c, togglePopover() {
    l.value = q(l.value, { 0: 1, 1: 0 });
  }, closePopover() {
    l.value !== 1 && (l.value = 1);
  }, close(v) {
    g.closePopover();
    let P = (() => v ? v instanceof HTMLElement ? v : v.value instanceof HTMLElement ? T(v) : T(g.button) : T(g.button))();
    P == null || P.focus();
  } };
  se(yn, g), Vt(C(() => q(l.value, { 0: te.Open, 1: te.Closed })));
  let p = { buttonId: g.buttonId, panelId: g.panelId, close() {
    g.closePopover();
  } }, x = wn(), m = x == null ? void 0 : x.registerPopover, [b, w] = Hl(), k = Nl({ mainTreeNodeRef: x == null ? void 0 : x.mainTreeNodeRef, portals: b, defaultContainers: [o, f] });
  function S() {
    var v, P, O, $;
    return ($ = x == null ? void 0 : x.isFocusWithinPopoverGroup()) != null ? $ : ((v = h.value) == null ? void 0 : v.activeElement) && (((P = T(o)) == null ? void 0 : P.contains(h.value.activeElement)) || ((O = T(f)) == null ? void 0 : O.contains(h.value.activeElement)));
  }
  return ve(() => m == null ? void 0 : m(p)), Rl((s = h.value) == null ? void 0 : s.defaultView, "focus", (v) => {
    var P, O;
    v.target !== window && v.target instanceof HTMLElement && l.value === 0 && (S() || o && f && (k.contains(v.target) || (P = T(g.beforePanelSentinel)) != null && P.contains(v.target) || (O = T(g.afterPanelSentinel)) != null && O.contains(v.target) || g.closePopover()));
  }, !0), xr(k.resolveContainers, (v, P) => {
    var O;
    g.closePopover(), ft(P, ct.Loose) || (v.preventDefault(), (O = T(o)) == null || O.focus());
  }, C(() => l.value === 0)), () => {
    let v = { open: l.value === 0, close: g.close };
    return n(Be, [n(w, {}, () => U({ theirProps: { ...e, ...r }, ourProps: { ref: i }, slot: v, slots: t, attrs: r, name: "Popover" })), n(k.MainTreeNode)]);
  };
} }), ci = D({ name: "PopoverButton", props: { as: { type: [Object, String], default: "button" }, disabled: { type: [Boolean], default: !1 }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { attrs: t, slots: r, expose: a }) {
  var s;
  let i = (s = e.id) != null ? s : `headlessui-popover-button-${K()}`, l = zt("PopoverButton"), o = C(() => be(l.button));
  a({ el: l.button, $el: l.button }), X(() => {
    l.buttonId.value = i;
  }), xe(() => {
    l.buttonId.value = null;
  });
  let u = wn(), c = u == null ? void 0 : u.closeOthers, f = di(), h = C(() => f === null ? !1 : f.value === l.panelId.value), d = y(null), g = `headlessui-focus-sentinel-${K()}`;
  h.value || ve(() => {
    l.button.value = T(d);
  });
  let p = ht(C(() => ({ as: e.as, type: t.type })), d);
  function x(v) {
    var P, O, $, W, ce;
    if (h.value) {
      if (l.popoverState.value === 1)
        return;
      switch (v.key) {
        case j.Space:
        case j.Enter:
          v.preventDefault(), (O = (P = v.target).click) == null || O.call(P), l.closePopover(), ($ = T(l.button)) == null || $.focus();
          break;
      }
    } else
      switch (v.key) {
        case j.Space:
        case j.Enter:
          v.preventDefault(), v.stopPropagation(), l.popoverState.value === 1 && (c == null || c(l.buttonId.value)), l.togglePopover();
          break;
        case j.Escape:
          if (l.popoverState.value !== 0)
            return c == null ? void 0 : c(l.buttonId.value);
          if (!T(l.button) || (W = o.value) != null && W.activeElement && !((ce = T(l.button)) != null && ce.contains(o.value.activeElement)))
            return;
          v.preventDefault(), v.stopPropagation(), l.closePopover();
          break;
      }
  }
  function m(v) {
    h.value || v.key === j.Space && v.preventDefault();
  }
  function b(v) {
    var P, O;
    e.disabled || (h.value ? (l.closePopover(), (P = T(l.button)) == null || P.focus()) : (v.preventDefault(), v.stopPropagation(), l.popoverState.value === 1 && (c == null || c(l.buttonId.value)), l.togglePopover(), (O = T(l.button)) == null || O.focus()));
  }
  function w(v) {
    v.preventDefault(), v.stopPropagation();
  }
  let k = ln();
  function S() {
    let v = T(l.panel);
    if (!v)
      return;
    function P() {
      q(k.value, { [Pe.Forwards]: () => Se(v, ue.First), [Pe.Backwards]: () => Se(v, ue.Last) }) === Je.Error && Se(dt().filter((O) => O.dataset.headlessuiFocusGuard !== "true"), q(k.value, { [Pe.Forwards]: ue.Next, [Pe.Backwards]: ue.Previous }), { relativeTo: T(l.button) });
    }
    P();
  }
  return () => {
    let v = l.popoverState.value === 0, P = { open: v }, { ...O } = e, $ = h.value ? { ref: d, type: p.value, onKeydown: x, onClick: b } : { ref: d, id: i, type: p.value, "aria-expanded": l.popoverState.value === 0, "aria-controls": T(l.panel) ? l.panelId.value : void 0, disabled: e.disabled ? !0 : void 0, onKeydown: x, onKeyup: m, onClick: b, onMousedown: w };
    return n(Be, [U({ ourProps: $, theirProps: { ...t, ...O }, slot: P, attrs: t, slots: r, name: "PopoverButton" }), v && !h.value && l.isPortalled.value && n(je, { id: g, features: Ie.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: S })]);
  };
} });
D({ name: "PopoverOverlay", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 } }, setup(e, { attrs: t, slots: r }) {
  let a = zt("PopoverOverlay"), s = `headlessui-popover-overlay-${K()}`, i = gt(), l = C(() => i !== null ? (i.value & te.Open) === te.Open : a.popoverState.value === 0);
  function o() {
    a.closePopover();
  }
  return () => {
    let u = { open: a.popoverState.value === 0 };
    return U({ ourProps: { id: s, "aria-hidden": !0, onClick: o }, theirProps: e, slot: u, attrs: t, slots: r, features: we.RenderStrategy | we.Static, visible: l.value, name: "PopoverOverlay" });
  };
} });
let fi = D({ name: "PopoverPanel", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, focus: { type: Boolean, default: !1 }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { attrs: t, slots: r, expose: a }) {
  var s;
  let i = (s = e.id) != null ? s : `headlessui-popover-panel-${K()}`, { focus: l } = e, o = zt("PopoverPanel"), u = C(() => be(o.panel)), c = `headlessui-focus-sentinel-before-${K()}`, f = `headlessui-focus-sentinel-after-${K()}`;
  a({ el: o.panel, $el: o.panel }), X(() => {
    o.panelId.value = i;
  }), xe(() => {
    o.panelId.value = null;
  }), se(kn, o.panelId), ve(() => {
    var w, k;
    if (!l || o.popoverState.value !== 0 || !o.panel)
      return;
    let S = (w = u.value) == null ? void 0 : w.activeElement;
    (k = T(o.panel)) != null && k.contains(S) || Se(T(o.panel), ue.First);
  });
  let h = gt(), d = C(() => h !== null ? (h.value & te.Open) === te.Open : o.popoverState.value === 0);
  function g(w) {
    var k, S;
    switch (w.key) {
      case j.Escape:
        if (o.popoverState.value !== 0 || !T(o.panel) || u.value && !((k = T(o.panel)) != null && k.contains(u.value.activeElement)))
          return;
        w.preventDefault(), w.stopPropagation(), o.closePopover(), (S = T(o.button)) == null || S.focus();
        break;
    }
  }
  function p(w) {
    var k, S, v, P, O;
    let $ = w.relatedTarget;
    $ && T(o.panel) && ((k = T(o.panel)) != null && k.contains($) || (o.closePopover(), ((v = (S = T(o.beforePanelSentinel)) == null ? void 0 : S.contains) != null && v.call(S, $) || (O = (P = T(o.afterPanelSentinel)) == null ? void 0 : P.contains) != null && O.call(P, $)) && $.focus({ preventScroll: !0 })));
  }
  let x = ln();
  function m() {
    let w = T(o.panel);
    if (!w)
      return;
    function k() {
      q(x.value, { [Pe.Forwards]: () => {
        var S;
        Se(w, ue.First) === Je.Error && ((S = T(o.afterPanelSentinel)) == null || S.focus());
      }, [Pe.Backwards]: () => {
        var S;
        (S = T(o.button)) == null || S.focus({ preventScroll: !0 });
      } });
    }
    k();
  }
  function b() {
    let w = T(o.panel);
    if (!w)
      return;
    function k() {
      q(x.value, { [Pe.Forwards]: () => {
        let S = T(o.button), v = T(o.panel);
        if (!S)
          return;
        let P = dt(), O = P.indexOf(S), $ = P.slice(0, O + 1), W = [...P.slice(O + 1), ...$];
        for (let ce of W.slice())
          if (ce.dataset.headlessuiFocusGuard === "true" || v != null && v.contains(ce)) {
            let fe = W.indexOf(ce);
            fe !== -1 && W.splice(fe, 1);
          }
        Se(W, ue.First, { sorted: !1 });
      }, [Pe.Backwards]: () => {
        var S;
        Se(w, ue.Previous) === Je.Error && ((S = T(o.button)) == null || S.focus());
      } });
    }
    k();
  }
  return () => {
    let w = { open: o.popoverState.value === 0, close: o.close }, { focus: k, ...S } = e, v = { ref: o.panel, id: i, onKeydown: g, onFocusout: l && o.popoverState.value === 0 ? p : void 0, tabIndex: -1 };
    return U({ ourProps: v, theirProps: { ...t, ...S }, attrs: t, slot: w, slots: { ...r, default: (...P) => {
      var O;
      return [n(Be, [d.value && o.isPortalled.value && n(je, { id: c, ref: o.beforePanelSentinel, features: Ie.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: m }), (O = r.default) == null ? void 0 : O.call(r, ...P), d.value && o.isPortalled.value && n(je, { id: f, ref: o.afterPanelSentinel, features: Ie.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: b })])];
    } }, features: we.RenderStrategy | we.Static, visible: d.value, name: "PopoverPanel" });
  };
} });
D({ name: "PopoverGroup", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" } }, setup(e, { attrs: t, slots: r, expose: a }) {
  let s = y(null), i = Ns([]), l = C(() => be(s)), o = Vl();
  a({ el: s, $el: s });
  function u(d) {
    let g = i.value.indexOf(d);
    g !== -1 && i.value.splice(g, 1);
  }
  function c(d) {
    return i.value.push(d), () => {
      u(d);
    };
  }
  function f() {
    var d;
    let g = l.value;
    if (!g)
      return !1;
    let p = g.activeElement;
    return (d = T(s)) != null && d.contains(p) ? !0 : i.value.some((x) => {
      var m, b;
      return ((m = g.getElementById(x.buttonId.value)) == null ? void 0 : m.contains(p)) || ((b = g.getElementById(x.panelId.value)) == null ? void 0 : b.contains(p));
    });
  }
  function h(d) {
    for (let g of i.value)
      g.buttonId.value !== d && g.close();
  }
  return se(xn, { registerPopover: c, unregisterPopover: u, isFocusWithinPopoverGroup: f, closeOthers: h, mainTreeNodeRef: o.mainTreeNodeRef }), () => n(Be, [U({ ourProps: { ref: s }, theirProps: { ...e, ...t }, slot: {}, attrs: t, slots: r, name: "PopoverGroup" }), n(o.MainTreeNode)]);
} });
let _n = Symbol("LabelContext");
function An() {
  let e = ee(_n, null);
  if (e === null) {
    let t = new Error("You used a <Label /> component, but it is not inside a parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, An), t;
  }
  return e;
}
function Cr({ slot: e = {}, name: t = "Label", props: r = {} } = {}) {
  let a = y([]);
  function s(i) {
    return a.value.push(i), () => {
      let l = a.value.indexOf(i);
      l !== -1 && a.value.splice(l, 1);
    };
  }
  return se(_n, { register: s, slot: e, name: t, props: r }), C(() => a.value.length > 0 ? a.value.join(" ") : void 0);
}
let Tn = D({ name: "Label", props: { as: { type: [Object, String], default: "label" }, passive: { type: [Boolean], default: !1 }, id: { type: String, default: null } }, setup(e, { slots: t, attrs: r }) {
  var a;
  let s = (a = e.id) != null ? a : `headlessui-label-${K()}`, i = An();
  return X(() => xe(i.register(s))), () => {
    let { name: l = "Label", slot: o = {}, props: u = {} } = i, { passive: c, ...f } = e, h = { ...Object.entries(u).reduce((d, [g, p]) => Object.assign(d, { [g]: Ge(p) }), {}), id: s };
    return c && (delete h.onClick, delete h.htmlFor, delete f.onClick), U({ ourProps: h, theirProps: f, slot: o, attrs: r, slots: t, name: l });
  };
} });
function hi(e, t) {
  return e === t;
}
let Cn = Symbol("RadioGroupContext");
function Pn(e) {
  let t = ee(Cn, null);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Pn), r;
  }
  return t;
}
let Pr = D({ name: "RadioGroup", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "div" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => hi }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { emit: t, attrs: r, slots: a, expose: s }) {
  var i;
  let l = (i = e.id) != null ? i : `headlessui-radiogroup-${K()}`, o = y(null), u = y([]), c = Cr({ name: "RadioGroupLabel" }), f = Sr({ name: "RadioGroupDescription" });
  s({ el: o, $el: o });
  let [h, d] = yr(C(() => e.modelValue), (m) => t("update:modelValue", m), C(() => e.defaultValue)), g = { options: u, value: h, disabled: C(() => e.disabled), firstOption: C(() => u.value.find((m) => !m.propsRef.disabled)), containsCheckedOption: C(() => u.value.some((m) => g.compare(Q(m.propsRef.value), Q(e.modelValue)))), compare(m, b) {
    if (typeof e.by == "string") {
      let w = e.by;
      return (m == null ? void 0 : m[w]) === (b == null ? void 0 : b[w]);
    }
    return e.by(m, b);
  }, change(m) {
    var b;
    if (e.disabled || g.compare(Q(h.value), Q(m)))
      return !1;
    let w = (b = u.value.find((k) => g.compare(Q(k.propsRef.value), Q(m)))) == null ? void 0 : b.propsRef;
    return w != null && w.disabled ? !1 : (d(m), !0);
  }, registerOption(m) {
    u.value.push(m), u.value = Rt(u.value, (b) => b.element);
  }, unregisterOption(m) {
    let b = u.value.findIndex((w) => w.id === m);
    b !== -1 && u.value.splice(b, 1);
  } };
  se(Cn, g), qa({ container: C(() => T(o)), accept(m) {
    return m.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : m.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(m) {
    m.setAttribute("role", "none");
  } });
  function p(m) {
    if (!o.value || !o.value.contains(m.target))
      return;
    let b = u.value.filter((w) => w.propsRef.disabled === !1).map((w) => w.element);
    switch (m.key) {
      case j.Enter:
        sn(m.currentTarget);
        break;
      case j.ArrowLeft:
      case j.ArrowUp:
        if (m.preventDefault(), m.stopPropagation(), Se(b, ue.Previous | ue.WrapAround) === Je.Success) {
          let w = u.value.find((k) => {
            var S;
            return k.element === ((S = be(o)) == null ? void 0 : S.activeElement);
          });
          w && g.change(w.propsRef.value);
        }
        break;
      case j.ArrowRight:
      case j.ArrowDown:
        if (m.preventDefault(), m.stopPropagation(), Se(b, ue.Next | ue.WrapAround) === Je.Success) {
          let w = u.value.find((k) => {
            var S;
            return k.element === ((S = be(k.element)) == null ? void 0 : S.activeElement);
          });
          w && g.change(w.propsRef.value);
        }
        break;
      case j.Space:
        {
          m.preventDefault(), m.stopPropagation();
          let w = u.value.find((k) => {
            var S;
            return k.element === ((S = be(k.element)) == null ? void 0 : S.activeElement);
          });
          w && g.change(w.propsRef.value);
        }
        break;
    }
  }
  let x = C(() => {
    var m;
    return (m = T(o)) == null ? void 0 : m.closest("form");
  });
  return X(() => {
    G([x], () => {
      if (!x.value || e.defaultValue === void 0)
        return;
      function m() {
        g.change(e.defaultValue);
      }
      return x.value.addEventListener("reset", m), () => {
        var b;
        (b = x.value) == null || b.removeEventListener("reset", m);
      };
    }, { immediate: !0 });
  }), () => {
    let { disabled: m, name: b, form: w, ...k } = e, S = { ref: o, id: l, role: "radiogroup", "aria-labelledby": c.value, "aria-describedby": f.value, onKeydown: p };
    return n(Be, [...b != null && h.value != null ? kr({ [b]: h.value }).map(([v, P]) => n(je, wr({ features: Ie.Hidden, key: v, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: w, name: v, value: P }))) : [], U({ ourProps: S, theirProps: { ...r, ...Nt(k, ["modelValue", "defaultValue", "by"]) }, slot: {}, attrs: r, slots: a, name: "RadioGroup" })]);
  };
} });
var gi = ((e) => (e[e.Empty = 1] = "Empty", e[e.Active = 2] = "Active", e))(gi || {});
let Ir = D({ name: "RadioGroupOption", props: { as: { type: [Object, String], default: "div" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r, expose: a }) {
  var s;
  let i = (s = e.id) != null ? s : `headlessui-radiogroup-option-${K()}`, l = Pn("RadioGroupOption"), o = Cr({ name: "RadioGroupLabel" }), u = Sr({ name: "RadioGroupDescription" }), c = y(null), f = C(() => ({ value: e.value, disabled: e.disabled })), h = y(1);
  a({ el: c, $el: c });
  let d = C(() => T(c));
  X(() => l.registerOption({ id: i, element: d, propsRef: f })), xe(() => l.unregisterOption(i));
  let g = C(() => {
    var S;
    return ((S = l.firstOption.value) == null ? void 0 : S.id) === i;
  }), p = C(() => l.disabled.value || e.disabled), x = C(() => l.compare(Q(l.value.value), Q(e.value))), m = C(() => p.value ? -1 : x.value || !l.containsCheckedOption.value && g.value ? 0 : -1);
  function b() {
    var S;
    l.change(e.value) && (h.value |= 2, (S = T(c)) == null || S.focus());
  }
  function w() {
    h.value |= 2;
  }
  function k() {
    h.value &= -3;
  }
  return () => {
    let { value: S, disabled: v, ...P } = e, O = { checked: x.value, disabled: p.value, active: !!(h.value & 2) }, $ = { id: i, ref: c, role: "radio", "aria-checked": x.value ? "true" : "false", "aria-labelledby": o.value, "aria-describedby": u.value, "aria-disabled": p.value ? !0 : void 0, tabIndex: m.value, onClick: p.value ? void 0 : b, onFocus: p.value ? void 0 : w, onBlur: p.value ? void 0 : k };
    return U({ ourProps: $, theirProps: P, slot: O, attrs: t, slots: r, name: "RadioGroupOption" });
  };
} }), Or = Tn, Ct = dn, In = Symbol("GroupContext"), pi = D({ name: "SwitchGroup", props: { as: { type: [Object, String], default: "template" } }, setup(e, { slots: t, attrs: r }) {
  let a = y(null), s = Cr({ name: "SwitchLabel", props: { htmlFor: C(() => {
    var l;
    return (l = a.value) == null ? void 0 : l.id;
  }), onClick(l) {
    a.value && (l.currentTarget.tagName === "LABEL" && l.preventDefault(), a.value.click(), a.value.focus({ preventScroll: !0 }));
  } } }), i = Sr({ name: "SwitchDescription" });
  return se(In, { switchRef: a, labelledby: s, describedby: i }), () => U({ theirProps: e, ourProps: {}, slot: {}, slots: t, attrs: r, name: "SwitchGroup" });
} }), mi = D({ name: "Switch", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "button" }, modelValue: { type: Boolean, default: void 0 }, defaultChecked: { type: Boolean, optional: !0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, value: { type: String, optional: !0 }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { emit: t, attrs: r, slots: a, expose: s }) {
  var i;
  let l = (i = e.id) != null ? i : `headlessui-switch-${K()}`, o = ee(In, null), [u, c] = yr(C(() => e.modelValue), (w) => t("update:modelValue", w), C(() => e.defaultChecked));
  function f() {
    c(!u.value);
  }
  let h = y(null), d = o === null ? h : o.switchRef, g = ht(C(() => ({ as: e.as, type: r.type })), d);
  s({ el: d, $el: d });
  function p(w) {
    w.preventDefault(), f();
  }
  function x(w) {
    w.key === j.Space ? (w.preventDefault(), f()) : w.key === j.Enter && sn(w.currentTarget);
  }
  function m(w) {
    w.preventDefault();
  }
  let b = C(() => {
    var w, k;
    return (k = (w = T(d)) == null ? void 0 : w.closest) == null ? void 0 : k.call(w, "form");
  });
  return X(() => {
    G([b], () => {
      if (!b.value || e.defaultChecked === void 0)
        return;
      function w() {
        c(e.defaultChecked);
      }
      return b.value.addEventListener("reset", w), () => {
        var k;
        (k = b.value) == null || k.removeEventListener("reset", w);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: w, value: k, form: S, ...v } = e, P = { checked: u.value }, O = { id: l, ref: d, role: "switch", type: g.value, tabIndex: 0, "aria-checked": u.value, "aria-labelledby": o == null ? void 0 : o.labelledby.value, "aria-describedby": o == null ? void 0 : o.describedby.value, onClick: p, onKeyup: x, onKeypress: m };
    return n(Be, [w != null && u.value != null ? n(je, wr({ features: Ie.Hidden, as: "input", type: "checkbox", hidden: !0, readOnly: !0, checked: u.value, form: S, name: w, value: k })) : null, U({ ourProps: O, theirProps: { ...r, ...Nt(v, ["modelValue", "defaultChecked"]) }, slot: P, attrs: r, slots: a, name: "Switch" })]);
  };
} }), bi = Tn, vi = dn;
const yi = D({
  name: "WrapperMenuProxy",
  emits: ["toggled"],
  props: { open: { type: Boolean, default: !1 } },
  watch: {
    open(e) {
      setTimeout(() => {
        this.$emit("toggled", e);
      }, 25);
    }
  },
  render() {
    return n("div", null, ["default" in this.$slots ? this.$slots.default({ open }) : null]);
  }
}), xi = D({
  name: "AtDropdown",
  props: {
    title: { type: String, default: "Выберите значение" },
    color: { type: String, default: "" },
    size: { type: String, default: "md" },
    loading: { type: Boolean, default: !1 },
    withDividers: { type: Boolean, default: !1 },
    icon: { type: [String, Object], default: () => "" },
    iconButton: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    minWidth: {
      type: Number,
      default: 0
    },
    maxWidth: {
      type: Number,
      default: 224
    },
    offset: {
      type: Array,
      default: () => [0, 4]
    },
    placement: {
      type: String,
      default: "bottom",
      validator: (e) => e && ["bottom", "top", "left", "right"].includes(e)
    },
    alignment: {
      type: String,
      default: "start",
      validator: (e) => e && ["start", "center", "end"].includes(e)
    },
    teleport: { type: Boolean, default: !1 },
    teleportToRef: { type: Object, default: null },
    teleportToSelector: { type: String, default: "body" }
  },
  setup(e) {
    const t = y(null), r = y(null), { x: a, y: s, updatePosition: i, destroyAutoFloating: l } = Qe(t, r, {
      autoFloating: !0,
      placement: e.placement,
      alignment: e.alignment,
      offset: e.offset,
      getFloatingDomElement: (o) => o.value.$el,
      getReferenceDomElement: (o) => o.value.$el
    });
    return X(() => {
      i();
    }), G([() => {
      var o;
      return (o = r.value) == null ? void 0 : o.$el;
    }, () => t.value], () => {
      i();
    }), qe(() => {
      l();
    }), {
      referenceRef: t,
      floatingRef: r,
      x: a,
      y: s
    };
  },
  render() {
    return n(
      Ar,
      { as: "div", class: "inline-block text-left" },
      {
        default: ({ open: e }) => {
          var t;
          return [
            n(
              yi,
              {
                open: e,
                ref: "wrapperMenuProxy"
              },
              {
                default: () => [
                  n(
                    Gt,
                    {
                      ref: "referenceRef",
                      as: "div",
                      class: "cursor-pointer select-none",
                      disabled: this.disabled
                    },
                    () => [
                      "button" in this.$slots ? this.$slots.button({ ...this.$props }) : n(
                        "div",
                        {
                          class: [
                            { "pointer-events-none": this.loading },
                            Aa(this.color, this.loading, F(this.disabled)),
                            Ta(this.size, this.iconButton),
                            "inline-flex items-center border font-medium rounded-md focus:outline-none transition ease-in-out duration-150",
                            { "rounded-full": this.iconButton }
                          ]
                        },
                        [
                          this.loading ? n(nt, {
                            class: "mr-3",
                            color: this.color,
                            size: this.size
                          }) : null,
                          this.icon ? n(
                            "span",
                            {
                              class: [
                                "inline-block align-middle",
                                this.iconButton ? {} : {
                                  "mr-1": this.size === "xs" || this.size === "sm",
                                  "mr-2": this.size !== "xs" && this.size !== "sm"
                                }
                              ]
                            },
                            [
                              n(de(this.icon).Icon, {
                                class: [
                                  this.size === "xs" ? "h-3.5" : this.size === "md" || this.size === "lg" ? "h-5" : "h-4"
                                ]
                              })
                            ]
                          ) : null,
                          this.iconButton ? null : this.title,
                          this.iconButton ? null : n(pr, {
                            class: "-mr-1 ml-2 h-5 w-5",
                            "aria-hidden": !0
                          })
                        ]
                      )
                    ]
                  )
                ]
              }
            ),
            n(
              Ee,
              {
                to: (t = this.teleportToRef) != null && t.value ? this.teleportToRef.value : this.teleportToSelector,
                disabled: !this.teleport
              },
              n(
                _e,
                {
                  enterActiveClass: "transition transition-opacity duration-200",
                  enterFromClass: "opacity-0",
                  enterToClass: "opacity-100",
                  leaveActiveClass: "transition transition-opacity duration-200",
                  leaveFromClass: "opacity-100",
                  leaveToClass: "opacity-0"
                },
                {
                  default: () => [
                    n(
                      Tr,
                      {
                        as: "div",
                        class: ["absolute top-0 left-0 w-full"],
                        style: {
                          transform: `translate(${this.x}px, ${this.y}px)`,
                          zIndex: Ae.low,
                          minWidth: this.minWidth ? this.minWidth / 16 + "rem" : null,
                          maxWidth: this.maxWidth ? this.maxWidth / 16 + "rem" : null
                        },
                        ref: "floatingRef"
                      },
                      {
                        default: () => [
                          "items" in this.$slots ? this.$slots.items() : n(
                            "div",
                            {
                              class: [
                                "origin-top-right max-h-48 overflow-y-auto w-full rounded-md",
                                "shadow-lg bg-white dark:bg-gray-700 ring-1 ring-black dark:ring-gray-700 ring-opacity-5 focus:outline-none"
                              ],
                              onScroll: (r) => {
                                r.target.scrollTop === r.target.scrollHeight - r.target.offsetHeight && this.$emit("onScrolledToBottom");
                              }
                            },
                            {
                              default: () => {
                                var r, a, s, i;
                                return [
                                  n(
                                    "div",
                                    {
                                      class: [
                                        "py-1",
                                        {
                                          "divide-y divide-gray-100 dark:divide-gray-600": this.withDividers
                                        }
                                      ]
                                    },
                                    [
                                      "header" in this.$slots ? n("div", { class: "block px-4 py-2" }, (a = (r = this.$slots).header) == null ? void 0 : a.call(r)) : null,
                                      (i = (s = this.$slots).default) == null ? void 0 : i.call(s)
                                    ]
                                  )
                                ];
                              }
                            }
                          )
                        ]
                      }
                    )
                  ]
                }
              )
            )
          ];
        }
      }
    );
  }
}), Mr = (e, { slots: t, emit: r }) => n(vn, null, {
  default: ({ active: a }) => n(
    "span",
    {
      class: [
        "cursor-pointer block px-4 py-2 text-sm",
        a || e.active ? "bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white" : "text-gray-700 dark:text-white",
        { "group flex items-center": e.icon }
      ],
      onClick: () => {
        r("click");
      }
    },
    [
      e.icon ? n(de(e.icon).Icon, {
        class: [
          a || e.active ? "text-gray-500 dark:text-gray-300" : "text-gray-400 dark:text-gray-300 group-hover:text-gray-500 dark:group-hover:text-gray-300",
          "mr-3 h-5 w-5"
        ],
        "aria-hidden": !0
      }) : null,
      e.title || t.default()
    ]
  )
});
Mr.props = {
  active: { type: Boolean, default: !1 },
  title: { type: String, default: "" },
  icon: { type: [String, Object], default: () => "" }
};
Mr.emits = ["click"];
const Pt = Mr, wi = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAANlBMVEXd3d2ampqXl5e9vb3g4ODS0tKUlJS/v7/Pz8/IyMivr6/W1tbFxcWnp6esrKyfn5+2trajo6Ns30qvAAADqElEQVR4nO2c65qqMAwAoQbwAou+/8se3T1CgVbQLb3tzG8kzlcISSktCgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIBNiG9861XtwS9t5VNS2r5Wvqn71puifNVlCOovT4rypYIIlqXyoyhtmBF8UHu5UKUPJliWvQ/DKtwQ3gex2l9Q2lB34QPl4TKVRjP09KDQAh48GB6GgOrm6Wl/U2EM1dVbxXZVQQxv/qqoIX97NfQRbAh69Rg0jKHPoBimHxTDX57d3MznYihSnZrmZGjm8zCU4/l/FViej7NT52Aol64ea7O6u0xOnoHhvWOZtCxq2kSkbyjNoumsG+30yRsaJ0b0GYvkDS/Gplpddg1qZYdg0pkNuyFA6oZHy8xPfdwxqB33weRsmflR52eE1A3Nfg8yMaysk3fqOXeYtqGc7IYn2Snoyz/k3LCxGzYY7gFX6ftkn2n+wNMi/yd+/lXbH6i8E++etiz3SbkDluLQ13W39uY23VkMqcrvo+tu7cBUZ6KGG0ytvWxMdTZxXJiyvtgnxRnhyVNgfHzbj09tVn9Wq6jrlsyU0puZRX6styj+MqgLtgaTZS02eQDsEtQJW4OZ6pSPF95Fabj0eyiePvuDERpaiulSzZ8DLoM6YlOwcRHTQvHyyV+MztBQZo5cjL9YycuRGRrSqI7pB4fryzs0NkNzuzdcp/38jMW9JFUvi/PYDFeWSc+q8Gf/sTB/L6g7VoPZ0qim2Gm/HKdLX/QfURna06imOFbhchjv2Yn5W0GdshJs27cKg6Kc9cOtLVZEhnJcH8H/ivKdY6aH2/qPiAxfp1HdpW+r6qrmh1v6j4gM3/jaZLoIf1A0X/uxGLr4IsrYf8RiuCWNblA0VDeRGLr65Kte9h9xGIr9PeCbLFusOAzNPe9nivMWKw7DmzvDRYsVg6HjD0v7TUF9Gmrfezlh1miEN5ST688up41GcEN3aVRT7EyXSLAxdO5XThuN0IZycz+E5ayLDGpoXS3ya8Wh0QhrqHfpjqmjWNfmPo3qiq0Yg/o0lM0972eKP41G0DHc0698NhoBDXdKoxqqkpCGu6VRXfHeaAQzfPkGxh2XcIZ7plGdUIbNvml0RPXDWnDPY+htoxrVBTEsPY3gJJZfwxBgiCGGGGKIIYYYYoghhtkYZr/3Zf77l/6BPWjz30c4/72gi/z38y7y35O9yH9f/R9Jz/jVAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgHT5B1+/Qi/CZGnDAAAAAElFTkSuQmCC", On = (e) => {
  const t = (a) => n("div", { class: "relative flex items-start space-x-3" }, [
    n("div", { class: "relative" }, [
      n("img", {
        src: a.image || wi,
        alt: a.title,
        class: [
          "h-10 w-10 rounded-full bg-gray-400 flex items-center justify-center ring-8 ring-white object-cover",
          "dark:bg-gray-100 dark:ring-gray-900"
        ]
      }),
      a.icon ? n(
        "span",
        {
          class: "absolute -bottom-0.5 -right-1 bg-white rounded-tl px-0.5 py-px"
        },
        [
          n(de(a.icon).Icon, {
            class: "h-5 w-5 text-gray-400 dark:text-gray-900",
            "aria-hidden": !0
          })
        ]
      ) : null
    ]),
    n("div", { class: "min-w-0 flex-1" }, [
      n("div", [
        n("div", { class: "text-sm" }, [
          n("span", { class: "font-medium text-gray-900 dark:text-white" }, a.title)
        ]),
        n("p", { class: "mt-0.5 text-sm text-gray-500 dark:text-gray-300" }, Hr(a.date))
      ]),
      n("div", { class: "mt-2 text-sm text-gray-700 dark:text-gray-200" }, [n("p", a.content)])
    ])
  ]), r = (a) => n("div", { class: "relative flex space-x-3" }, [
    n("div", [
      n(
        "span",
        {
          class: [
            a.iconBgColor ? "bg-" + a.iconBgColor + "-500" : "bg-gray-400 dark:bg-gray-100",
            "h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white dark:ring-gray-900",
            {
              "mx-1": e.items.some((s) => s.type && s.type === "comment")
            }
          ]
        },
        [
          n(de(a.icon).Icon, {
            class: "h-5 w-5 text-white dark:text-gray-900",
            "aria-hidden": !0
          })
        ]
      )
    ]),
    n("div", { class: "min-w-0 flex-1 pt-1.5 flex justify-between space-x-4" }, [
      n("div", [
        n("p", { class: "text-sm text-gray-500 dark:text-gray-300" }, [
          a.title,
          n("span", { class: "font-medium text-gray-900 ml-1 dark:text-white" }, a.content)
        ])
      ]),
      a.date ? n(
        "div",
        {
          class: "text-right text-sm whitespace-nowrap text-gray-500 dark:text-gray-300"
        },
        [n("time", { datetime: a.date }, Hr(a.date))]
      ) : null
    ])
  ]);
  return n("div", { class: "flow-root" }, [
    n("ul", { class: "-mb-8", role: "list" }, [
      e.items.length ? e.items.map((a, s) => n("li", null, [
        n("div", { class: "relative pb-8" }, [
          s !== e.items.length - 1 ? n("span", {
            class: [
              "absolute top-4 -ml-px h-full w-0.5 bg-gray-200 dark:bg-gray-400",
              e.items.some((i) => i.type && i.type === "comment") ? "left-5" : "left-4"
            ],
            "aria-hidden": !0
          }) : null,
          a.type && a.type === "comment" ? t(a) : r(a)
        ])
      ])) : null
    ])
  ]);
};
On.props = {
  items: {
    type: Array,
    required: !0,
    validator: (e) => e.every((t) => E(t, "title") && E(t, "content"))
  }
};
const Ho = On, Uo = D({
  name: "AtFileSelect",
  props: {
    ...Oe.props,
    id: { type: String, default: () => re("at-file-select-") },
    multiple: { type: Boolean, default: !1 },
    title: { type: String, default: "" },
    titleMore: { type: String, default: "" },
    showSignature: { type: Boolean, default: !0 },
    formKey: { type: String, default: "files" },
    accept: { type: [String, Object, Array], default: ".*" },
    size: { type: [Number, String, 1 / 0], default: 1 / 0 }
  },
  setup(e, { emit: t }) {
    let r = y(new FormData()), a = y([]), s = y([]);
    function i(u) {
      if (e.multiple)
        for (let c of u) {
          const f = new FileReader();
          s.value.push(c), r.value.append(e.formKey + "[]", c), f.onload = (h) => {
            a.value.push({
              preview: h.target.result,
              name: c.name,
              size: c.size
            });
          }, f.readAsDataURL(c);
        }
      else {
        const c = new FileReader();
        c.onload = (f) => {
          a.value.unshift({
            preview: f.target.result,
            name: u[0].name,
            size: u[0].size
          });
        }, c.readAsDataURL(u[0]), r.value.append(e.formKey, u[0]), a.value = [], s.value = [], s.value.push(u[0]);
      }
      t("onSelect", r.value);
    }
    const l = C(() => {
      let u = Zr(e.accept).text;
      if (Number.isInteger(Number(e.size))) {
        u += " размером не более ";
        const c = zr(Number(e.size));
        let f = "";
        switch (c.key) {
          case "bytes":
            f = "байт";
            break;
          case "kilobyte":
            f = "килобайт";
            break;
          case "megabyte":
            f = "мегабайт";
            break;
          case "gigabyte":
            f = "гигабайт";
            break;
          case "terabyte":
            f = "терабайт";
            break;
        }
        u += c[c.key] + " " + f;
      }
      return u;
    });
    function o(u, c) {
      if (u.preventDefault(), u.stopPropagation(), a.value = a.value.filter((f, h) => h !== c), s.value = s.value.filter((f, h) => h !== c), e.multiple) {
        r.value.delete(e.formKey + "[]");
        for (let f of s.value)
          r.value.append(e.formKey + "[]", f);
      } else {
        r.value.delete(e.formKey);
        for (let f of s.value)
          r.value.append(e.formKey, f);
      }
      t("onSelect", r.value);
    }
    return {
      filesFormData: r,
      filesToPreview: a,
      files: s,
      onFileSelect: i,
      signature: l,
      removeFileFromFilesList: o
    };
  },
  render() {
    const e = F(this.disabled), t = y(re("inputRef")), r = (a, s) => {
      var i, l, o;
      return n("div", { class: "flex items-center mt-3" }, [
        n("div", { class: "flex-shrink-0", ref: s === 0 ? "leftColRef" : null }, [
          n("img", {
            class: "h-14 w-14 object-cover rounded-md",
            src: a.preview
          })
        ]),
        n(
          "div",
          {
            class: "text-left w-4/6 flex-1 px-3",
            style: `max-width: ${((i = this.$refs.mainBlockRef) == null ? void 0 : i.clientWidth) - (((l = this.$refs.leftColRef) == null ? void 0 : l.clientWidth) + ((o = this.$refs.rightColRef) == null ? void 0 : o.clientWidth))}px`
          },
          [
            n(
              "p",
              {
                class: "p-0 mb-1 text-gray-800 break-all truncate text-sm dark:text-white"
              },
              a.name
            ),
            n("p", { class: "p-0 m-0 text-gray-400 text-xs" }, `(${zr(a.size).megabyte.toFixed(2)} мб.)`)
          ]
        ),
        n("div", { class: "flex-shrink-0", ref: s === 0 ? "rightColRef" : null }, [
          n(
            "button",
            {
              onClick: (u) => {
                this.removeFileFromFilesList(u, s);
              }
            },
            [n(Ps, { class: "h-6 w-6 text-red-500" })]
          )
        ])
      ]);
    };
    return n("div", [
      n("form", null, [
        this.label ? n(
          "label",
          {
            for: this.id,
            class: "block text-sm font-medium text-gray-700 mb-1 dark:text-white"
          },
          this.label
        ) : null,
        n(
          "button",
          {
            onClick: (a) => {
              var s;
              a.preventDefault(), a.stopPropagation(), (s = t.value) == null || s.click();
            },
            class: [
              "px-6 pt-5 pb-6 border-2 w-full border-gray-300 border-dashed rounded-md rounded-md font-medium focus:outline-none text-primary-600",
              "dark:border-gray-600 dark:text-white",
              ot(this.error, this.success),
              {
                "bg-white hover:text-primary-500 focus:ring-primary-500 focus:ring-2 focus:ring-offset-2 dark:bg-gray-700 dark:hover:text-gray-200 dark:focus:ring-offset-gray-900 dark:focus:ring-primary-600": !e
              },
              { "bg-gray-50 dark:bg-gray-600 cursor-not-allowed": e }
            ]
          },
          [
            this.multiple ? n("div", { class: "block w-full" }, [
              n("div", { class: "flex items-center w-full justify-center" }, [
                n(Fr, {
                  class: "mr-2 h-5 w-5 block text-gray-400"
                }),
                this.filesToPreview.length ? this.titleMore || "Добавить еще файлы" : this.title || "Выберите файлы"
              ]),
              this.showSignature ? n("p", { class: "text-xs text-gray-400 mt-3" }, this.signature) : null,
              this.filesToPreview.length ? n("div", { class: "mt-4", ref: "mainBlockRef" }, [
                this.filesToPreview.map((a, s) => r(a, s))
              ]) : null
            ]) : n("div", { class: "block w-full" }, [
              n("div", { class: "flex items-center w-full justify-center" }, [
                n(Fr, {
                  class: "mr-2 h-5 w-5 block text-gray-400 dark:text-gray-300"
                }),
                this.filesToPreview.length ? this.titleMore || "Загрузить другой файл" : this.title || "Выберите файл"
              ]),
              this.showSignature ? n("p", { class: "text-xs text-gray-400 mt-3" }, this.signature) : null,
              this.filesToPreview.length ? n("div", { class: "mt-4", ref: "mainBlockRef" }, [r(this.filesToPreview[0], 0)]) : null
            ])
          ]
        ),
        n("input", {
          id: this.id,
          type: "file",
          disabled: e,
          ref: t,
          multiple: this.multiple,
          accept: Zr(this.accept).mime,
          onChange: (a) => {
            a.preventDefault(), a.stopPropagation(), this.onFileSelect(a.target.files);
          },
          hidden: !0,
          class: "hidden"
        }),
        this.error ? n(Le, { type: He(this.error, this.success) }, { default: () => this.error }) : null
      ])
    ]);
  }
}), Mn = (e, { emit: t, slots: r }) => n(
  Ar,
  { class: "relative inline-block text-left", as: "div" },
  {
    default: () => [
      n("div", [
        n(
          Gt,
          {
            class: [
              "whitespace-nowrap inline-flex justify-center px-3 focus:ring-primary-500 focus:border-primary-500 h-full py-0 border-transparent bg-transparent text-gray-500 sm:text-sm dark:text-white dark:focus:ring-primary-600 dark:focus:border-primary-600",
              e.side === "left" ? "rounded-l-md" : "rounded-r-md",
              { "cursor-not-allowed": F(e.disabled) }
            ]
          },
          {
            default: () => {
              var a;
              return [
                "title" in r ? r.title() : ((a = e.items.find((s) => (s == null ? void 0 : s[e.valueType]) === e.modelValue)) == null ? void 0 : a[e.valueTitle]) || e.modelValue,
                n(pr, {
                  class: "w-5 h-5 ml-2 -mr-1 text-violet-200 hover:text-violet-100",
                  "aria-hidden": "true"
                })
              ];
            }
          }
        )
      ]),
      n(
        _e,
        {
          enterActiveClass: "transition duration-100 ease-out",
          enterFromClass: "transform scale-95 opacity-0",
          enterToClass: "transform scale-100 opacity-100",
          leaveFromClass: "transform scale-100 opacity-100",
          leaveActiveClass: "transition duration-75 ease-in",
          leaveToClass: "transform scale-95 opacity-0"
        },
        {
          default: () => n(
            Tr,
            {
              class: "absolute left-0 z-10 w-max mt-2 origin-top-right bg-white dark:bg-gray-700 focus:outline-none divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black dark:ring-gray-700 ring-opacity-5 focus:outline-none"
            },
            {
              default: () => n("div", { class: "pa-1" }, [
                e.items.map(
                  (a) => n(
                    vn,
                    {},
                    {
                      default: ({ close: s, disabled: i }) => n(
                        "button",
                        {
                          type: "button",
                          class: [
                            a[e.valueType] === e.modelValue ? "bg-gray-100 dark:bg-gray-800" : "",
                            "group flex rounded-md items-center w-full px-2 py-2 text-sm text-gray-900 dark:text-white"
                          ],
                          onClick: (l) => {
                            i || (l.preventDefault(), l.stopPropagation(), t("update:modelValue", a[e.valueType]), s());
                          }
                        },
                        ["optionTitle" in r ? r.optionTitle({ item: a }) : a.title]
                      )
                    }
                  )
                )
              ])
            }
          )
        }
      )
    ]
  }
);
Mn.props = {
  id: { type: String, default: () => re("at-input-add-on-select-") },
  modelValue: { type: [String, Number], default: "" },
  items: { type: Array, default: [] },
  valueType: { type: String, default: "value" },
  valueTitle: { type: String, default: "title" },
  side: {
    type: String,
    default: "left",
    validator: (e) => e === "left" || e === "right"
  },
  disabled: { type: [Boolean, Number, String], default: !1 }
};
const ki = Mn, Dn = (e, t) => {
  let r = {
    title: e.title,
    corner: null,
    error: F(e.error),
    success: F(e.success)
  };
  const a = "corner" in t.slots ? n("span", { class: "text-sm leading-5 text-gray-500 dark:text-gray-300" }, t.slots.corner(r)) : null;
  if (r = Object.assign(
    {},
    r,
    "corner" in t.slots ? {
      corner: {
        name: "AtInputLabelCorner",
        render() {
          return a;
        }
      }
    } : {}
  ), "label" in t.slots)
    return t.slots.label(r);
  const s = n(
    "span",
    {
      class: [
        "text-sm font-medium leading-5 text-gray-700 dark:text-white",
        {
          "text-red-600 dark:text-red-500": r.error,
          "text-green-600 dark:text-green-500": r.success
        }
      ]
    },
    "default" in t.slots ? t.slots.default(r) : e.title
  );
  return "default" in t.slots || e.title ? n(
    "span",
    Object.assign({}, t.attrs, {
      class: ["mb-1", { "flex justify-between": a }].concat(
        "class" in t.attrs ? t.attrs.class : "",
        "staticClass" in t.attrs ? t.attrs.staticClass : ""
      )
    }),
    [a ? [s, a] : s]
  ) : null;
};
Dn.props = {
  title: { type: String, default: "" },
  error: { type: [Boolean, String, Number], default: !1 },
  success: { default: !1 }
};
const Si = Dn, $n = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Si
}, Symbol.toStringTag, { value: "Module" })), _i = (e, t) => n(
  "div",
  Object.assign({}, t.attrs, {
    class: [
      "bg-white shadow overflow-hidden sm:rounded-md dark:bg-gray-800 border border-transparent border-gray-300"
    ].concat("class" in t.attrs ? t.attrs.class : "")
  }),
  [n("ul", ["default" in t.slots ? t.slots.default() : null])]
), Wo = _i;
const jn = (e, t) => {
  const r = Vs("router-link");
  return "default" in t.slots ? n(
    "li",
    Object.assign({}, t.attrs, {
      class: ["at-list-link"].concat("class" in t.attrs ? t.attrs.class : ""),
      style: "list-style-type: none;"
    }),
    [
      n(
        e.to ? r : e.tag,
        Object.assign(
          {},
          {
            class: "block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out dark:bg-gray-800 dark:focus:bg-gray-900"
          },
          e.to ? {
            to: e.to,
            replace: e.replace,
            append: e.append,
            activeClass: e.activeClass,
            exact: e.exact,
            exactActiveClass: e.exactActiveClass,
            ariaCurrentValue: e.ariaCurrentValue,
            tag: e.tag
          } : {}
        ),
        [
          n("div", { class: "flex items-center px-4 py-4 sm:px-6" }, [
            n(
              "div",
              {
                class: "min-w-0 flex-1 flex items-center dark:text-white"
              },
              [t.slots.default()]
            ),
            e.icon ? n("div", { class: ["text-gray-400"] }, [
              n("div", { class: ["mr-1 h-5 w-5"] }, [n(de(e.icon).Icon)])
            ]) : null
          ])
        ]
      )
    ]
  ) : null;
};
jn.props = {
  tag: { type: String, default: "div" },
  to: {
    type: [Object, String],
    validator: (e) => it(e),
    default: ""
  },
  icon: { type: [String, Object], default: () => "ChevronRight" },
  replace: { type: Boolean, default: !1 },
  append: { type: Boolean, default: !1 },
  activeClass: { type: String, default: "router-link-active" },
  exact: { type: Boolean, default: !1 },
  exactActiveClass: { type: String, default: "router-link-exact-active" },
  ariaCurrentValue: {
    type: String,
    default: "page",
    validator: (e) => e === "page" || e === "step" || e === "location" || e === "date" || e === "time"
  }
};
const Zo = jn, nr = "data:image/svg+xml;base64,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", sr = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBpZD0iZmxhZy1pY29ucy11eiIgdmlld0JveD0iMCAwIDUxMiA1MTIiPgogIDxwYXRoIGZpbGw9IiMxZWI1M2EiIGQ9Ik0wIDM0MS4zaDUxMlY1MTJIMHoiLz4KICA8cGF0aCBmaWxsPSIjMDA5OWI1IiBkPSJNMCAwaDUxMnYxNzAuN0gweiIvPgogIDxwYXRoIGZpbGw9IiNjZTExMjYiIGQ9Ik0wIDE2My44aDUxMnYxODQuNEgweiIvPgogIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDE3NGg1MTJ2MTY0SDB6Ii8+CiAgPGNpcmNsZSBjeD0iMTQzLjQiIGN5PSI4MS45IiByPSI2MS40IiBmaWxsPSIjZmZmIi8+CiAgPGNpcmNsZSBjeD0iMTYzLjgiIGN5PSI4MS45IiByPSI2MS40IiBmaWxsPSIjMDA5OWI1Ii8+CiAgPGcgZmlsbD0iI2ZmZiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjc4LjUgMTMxKSBzY2FsZSgyLjA0OCkiPgogICAgPGcgaWQ9ImUiPgogICAgICA8ZyBpZD0iZCI+CiAgICAgICAgPGcgaWQ9ImMiPgogICAgICAgICAgPGcgaWQ9ImIiPgogICAgICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTAtNi0xLjktLjMgMSAuNyIvPgogICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNhIiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB0cmFuc2Zvcm09InNjYWxlKC0xIDEpIi8+CiAgICAgICAgICA8L2c+CiAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNiIiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB0cmFuc2Zvcm09InJvdGF0ZSg3MikiLz4KICAgICAgICA8L2c+CiAgICAgICAgPHVzZSB4bGluazpocmVmPSIjYiIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdHJhbnNmb3JtPSJyb3RhdGUoLTcyKSIvPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2MiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHRyYW5zZm9ybT0icm90YXRlKDE0NCkiLz4KICAgICAgPC9nPgogICAgICA8dXNlIHhsaW5rOmhyZWY9IiNkIiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB5PSItMjQiLz4KICAgICAgPHVzZSB4bGluazpocmVmPSIjZCIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgeT0iLTQ4Ii8+CiAgICA8L2c+CiAgICA8dXNlIHhsaW5rOmhyZWY9IiNlIiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB4PSIyNCIvPgogICAgPHVzZSB4bGluazpocmVmPSIjZSIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgeD0iNDgiLz4KICAgIDx1c2UgeGxpbms6aHJlZj0iI2QiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHg9Ii00OCIvPgogICAgPHVzZSB4bGluazpocmVmPSIjZCIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgeD0iLTI0Ii8+CiAgICA8dXNlIHhsaW5rOmhyZWY9IiNkIiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB4PSItMjQiIHk9Ii0yNCIvPgogIDwvZz4KPC9zdmc+Cg==", Ai = D({
  name: "AtPhoneSelect",
  props: {
    ...Oe.props,
    id: { type: String, default: () => re("at-phone-select-") },
    modelValue: { type: [String, Number], default: "" },
    label: { type: String, default: "Номер телефона" },
    placeholder: { type: String, default: "99 999 99 99" },
    mask: { type: String, default: "## ### ## ##" }
  },
  setup(e) {
    let t = y("998"), r = y(e.modelValue);
    return String(e.modelValue).length === 12 && (r.value = e.modelValue.slice(3), t.value = e.modelValue.slice(0, 3)), { country: t, phone: r, prefix: [
      { value: "998", title: "(+998)", flag: "uz" },
      { value: "992", title: "(+992)", flag: "tj" }
    ] };
  },
  watch: {
    modelValue() {
      this.modelValue.length === 0 && (this.phone = "");
    }
  },
  render() {
    return n(
      st,
      {
        id: this.id,
        addOnBeforeSelect: !0,
        modelValue: this.phone,
        mask: this.mask,
        placeholder: this.placeholder,
        label: this.label,
        error: this.error,
        success: this.success,
        disabled: F(this.disabled),
        "onUpdate:modelValue": (e) => {
          this.phone = e, this.$emit("update:modelValue", this.country + e), this.$emit("onChange", e);
        }
      },
      {
        addOnBefore: () => n(
          ki,
          {
            items: this.prefix,
            modelValue: this.country,
            beforeInput: !0,
            disabled: F(this.disabled),
            "onUpdate:modelValue": (e) => {
              this.$emit("update:modelValue", e + this.phone), this.country = e;
            }
          },
          {
            title: () => n("div", { class: "flex items-center" }, [
              n("img", {
                src: this.country === "998" ? sr : nr,
                alt: this.country === "998" ? sr : nr,
                class: "w-3 h-3 mr-2"
              }),
              this.country
            ]),
            optionTitle: ({ item: e }) => n("div", { class: "flex items-center" }, [
              n("img", {
                src: e.flag === "uz" ? sr : nr,
                alt: e.flag,
                class: "w-3 h-3 mr-2"
              }),
              e.title
            ])
          }
        )
      }
    );
  }
}), Yo = D({
  name: "AtLoginPage",
  emits: ["submit"],
  model: {
    prop: ["phone", "email", "password", "rememberMe"]
  },
  props: {
    title: { type: String, default: "Авторизация" },
    titleLogo: {
      type: Object,
      default: () => {
      },
      validator: function(e) {
        return E(e, "name") && E(e, "path");
      }
    },
    phoneLabel: { type: String, default: "Номер телефона" },
    phoneErrorText: { type: String, default: "" },
    phone: { type: String, default: "" },
    emailLabel: { type: String, default: "Эл.почта" },
    emailErrorText: { type: String, default: "" },
    email: { type: String, default: "" },
    withEmail: { type: Boolean, default: !1 },
    password: { type: String, default: "" },
    passwordLabel: { type: String, default: "Пароль" },
    passwordErrorText: { type: String, default: "" },
    rememberMe: { type: Boolean, default: !1 },
    rememberMeLabel: {
      type: String,
      default: "Запомнить меня на этом устройстве"
    },
    submitted: { type: Boolean, default: !1 },
    submitLabel: { type: String, default: "Войти" },
    submitLoading: { type: Boolean, default: !1 }
  },
  setup(e, { emit: t }) {
    const r = y("password");
    function a(s) {
      s.preventDefault(), t("submit");
    }
    return {
      submitForm: a,
      passwordInputType: r
    };
  },
  render() {
    var e, t;
    return n(
      "form",
      {
        onSubmit: this.submitForm
      },
      [
        n(
          "div",
          {
            class: "p-4 max-w-xl min-w-md sm:py-6 sm:px-8 mx-auto relative m-auto"
          },
          [
            n("div", { class: "text-center w-96" }, [
              this.titleLogo ? n("img", {
                class: "h-10 mx-auto",
                src: (e = this == null ? void 0 : this.titleLogo) == null ? void 0 : e.path,
                alt: (t = this == null ? void 0 : this.titleLogo) == null ? void 0 : t.name
              }) : n("h", { class: "text-xl mx-auto inline" }, [n("b", this.title)])
            ]),
            this.withEmail ? n("div", { class: "mb-4 w-96" }, [
              n(st, {
                label: this.emailLabel,
                placeholder: "test-08@mail.com",
                error: this.submitted && this.emailErrorText.length ? this.emailErrorText : null,
                modelValue: this.email,
                type: "email",
                ref: "emailInput",
                "onUpdate:modelValue": (r) => this.$emit("update:email", r)
              })
            ]) : n("div", { class: "mb-4 mt-4 w-96" }, [
              n(Ai, {
                label: this.phoneLabel,
                error: this.submitted && this.phoneErrorText.length ? this.phoneErrorText : null,
                modelValue: this.phone,
                ref: "phoneInput",
                "onUpdate:modelValue": (r) => this.$emit("update:phone", r)
              })
            ]),
            n("div", { class: "mb-4 w-96" }, [
              n(
                st,
                {
                  label: this.passwordLabel,
                  placeholder: "*********",
                  error: this.submitted && this.passwordErrorText.length ? this.passwordErrorText : null,
                  modelValue: this.password,
                  type: this.passwordInputType,
                  "onUpdate:modelValue": (r) => this.$emit("update:password", r)
                },
                {
                  addOnAfter: () => n(
                    or,
                    {
                      side: "right",
                      select: !0,
                      class: "border-r-0 border-t-0 border-b-0 cursor-pointer"
                    },
                    {
                      default: () => this.passwordInputType === "text" ? n(Is, {
                        class: "h-5 w-5 text-gray-400 dark:text-white",
                        onClick: () => this.passwordInputType = "password"
                      }) : n(Os, {
                        class: "h-5 w-5 text-gray-400 dark:text-white",
                        onClick: () => this.passwordInputType = "text"
                      })
                    }
                  )
                }
              )
            ]),
            n("div", { class: "w-96 grid grid-cols-5 gap-4" }, [
              n(
                "div",
                { class: "col-start-1 col-span-5" },
                n(nl, {
                  modelValue: this.rememberMe,
                  label: this.rememberMeLabel,
                  "onUpdate:modelValue": (r) => this.$emit("update:rememberMe", r)
                })
              ),
              n(
                "div",
                { class: "col-span-5 w-96" },
                n(
                  Bt,
                  {
                    color: "primary",
                    class: "w-full",
                    loading: this.submitLoading
                  },
                  {
                    default: () => n("span", { class: `${this.submitLoading ? "ml-3" : ""}` }, this.submitLabel)
                  }
                )
              )
            ])
          ]
        )
      ]
    );
  }
}), Ti = (e, t) => n(
  "h3",
  Object.assign({}, t.attrs, {
    class: ["text-lg leading-6 font-medium text-gray-900 dark:text-white"].concat(
      "class" in t.attrs ? t.attrs.class : "",
      "staticClass" in t.attrs ? t.attrs.staticClass : ""
    )
  }),
  "default" in t.slots ? t.slots.default() : null
), Ci = Ti, da = {
  xs: "sm:max-w-xs",
  sm: "sm:max-w-sm",
  md: "sm:max-w-md",
  lg: "sm:max-w-lg",
  xl: "sm:max-w-xl",
  "2xl": "sm:max-w-2xl",
  "3xl": "sm:max-w-3xl",
  "4xl": "sm:max-w-4xl",
  "5xl": "sm:max-w-5xl",
  "6xl": "sm:max-w-6xl",
  full: "sm:max-w-full"
};
const Pi = (e) => {
  const t = document.querySelector("body"), r = document.querySelector(".at-sidebar");
  V(t, "HTMLBodyElement") && "style" in t && (t.style.overflow = e), V(r, "HTMLDivElement") && "style" in r && (r.style.overflow = e);
}, Xo = D({
  name: "AtModal",
  emits: ["update:modelValue"],
  props: {
    id: { type: String, default: () => re("at-modal-") },
    modelValue: { type: [Boolean, String, Number], default: !1 },
    title: { type: String, default: "" },
    description: { type: String, default: "" },
    size: {
      type: String,
      default: "md",
      validator: (e) => Object.prototype.hasOwnProperty.call(da, e)
    },
    conditionalRendering: {
      type: Boolean,
      default: !1
    }
  },
  setup(e, t) {
    let r = y(e.id);
    const a = (f) => {
      e.id === r.value && Pi(f ? "hidden" : "auto");
    }, s = () => {
      a(!1), t.emit("update:modelValue", !1);
    }, i = C(() => ({
      value: F(e.modelValue),
      title: e.title,
      description: e.description,
      close: s
    })), l = y(null), o = y(null), u = (f) => {
      o.value = f.target;
    };
    return document.addEventListener("mousedown", u), qe(() => {
      document.removeEventListener("mousedown", u);
    }), {
      closeOnClickOnOverlay: (f) => {
        o.value === l.value && (f.preventDefault(), f.stopPropagation(), s());
      },
      rootEl: l,
      slotProps: i,
      toggleVisible: a,
      close: s
    };
  },
  render() {
    return n(
      Ee,
      { to: "body" },
      n(
        "div",
        {
          class: [
            "at-modal-package fixed inset-0 z-10 duration-300",
            this.modelValue ? "opacity-1 pointer-events-auto visible" : "opacity-0 pointer-events-none invisible"
          ],
          style: {
            zIndex: Ae.medium
          }
        },
        [
          n(
            "div",
            {
              "at-modal": this.id,
              ref: "rootEl",
              class: ["fixed h-full w-full text-center p-4 md:py-7", "flex flex-col overflow-y-auto overflow-x-none"],
              onClick: this.closeOnClickOnOverlay
            },
            [
              n(
                _e,
                {
                  appear: !0,
                  enterFromClass: this.conditionalRendering ? "scale-95" : "",
                  leaveToClass: this.conditionalRendering ? "scale-95" : ""
                },
                () => {
                  var e;
                  return !this.conditionalRendering || this.modelValue ? n(
                    "div",
                    {
                      class: [
                        "transition-transform ease-in duration-200 transform z-20",
                        "max-w-full m-auto",
                        {
                          "scale-95": !this.modelValue
                        }
                      ]
                    },
                    [
                      n(
                        "div",
                        {
                          class: [
                            "rounded-lg text-left shadow-xl relative flex flex-col",
                            da[this.size],
                            "sm:w-full bg-white dark:bg-gray-800",
                            ("footer" in this.$slots, "pt-5 sm:pt-6")
                          ]
                        },
                        [
                          n("div", { class: "sm:block absolute top-0 right-0 pt-4 pr-4" }, [
                            n(
                              "button",
                              {
                                class: "outline-none text-gray-400 dark:text-white hover:text-gray-500 dark:hover:text-gray-200 focus:outline-none",
                                onClick: this.close
                              },
                              [n(jt, { style: [{ width: "24px", height: "24px" }] })]
                            )
                          ]),
                          n("div", { class: "mb-2 px-4 sm:px-6" }, [
                            "title" in this.$slots ? this.$slots.title(this.slotProps) : this.title ? n(Ci, {}, { default: () => this.title }) : null
                          ]),
                          n(
                            "div",
                            {
                              class: "h-full text-sm text-gray-500 dark:text-gray-300 flex flex-col pb-4 sm:pb-6 w-screen max-w-full px-4 sm:px-6"
                            },
                            [
                              "default" in this.$slots ? (e = this.$slots) == null ? void 0 : e.default(this.slotProps) : this.description ? n("p", this.description) : null
                            ]
                          ),
                          "footer" in this.$slots ? n(
                            "div",
                            {
                              class: "rounded-b-lg bg-gray-50 dark:bg-gray-900 dark:text-white px-4 py-3 sm:px-6 block"
                            },
                            this.$slots.footer(this.slotProps)
                          ) : null
                        ]
                      )
                    ]
                  ) : null;
                }
              )
            ]
          )
        ]
      )
    );
  }
}), Ii = {
  props: {
    offset: {
      type: Array,
      default: () => [0, 4]
    },
    placement: {
      type: String,
      default: "bottom",
      validator: (e) => e && ["bottom", "top", "left", "right"].includes(e)
    },
    alignment: {
      type: String,
      default: "center",
      validator: (e) => e && ["start", "center", "end"].includes(e)
    },
    teleport: { type: Boolean, default: !1 },
    teleportToRef: { type: Object, default: null },
    teleportToSelector: { type: String, default: "body" }
  }
}, Oi = br(() => Promise.resolve().then(() => $n)), Mi = 95, ca = D({
  name: "AtMultiselect",
  emits: ["update:modelValue", "scrollToBottom", "search", "open", "close", "create"],
  props: {
    ...Oe.props,
    ...Ii.props,
    options: { type: Array, default: () => [] },
    valueType: { type: String, default: "value" },
    valuePrint: { type: String, default: "title" },
    modelValue: { type: Array, default: () => [] },
    placeholder: { type: String, default: "Выберите элементы" },
    searchPlaceholder: { type: String, default: "Поиск по элементам..." },
    hint: { type: String, default: null },
    externalSearch: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    noDataText: { type: String, default: "Ничего не найдено" },
    creatable: { type: Boolean, default: !1 },
    createButtonLoading: { type: Boolean, default: !1 },
    createButtonText: { type: String, default: "Создать" }
  },
  directives: { ...ut },
  setup(e, { emit: t, slots: r }) {
    const a = lt("click-outside"), s = y(!1), i = y(!1), l = y(!1), o = y(null), u = y([]), c = y(null), f = y(null), { x: h, y: d, updatePosition: g, destroyAutoFloating: p } = Qe(c, f, {
      autoFloating: !0,
      placement: e.placement,
      alignment: e.alignment,
      offset: e.offset
    });
    X(() => {
      g();
    }), G([() => f.value, () => c.value], g);
    const x = C(() => r.label ? r.label() : e.label ? n(Oi, () => e.label) : null), m = C(() => {
      const M = [
        "relative w-full border border-gray-300 rounded-md shadow-sm px-3 py-2 text-left cursor-default sm:text-sm cursor-pointer text-gray-700 placeholder-gray-600 dark:text-white dark:placeholder-gray-400",
        "flex items-center"
      ];
      return e.disabled ? M.push("bg-gray-50 dark:bg-gray-600 cursor-not-allowed") : M.push(
        "bg-white focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:focus:ring-gray-500 dark:focus:border-gray-500"
      ), u.value.length && M.push("text-gray-500 dark:text-gray-300"), (e.error || e.success) && M.push(ot(e.error, e.success)), M;
    }), b = C(() => {
      let M = e.options.map((Z) => ({
        ...Z,
        _selected: w.value.some((le) => le == Z[e.valueType])
      }));
      return i.value && !e.externalSearch && (M = M.filter(
        (Z) => {
          var le, tt;
          return (tt = Z == null ? void 0 : Z[e.valuePrint]) == null ? void 0 : tt.toLowerCase().includes((le = o.value) == null ? void 0 : le.toLowerCase());
        }
      )), M;
    }), w = C(() => u.value.map((M) => M[e.valueType])), k = C(() => e.externalSearch ? 500 : 0), S = (M) => {
      const Z = M.target.value;
      o.value = Z, l.value = !1, v(Z);
    }, v = Pa((M) => {
      i.value = !!M, t("search", M);
    }, k.value), P = () => {
      s.value && (s.value = !1, o.value = "", i.value && (i.value = !1, t("search", "")));
    }, O = (M) => {
      const Z = M == null ? void 0 : M[e.valuePrint], le = M == null ? void 0 : M[e.valueType];
      return {
        [e.valuePrint]: Z,
        [e.valueType]: le,
        modelValue: M,
        color: $s(Z)
      };
    }, $ = (M) => {
      w.value.includes(M[e.valueType]) ? u.value = u.value.filter(
        (Z) => (Z == null ? void 0 : Z[e.valueType]) != (M == null ? void 0 : M[e.valueType])
      ) : u.value.push(O(Ye(M))), t("update:modelValue", w.value);
    }, W = (M) => {
      M.value >= Mi ? !e.loading && !l.value && (l.value = !0, t("scrollToBottom", {
        query: i.value ? o.value : null
      })) : e.loading || (l.value = !1);
    }, { listener: ce } = Za(W), fe = () => {
      e.modelValue.length === w.value.length && e.modelValue.every((M, Z) => M == w.value[Z]) || (u.value = e.modelValue.map((M) => ({
        ...u.value.find((le) => le[e.valueType] == M) || O(e.options.find((le) => le[e.valueType] == M) || M)
      })));
    }, et = () => {
      t("create", o.value);
    };
    G(
      () => e.modelValue,
      () => {
        fe();
      },
      { immediate: !0 }
    ), G(
      () => e.loading,
      (M) => {
        !M && l.value && (l.value = !1);
      }
    ), G(
      () => e.options,
      () => {
        e.loading || (l.value = !1, fe());
      }
    ), G(s, (M) => {
      t(M ? "open" : "close");
    });
    const Te = y(0), Re = y(null);
    return "ResizeObserver" in window && e.teleport && (Re.value = new ResizeObserver((M) => {
      if (M != null && M.length) {
        const le = M[0].borderBoxSize[0];
        Te.value = le.inlineSize, ne(() => {
          g();
        });
      }
    })), X(() => {
      var M;
      (M = Re.value) != null && M.observe && e.teleport && Re.value.observe(c.value);
    }), qe(() => {
      var M;
      p(), (M = Re.value) != null && M.disconnect && Re.value.disconnect();
    }), {
      selectedOptions: u,
      label: x,
      buttonClasses: m,
      showOptionsList: s,
      optionsComputed: b,
      inputValue: o,
      scrolledToBottom: l,
      clickOutside: a,
      listener: ce,
      onInput: S,
      clickOutsideHandler: P,
      toggleOption: $,
      referenceRef: c,
      floatingRef: f,
      x: h,
      y: d,
      optionsWidth: Te,
      createOption: et
    };
  },
  render() {
    var e;
    return Ke(
      n("div", { id: this.id, class: "relative" }, [
        this.label || this.hint ? n("div", { class: "flex items-center" }, [
          this.label,
          this.hint ? n("div", { class: "ml-auto text-sm text-gray-500 dark:text-gray-300" }, this.hint) : null
        ]) : null,
        n(
          "button",
          {
            ref: "referenceRef",
            type: "button",
            class: this.buttonClasses,
            disabled: this.disabled,
            onClick: () => this.showOptionsList = !0
          },
          [
            n("div", { class: "w-full flex flex-wrap gap-1" }, [
              this.selectedOptions.length ? this.selectedOptions.map(
                (t) => n(
                  ir,
                  {
                    color: t.color
                  },
                  () => n("div", { class: "flex items-center space-x-1" }, [
                    n("span", null, (t == null ? void 0 : t[this.valuePrint]) || (t == null ? void 0 : t.modelValue)),
                    n(
                      "div",
                      {
                        class: "p-0.5",
                        onClick: (r) => {
                          r.stopPropagation(), !this.disabled && this.toggleOption(t);
                        }
                      },
                      n(jt, {
                        class: "h-3 w-3"
                      })
                    )
                  ])
                )
              ) : n("span", null, this.placeholder)
            ]),
            n(mr, { class: "h-5 w-5 text-gray-400", "aria-hidden": !0 })
          ]
        ),
        n(
          Ee,
          {
            to: (e = this.teleportToRef) != null && e.value ? this.teleportToRef.value : this.teleportToSelector,
            disabled: !this.teleport
          },
          n(
            _e,
            {
              enterActiveClass: "transition transition-opacity duration-200",
              enterFromClass: "opacity-0",
              enterToClass: "opacity-100",
              leaveActiveClass: "transition transition-opacity duration-200",
              leaveFromClass: "opacity-100",
              leaveToClass: "opacity-0"
            },
            () => this.showOptionsList ? n(
              "div",
              {
                class: [
                  "absolute top-0 left-0 w-full bg-white shadow-lg max-h-60 rounded-md pb-1 text-base ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
                  "dark:bg-gray-700"
                ],
                ref: "floatingRef",
                style: {
                  transform: `translate(${this.x}px, ${this.y}px)`,
                  zIndex: Ae.low,
                  maxWidth: this.optionsWidth ? this.optionsWidth / 16 + "rem" : null
                }
              },
              [
                n("div", { class: "p-3 py-2 z-40 bg-white w-full dark:bg-gray-700 flex items-center" }, [
                  n("input", {
                    modelValue: this.inputValue,
                    type: "search",
                    class: [
                      "shadow-sm focus:ring-primary-500 focus:border-primary-500 block w-full sm:text-sm bg-gray-100 border-0 rounded-md py-1 w-full placeholder-opacity-100 placeholder-gray-600 pl-2 pr-7",
                      "dark:bg-gray-800 dark:text-white dark:placeholder-gray-400 dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:placeholder-gray-400"
                    ],
                    placeholder: this.searchPlaceholder,
                    onInput: this.onInput
                  }),
                  n(Ms, { class: "absolute h-5 w-5 text-gray-400 right-4" })
                ]),
                n("ul", { class: "overflow-auto h-full max-h-48", onScroll: this.listener }, [
                  this.optionsComputed.length && (!this.loading || this.scrolledToBottom) ? this.optionsComputed.map(
                    (t) => n(
                      "li",
                      n(
                        "button",
                        {
                          type: "button",
                          class: [
                            "cursor-default select-none relative py-2 px-3 cursor-pointer flex items-center justify-between w-full flex items-center justify-between text-left",
                            t != null && t._selected ? "text-white bg-primary-600 dark:bg-primary-500" : "text-gray-900 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-800"
                          ],
                          onClick: () => this.toggleOption(t)
                        },
                        [
                          "option" in this.$slots ? this.$slots.option({ option: t }) : t[this.valuePrint],
                          !this.$slots.option && (t != null && t._selected) ? n(Ds, { class: "text-white mr-2 h-4 w-4 inline truncate" }) : null
                        ]
                      )
                    )
                  ) : null,
                  !this.loading && !this.optionsComputed.length ? n("li", { class: "space-y-2 pt-2 block text-center text-sm" }, [
                    n("span", [this.noDataText]),
                    this.creatable ? n(
                      "button",
                      {
                        type: "button",
                        class: [
                          "text-start flex items-center justify-between text-dark dark:text-white text-xs font-medium px-3 py-2 bg-gray-100 w-full border"
                        ],
                        disabled: this.createButtonLoading,
                        onClick: this.createOption
                      },
                      [
                        n("div", { class: "space-x-2" }, [
                          n("span", [this.createButtonText]),
                          n(
                            ir,
                            {
                              color: "blue"
                            },
                            () => n("span", this.inputValue)
                          )
                        ]),
                        this.createButtonLoading ? n(nt, { class: "w-4 h-4 ml-4" }) : null
                      ]
                    ) : null
                  ]) : null,
                  "loading" in this.$slots ? this.$slots.loading() : this.loading && n("li", { class: "flex justify-center items-center py-3" }, n(nt))
                ])
              ]
            ) : null
          )
        ),
        // Error message and help text printing
        this.error || this.success ? n(
          Le,
          { type: He(this.error, this.success) },
          { default: () => this.error || this.success }
        ) : null
      ]),
      [[this.clickOutside, this.clickOutsideHandler]]
    );
  }
}), Jo = D({
  props: {
    navLinks: {
      type: Array,
      default: () => [],
      validator: (e) => e.every((t) => E(t, "title") && E(t, "to"))
    },
    logo: {
      type: Object,
      default: () => {
      },
      validator: function(e) {
        return E(e, "name") && E(e, "path");
      }
    },
    user: {
      type: Object,
      default: () => {
      },
      validator: (e) => Object.keys(e).length ? E(e, "name") && E(e, "phone") : {}
    },
    inContainer: { type: Boolean, default: !1 }
  },
  setup(e, { slots: t }) {
    return {
      rightSlotExist: "right" in t
    };
  },
  render() {
    const e = (a) => [
      a ? "bg-primary-50 text-primary-700 border-primary-500 dark:bg-gray-700 dark:text-white dark:border-primary-500" : "border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800",
      "block pl-3 pr-4 py-2 border-l-4 text-base font-medium"
    ], t = () => {
      var a, s;
      if (E(this.user, "links")) {
        if (this.user.links.every((i) => E(i, "title") && E(i, "route")))
          return (s = (a = this.user) == null ? void 0 : a.links) == null ? void 0 : s.map(
            (i) => n(Pt, {
              title: i.title,
              icon: i.icon || "",
              active: i.route.name === this.$route.name,
              onClick: () => {
                this.$router.push(i.route);
              }
            })
          );
        throw new Error(
          'User navigation link must contain "title" and "route" parameters, "icon" parameter is secondary'
        );
      } else
        return [];
    }, r = () => {
      var a, s;
      if (E(this.user, "links")) {
        if (this.user.links.every((i) => E(i, "title") && E(i, "route")))
          return (s = (a = this.user) == null ? void 0 : a.links) == null ? void 0 : s.map(
            (i) => n(
              me,
              {
                to: i.route,
                class: e(i.route.name === this.$route.name)
              },
              { default: () => i.title }
            )
          );
        throw new Error(
          'User navigation link must contain "title" and "route" parameters, "icon" parameter is secondary'
        );
      } else
        return [];
    };
    return n(
      Zl,
      {
        as: "nav",
        class: ["border-b", "bg-white border-gray-200", "dark:bg-gray-800 dark:border-gray-800"]
      },
      {
        default: ({ open: a }) => {
          var s, i;
          return [
            n(
              "div",
              {
                class: ["mx-auto px-4", this.inContainer ? "container" : "sm:px-6 lg:px-8"]
              },
              [
                n("div", { class: "flex justify-between h-16" }, [
                  n("div", { class: "flex" }, [
                    n("div", { class: "flex-shrink-0 flex items-center" }, [
                      n(
                        me,
                        { to: "/", exact: !0 },
                        {
                          default: () => {
                            var l, o, u, c;
                            return [
                              n("img", {
                                class: "h-8 w-auto hidden dark:block",
                                src: ((l = this.logo) == null ? void 0 : l.path) ?? "https://tailwindui.com/img/logos/workflow-logo-indigo-500-mark-white-text.svg",
                                alt: ((o = this.logo) == null ? void 0 : o.name) ?? "Nav logo"
                              }),
                              n("img", {
                                class: "h-8 w-auto block dark:hidden",
                                src: ((u = this.logo) == null ? void 0 : u.path) ?? "https://tailwindui.com/img/logos/workflow-logo-indigo-600-mark-gray-800-text.svg",
                                alt: ((c = this.logo) == null ? void 0 : c.name) ?? "Nav logo"
                              })
                            ];
                          }
                        }
                      )
                    ]),
                    n("div", { class: "hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8" }, [
                      this.navLinks.map((l) => n(
                        me,
                        {
                          to: l.to,
                          class: [
                            l.to.name === this.$route.name ? "border-primary-500 text-gray-900 dark:border-primary-500 dark:text-white inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium" : "text-gray-500 hover:border-gray-300 hover:text-gray-700 border-transparent dark:text-gray-400 dark:hover:border-white dark:hover:text-white dark:border-transparent inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                          ],
                          "aria-current": l.to.name === this.$route.name ? "page" : void 0
                        },
                        () => [
                          l.title,
                          l.badge ? n("div", { class: "ml-2" }, [n(ir, { color: "red" }, [l.badge])]) : null
                        ]
                      ))
                    ])
                  ]),
                  n("div", { class: "hidden sm:ml-6 sm:flex sm:items-center" }, [
                    this.rightSlotExist && n("div", [(i = (s = this.$slots).right) == null ? void 0 : i.call(s)]),
                    n(
                      Ar,
                      { as: "div", class: "ml-3 relative" },
                      {
                        default: () => [
                          n("div", [
                            n(
                              Gt,
                              {
                                class: "max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                              },
                              {
                                default: () => {
                                  var l, o;
                                  return n("img", {
                                    src: ((l = this == null ? void 0 : this.user) == null ? void 0 : l.avatar_link) ?? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmPReGCHDr3lDMPI3fSycaaL0ecArfpvJtfQ&usqp=CAU",
                                    alt: ((o = this.user) == null ? void 0 : o.name) ?? "Пользователь",
                                    class: "h-8 w-8 rounded-full"
                                  });
                                }
                              }
                            )
                          ]),
                          n(
                            _e,
                            {
                              enterActiveClass: "transition ease-out duration-200",
                              enterFromClass: "transform opacity-0 scale-95",
                              enterToClass: "transform opacity-100 scale-100",
                              leaveActiveClass: "transition ease-in duration-75",
                              leaveFromClass: "transform opacity-100 scale-100",
                              leaveToClass: "transform opacity-0 scale-95"
                            },
                            {
                              default: () => [
                                n(
                                  Tr,
                                  {
                                    class: [
                                      "origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none",
                                      "dark:bg-gray-700 dark:ring-gray-700"
                                    ]
                                  },
                                  {
                                    default: () => {
                                      var l, o, u, c, f;
                                      return [
                                        n("div", { class: "block px-4 py-3" }, [
                                          n(
                                            "div",
                                            {
                                              class: "text-base font-medium text-gray-800 dark:text-white"
                                            },
                                            ((l = this.user) == null ? void 0 : l.full_name) || `${((o = this.user) == null ? void 0 : o.name) ?? ""} ${((u = this.user) == null ? void 0 : u.surname) ?? ""}`
                                          ),
                                          (c = this.user) != null && c.phone ? n(
                                            "div",
                                            {
                                              class: "text-sm font-medium text-gray-500 dark:text-gray-300"
                                            },
                                            (f = this.user) == null ? void 0 : f.phone
                                          ) : null
                                        ]),
                                        t(),
                                        n(Pt, {
                                          title: "Выйти",
                                          icon: { name: "logout", type: "outline" },
                                          onClick: () => this.$emit("logout")
                                        })
                                      ];
                                    }
                                  }
                                )
                              ]
                            }
                          )
                        ]
                      }
                    )
                  ]),
                  n("div", { class: "-mr-2 flex items-center sm:hidden" }, [
                    n(
                      Yl,
                      {
                        class: [
                          "inline-flex items-center justify-center p-2 rounded-md text-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2",
                          "bg-white hover:text-gray-500 hover:bg-gray-100 focus:ring-primary-500",
                          "dark:text-gray-300 dark:bg-gray-800 dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-offset-gray-800"
                        ]
                      },
                      {
                        default: () => a ? n(ya, {
                          class: "block h-6 w-6",
                          "aria-hidden": !0
                        }) : n(va, {
                          class: "block h-6 w-6",
                          "aria-hidden": !0
                        })
                      }
                    )
                  ])
                ])
              ]
            ),
            n(
              Xl,
              { class: "sm:hidden" },
              {
                default: () => {
                  var l, o, u, c, f, h, d, g, p;
                  return [
                    n("div", { class: "pt-2 pb-3 space-y-1" }, [
                      this.navLinks.map(
                        (x) => n(
                          me,
                          {
                            to: x.to,
                            class: e(x.to.name === this.$route.name),
                            "aria-current": x.to.name === this.$route.name ? "page" : void 0
                          },
                          { default: () => x.title }
                        )
                      )
                    ]),
                    n("div", { class: "pt-4 pb-3 border-t border-gray-200" }, [
                      n("div", { class: "flex items-center px-4" }, [
                        n("div", { class: "flex-shrink-0" }, [
                          n("img", {
                            class: "h-10 w-10 rounded-full",
                            src: ((l = this == null ? void 0 : this.user) == null ? void 0 : l.avatar_link) ?? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmPReGCHDr3lDMPI3fSycaaL0ecArfpvJtfQ&usqp=CAU",
                            alt: ((o = this.user) == null ? void 0 : o.name) ?? "Пользователь"
                          })
                        ]),
                        n("div", { class: "ml-3" }, [
                          n(
                            "div",
                            { class: "text-base font-medium text-gray-800" },
                            ((u = this.user) == null ? void 0 : u.full_name) || `${((c = this.user) == null ? void 0 : c.name) ?? ""} ${((f = this.user) == null ? void 0 : f.surname) ?? ""}`
                          ),
                          (h = this.user) != null && h.phone ? n("div", { class: "text-sm font-medium text-gray-500" }, (d = this.user) == null ? void 0 : d.phone) : null
                        ])
                      ]),
                      n("div", { class: "mt-3 space-y-1" }, [
                        this.rightSlotExist && n("div", { class: "px-4" }, [(p = (g = this.$slots).right) == null ? void 0 : p.call(g)]),
                        r(),
                        n(
                          "button",
                          {
                            class: "block w-full text-left px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100",
                            onClick: () => this.$emit("logout")
                          },
                          "Выйти"
                        )
                      ])
                    ])
                  ];
                }
              }
            )
          ];
        }
      }
    );
  }
}), Di = (e) => (wa(), Fs(
  "svg",
  {
    id: "fd59ce54-f850-4dfc-bc34-dd7d379d600e",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1074.392",
    height: "584.231",
    viewBox: "0 0 1074.392 584.231",
    class: "max-h-full max-w-full h-auto w-auto"
  },
  [
    R("title", null, "page not found"),
    R("ellipse", {
      cx: "540.64346",
      cy: "549.3094",
      rx: "527.5",
      ry: "34.9216",
      fill: "#f2f2f2"
    }),
    R("path", {
      d: "M583.47969,324.89424c-85.94407,0-147.651,55.13938-147.651,183.79791,0,145.813,61.70691,184.41057,147.651,184.41057s151.327-42.27352,151.327-184.41057C734.80664,356.75255,669.42376,324.89424,583.47969,324.89424Zm.56495,319.80837c-59.52686,0-90.62592-34.92288-90.62592-135.9163,0-89.11185,32.37209-136.10461,91.899-136.10461s91.899,30.86774,91.899,136.10461C677.21663,607.23367,643.5715,644.70261,584.04464,644.70261Z",
      transform: "translate(-63.054 -157.8845)",
      fill: "#2f2e41"
    }),
    R("path", {
      d: "M384.36531,591.40121H348.831V486.76183A20.95585,20.95585,0,0,0,327.87517,465.806h-8.32638a20.95585,20.95585,0,0,0-20.95586,20.95585V591.40121H198.36285a11.96327,11.96327,0,0,1-10.57763-17.552l106.0824-200.78034A20.95585,20.95585,0,0,0,284.28724,344.33l-6.26231-2.9572a20.95585,20.95585,0,0,0-27.4293,9.07005L121.21416,592.4754a28.41578,28.41578,0,0,0-3.35584,13.39612v0a28.41583,28.41583,0,0,0,28.41584,28.41583H298.59293v66.16727a25.119,25.119,0,0,0,25.119,25.119h.00005a25.119,25.119,0,0,0,25.119-25.119V634.28739h35.53428a21.44307,21.44307,0,0,0,21.44307-21.44307v0A21.44307,21.44307,0,0,0,384.36531,591.40121Z",
      transform: "translate(-63.054 -157.8845)",
      class: `fill-current text-${e}-600`
    }),
    R("path", {
      d: "M1042.36183,591.40121h-35.53428V486.76183A20.95585,20.95585,0,0,0,985.87169,465.806h-8.32638a20.95585,20.95585,0,0,0-20.95586,20.95585V591.40121H856.35937a11.96326,11.96326,0,0,1-10.57763-17.552L951.86413,373.06891A20.95586,20.95586,0,0,0,942.28376,344.33l-6.26231-2.9572a20.95586,20.95586,0,0,0-27.42931,9.07005L779.21068,592.4754a28.41578,28.41578,0,0,0-3.35584,13.39612v0a28.41583,28.41583,0,0,0,28.41583,28.41583H956.58945v66.16727a25.119,25.119,0,0,0,25.119,25.119h0a25.119,25.119,0,0,0,25.119-25.119V634.28739h35.53428a21.44307,21.44307,0,0,0,21.44307-21.44307v0A21.44307,21.44307,0,0,0,1042.36183,591.40121Z",
      transform: "translate(-63.054 -157.8845)",
      class: `fill-current text-${e}-600`
    }),
    R("path", {
      d: "M394.16787,579.148H358.63358V474.50864a20.95585,20.95585,0,0,0-20.95585-20.95586h-8.32638a20.95586,20.95586,0,0,0-20.95586,20.95586V579.148H208.16541a11.96327,11.96327,0,0,1-10.57763-17.552L303.67017,360.81572a20.95586,20.95586,0,0,0-9.58037-28.73893l-6.26231-2.9572a20.95586,20.95586,0,0,0-27.42931,9.07L131.01672,580.2222a28.41582,28.41582,0,0,0-3.35584,13.39613v0a28.41583,28.41583,0,0,0,28.41583,28.41583H308.39549v66.16727a25.119,25.119,0,0,0,25.119,25.119h.00005a25.119,25.119,0,0,0,25.119-25.119V622.0342h35.53429a21.44307,21.44307,0,0,0,21.44307-21.44307v0A21.44307,21.44307,0,0,0,394.16787,579.148Z",
      transform: "translate(-63.054 -157.8845)",
      fill: "none",
      stroke: "#3f3d56",
      "stroke-miterlimit": "10"
    }),
    R("path", {
      d: "M1060.74162,579.148h-35.53428V474.50864a20.95586,20.95586,0,0,0-20.95586-20.95586H995.9251a20.95586,20.95586,0,0,0-20.95586,20.95586V579.148H874.73916a11.96327,11.96327,0,0,1-10.57763-17.552L970.24392,360.81572a20.95586,20.95586,0,0,0-9.58037-28.73893l-6.26231-2.9572a20.95586,20.95586,0,0,0-27.42931,9.07L797.59047,580.2222a28.41582,28.41582,0,0,0-3.35584,13.39613v0a28.41583,28.41583,0,0,0,28.41583,28.41583H974.96924v66.16727a25.119,25.119,0,0,0,25.119,25.119h0a25.119,25.119,0,0,0,25.119-25.119V622.0342h35.53428a21.44307,21.44307,0,0,0,21.44307-21.44307v0A21.44307,21.44307,0,0,0,1060.74162,579.148Z",
      transform: "translate(-63.054 -157.8845)",
      fill: "none",
      stroke: "#3f3d56",
      "stroke-miterlimit": "10"
    }),
    R("path", {
      d: "M603.0848,313.86637c-85.94407,0-147.651,55.13937-147.651,183.79791,0,145.813,61.70691,184.41057,147.651,184.41057s151.327-42.27352,151.327-184.41057C754.41175,345.72467,689.02887,313.86637,603.0848,313.86637Zm.565,319.80836c-59.52686,0-90.62592-34.92287-90.62592-135.91629,0-89.11185,32.37209-136.10461,91.899-136.10461s91.899,30.86774,91.899,136.10461C696.82174,596.20579,663.17661,633.67473,603.64975,633.67473Z",
      transform: "translate(-63.054 -157.8845)",
      fill: "none",
      stroke: "#3f3d56",
      "stroke-miterlimit": "10"
    }),
    R("path", {
      d: "M1069.91781,577.43414a20.81252,20.81252,0,1,0,2.7716-39.91524l.52093,10.7122-5.06814-9.18045a20.734,20.734,0,0,0-10.68367,11.72261,20.40847,20.40847,0,0,0-1.19713,5.62986A20.80856,20.80856,0,0,0,1069.91781,577.43414Z",
      transform: "translate(-63.054 -157.8845)",
      fill: "#57b894"
    }),
    R("path", {
      d: "M1094.99516,701.67756c-1.78906-9.11027,5.9633-17.1868,13.62086-22.43651s16.605-10.40779,19.21775-19.31684c3.755-12.80387-7.43-24.52981-16.13564-34.64176a125.30044,125.30044,0,0,1-16.52359-24.55738c-1.81107-3.5325-3.47558-7.22528-3.95221-11.16626-.68641-5.67546,1.13693-11.32309,2.9739-16.73673q9.17925-27.05169,19.62843-53.65005",
      transform: "translate(-63.054 -157.8845)",
      fill: "none",
      stroke: "#3f3d56",
      "stroke-miterlimit": "10"
    }),
    R("path", {
      d: "M1070.77493,574.6762a20.81252,20.81252,0,1,0,2.7716-39.91524l.52093,10.7122-5.06815-9.18045a20.734,20.734,0,0,0-10.68366,11.72261,20.40847,20.40847,0,0,0-1.19713,5.62986A20.80855,20.80855,0,0,0,1070.77493,574.6762Z",
      transform: "translate(-63.054 -157.8845)",
      fill: "none",
      stroke: "#3f3d56",
      "stroke-miterlimit": "10"
    }),
    R("path", {
      d: "M1092.45136,515.47266a20.78819,20.78819,0,0,1,14.97993-13.19764l1.71361,10.18378,3.177-10.69566a20.81,20.81,0,1,1-19.87057,13.70952Z",
      transform: "translate(-63.054 -157.8845)",
      fill: "#57b894"
    }),
    R("path", {
      d: "M1093.59418,511.7954a20.7882,20.7882,0,0,1,14.97993-13.19763l1.71361,10.18378,3.177-10.69567a20.81,20.81,0,1,1-19.87057,13.70952Z",
      transform: "translate(-63.054 -157.8845)",
      fill: "none",
      stroke: "#3f3d56",
      "stroke-miterlimit": "10"
    }),
    R("path", {
      d: "M1108.04474,625.48885a20.81,20.81,0,0,0,18.419-37.02267l-2.44121,8.21926-1.73105-10.30382a.36183.36183,0,0,0-.053-.0201,20.81113,20.81113,0,1,0-14.1938,39.12733Z",
      transform: "translate(-63.054 -157.8845)",
      fill: "#57b894"
    }),
    R("path", {
      d: "M1109.035,621.76417a20.81,20.81,0,0,0,18.419-37.02267l-2.44121,8.21926-1.73105-10.30382a.3621.3621,0,0,0-.053-.0201,20.81113,20.81113,0,1,0-14.1938,39.12733Z",
      transform: "translate(-63.054 -157.8845)",
      fill: "none",
      stroke: "#3f3d56",
      "stroke-miterlimit": "10"
    }),
    R("path", {
      d: "M1086.37782,660.05148a20.80131,20.80131,0,1,0,4.01058-16.29737l9.27267,13.95654-12.66994-7.40768A20.61638,20.61638,0,0,0,1086.37782,660.05148Z",
      transform: "translate(-63.054 -157.8845)",
      fill: "#57b894"
    }),
    R("path", {
      d: "M1087.23494,657.29354a20.80131,20.80131,0,1,0,4.01058-16.29737l9.27267,13.95655-12.66994-7.40769A20.61626,20.61626,0,0,0,1087.23494,657.29354Z",
      transform: "translate(-63.054 -157.8845)",
      fill: "none",
      stroke: "#3f3d56",
      "stroke-miterlimit": "10"
    }),
    R("path", {
      d: "M72.06146,628.13325a13.67421,13.67421,0,1,0,1.821-26.225l.34227,7.03811-3.32987-6.03172a13.62263,13.62263,0,0,0-7.01936,7.702,13.40883,13.40883,0,0,0-.78654,3.69893A13.6716,13.6716,0,0,0,72.06146,628.13325Z",
      transform: "translate(-63.054 -157.8845)",
      fill: "#57b894"
    }),
    R("path", {
      d: "M88.53774,709.76344c-1.17545-5.98561,3.918-11.292,8.94915-14.7412s10.90978-6.8381,12.62642-12.69151c2.46711-8.41238-4.88167-16.11653-10.60142-22.76027A82.32442,82.32442,0,0,1,88.6556,643.43581a22.20962,22.20962,0,0,1-2.59668-7.33643c-.451-3.72888.747-7.43947,1.95391-10.99634q6.03093-17.77346,12.89623-35.24906",
      transform: "translate(-63.054 -157.8845)",
      fill: "none",
      stroke: "#3f3d56",
      "stroke-miterlimit": "10"
    }),
    R("path", {
      d: "M72.62461,626.32123a13.6742,13.6742,0,1,0,1.821-26.225l.34227,7.03812L71.458,601.10258a13.62262,13.62262,0,0,0-7.01936,7.702,13.40912,13.40912,0,0,0-.78654,3.69892A13.67158,13.67158,0,0,0,72.62461,626.32123Z",
      transform: "translate(-63.054 -157.8845)",
      fill: "none",
      stroke: "#3f3d56",
      "stroke-miterlimit": "10"
    }),
    R("path", {
      d: "M86.86641,587.42343a13.65822,13.65822,0,0,1,9.84209-8.67109l1.12587,6.69093,2.08737-7.02725a13.67252,13.67252,0,1,1-13.05533,9.00741Z",
      transform: "translate(-63.054 -157.8845)",
      fill: "#57b894"
    }),
    R("path", {
      d: "M87.61727,585.0074a13.65822,13.65822,0,0,1,9.84209-8.67108l1.12587,6.69093L100.6726,576a13.67252,13.67252,0,1,1-13.05533,9.0074Z",
      transform: "translate(-63.054 -157.8845)",
      fill: "none",
      stroke: "#3f3d56",
      "stroke-miterlimit": "10"
    }),
    R("path", {
      d: "M97.11155,659.70607a13.67255,13.67255,0,0,0,12.10164-24.32457l-1.60392,5.4002-1.13733-6.76979a.238.238,0,0,0-.0348-.0132,13.67329,13.67329,0,1,0-9.32559,25.70736Z",
      transform: "translate(-63.054 -157.8845)",
      fill: "#57b894"
    }),
    R("path", {
      d: "M97.76214,657.25889a13.67255,13.67255,0,0,0,12.10164-24.32457l-1.60392,5.4002-1.13733-6.7698a.238.238,0,0,0-.0348-.0132,13.67329,13.67329,0,1,0-9.32559,25.70737Z",
      transform: "translate(-63.054 -157.8845)",
      fill: "none",
      stroke: "#3f3d56",
      "stroke-miterlimit": "10"
    }),
    R("path", {
      d: "M82.876,682.41435a13.66684,13.66684,0,1,0,2.635-10.70767l6.09231,9.16971-8.32438-4.867A13.54535,13.54535,0,0,0,82.876,682.41435Z",
      transform: "translate(-63.054 -157.8845)",
      fill: "#57b894"
    }),
    R("path", {
      d: "M83.43913,680.60233a13.66684,13.66684,0,1,0,2.635-10.70767l6.09231,9.16971-8.32439-4.867A13.54535,13.54535,0,0,0,83.43913,680.60233Z",
      transform: "translate(-63.054 -157.8845)",
      fill: "none",
      stroke: "#3f3d56",
      "stroke-miterlimit": "10"
    }),
    R("ellipse", {
      cx: "480.946",
      cy: "319.1155",
      rx: "17",
      ry: "22",
      fill: "#2f2e41"
    }),
    R("ellipse", {
      cx: "573.446",
      cy: "319.6155",
      rx: "17",
      ry: "22",
      fill: "#2f2e41"
    }),
    R("path", {
      d: "M623.5,542.5c0,9.94-13.88,18-31,18s-31-8.06-31-18c0-8.61,10.41-15.81,24.32-17.57a50.10353,50.10353,0,0,1,6.68-.43,50.69869,50.69869,0,0,1,11.13,1.2C615.25,528.29,623.5,534.84,623.5,542.5Z",
      transform: "translate(-63.054 -157.8845)",
      fill: "#2f2e41"
    }),
    R("ellipse", {
      cx: "484.946",
      cy: "314.1155",
      rx: "17",
      ry: "22",
      fill: "none",
      stroke: "#3f3d56",
      "stroke-miterlimit": "10"
    }),
    R("ellipse", {
      cx: "577.446",
      cy: "314.6155",
      rx: "17",
      ry: "22",
      fill: "none",
      stroke: "#3f3d56",
      "stroke-miterlimit": "10"
    }),
    R("ellipse", {
      cx: "533.446",
      cy: "379.6155",
      rx: "31",
      ry: "18",
      fill: "none",
      stroke: "#3f3d56",
      "stroke-miterlimit": "10"
    }),
    R("path", {
      d: "M604,527.2a4.93658,4.93658,0,0,1-1.32,3.392A4.33873,4.33873,0,0,1,599.5,532h-10a4.66433,4.66433,0,0,1-4.5-4.8,4.90458,4.90458,0,0,1,.82-2.74134A47.02,47.02,0,0,1,592.5,524a47.66454,47.66454,0,0,1,11.13,1.28A5.06656,5.06656,0,0,1,604,527.2Z",
      transform: "translate(-63.054 -157.8845)",
      fill: "#fff"
    }),
    R("circle", {
      cx: "484.946",
      cy: "308.1155",
      r: "5",
      fill: "#fff"
    }),
    R("circle", {
      cx: "577.946",
      cy: "308.1155",
      r: "5",
      fill: "#fff"
    }),
    R("circle", {
      cx: "582.946",
      cy: "355.1155",
      r: "5",
      fill: "#ffc107",
      opacity: "0.3"
    }),
    R("circle", {
      cx: "460.946",
      cy: "355.1155",
      r: "5",
      fill: "#ffc107",
      opacity: "0.3"
    })
  ]
)), Ko = D({
  name: "AtNotFoundPage",
  props: {
    title: { type: String, default: "-" },
    description: { type: String, default: "-" },
    btnTitle: { type: String, default: "Вернуться на главную" },
    btnColor: { type: String, default: "primary" },
    color: { type: String, default: "indigo" }
  },
  render() {
    return n("div", {}, [
      n("div", { class: "" }, [
        n(
          "div",
          {
            class: "grid md:grid-cols-2 gap-12 justify-center py-12 items-center"
          },
          [
            n("div", { class: "flex justify-end mb-4 md:mb-0" }, [Di(this.color)]),
            n("div", { class: "mb-4 md:mb-0" }, [
              n("div", { class: "mb-6 text-center md:text-left" }, [
                n("h1", { class: "text-3xl font-semibold" }, this.title),
                n("span", { class: "text-base mt-4 block" }, this.description)
              ]),
              n("div", { class: "flex justify-center md:justify-start" }, [
                n(Bt, { color: this.btnColor, to: { path: "/" } }, { default: () => this.btnTitle })
              ])
            ])
          ]
        )
      ])
    ]);
  }
}), En = (e, t) => n(
  "button",
  Object.assign({}, t.attrs, {
    class: [
      "items-center py-2 relative border text-sm leading-5 font-medium ease-in-out duration-150 transition",
      "focus:ring-1 focus:ring-primary-500 focus:ring-opacity-50",
      "focus:outline-none focus:z-10 cursor-pointer",
      "dark:focus:ring-primary-600",
      e.selected ? ["text-white", "border-primary-600 bg-primary-600", "dark:border-primary-500 dark:bg-primary-500"] : [
        "border-gray-300 bg-white active:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:active:bg-gray-700",
        "focus:border-primary-300",
        "text-gray-700 active:text-gray-700 hover:text-gray-500 dark:text-white dark:active:text-white dark:hover:text-gray-200"
      ]
    ].concat("class" in t.attrs ? t.attrs.class : "", "staticClass" in t.attrs ? t.data.staticClass : "")
  }),
  "default" in t.slots ? t.slots.default() : null
);
En.props = {
  selected: { type: Boolean, required: !0 }
};
const lr = En;
function $i() {
  return { generatePages: (t, r) => {
    const a = (o, u, c = () => null) => {
      const f = [];
      o = o > 0 ? o : 1;
      let h = 0;
      for (let d = o; d <= u; d++)
        f.push(c(d, h++, u));
      return f;
    };
    if (r === 1)
      return [{ page: 1, hidden: !1 }];
    if (r < 6)
      return a(1, r, (o) => ({ page: o, hidden: !1 }));
    const s = r % 2 === 0 ? 1 : 0, i = Math.min(Math.floor(r / 2), 3), l = r - i + 1 + s;
    if (t > i && t < l) {
      const o = t - i + 2, u = t + i - 1 - s;
      return [
        { page: 1, hidden: !0 },
        { title: "...", page: 2, hidden: !1 }
      ].concat(
        a(o, u, (c) => ({ page: c, hidden: !1 })),
        [
          { title: "...", page: Math.max(1, r - 1), hidden: !1 },
          { page: r, hidden: !0 }
        ]
      );
    } else if (t === i) {
      const o = t + i - s;
      return a(1, o, (u, c, f) => ({
        page: u,
        hidden: c === 0 || u === f
      })).concat([
        { title: "...", page: Math.max(1, r - 1), hidden: !1 },
        { page: r, hidden: !1 }
      ]);
    } else {
      if (t === l)
        return [
          { page: 1, hidden: !1 },
          { title: "...", page: 2, hidden: !1 }
        ].concat(
          a(Math.min(t - 1, t - 3), r, (o, u) => ({
            page: o,
            hidden: u === 0 || u === 1
          }))
        );
      {
        const o = a(1, i, (c, f, h) => ({
          page: c,
          hidden: h === c
        })), u = o[o.length - 1] !== void 0 ? o[o.length - 1].page : 0;
        return o.concat(
          [{ title: "...", page: u + 1, hidden: !1 }],
          u > 0 ? a(Math.max(u + 1, r - 2), r, (c, f) => ({
            page: c,
            hidden: f === 0
          })) : []
        );
      }
    }
  } };
}
const Me = (e) => {
  const t = parseInt(e, 10);
  if (Number.isInteger(t))
    return t;
}, Bn = (e, t) => {
  let r = y(1);
  const { generatePages: a } = $i(), s = (l) => {
    r.value = l, t.emit("update:modelValue", l);
  }, i = () => Number.isInteger(Me(r.value)) && Number.isInteger(Me(e.total)) ? a(Me(r.value), Me(e.total)) : [];
  return r.value = Me(e.modelValue || 1), n("nav", { class: ["relative z-0 inline-flex shadow-sm"] }, [
    n(
      lr,
      {
        class: "inline-flex px-2.5 rounded-l-md",
        selected: !1,
        onClick: (l) => {
          l.stopPropagation();
          const o = Me(r.value);
          if (Number.isInteger(o)) {
            const u = Math.max(1, o - 1);
            u !== o && s(u);
          }
        }
      },
      {
        default: () => n(js, {
          style: [{ width: "16px", height: "16px" }]
        })
      }
    ),
    i().map(
      (l, o) => n(
        lr,
        {
          class: l.title === "..." ? "-ml-px inline-flex px-4" : [
            "-ml-px px-4",
            {
              "hidden md:inline-flex": l.hidden,
              "inline-flex": !l.hidden
            }
          ],
          selected: r.value === l.page,
          onClick: (u) => {
            u.stopPropagation(), l.page !== r.value && s(l.page);
          },
          key: "at-pagination-button-page-" + o
        },
        {
          default: () => l.title === "..." ? l.title : l.page
        }
      )
    ),
    n(
      lr,
      {
        class: "inline-flex px-2.5 -ml-px rounded-r-md",
        selected: !1,
        onClick: (l) => {
          l.stopPropagation();
          const o = Me(r.value), u = Me(e.total);
          if (Number.isInteger(o) && Number.isInteger(u)) {
            const c = Math.min(u, o + 1);
            c > o && s(c);
          }
        }
      },
      {
        default: () => n(gr, {
          style: [{ width: "16px", height: "16px" }]
        })
      }
    )
  ]);
};
Bn.props = {
  modelValue: { type: [Number, String], default: 1 },
  total: { type: [Number, String], default: 0 }
};
const qo = Bn, ji = {
  sm: "text-base",
  md: "text-base",
  lg: "text-lg leading-6 font-medium"
}, Ln = (e, t) => {
  const r = ji[e.size];
  return "default" in t.slots ? n(
    e.tag,
    Object.assign({}, t.attrs, {
      class: ["text-gray-900 dark:text-white"].concat("class" in t.attrs ? t.attrs.class : "", r)
    }),
    [t.slots.default()]
  ) : null;
};
Ln.props = {
  tag: { type: String, default: "h2" },
  size: {
    type: String,
    default: "lg",
    validator: (e) => e && ["sm", "md", "lg"].includes(e)
  }
};
const Ei = Ln, Bi = (e, t) => "default" in t.slots ? n(
  "p",
  Object.assign({}, t.attrs, {
    class: ["mt-1 text-sm leading-5 text-gray-500 dark:text-gray-300"].concat(
      "class" in t.attrs ? t.attrs.class : ""
    )
  }),
  t.slots.default()
) : null, Li = Bi, Rn = (e, t) => {
  const r = "at-panel__body", a = {
    [`${r}_no-padding`]: e.noPadding,
    [`${r}_no-padding-x`]: e.noPaddingX,
    [`${r}_no-padding-y`]: e.noPaddingY,
    [`${r}_no-padding-top`]: e.noPaddingTop,
    [`${r}_no-padding-bottom`]: e.noPaddingBottom
  };
  return n(
    "div",
    {
      class: [r, a]
    },
    t.slots.default()
  );
};
Rn.props = {
  noPadding: {
    type: Boolean,
    default: !1
  },
  noPaddingX: {
    type: Boolean,
    default: !1
  },
  noPaddingY: {
    type: Boolean,
    default: !1
  },
  noPaddingTop: {
    type: Boolean,
    default: !1
  },
  noPaddingBottom: {
    type: Boolean,
    default: !1
  }
};
const Ri = Rn;
const Nn = (e, t) => {
  const r = `at-panel at-panel_size-${e.size}`, a = "header" in t.slots || e.title || e.subTitle ? n(
    "div",
    {
      class: [
        "at-panel__header",
        {
          "at-panel__header_no-padding": e == null ? void 0 : e.noHeaderPadding,
          "border-b border-gray-200 dark:border-gray-700": F(e.borderHeader)
        }
      ]
    },
    "header" in t.slots ? t.slots.header({
      title: e.title,
      subTitle: e.subTitle
    }) : [
      e.title ? n(Ei, { size: e.size }, { default: () => e.title }) : null,
      e.subTitle ? n(Li, null, { default: () => e.subTitle }) : null
    ]
  ) : void 0;
  return n(
    "div",
    {
      class: [
        r,
        "bg-white shadow rounded-lg w-full border border-transparent dark:border-gray-700 dark:bg-gray-800 dark:text-white",
        {
          "hover:shadow-lg transition duration-200 hover:-translate-y-1 transform": e.lift
        }
      ],
      style: { marginBlockEnd: "auto" }
    },
    [
      a,
      "default" in t.slots ? n(
        Ri,
        {
          noPadding: e.noBodyPadding,
          class: {
            "overflow-x-auto": F(e.overflow)
          }
        },
        t.slots.default
      ) : null,
      "footer" in t.slots ? n(
        "div",
        {
          class: [
            "at-panel__footer",
            "bg-white rounded-b-lg dark:bg-gray-900 dark:text-white",
            {
              "border-t border-gray-200 dark:border-gray-700": F(e.borderFooter)
            }
          ]
        },
        t.slots.footer()
      ) : null
    ]
  );
};
Nn.props = {
  title: { type: String, default: "" },
  subTitle: { type: String, default: "" },
  noHeaderPadding: { type: Boolean, default: !1 },
  noBodyPadding: { type: Boolean, default: !1 },
  borderHeader: { type: [Boolean, String, Number], default: !0 },
  borderFooter: { type: [Boolean, String, Number], default: !0 },
  overflow: { type: [Boolean, String, Number], default: !0 },
  lift: { type: Boolean, default: !1 },
  size: {
    type: String,
    default: "lg",
    validator: (e) => e && ["sm", "md", "lg"].includes(e)
  }
};
const Qo = Nn, eu = D({
  name: "AtPopover",
  props: {
    modelValue: {
      type: Boolean,
      default: !1
    },
    minWidth: {
      type: Number,
      default: 0
    },
    maxWidth: {
      type: Number,
      default: null
    },
    maxHeight: {
      type: Number,
      default: null
    },
    offset: {
      type: Array,
      default: () => [0, 0]
    },
    placement: {
      type: String,
      default: "bottom",
      validator: (e) => e && ["bottom", "top", "left", "right"].includes(e)
    },
    alignment: {
      type: String,
      default: "center",
      validator: (e) => e && ["start", "center", "end"].includes(e)
    },
    buttonClass: {
      type: String,
      default: ""
    },
    panelClass: {
      type: String,
      default: ""
    },
    static: {
      type: Boolean,
      default: !1
    },
    teleport: { type: Boolean, default: !1 },
    teleportToRef: { type: Object, default: null },
    teleportToSelector: { type: String, default: "body" }
  },
  directives: { ...ut },
  setup(e, { emit: t }) {
    const r = y(null), a = y(null), { x: s, y: i, updatePosition: l, destroyAutoFloating: o } = Qe(r, a, {
      autoFloating: !0,
      placement: e.placement,
      alignment: e.alignment,
      offset: e.offset
    }), u = y(e.modelValue || e.static);
    G(
      () => e.modelValue,
      (d) => {
        d !== u.value && (u.value = d);
      }
    ), X(() => {
      l();
    }), G([() => a.value, () => r.value], l), qe(() => {
      o();
    });
    const c = () => {
      u.value = !0, t("update:modelValue", !0);
    }, f = lt("click-outside");
    return {
      referenceRef: r,
      floatingRef: a,
      x: s,
      y: i,
      clickOutside: f,
      clickOutsideHandler: (d) => {
        const g = (d == null ? void 0 : d.path) || (d != null && d.composedPath ? d == null ? void 0 : d.composedPath() : void 0);
        if (u.value && !e.static && g.indexOf(a.value) < 0) {
          const p = !u.value;
          u.value = p, t("update:modelValue", p);
        }
      },
      isShow: u,
      open: c
    };
  },
  render() {
    var e;
    return n("div", { class: "relative border-0 p-0" }, [
      Ke(
        n("div", [
          n(
            "button",
            {
              ref: "referenceRef",
              class: this.buttonClass,
              onClick: this.open
            },
            "button" in this.$slots ? this.$slots.button({ ...this.$props, isActive: this.isShow }) : n(Bt, null, () => "Open")
          ),
          this.isShow ? n(
            Ee,
            {
              to: (e = this.teleportToRef) != null && e.value ? this.teleportToRef.value : this.teleportToSelector,
              disabled: !this.teleport
            },
            n(
              _e,
              {
                enterActiveClass: "transition transition-opacity duration-200",
                enterFromClass: "opacity-0",
                enterToClass: "opacity-100",
                leaveActiveClass: "transition transition-opacity duration-200",
                leaveFromClass: "opacity-100",
                leaveToClass: "opacity-0"
              },
              () => n(
                "div",
                {
                  ref: "floatingRef",
                  class: ["absolute top-0 left-0 shadow", this.panelClass],
                  style: {
                    transform: `translate(${this.x}px, ${this.y}px)`,
                    zIndex: Ae.low
                  }
                },
                n(
                  "div",
                  {
                    class: "bg-white dark:bg-gray-700 rounded-md dark:bg-gray-700 focus:outline-none overflow-y-auto",
                    style: {
                      minWidth: this.minWidth ? this.minWidth / 16 + "rem" : null,
                      maxWidth: this.maxWidth ? this.maxWidth / 16 + "rem" : null,
                      maxHeight: this.maxHeight ? this.maxHeight / 16 + "rem" : null
                    }
                  },
                  [
                    this.$slots.default && n("div", { class: "p-3 md:p-5" }, this.$slots.default()),
                    this.$slots.footer && n(
                      "div",
                      {
                        class: "bg-gray-50 dark:bg-gray-900 p-3 md:p-5 bg-gray-50"
                      },
                      this.$slots.footer()
                    )
                  ]
                )
              )
            )
          ) : null
        ]),
        [[this.clickOutside, this.clickOutsideHandler]]
      )
    ]);
  }
}), Dr = (e, { emit: t, slots: r }) => n(
  Pr,
  {
    modelValue: e.modelValue,
    disabled: e.disabled,
    "onUpdate:modelValue": (a) => t("update:modelValue", a)
  },
  {
    default: () => [
      n("div", { class: "space-y-4" }, [
        e.items.map((a) => n(
          Ir,
          {
            as: "template",
            value: a[e.valueType],
            disabled: a.disabled
          },
          {
            default: ({ checked: s, active: i }) => n(
              "div",
              {
                class: [
                  "relative block rounded-lg border border-gray-300 bg-white shadow-sm px-6 py-4 cursor-pointer hover:border-gray-400 sm:flex sm:justify-between focus:outline-none",
                  "dark:border-gray-700 dark:bg-gray-800 dark:hover:border-gray-600",
                  {
                    "ring-1 ring-offset-2 ring-primary-500 dark:ring-gray-700 dark:ring-offset-gray-900": i,
                    "border-red-300 dark:border-red-500 form-radio--error": e.error,
                    "border-green-500 dark:border-green-500 form-radio--success": e.success,
                    "border-gray-100 hover:border-gray-100 dark:border-gray-600 dark:hover:border-gray-600 cursor-not-allowed": e.disabled || a.disabled
                  }
                ]
              },
              [
                n("div", { class: "flex items-center" }, [
                  n("div", { class: "text-sm" }, [
                    n(
                      Or,
                      {
                        as: "p",
                        class: "font-medium text-gray-900 dark:text-white"
                      },
                      { default: () => a.title }
                    ),
                    a.subtitle ? n(
                      Ct,
                      {
                        as: "div",
                        class: "text-gray-500 dark:text-gray-300"
                      },
                      { default: () => a.subtitle }
                    ) : null
                  ])
                ]),
                "right" in r ? n(
                  Ct,
                  {
                    as: "div",
                    class: "mt-2 flex text-sm sm:mt-0 sm:block sm:ml-4 sm:text-right"
                  },
                  { default: () => r.right({ item: a }) }
                ) : null,
                n("div", {
                  class: [
                    s ? "border-primary-500 dark:border-gray-500" : "border-transparent",
                    "absolute -inset-px rounded-lg border-2 pointer-events-none"
                  ],
                  "aria-hidden": !0
                })
              ]
            )
          }
        ))
      ])
    ]
  }
);
Dr.props = {
  id: { type: String, default: () => re("at-radio-") },
  valueType: { type: String, default: "label" },
  items: { type: Array, required: !0 },
  noBorder: { type: Boolean, default: !1 },
  modelValue: {},
  error: { type: [Boolean, String, Number], default: !1 },
  success: { type: [Boolean, String, Number], default: !1 },
  disabled: { type: [Boolean, String, Number], default: !1 }
};
Dr.emits = ["update:modelValue"];
const tu = Dr;
const $r = (e, { emit: t, slots: r }) => n(
  Pr,
  {
    modelValue: e.modelValue,
    disabled: e.disabled,
    "onUpdate:modelValue": (a) => t("update:modelValue", a)
  },
  {
    default: () => n(
      "div",
      {
        class: [
          "rounded-md -space-y-px",
          e.inline || e.noBorder ? "bg-transparent" : "bg-white",
          { flex: e.inline },
          { "dark:bg-gray-800": !e.inline && !e.noBorder }
        ]
      },
      [
        e.items.map((a, s) => n(
          Ir,
          {
            as: "template",
            value: a[e.valueType],
            disabled: e.disabled || a.disabled,
            class: [{ "mr-5": e.inline }]
          },
          {
            default: ({ checked: i, active: l }) => n(
              "div",
              {
                class: [
                  "relative flex focus:outline-none",
                  {
                    "rounded-tl-md rounded-tr-md": s === 0,
                    "rounded-bl-md rounded-br-md": s === e.items.length - 1,
                    "border-primary-200 z-10 dark:border-gray-700": i,
                    "bg-primary-50 dark:bg-gray-900": i && !e.noBorder,
                    "bg-gray-50 dark:bg-gray-600 cursor-not-allowed": e.disabled || a.disabled,
                    "cursor-pointer": !e.disabled && !a.disabled,
                    "border-gray-200 dark:border-gray-700": !i,
                    "pb-4": !e.inline,
                    "border px-4 pt-4": !e.noBorder,
                    "border-red-300 dark:border-red-500 form-radio--error": e.error,
                    "border-green-500 dark:border-green-500 form-radio--success": e.success
                  }
                ]
              },
              [
                n(
                  "span",
                  {
                    class: [
                      i ? "bg-primary-600 border-transparent" : "bg-white border-gray-300",
                      l ? "ring-2 ring-offset-2 ring-primary-500 dark:ring-offset-gray-900" : "",
                      "h-4 w-4 mt-0.5 mr-3 cursor-pointer rounded-full border flex items-center justify-center",
                      {
                        "border-red-300 form-radio--error": e.error,
                        "border-green-500 form-radio--success": e.success
                      }
                    ],
                    "aria-hidden": !0
                  },
                  [
                    n("span", {
                      class: "rounded-full bg-white w-1.5 h-1.5"
                    })
                  ]
                ),
                "item" in r ? r.item({ item: a }) : n("div", { class: "flex flex-col" }, [
                  a.title ? n(
                    Or,
                    {
                      as: "span",
                      class: [
                        i ? "text-primary-900 dark:text-primary-400" : "text-gray-900 dark:text-white",
                        "block text-sm font-medium"
                      ]
                    },
                    { default: () => a.title }
                  ) : null,
                  a.subtitle ? n(
                    Ct,
                    {
                      as: "span",
                      class: [
                        i ? "text-primary-700 dark:text-primary-300" : "text-gray-500 dark:text-white",
                        "block text-sm"
                      ]
                    },
                    { default: () => a.subtitle }
                  ) : null
                ])
              ]
            )
          }
        ))
      ]
    )
  }
);
$r.props = {
  id: { type: String, default: () => re("at-radio-") },
  valueType: { type: String, default: "value" },
  items: { type: Array, required: !0 },
  noBorder: { type: Boolean, default: !1 },
  modelValue: {},
  inline: { type: Boolean, default: !1 },
  error: { type: [Boolean, String, Number], default: !1 },
  success: { type: [Boolean, String, Number], default: !1 },
  disabled: { type: [Boolean, String, Number], default: !1 }
};
$r.emits = ["update:modelValue"];
const ru = $r, jr = (e, { emit: t }) => {
  const r = F(e.disabled);
  return n("div", [
    n(
      "label",
      {
        class: [
          "rounded-tl-md rounded-tr-md relative flex cursor-pointer focus:outline-non",
          { "cursor-not-allowed": r }
        ]
      },
      [
        n("input", {
          value: e.value,
          checked: e.value === e.modelValue,
          disabled: r,
          type: "radio",
          class: [
            "h-4 w-4 mt-0.5",
            !e.error && !e.success ? [
              "border-gray-300",
              "text-primary-600",
              "focus:ring-primary-500",
              "dark:text-primary-500",
              "dark:focus:ring-offset-gray-900",
              "dark:focus:ring-primary-400"
            ] : "",
            {
              "cursor-pointer": !r,
              "cursor-not-allowed": r,
              "border-red-300 text-red-500 focus:ring-red-500 dark:border-red-500 dark:text-red-500 dark:focus:ring-red-400 dark:focus:ring-offset-gray-900": e.error,
              "border-green-500 text-green-500 focus:ring-green-500 dark:border-green-500 dark:text-green-500 dark:focus:ring-green-400 dark:focus:ring-offset-gray-900": e.success
            }
          ],
          name: e.name,
          "aria-labelledby": e.id + "label",
          "aria-describedby": e.id + "description",
          onInput: (a) => {
            a.preventDefault(), a.stopPropagation(), t("update:modelValue", a.target.value);
          }
        }),
        e.label || e.description ? n("div", { class: "ml-3 flex flex-col" }, [
          e.label ? n(
            "span",
            {
              class: [
                "block text-sm font-medium",
                e.modelValue === e.value ? ["text-primary-900", "dark:text-primary-500"] : "text-gray-900 dark:text-white"
              ],
              id: e.id + "label"
            },
            e.label
          ) : null,
          e.description ? n(
            "span",
            {
              class: [
                "block text-sm",
                e.modelValue === e.value ? ["text-primary-700", "dark:text-primary-300"] : "text-gray-500 dark:text-white"
              ],
              id: e.id + "description"
            },
            e.description
          ) : null
        ]) : null
      ]
    ),
    e.error ? n(Le, { type: He(e.error, e.success), mt: null }, { default: () => e.error }) : null
  ]);
};
jr.props = {
  id: { type: String, default: () => re("at-radio-option-") },
  modelValue: { type: [String, Number, Boolean], default: "" },
  value: { type: [String, Number, Boolean], default: "" },
  name: { type: String, default: re("at-radio-option-name") },
  label: { type: String, default: "" },
  description: { type: String, default: "" },
  error: { type: [Boolean, String, Number], default: !1 },
  success: { type: [Boolean, String, Number], default: !1 },
  disabled: { type: [Boolean, String, Number], default: !1 }
};
jr.emits = ["update:modelValue"];
const au = jr, Ni = {
  1: "md:grid md:grid-cols-1",
  2: "md:grid md:grid-cols-2",
  3: "md:grid md:grid-cols-3",
  4: "md:grid md:grid-cols-4",
  5: "md:grid md:grid-cols-5",
  6: "md:grid md:grid-cols-6",
  7: "md:grid md:grid-cols-7",
  8: "md:grid md:grid-cols-8",
  9: "md:grid md:grid-cols-9",
  10: "md:grid md:grid-cols-10",
  11: "md:grid md:grid-cols-11",
  12: "md:grid md:grid-cols-12"
}, Er = (e, { emit: t, slots: r }) => n(
  Pr,
  {
    modelValue: e.modelValue,
    "onUpdate:modelValue": (a) => t("update:modelValue", a)
  },
  {
    default: () => [
      n(
        "div",
        {
          class: "relative bg-white rounded-md -space-y-px dark:bg-gray-800"
        },
        [
          e.items.map((a, s) => n(
            Ir,
            {
              as: "template",
              value: a[e.valueType]
            },
            {
              default: ({ checked: i, active: l }) => n(
                "div",
                {
                  class: [
                    "relative border p-4 flex flex-col cursor-pointer md:pl-4 md:pr-6 focus:outline-none",
                    Ni[e.cols],
                    {
                      "rounded-tl-md rounded-tr-md": s === 0,
                      "rounded-bl-md rounded-br-md": s === e.items.length - 1,
                      "bg-primary-50 border-primary-200 z-10 dark:bg-gray-900 dark:border-gray-700 z-10": i,
                      "border-gray-200 dark:border-gray-700": !i,
                      "border-red-300 dark:border-red-500 form-radio--error": e.error,
                      "border-green-500 dark:border-red-300 form-radio--success": e.success
                    }
                  ]
                },
                [
                  n("div", { class: "flex items-center text-sm" }, [
                    n(
                      "span",
                      {
                        class: [
                          i ? "bg-primary-600 border-transparent" : "bg-white border-gray-300",
                          l ? "ring-2 ring-offset-2 ring-primary-500 dark:ring-offset-gray-900" : "",
                          "h-4 w-4 rounded-full border flex items-center justify-center"
                        ],
                        "aria-hidden": !0
                      },
                      [
                        n("span", {
                          class: "rounded-full bg-white w-1.5 h-1.5"
                        })
                      ]
                    ),
                    n(
                      Or,
                      {
                        as: "span",
                        class: [
                          i ? "text-primary-900 dark:text-white" : "text-gray-900 dark:text-white",
                          "ml-3 font-medium"
                        ]
                      },
                      { default: () => a.title }
                    )
                  ]),
                  "columns" in r ? r.columns({ columns: a.columns }) : a.columns.length ? a.columns.map((o, u) => n(
                    Ct,
                    {
                      class: [
                        "ml-6 pl-1 text-sm md:ml-0 md:pl-0",
                        u === a.columns.length - 1 ? "md:text-right" : "md:text-center",
                        i ? "text-primary-900 dark:text-white" : "dark:text-gray-200"
                      ]
                    },
                    { default: () => o.text }
                  )) : null
                ]
              )
            }
          ))
        ]
      )
    ]
  }
);
Er.props = {
  id: { type: String, default: () => re("at-radio-") },
  valueType: { type: String, default: "label" },
  items: { type: Array, required: !0 },
  cols: { type: [Number, String], default: 3 },
  modelValue: {},
  error: { type: [Boolean, String, Number], default: !1 },
  success: { type: [Boolean, String, Number], default: !1 },
  disabled: { type: [Boolean, String, Number], default: !1 }
};
Er.emits = ["update:modelValue"];
const nu = Er, Vn = D({
  emits: ["change", "update:modelValue", "open", "close"],
  props: {
    ...Oe.props,
    modelValue: { type: [Object, String, Number], default: () => {
    } },
    valueType: { type: String, default: "value" },
    label: { type: String, default: "" },
    beforeInput: { type: Boolean, default: !1 },
    placeholder: { type: String, default: "Выберите значение" },
    teleport: { type: Boolean, default: !1 },
    teleportToRef: { type: Object, default: null },
    teleportToSelector: { type: String, default: "body" },
    offset: {
      type: Array,
      default: () => [0, 0]
    },
    placement: {
      type: String,
      default: "bottom",
      validator: (e) => e && ["bottom", "top", "left", "right"].includes(e)
    },
    alignment: {
      type: String,
      default: "center",
      validator: (e) => e && ["start", "center", "end"].includes(e)
    },
    options: {
      type: Array,
      validator: (e) => e.every(
        (t) => Object.prototype.toString.call(t) === "[object Object]" && "title" in t && "value" in t
      )
    }
  },
  setup(e, { slots: t, emit: r }) {
    const a = y(null), s = y(null), i = y(!1), { x: l, y: o, updatePosition: u, destroyAutoFloating: c } = Qe(a, s, {
      autoFloating: !0,
      placement: e.placement,
      alignment: e.alignment,
      offset: e.offset,
      getFloatingDomElement: (p) => {
        var x;
        return (x = p.value) == null ? void 0 : x.$el;
      }
    }), f = C(() => e.options.find((p) => p[e.valueType] === e.modelValue)), h = C(() => {
      var p;
      return ((p = f.value) == null ? void 0 : p[e.valueType]) || [];
    });
    X(() => {
      u();
    }), G([() => {
      var p;
      return (p = s.value) == null ? void 0 : p.$el;
    }, () => a.value], () => {
      u();
    }), qe(() => {
      c();
    });
    const d = () => {
      i.value && (i.value = !1, r("close"));
    }, g = "label" in t ? t.label : e.label;
    return {
      selectedItem: f,
      labelContent: g,
      referenceRef: a,
      floatingRef: s,
      x: l,
      y: o,
      handleClickOutside: d,
      isOpen: i,
      selectedItemValue: h
    };
  },
  render() {
    return Ke(
      n("div", [
        n(
          ri,
          { as: "div", modelValue: this.selectedItemValue, disabled: this.disabled },
          {
            default: () => [
              this.labelContent ? n(
                ai,
                { class: "block text-sm font-medium text-gray-700 leading-6 mb-1 dark:text-white" },
                { default: () => this.labelContent }
              ) : null,
              n(
                "div",
                { ref: "referenceRef" },
                "button" in this.$slots ? this.$slots.button({ disabled: this.disabled, selectedItem: this.selectedItem }) : n(
                  mn,
                  {
                    onClick: () => {
                      this.isOpen = !this.isOpen, this.isOpen ? this.$emit("open") : this.$emit("close");
                    },
                    class: [
                      this.beforeInput ? "" : "border border-gray-300 shadow-sm",
                      "rounded-md cursor-pointer bg-white relative w-full min-w-20 pl-3 pr-10 py-2 text-left  sm:text-sm",
                      ot(this.error, this.success),
                      "transition duration-200",
                      {
                        "cursor-default focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700": !this.disabled
                      },
                      { "text-gray-500 dark:text-gray-300": !this.modelValue },
                      { "bg-gray-50 dark:bg-gray-600 cursor-not-allowed": this.disabled }
                    ]
                  },
                  {
                    default: () => [
                      this.selectedItem && n("div", { class: "flex items-center" }, [
                        this.selectedItem.avatar && n("img", {
                          src: this.selectedItem.avatar,
                          class: "flex-shrink-0 h-6 w-6 rounded-full"
                        }),
                        n("span", { class: ["block truncate", this.selectedItem.avatar ? "ml-2" : ""] }, [
                          this.selectedItem.title
                        ])
                      ]),
                      !this.selectedItem && n("span", [this.placeholder]),
                      n(
                        "span",
                        { class: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none" },
                        [n(mr, { class: "h-5 w-5 text-gray-400", "aria-hidden": !0 })]
                      )
                    ]
                  }
                )
              ),
              n(
                Ee,
                {
                  to: this.teleportToRef ? this.teleportToRef : this.teleportToSelector,
                  disabled: !this.teleport
                },
                n(
                  _e,
                  {
                    leaveActiveClass: "transition ease-in duration-100",
                    leaveFromClass: "opacity-100",
                    leaveToClass: "opacity-0"
                  },
                  {
                    default: () => {
                      var e;
                      return n(
                        ni,
                        {
                          class: [
                            "absolute top-0 left-0 mt-1 w-full min-w-20 bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm",
                            "dark:bg-gray-700 dark:ring-gray-600"
                          ],
                          ref: "floatingRef",
                          style: {
                            width: `${(e = this.referenceRef) == null ? void 0 : e.clientWidth}px`,
                            transform: `translate(${this.x}px, ${this.y}px)`,
                            zIndex: Ae.low
                          }
                        },
                        {
                          default: () => this.options.map(
                            (t) => n(
                              si,
                              {
                                as: "template",
                                value: t.value,
                                onClick: () => {
                                  this.isOpen = !1, this.$emit("close");
                                }
                              },
                              {
                                default: () => n(
                                  "li",
                                  {
                                    class: [
                                      this.selectedItem && t.value === this.selectedItem[this.valueType] ? "text-white bg-primary-600 dark:bg-primary-500 dark:text-white" : "text-gray-900 hover:text-gray-900 hover:bg-gray-100 dark:text-white dark:hover:text-white dark:hover:bg-gray-800",
                                      "cursor-pointer select-none relative py-2 pl-3 pr-9"
                                    ],
                                    onClick: () => {
                                      this.$emit("update:modelValue", this.valueType ? t[this.valueType] : t), this.$emit("change", this.valueType ? t[this.valueType] : t);
                                    }
                                  },
                                  [
                                    t.value === this.selectedItemValue ? n("span", {
                                      class: [
                                        t.value === this.selectedItemValue ? "text-white" : "text-primary-600",
                                        "absolute inset-y-0 right-0 flex items-center pr-4"
                                      ]
                                    }) : "",
                                    n("div", { class: "flex items-center" }, [
                                      t != null && t.avatar ? n("img", {
                                        src: t == null ? void 0 : t.avatar,
                                        class: "flex-shrink-0 h-6 w-6 rounded-full"
                                      }) : "",
                                      n(
                                        "span",
                                        {
                                          class: [
                                            t.value === this.selectedItemValue ? "font-semibold" : "font-normal",
                                            "ml-3 block truncate"
                                          ]
                                        },
                                        [
                                          "option" in this.$slots ? this.$slots.option({ option: t }) : t.title
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              }
                            )
                          )
                        }
                      );
                    }
                  }
                )
              )
            ]
          }
        ),
        this.error ? n(Le, { type: He(this.error, this.success) }, { default: () => this.error }) : null
      ]),
      [[ut["click-outside"], this.handleClickOutside]]
    );
  }
}), Fn = (e, t) => {
  const r = {
    selected: F(e.selected),
    disabled: F(e.disabled)
  };
  let a = "default" in t.slots ? t.slots.default(r) : null;
  return Array.isArray(a) && !a.every((s) => Object.prototype.toString.call(s) === "[object Object]" && "tag" in s && s.tag) && (a = n(
    "span",
    {
      class: ["truncate", { "font-semibold": r.selected, "font-normal": !r.selected }]
    },
    a
  )), n(
    e.tag ? e.tag : "li",
    Object.assign({}, t.attrs, {
      class: [].concat(
        "class" in t.attrs ? t.attrs.class : "",
        "staticClass" in t.attrs ? t.attrs.staticClass : "",
        [
          "text-gray-900 hover:bg-gray-100 select-none relative py-2 px-3",
          {
            "cursor-pointer": !r.disabled && !r.selected,
            "bg-gray-100": !r.disabled && r.selected,
            "bg-gray-200": r.disabled
          }
        ]
      )
    }),
    [a]
  );
};
Fn.props = {
  tag: { type: String, default: "li" },
  selected: { type: [Boolean, String, Number], default: !1 },
  disabled: { type: [Boolean, String, Number], default: !1 }
};
const su = Fn, Gn = (e) => e.to ? E(e, "to") && typeof e.to == "object" && E(e, "title") && typeof e.title == "string" : E(e, "routes") && e.routes.length && E(e, "title") && typeof e.title == "string", zn = (e) => V(e, "array") ? e.every((t) => !(!V(t, "object") || !(E(t, "title") && V(t.title, "string")) || !(E(t, "onClick") && V(t.onClick, "function")) || E(t, "icon") && (!V(t.icon, "object") && !V(t.icon, "string") || V(t.icon, "object") && (!(E(t.icon, "name") && V(t.icon.name, "string")) || !(E(t.icon, "type") && V(t.icon.type, "string")))))) : !1, Vi = (e) => V(e, "array") ? e.every(
  (t) => Object.prototype.toString.call(t) === "[object Object]" && "title" in t && "value" in t
) : !1, Hn = {
  methods: {
    checkActiveRoute(e) {
      var t, r, a, s, i, l, o;
      return e != null && e.routes && ((t = e == null ? void 0 : e.routes) != null && t.length) ? ((r = this.$route) == null ? void 0 : r.name) && ((a = e == null ? void 0 : e.routes) == null ? void 0 : a.some((u) => {
        var c, f, h;
        return (h = (c = this.$route) == null ? void 0 : c.name) == null ? void 0 : h.match(`${(f = u == null ? void 0 : u.to) == null ? void 0 : f.name}*`);
      })) : ((s = this.$route) == null ? void 0 : s.name) && ((o = (i = this.$route) == null ? void 0 : i.name) == null ? void 0 : o.match(`${(l = e == null ? void 0 : e.to) == null ? void 0 : l.name}*`));
    }
  }
}, Br = {
  props: {
    items: {
      type: Array,
      default: () => [],
      validator: (e) => e.every((t) => Gn(t))
    },
    logo: {
      type: Object,
      default: () => {
      },
      validator: function(e) {
        return E(e, "name") && (E(e, "path") || E(e, "darkPath"));
      }
    },
    user: {
      type: Object,
      default: () => {
      },
      validator: (e) => Object.keys(e).length ? E(e, "name") && E(e, "phone") : {}
    },
    userDropdownItems: {
      type: Array,
      default: () => [],
      validator: (e) => zn(e)
    },
    modules: {
      type: Array,
      default: () => [],
      validator: (e) => Vi(e)
    },
    module: {
      type: [Object, String, Number],
      default: () => ""
    },
    noUserSection: { type: Boolean, default: !1 }
  }
}, Un = {
  props: {
    item: {
      type: Object,
      default: () => {
      },
      validator: function(e) {
        return Gn(e);
      }
    },
    active: { type: Boolean, default: !1 }
  }
}, Wn = (e, { emit: t }) => {
  var l, o, u;
  const r = (c) => c ? "bg-gray-100 text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md dark:bg-primary-500 dark:bg-opacity-10 dark:text-primary-500" : "text-gray-700 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md dark:text-gray-200 dark:hover:bg-gray-900 dark:hover:bg-opacity-70 dark:hover:text-white", a = () => {
    var c, f;
    return (f = (c = e.item) == null ? void 0 : c.routes) == null ? void 0 : f.map(
      (h) => {
        var d;
        return n(
          me,
          {
            to: Object.assign({}, h == null ? void 0 : h.to),
            class: ["pl-10", r(e.routeName === ((d = h == null ? void 0 : h.to) == null ? void 0 : d.name))]
          },
          {
            default: () => [
              h == null ? void 0 : h.title,
              h != null && h.count ? n(
                "span",
                {
                  class: [
                    "bg-gray-100 group-hover:bg-gray-200 inline-block py-0.5 px-3 text-xs font-medium rounded-full ml-auto",
                    "dark:bg-primary-500 dark:bg-opacity-10 dark:text-primary-500 dark:group-hover:bg-primary-600"
                  ]
                },
                h == null ? void 0 : h.count
              ) : null
            ]
          }
        );
      }
    );
  }, s = () => {
    var c;
    return n(
      me,
      {
        to: (c = e.item) == null ? void 0 : c.to,
        class: [r(e.active)]
      },
      {
        default: () => {
          var f, h, d, g, p;
          return [
            e.item.icon ? n(de(e.item.icon).Icon, {
              class: [
                "mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500",
                "dark:text-gray-300 dark:group-hover:text-gray-200",
                {
                  "text-gray-500 dark:text-gray-200": e.routeName === ((h = (f = e.item) == null ? void 0 : f.to) == null ? void 0 : h.name)
                }
              ]
            }) : null,
            (d = e.item) == null ? void 0 : d.title,
            (g = e.item) != null && g.count ? n(
              "span",
              {
                class: [
                  "bg-gray-100 group-hover:bg-gray-200 inline-block py-0.5 px-3 text-xs font-medium rounded-full ml-auto",
                  "dark:bg-primary-500 dark:bg-opacity-10 dark:text-primary-500 dark:group-hover:bg-primary-600"
                ]
              },
              (p = e.item) == null ? void 0 : p.count
            ) : null
          ];
        }
      }
    );
  }, i = () => {
    var c, f, h, d, g, p, x, m, b;
    return n("div", { class: ["space-y-1"] }, [
      n(
        "button",
        {
          type: "button",
          class: [
            "group w-full flex items-center pl-2 pr-1 py-2 text-sm font-medium rounded-md hover:text-gray-900 hover:bg-gray-50 focus:outline-none dark:hover:text-white dark:hover:bg-gray-900 dark:hover:bg-opacity-70",
            e.collapsed || (f = (c = e.item) == null ? void 0 : c.routes) != null && f.some((w) => {
              var k;
              return ((k = w == null ? void 0 : w.to) == null ? void 0 : k.name) === e.routeName;
            }) ? "bg-gray-50 text-gray-900 dark:bg-gray-900 dark:bg-opacity-70 dark:text-white" : "bg-white text-gray-600 dark:bg-gray-800 dark:text-gray-200"
          ],
          onClick: (w) => {
            w.stopPropagation(), t("click");
          }
        },
        [
          e.item.icon ? n(de(e.item.icon).Icon, {
            class: [
              "mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500",
              "dark:text-gray-300 dark:group-hover:text-gray-300"
            ]
          }) : null,
          (h = e.item) == null ? void 0 : h.title,
          n("div", { class: ["ml-auto flex items-center"] }, [
            (d = e.item) != null && d.count ? n(
              "span",
              {
                class: [
                  "bg-gray-100 group-hover:bg-gray-200 inline-block py-0.5 px-3 text-xs font-medium rounded-full ml-auto",
                  "dark:bg-gray-800 dark:group-hover:bg-gray-900"
                ]
              },
              (g = e.item) == null ? void 0 : g.count
            ) : null,
            n(gr, {
              class: [
                "transform ease-in-out duration-150 mx-2 h-5 w-5 text-gray-400",
                {
                  "rotate-90": e.collapsed || ((x = (p = e.item) == null ? void 0 : p.routes) == null ? void 0 : x.some((w) => {
                    var k;
                    return ((k = w == null ? void 0 : w.to) == null ? void 0 : k.name) === e.routeName;
                  }))
                }
              ]
            })
          ])
        ]
      ),
      n(
        "div",
        {
          class: [
            "space-y-1 sidebar-collapse-block ",
            {
              "is-collapsed": e.collapsed || ((b = (m = e.item) == null ? void 0 : m.routes) == null ? void 0 : b.some((w) => {
                var k;
                return ((k = w == null ? void 0 : w.to) == null ? void 0 : k.name) === e.routeName;
              }))
            }
          ]
        },
        [a()]
      )
    ]);
  };
  return (l = e.item) != null && l.routes && ((u = (o = e.item) == null ? void 0 : o.routes) != null && u.length) ? i() : s();
};
Wn.props = {
  routeName: { type: String, default: "" },
  collapsed: { type: Boolean, default: !1 },
  ...Un.props
};
const Fi = Wn, Zn = D({
  name: "AtSidebarItem",
  props: { ...Un.props },
  setup() {
    const e = y(!1);
    function t() {
      e.value = !e.value;
    }
    return {
      isCollapseItem: e,
      toggleItemCollapse: t
    };
  },
  render() {
    var e;
    return n(Fi, {
      item: this.item,
      collapsed: this.isCollapseItem,
      active: this.active,
      routeName: ((e = this == null ? void 0 : this.$route) == null ? void 0 : e.name) ?? "",
      onClick: () => {
        this.toggleItemCollapse();
      }
    });
  }
}), Lr = {
  "#": { pattern: /\d/ },
  X: { pattern: /[0-9a-zA-Z]/ },
  S: { pattern: /[a-zA-Z]/ },
  A: { pattern: /[a-zA-Z]/, transform: (e) => e.toLocaleUpperCase() },
  a: { pattern: /[a-zA-Z]/, transform: (e) => e.toLocaleLowerCase() },
  "!": { escape: !0 }
};
function fa(e, t, r = !0, a) {
  e = e || "", t = t || "";
  let s = 0, i = 0, l = "";
  for (; s < t.length && i < e.length; ) {
    let u = t[s];
    const c = a[u], f = e[i];
    c && !c.escape ? (c.pattern.test(f) && (l += c.transform ? c.transform(f) : f, s++), i++) : (c && c.escape && (s++, u = t[s]), r && (l += u), f === u && i++, s++);
  }
  let o = "";
  for (; s < t.length && r; ) {
    const u = t[s];
    if (a[u]) {
      o = "";
      break;
    }
    o += u, s++;
  }
  return l + o;
}
function Gi(e, t, r) {
  return t = t.sort((a, s) => a.length - s.length), function(a, s, i = !0) {
    let l = 0;
    for (; l < t.length; ) {
      const o = t[l];
      l++;
      const u = t[l];
      if (!(u && e(a, u, !0, r).length > o.length))
        return e(a, o, i, r);
    }
    return "";
  };
}
function It(e, t, r = !0, a) {
  return Array.isArray(t) ? Gi(fa, t, a)(e, t, r, a) : fa(e, t, r, a);
}
function ha(e) {
  if (typeof document < "u")
    try {
      const t = document.createEvent("Event");
      return t.initEvent(e, !0, !0), t;
    } catch {
      return;
    }
}
const zi = {
  beforeMount: (e, t) => {
    const r = ha("input");
    if (r !== void 0) {
      let a = t.value;
      if ((Array.isArray(a) || typeof a == "string") && (a = {
        mask: a,
        tokens: Lr
      }), e.tagName.toLocaleUpperCase() !== "INPUT") {
        const i = e.getElementsByTagName("input");
        if (i.length !== 1)
          throw new Error("v-mask directive requires 1 input, found " + i.length);
        e = i[0];
      }
      e.oninput = function(i) {
        const l = ha("input");
        if (l !== void 0) {
          if (!i.isTrusted)
            return;
          let o = e.selectionEnd;
          const u = e.value[o - 1];
          for (e.value = It(e.value, a.mask, !0, a.tokens); o < e.value.length && e.value.charAt(o - 1) !== u; )
            o++;
          e === document.activeElement && (e.setSelectionRange(o, o), setTimeout(function() {
            e.setSelectionRange(o, o);
          }, 0)), e.dispatchEvent(l);
        }
      };
      const s = It(e.value, a.mask, !0, a.tokens);
      s !== e.value && (e.value = s, e.dispatchEvent(r));
    }
  }
}, lu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  directive: zi,
  masker: It,
  tokens: Lr
}, Symbol.toStringTag, { value: "Module" })), Yn = D({
  props: {
    user: {
      type: Object,
      default: () => {
      },
      validator: (e) => Object.keys(e).length ? E(e, "name") && E(e, "phone") : {}
    }
  },
  render() {
    var r, a, s, i;
    const e = (l) => {
      var o;
      return `+${It(l, ((o = this.user) == null ? void 0 : o.phoneFormat) ?? "### ## ### ## ##", !0, Lr)}`;
    }, t = () => n(
      "svg",
      {
        class: ["flex-shrink-0 h-5 w-5 text-gray-400 group-hover:text-gray-500"],
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        fill: "currentColor"
      },
      [
        n("path", {
          "fill-rule": "evenodd",
          d: "M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
          "clip-rule": "evenodd"
        })
      ]
    );
    return n(
      "div",
      {
        class: ["group w-full text-sm text-left font-medium text-gray-700", "dark:bg-gray-800 dark:text-white"]
      },
      n("span", { class: ["flex w-full justify-between items-center"] }, [
        n(
          "span",
          {
            class: ["flex min-w-0 items-center justify-between space-x-3"]
          },
          [
            n("img", {
              class: ["w-10 h-10 bg-gray-300 rounded-full flex-shrink-0 object-cover dark:bg-gray-900"],
              src: ((r = this.user) == null ? void 0 : r.avatar_link) ?? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmPReGCHDr3lDMPI3fSycaaL0ecArfpvJtfQ&usqp=CAU",
              alt: "User avatar"
            }),
            n("span", { class: ["flex-1 min-w-0 text-left"] }, [
              n(
                "span",
                {
                  class: ["text-gray-900 text-sm font-medium truncate block dark:text-white"]
                },
                ((a = this.user) == null ? void 0 : a.name) ?? "Неизвестный"
              ),
              n(
                "span",
                { class: ["text-gray-500 text-xs truncate dark:text-gray-300"] },
                (s = this.user) != null && s.phone ? e((i = this.user) == null ? void 0 : i.phone) : "–"
              )
            ])
          ]
        ),
        t()
      ])
    );
  }
}), Xn = D({
  name: "SidebarUserDropdown",
  emits: ["logout"],
  props: {
    user: {
      type: Object,
      default: null,
      validator: (e) => Object.keys(e).length ? E(e, "name") && E(e, "phone") : {}
    },
    isMobileOrTablet: { type: Boolean, default: !1 },
    items: {
      type: Array,
      default: () => [],
      validator: (e) => zn(e)
    }
  },
  setup() {
    let e = y(!1), t = y(!1);
    const r = ee("sidebar-props");
    return { isOpen: e, showMenu: t, sidebarProps: r };
  },
  render() {
    const e = () => {
      var r;
      let t = [];
      return this.items.length > 0 && (t = this.items), ((r = this.sidebarProps.userDropdownItems) == null ? void 0 : r.length) > 0 && (t = this.sidebarProps.userDropdownItems), t.length > 0 ? t.map(
        (a) => n(
          Pt,
          {
            icon: a.icon,
            onClick: a.onClick
          },
          { default: () => a.title }
        )
      ) : n(
        Pt,
        {
          icon: { name: "logout", type: "outline" },
          onClick: () => {
            this.$emit("logout");
          }
        },
        { default: () => "Выйти" }
      );
    };
    return n(
      "div",
      {
        class: "mt-2 -mb-2 border-t border-gray-200 dark:border-gray-700 py-5 px-3.5 relative flex flex-col items-stretch text-left w-full",
        as: "div"
      },
      [
        n(
          xi,
          { width: "w-full" },
          {
            button: () => n(
              Gt,
              {
                class: "w-full focus:outline-none"
              },
              {
                default: () => n(Yn, { user: this.user ?? this.sidebarProps.user })
              }
            ),
            default: () => e()
          }
        )
      ]
    );
  }
}), Jn = (e) => e.logo ? [
  n(
    me,
    { to: "/", class: "block dark:hidden" },
    {
      default: () => n("img", {
        class: ["h-8 w-auto"],
        src: e.logo.path,
        alt: e.logo.name
      })
    }
  ),
  n(
    me,
    { to: "/", class: "hidden dark:block" },
    {
      default: () => n("img", {
        class: ["h-8 w-auto"],
        src: e.logo.darkPath,
        alt: e.logo.name
      })
    }
  )
] : n(
  me,
  { to: "/" },
  {
    default: () => n("img", {
      class: ["h-8 w-auto"],
      src: "https://tailwindui.com/img/logos/workflow-logo-indigo-600-mark-gray-800-text.svg",
      alt: "Логотип"
    })
  }
);
Jn.props = {
  logo: {
    type: Object,
    default: () => {
    },
    validator: function(e) {
      return E(e, "name") && (E(e, "path") || E(e, "darkPath"));
    }
  }
};
const Kn = Jn, qn = D({
  name: "SidebarModules",
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      type: [Object, String, Number],
      default: ""
    },
    modules: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      selectedModule: void 0
    };
  },
  created() {
    this.selectedModule = this.modelValue, this.selectedModule === "" && (this.selectedModule = this.modules[0].value, this.$emit("update:modelValue", this.selectedModule));
  },
  render() {
    return n("div", { class: ["flex flex-col items-stretch"] }, [
      n(
        Vn,
        {
          class: "w-full",
          options: this.modules,
          modelValue: this.selectedModule,
          onChange: (e) => {
            this.selectedModule = e, this.$emit("update:modelValue", e);
          }
        },
        {
          button: ({ disabled: e }) => n(
            mn,
            {
              class: [
                "rounded-md cursor-pointer bg-gray-50 relative w-full min-w-20 pl-3 pr-10 py-3 text-left sm:text-sm",
                "transition duration-200",
                {
                  "cursor-default focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700": !e
                },
                { "text-gray-500 dark:text-gray-300": !this.selectedModule }
              ]
            },
            {
              default: () => {
                var t;
                return [
                  n("div", { class: "flex items-center" }, [
                    n(
                      "span",
                      {
                        class: ["block truncate text-gray-900 dark:text-white"]
                      },
                      (t = this.modules.find((r) => r.value === this.selectedModule)) == null ? void 0 : t.title
                    )
                  ]),
                  n(
                    "span",
                    {
                      class: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
                    },
                    [
                      n(mr, {
                        class: "h-5 w-5 text-gray-400",
                        "aria-hidden": !0
                      })
                    ]
                  )
                ];
              }
            }
          )
        }
      )
    ]);
  }
}), Hi = D({
  name: "AtSidebarDesktop",
  emits: ["logout", "update:module"],
  props: {
    logout: { type: Function, default: () => {
    } },
    ...Br.props
  },
  methods: {
    ...Hn.methods
  },
  render() {
    var s, i, l;
    const e = "user-section" in this.$slots, t = !this.noUserSection, r = t && e ? (i = (s = this.$slots)["user-section"]) == null ? void 0 : i.call(s) : t ? n(
      Xn,
      {
        user: this.user,
        items: this.userDropdownItems,
        onLogout: () => this.$emit("logout")
      },
      {
        userDropdownItems: () => {
          var o, u;
          return "userDropdownItems" in this.$slots ? (u = (o = this.$slots).userDropdownItems) == null ? void 0 : u.call(o) : null;
        },
        ...this.$slots
      }
    ) : null, a = () => this.items.map(
      (o) => n("div", [
        n(Zn, {
          item: o,
          active: !!(this != null && this.checkActiveRoute(o))
        })
      ])
    );
    return n("div", { class: ["flex flex-shrink-0"] }, [
      n(
        "div",
        {
          class: [
            "flex flex-col w-64 border-r border-gray-200 pt-5 bg-white",
            "dark:border-gray-700 dark:bg-gray-800",
            { "pb-4": this.noUserSection }
          ]
        },
        [
          n("div", { class: ["px-4 pb-2"] }, [
            "logo" in this.$slots ? this.$slots.logo() : n(Kn, { logo: this.logo }),
            "modules" in this.$slots ? this.$slots.modules() : (l = this.modules) != null && l.length ? n(qn, {
              class: "py-2  ",
              modules: this.modules,
              modelValue: this.module,
              "onUpdate:modelValue": (o) => this.$emit("update:module", o)
            }) : null
          ]),
          n("div", { class: ["h-0 flex-1 flex flex-col pb-2"] }, [
            n("div", { class: ["flex-1 h-0 overflow-y-auto"] }, [
              n(
                "nav",
                {
                  class: ["flex-1 px-2 bg-white space-y-1 dark:bg-gray-800"]
                },
                [a()]
              )
            ]),
            r
          ])
        ]
      )
    ]);
  }
}), Ui = D({
  name: "SidebarMobile",
  props: {
    ...Br.props,
    isOpen: { type: Boolean, default: !1 }
  },
  emits: ["closeSidebar", "update:module"],
  data() {
    return {
      isHiddenSidebar: !0,
      isOpenSidebar: !1
    };
  },
  watch: {
    isOpen() {
      this.isOpen ? (this.isHiddenSidebar = !this.isOpen, setTimeout(() => {
        this.isOpenSidebar = this.isOpen;
      }, 50)) : (setTimeout(() => {
        this.isHiddenSidebar = !this.isOpen;
      }, 300), this.isOpenSidebar = this.isOpen);
    }
  },
  created() {
    this.isOpenSidebar = this.isOpen;
  },
  methods: {
    ...Hn.methods,
    closeSidebar() {
      this.$emit("closeSidebar");
    }
  },
  render() {
    var l;
    const e = () => this.items.map(
      (o) => n("div", [
        n(Zn, {
          item: o,
          active: !!(this != null && this.checkActiveRoute(o))
        })
      ])
    ), t = () => this.isOpenSidebar ? n(
      "button",
      {
        class: [
          "ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white text-white"
        ],
        onClick: () => this.closeSidebar()
      },
      [n("span", { class: ["sr-only"] }, "Close sidebar"), n(jt, { class: "h-4 w-4 text-white" })]
    ) : null, r = !this.noUserSection, a = "user-section" in this.$slots, s = "userDropdownItems" in this.$slots, i = (() => {
      var o, u;
      return r ? a ? (u = (o = this.$slots)["user-section"]) == null ? void 0 : u.call(o) : n(
        Xn,
        {
          user: this.user,
          items: this.userDropdownItems,
          onLogout: () => this.$emit("logout")
        },
        {
          userDropdownItems: () => {
            var c, f;
            return s ? (f = (c = this.$slots).userDropdownItems) == null ? void 0 : f.call(c) : null;
          },
          ...this.$slots
        }
      ) : null;
    })();
    return n(
      "div",
      {
        class: ["fixed inset-0 flex z-40", { hidden: this.isHiddenSidebar }]
      },
      [
        n("div", {
          class: [
            "fixed inset-0 bg-gray-600 bg-opacity-75 transition-opacity ease-linear duration-300",
            this.isOpenSidebar ? "opacity-100" : "opacity-0"
          ],
          "aria-hidden": "true",
          onClick: () => this.closeSidebar()
        }),
        n(
          "div",
          {
            class: [
              "relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-white transition ease-in-out duration-300 transform",
              "dark:bg-gray-800",
              this.isOpenSidebar ? "translate-x-0" : "-translate-x-full"
            ]
          },
          [
            n(
              "div",
              {
                class: [
                  "absolute top-0 right-0 -mr-12 pt-2 ease-in-out duration-300",
                  this.isOpenSidebar ? "opacity-100" : "opacity-0"
                ]
              },
              [t()]
            ),
            n("div", { class: ["px-4 pb-2"] }, [
              "logo" in this.$slots ? this.$slots.logo() : n(Kn, { logo: this.logo }),
              "modules" in this.$slots ? this.$slots.modules() : (l = this.modules) != null && l.length ? n(qn, {
                class: "py-2  ",
                modules: this.modules,
                modelValue: this.module,
                "onUpdate:modelValue": (o) => this.$emit("update:module", o)
              }) : null
            ]),
            n("div", { class: ["h-0 flex-1 flex flex-col pb-2"] }, [
              n(
                "div",
                {
                  class: ["flex-1 h-0 overflow-y-auto"]
                },
                [n("nav", { class: ["px-2 bg-white space-y-1 dark:bg-gray-800"] }, [e()])]
              ),
              i
            ])
          ]
        )
      ]
    );
  }
});
const iu = D({
  name: "AtSidebar",
  emits: ["logout", "update:module"],
  props: { ...Br.props, loggedIn: { type: Boolean, default: !1 } },
  setup(e) {
    const t = y(!1), r = y(!1), a = Hs();
    G(a, () => {
      t.value = !1;
    });
    const s = navigator.userAgent;
    /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(s) ? r.value = !0 : r.value = /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      s
    );
    function i() {
      t.value = !1;
    }
    function l() {
      t.value = !0;
    }
    return se(
      "sidebar-props",
      C(() => ({
        ...e
      }))
    ), {
      isOpen: t,
      isMobileOrTablet: r,
      closeSidebar: i,
      openSidebar: l
    };
  },
  render() {
    var t, r;
    return n("div", { class: ["h-screen flex overflow-hidden z-50"] }, [
      (() => this.isMobileOrTablet ? n(
        Ui,
        {
          items: this.items,
          logo: this.logo,
          user: this.user,
          userDropdownItems: this.userDropdownItems,
          modules: this.modules,
          module: this.module,
          noUserSection: this.noUserSection,
          loggedIn: this.loggedIn,
          isOpen: this.isOpen,
          onLogout: () => {
            this.$emit("logout");
          },
          "onUpdate:module": (a) => {
            this.$emit("update:module", a);
          },
          onCloseSidebar: () => this.closeSidebar()
        },
        { ...this.$slots }
      ) : n(
        Hi,
        {
          items: this.items,
          logo: this.logo,
          user: this.user,
          userDropdownItems: this.userDropdownItems,
          modules: this.modules,
          module: this.module,
          noUserSection: this.noUserSection,
          loggedIn: this.loggedIn,
          onLogout: () => {
            this.$emit("logout");
          },
          "onUpdate:module": (a) => {
            this.$emit("update:module", a);
          }
        },
        { ...this.$slots }
      ))(),
      n("div", { class: ["flex flex-col w-0 flex-1 overflow-hidden"] }, [
        this.isMobileOrTablet ? n(
          "div",
          {
            class: [
              "relative z-10 flex-shrink-0 flex h-12 bg-white border-b border-gray-200",
              "dark:bg-gray-800 dark:border-gray-700"
            ]
          },
          [
            n(
              "button",
              {
                class: [
                  "px-4 sm:px-6 py-6 inline-flex items-center justify-center rounded-md",
                  "text-gray-400 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500",
                  "dark:text-gray-300 dark:hover:text-white dark:focus:ring-primary-500"
                ],
                onClick: () => this.openSidebar()
              },
              [
                n("span", { class: ["sr-only"] }, "Open sidebar"),
                n(va, {
                  class: "h-6 w-6 text-gray-600 dark:text-gray-400"
                })
              ]
            )
          ]
        ) : null,
        n(
          "div",
          {
            class: ["at-sidebar px-4 sm:px-6 py-6 overflow-auto h-screen dark:bg-gray-900 dark:text-white"]
          },
          [(r = (t = this.$slots).default) == null ? void 0 : r.call(t)]
        )
      ])
    ]);
  }
}), ou = D({
  name: "SidebarUserPopover",
  slots: ["user-popover-header", "user-popover-content", "user-popover-footer"],
  props: {
    user: {
      type: Object,
      default: null,
      validator: (e) => Object.keys(e).length ? E(e, "name") && E(e, "phone") : {}
    }
  },
  setup() {
    return { sidebarProps: ee("sidebar-props") };
  },
  render() {
    return n(
      "div",
      {
        class: "mt-2 -mb-2 border-t border-gray-200 dark:border-gray-700 py-5 px-3.5 relative flex flex-col items-stretch text-left w-full"
      },
      [
        n(
          Sn,
          { class: "relative" },
          {
            default: () => [
              n(
                ci,
                {
                  class: "w-full focus:outline-none"
                },
                {
                  default: () => n(Yn, { user: this.user || this.sidebarProps.user })
                }
              ),
              n(
                fi,
                {
                  class: "absolute bottom-[120%] left-0 w-[328px] shadow-lg bg-white dark:bg-gray-700 ring-1 ring-black dark:ring-gray-700 ring-opacity-5 focus:outline-none rounded-lg",
                  style: {
                    zIndex: Ae.low
                  }
                },
                {
                  default: () => n("div", {}, [
                    "user-popover-header" in this.$slots && n(
                      "div",
                      {
                        class: "p-4 bg-[#F3F4F6] dark:bg-gray-700 dark:border-b dark:border-b-gray-500 dark:text-white"
                      },
                      this.$slots["user-popover-header"]()
                    ),
                    "user-popover-content" in this.$slots && n("div", { class: "p-4 dark:text-white" }, this.$slots["user-popover-content"]()),
                    "user-popover-footer" in this.$slots && n(
                      "div",
                      { class: "p-4 border-t dark:border-t-gray-500 dark:text-white" },
                      this.$slots["user-popover-footer"]()
                    )
                  ])
                }
              )
            ]
          }
        )
      ]
    );
  }
});
function Ze(e) {
  return n("div", { class: ["animate-pulse"] }, [
    n("div", {
      class: [].concat("class" in e.attrs ? e.attrs.class : ""),
      style: Object.assign({}, "style" in e.attrs ? e.attrs.style : {})
    })
  ]);
}
const Qn = (e, t) => {
  let r = [];
  switch (e.type) {
    case "row":
      r = ["h-4 bg-gray-200 rounded dark:bg-gray-700"];
      break;
    case "label":
      r = ["h-4 w-32 bg-gray-200 rounded dark:bg-gray-700"];
      break;
    case "avatar":
      r = ["bg-gray-200 rounded-full h-12 w-12 dark:bg-gray-700"];
      break;
    case "button":
      r = ["h-8 w-32 bg-gray-200 rounded dark:bg-gray-700"];
      break;
    case "image":
      r = ["h-48 w-full bg-gray-200 rounded dark:bg-gray-700"];
      break;
    default:
      r = ["h-8 bg-gray-200 rounded dark:bg-gray-700"];
      break;
  }
  return e.type === "input-with-label" || e.type === "textarea-with-label" ? n("div", { class: ["block"] }, [
    Ze(
      Object.assign({}, t, {
        attrs: Object.assign({}, t.attrs, {
          class: "bg-gray-200 rounded mb-2 dark:bg-gray-700",
          style: Object.assign({}, "style" in t.attrs ? t.attrs.style : {}, {
            height: 23 / 16 + "rem",
            maxWidth: 170 / 16 + "rem"
          })
        })
      })
    ),
    Ze(
      Object.assign({}, t, {
        attrs: Object.assign({}, t.attrs, {
          class: "bg-gray-200 rounded mb-0 dark:bg-gray-700",
          style: {
            height: e.type === "input-with-label" ? 39 / 16 + "rem" : 64 / 16 + "rem"
          }
        })
      })
    )
  ]) : e.type === "checkbox" || e.type === "checkbox-with-description" ? n("div", { class: ["block"] }, [
    n("div", { class: "flex flex-wrap" }, [
      Ze(
        Object.assign({}, t, {
          attrs: Object.assign({}, t.attrs, {
            class: "bg-gray-200 rounded mb-0 dark:bg-gray-700",
            style: {
              height: 16 / 16 + "rem",
              maxWidth: 16 / 16 + "rem",
              width: 16 / 16 + "rem"
            }
          })
        })
      ),
      n("div", { class: "flex-1 ml-3" }, [
        Ze(
          Object.assign({}, t, {
            attrs: Object.assign({}, t.attrs, {
              class: "bg-gray-200 rounded mb-0 dark:bg-gray-700",
              style: {
                height: 17 / 16 + "rem",
                maxWidth: 160 / 16 + "rem"
              }
            })
          })
        ),
        e.type === "checkbox-with-description" ? Ze(
          Object.assign({}, t, {
            attrs: Object.assign({}, t.attrs, {
              class: "bg-gray-200 rounded mb-0 dark:bg-gray-700",
              style: {
                height: 16 / 16 + "rem",
                marginTop: 7 / 16 + "rem"
              }
            })
          })
        ) : null
      ])
    ])
  ]) : Ze(
    Object.assign({}, t, {
      attrs: Object.assign({}, t.attrs, {
        class: [].concat(r, "class" in t.attrs ? t.attrs.class : "")
      })
    })
  );
};
Qn.props = {
  type: { type: String, default: "input" }
};
const uu = Qn, Wi = (e, t) => "default" in t.slots ? n(
  "dt",
  Object.assign({}, t.attrs, {
    class: ["text-sm font-medium text-gray-500 truncate dark:text-gray-300"].concat(
      "class" in t.attrs ? t.attrs.class : ""
    )
  }),
  t.slots.default()
) : null, Zi = Wi, Yi = (e, t) => "default" in t.slots ? n(
  "dd",
  Object.assign({}, t.attrs, {
    class: ["text-2xl font-semibold text-gray-900 dark:text-white"].concat(
      "class" in t.attrs ? t.attrs.class : ""
    )
  }),
  t.slots.default()
) : null, Xi = Yi, es = (e, t) => n(
  "div",
  Object.assign({}, t.attrs, {
    class: ["flex flex-wrap items-center bg-white overflow-hidden shadow rounded-lg w-full dark:bg-gray-800"].concat(
      "class" in t.attrs ? t.attrs.class : "",
      "staticClass" in t.attrs ? t.attrs.staticClass : ""
    )
  }),
  [
    n("div", { class: "w-full px-4 py-5 sm:p-5" }, [
      n("div", { class: "flex items-center" }, [
        e.icon ? n(
          "div",
          {
            class: "flex-shrink-0 text-white rounded-md bg-primary-600 dark:bg-primary-500"
          },
          [n(de(e.icon).Icon, { class: "w-8 m-2" })]
        ) : null,
        n("div", { class: ["w-0 flex-1", { "ml-5": e.icon }] }, [
          "title" in t.slots || e.title !== void 0 ? n(Zi, null, {
            default: () => "title" in t.slots ? t.slots.title() : e.title
          }) : null,
          "value" in t.slots || e.value !== void 0 ? n(
            Xi,
            {
              class: {
                "mt-1 text-3xl": !e.icon,
                "text-2xl": e.icon
              }
            },
            {
              default: () => "value" in t.slots ? t.slots.value() : e.value
            }
          ) : null
        ])
      ])
    ]),
    "default" in t.slots ? n(
      "div",
      {
        class: "w-full bg-white px-4 py-4 sm:px-5 font-medium dark:bg-gray-800 dark:text-white"
      },
      t.slots.default()
    ) : null
  ]
);
es.props = {
  title: { type: [String, Number], default: "" },
  value: { type: [String, Number], default: "" },
  icon: { type: [String, Object], default: () => "" }
};
const du = es, ts = (e, t) => e.title ? n(
  "div",
  Object.assign(
    {
      class: ["block dark:text-gray-200"].concat(
        "class" in t.attrs ? t.attrs.class : "",
        "staticClass" in t.attrs ? t.attrs.staticClass : ""
      )
    },
    t.attrs,
    Object.assign(
      {},
      "attrs" in t ? t.attrs : {},
      { "at-step-title": e.title },
      e.subTitle ? { "at-step-sub-title": e.subTitle } : {},
      e.value ? { "at-step-value": e.value } : {},
      e.icon ? { "at-step-icon": e.icon } : {}
    )
  ),
  "default" in t.slots ? t.slots.default({
    title: e.title,
    subTitle: e.subTitle,
    value: e.value,
    icon: e.icon
  }) : null
) : null;
ts.props = {
  title: { type: String, default: "" },
  subTitle: { type: String, default: "" },
  value: { type: [String, Number], default: "" },
  icon: { type: String, default: "" }
};
const cu = ts, Ji = D({
  name: "AtSteps",
  emits: ["update:modelValue"],
  props: {
    modelValue: { type: [String, Number], default: "" },
    steps: {
      type: Array,
      required: !0,
      validator: (e) => Array.isArray(e) && e.every(
        (t) => Object.prototype.toString.call(t) === "[object Object]" && "title" in t && "value" in t
      )
    },
    disabled: { type: [Boolean, String, Number], default: !1 }
  },
  setup(e, { emit: t }) {
    const r = y(void 0), a = $e(e).modelValue, s = C(() => F(e.disabled)), i = C(() => {
      const l = [];
      let o = !1;
      for (let u = e.steps.length - 1; u >= 0; u--)
        if (Object.prototype.toString.call(e.steps[u]) === "[object Object]") {
          let c;
          "subTitle" in e.steps[u] && e.steps[u].subTitle && (c = e.steps[u].subTitle);
          let f;
          "icon" in e.steps[u] && e.steps[u].icon && (f = n(de(e.steps[u].icon).Icon, {
            class: c ? "h-7 w-7" : "h-4 w-4"
          })), "value" in e.steps[u] && !o && Et(e.steps[u].value, Ye(r.value)) && (o = !0);
          const h = [];
          "title" in e.steps[u] && h.push(
            n(
              "span",
              {
                class: [
                  "block text-xs leading-4 font-semibold uppercase",
                  "group-hover:text-primary-800",
                  "dark:group-hover:text-primary-400",
                  "transition ease-in-out duration-150",
                  o ? "text-primary-600 dark:text-primary-400" : "text-gray-500 dark:text-gray-300"
                ]
              },
              e.steps[u].title
            )
          ), c && h.push(
            n(
              "span",
              {
                class: "block text-sm leading-5 font-medium dark:text-white"
              },
              c
            )
          );
          let d = h;
          f && (d = [
            n("div", { class: "flex items-center flex-wrap" }, [
              n(
                "div",
                {
                  class: [
                    "block",
                    {
                      "mr-3": c,
                      "mr-2": !c
                    },
                    o ? "text-primary-600 dark:text-primary-400" : "text-gray-500 dark:text-gray-300"
                  ]
                },
                [f]
              ),
              n("div", { class: "block" }, [h])
            ])
          ]), l.unshift(
            n("li", { class: "md:flex-1", key: "at-steps-" + u }, [
              n(
                "button",
                {
                  onClick: (g) => {
                    g.stopPropagation(), !s.value && "value" in e.steps[u] && t("update:modelValue", e.steps[u].value);
                  },
                  class: [
                    "w-full text-left pl-4 py-2 block border-l-4 transition ease-in-out duration-150 md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4 outline-none focus:outline-none",
                    o ? [
                      "border-primary-600",
                      "hover:border-primary-800",
                      "focus:border-primary-900",
                      "dark:border-primary-400",
                      "dark:hover:border-primary-300",
                      "dark:focus:border-primary-700"
                    ] : [
                      "border-gray-200 hover:border-gray-300 focus:border-gray-400",
                      "dark:border-gray-600 dark:hover:border-gray-500 dark:focus:border-gray-500"
                    ]
                  ]
                },
                d
              )
            ])
          );
        }
      return l;
    });
    return G(a, (l) => r.value = Ye(l)), vr(() => {
      a.value === void 0 ? Array.isArray(e.steps) && e.steps.length && Object.prototype.toString.call(e.steps[0]) === "[object Object]" && "value" in e.steps[0] && (r.value = Ye(e.steps[0].value)) : r.value = Ye(a.value);
    }), () => n("nav", null, [n("ul", { class: "space-y-4 md:flex md:space-y-0 md:space-x-8" }, [i.value])]);
  }
}), fu = D({
  name: "AtStepsGroup",
  emits: ["update:modelValue"],
  props: {
    disabled: { type: [String, Boolean, Number], default: !1 }
  },
  setup(e, { slots: t }) {
    const r = y(void 0), a = y([]), s = y({}), i = y([]), l = y({}), o = C(() => F(e.disabled));
    function u() {
      let c = { list: [], hash: {}, config: [] };
      "default" in t && (c = t.default().reduce(
        (f, h) => {
          if (Object.prototype.toString.call(h) === "[object Object]") {
            let d;
            "tag" in h ? d = h.tag : "props" in h && (d = h.props);
            let g;
            if ("attrs" in h && Object.prototype.toString.call(h.attrs) === "[object Object]" ? g = Object.assign({}, g, h.attrs) : d && (("title" in d || "value" in d || "sub-title" in d || "subTitle" in d || "icon" in d) && (g = {}), "title" in d && (g["at-step-title"] = d.title), "value" in d && (g["at-step-value"] = d.value), "sub-title" in d && (g["at-step-sub-title"] = d["sub-title"]), "subTitle" in d && (g["at-step-sub-title"] = d.subTitle), "icon" in d && (g["at-step-icon"] = d.icon)), d && g && "at-step-title" in g) {
              const p = "at-step-value" in g ? g["at-step-value"] : re("at-steps-"), x = { title: g["at-step-title"], value: p };
              "at-step-sub-title" in g && (x.subTitle = g["at-step-sub-title"]), "at-step-icon" in g && (x.icon = g["at-step-icon"]), f.config.push(x);
              const m = n("div", { class: "pt-6", "at-step": !0, "at-step-value": p }, [h]);
              f.list.push(m), f.hash[p] = m;
            }
          }
          return f;
        },
        { list: [], hash: {}, config: [] }
      )), a.value = c.list, i.value = c.config, (r.value === void 0 && i.value.length || r.value !== void 0 && r.value in c.hash && i.value.length) && (r.value = i.value[0].value), s.value = { ...c.hash }, l.value = { ...s.value[i.value[0].value] };
    }
    return u(), {
      steps: a,
      stepsConfig: i,
      selected: r,
      selectedHashChildren: l,
      stepsHash: s,
      hasDisabled: o
    };
  },
  render() {
    return this.steps.length ? n("div", { class: "block w-full" }, [
      this.stepsConfig.length ? n(Ji, {
        modelValue: this.selected,
        steps: this.stepsConfig,
        "onUpdate:modelValue": (e) => {
          this.selected !== e && !this.hasDisabled && (this.selected = e, this.selectedHashChildren = this.stepsHash[this.selected]);
        }
      }) : null,
      Object.prototype.toString.call(this.stepsHash) === "[object Object]" && this.selected in this.stepsHash ? this.selectedHashChildren : this.steps.find((e) => Object.prototype.toString.call(e.attrs) === "[object Object]" && "attrs" in e && Object.prototype.toString.call(e.attrs) === "[object Object]" && "at-step-value" in e.attrs ? Et(e.attrs["at-step-value"], this.selected) : !1)
    ]) : null;
  }
}), Ki = (e, t) => {
  const { Icon: r } = de(e);
  return n(r, {
    class: [
      "--ml-0.5 mr-2 h-5 w-5",
      t ? "text-primary-500 dark:text-primary-400" : "text-gray-400 group-hover:text-gray-500 dark:group-hover:text-gray-300"
    ],
    "aria-hidden": !0
  });
}, rs = (e, t) => n(
  "a",
  {
    class: [
      "group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm cursor-pointer whitespace-nowrap",
      e.selected === e.item.value ? ["border-primary-500", "text-primary-600", "dark:border-primary-400", "dark:text-primary-400"] : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-300 dark:hover:text-white dark:hover:border-gray-300"
    ],
    onClick: (r) => {
      r.preventDefault(), e.selected !== e.item.value && t.emit("select", e.item.value);
    }
  },
  [
    e.item.icon ? Ki(e.item.icon, e.selected === e.item.value) : null,
    n("span", ["default" in t.slots ? t.slots.default() : e.item.title])
  ]
);
rs.props = {
  item: {
    type: Object,
    validator: (e) => e,
    default: () => ({})
  },
  selected: {
    type: [String, Number, Boolean],
    default: () => {
    }
  }
};
const qi = rs, Qi = {
  props: {
    to: {
      type: [Object, String],
      validator: (e) => it(e),
      default: ""
    },
    replace: { type: Boolean, default: !1 },
    append: { type: Boolean, default: !1 },
    activeClass: { type: String, default: "router-link-active" },
    exact: { type: Boolean, default: !1 },
    exactActiveClass: { type: String, default: "router-link-exact-active" },
    ariaCurrentValue: {
      type: String,
      default: "page",
      validator: (e) => e === "page" || e === "step" || e === "location" || e === "date" || e === "time"
    }
  }
}, as = (e, t) => {
  const r = () => {
    const a = "default" in t.slots ? t.slots.default() : null;
    return F(e.arrow) ? [
      n("div", { class: "flex items-center" }, [
        n("div", { class: "min-w-0 flex-1 flex items-center pr-4" }, [a]),
        n("div", { class: "text-gray-400 dark:text-gray-200" }, [
          n("fe-chevron-right-icon", { props: { size: "20" } })
        ])
      ])
    ] : a;
  };
  return e.to ? n("td", null, [
    n(
      me,
      {
        class: ["at-table__body-element", "block whitespace-no-wrap"].concat(
          "class" in t.attrs ? t.attrs.class : ""
        ),
        to: e.to,
        replace: e.replace,
        append: e.append,
        activeClass: e.activeClass,
        exact: e.exact,
        exactActiveClass: e.exactActiveClass,
        ariaCurrentValue: e.ariaCurrentValue
      },
      {
        default: () => r()
      }
    )
  ]) : n(
    "td",
    Object.assign({}, t.attrs, {
      class: ["at-table__body-element", "whitespace-no-wrap"].concat(
        "class" in t.attrs ? t.attrs.class : ""
      )
    }),
    [r()]
  );
};
as.props = {
  ...Qi.props,
  tag: { type: String, default: "a" },
  arrow: { type: [Boolean, String, Number], default: !1 },
  size: {
    type: String,
    default: "lg",
    validator: (e) => e && ["sm", "md", "lg"].includes(e)
  }
};
const eo = as, to = (e, t) => n(
  "th",
  {
    class: [
      "at-table__head-element",
      "bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider",
      "dark:bg-gray-900 dark:text-white"
    ]
  },
  "default" in t.slots ? t.slots.default() : null
), ro = to, ns = (e, t) => {
  const r = [
    e.filled ? "bg-gray-50 dark:bg-gray-900" : "bg-white dark:bg-gray-800",
    "hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out dark:hover:bg-gray-900 dark:focus:bg-gray-50"
  ];
  return n(
    "tr",
    {
      class: r
    },
    "default" in t.slots ? t.slots.default() : null
  );
};
ns.props = {
  filled: {
    type: Boolean,
    default: !1
  }
};
const ao = ns;
const ss = (e, t) => {
  const r = "head" in t.slots ? t.slots.head({ head: e.head }) : null, a = "header" in t.slots, s = "footer" in t.slots, i = `at-table at-table_size-${e.size}`;
  return Array.isArray(e.head) && e.head.length || Array.isArray(e.elements) && e.elements.length || "default" in t.slots ? n(
    "div",
    Object.assign({}, t.attrs, {
      class: [
        i,
        "at-panel-no-padding text-sm sm:rounded-lg border border-transparent dark:border-gray-700"
      ].concat("class" in t.attrs ? t.attrs.class : "")
    }),
    [
      n(
        "div",
        {
          class: "at-table-wrapper shadow sm:rounded-lg"
        },
        [
          a ? n(
            "div",
            {
              class: [
                "at-table__header px-4 py-5 sm:px-6 bg-white sm:rounded-t-lg dark:bg-gray-800 dark:text-white",
                {
                  "border-b border-gray-200 dark:border-gray-700": F(e.borderHeader)
                }
              ]
            },
            [t.slots.header()]
          ) : null,
          n(
            "div",
            {
              class: [
                { "overflow-x-auto": F(e.overflow) },
                { "sm:rounded-b-lg": !s },
                { "sm:rounded-t-lg": !a }
              ]
            },
            [
              n("table", { class: "min-w-full divide-y divide-gray-200" }, [
                Array.isArray(e.head) && e.head.length || "head" in t.slots ? n("thead", [
                  n(
                    "tr",
                    {
                      class: [
                        "border-b border-gray-200 dark:border-gray-700",
                        {
                          "[&>th:first-child]:sm:rounded-t-lg [&>th:last-child]:sm:rounded-t-lg": !a && r
                        }
                      ]
                    },
                    !r || r && r.length === 1 ? e.head.map((l, o) => {
                      const u = Object.prototype.toString.call(l) === "[object Object]" && "context" in l && Object.prototype.toString.call(l.context) === "[object Object]" ? l.context : {};
                      if ("head" in t.slots)
                        return t.slots.head({
                          head: l,
                          index: o
                        });
                      const c = Object.assign({}, u);
                      return "data" in c && delete c.data, n(
                        ro,
                        Object.assign({}, c, {
                          size: e.size,
                          class: [
                            a ? "" : "sm:rounded-t-lg",
                            "class" in c ? c.class : "",
                            "data" in u && Object.prototype.toString.call(u.data) === "[object Object]" && "class" in u.data ? u.data.class : "",
                            "data" in u && Object.prototype.toString.call(u.data) === "[object Object]" && "staticClass" in u.data ? u.data.staticClass : ""
                          ]
                        }),
                        () => (l == null ? void 0 : l[e.headValuePrint]) ?? l
                      );
                    }) : r
                  )
                ]) : null,
                Array.isArray(e.elements) && e.elements.length ? n(
                  "tbody",
                  {
                    class: [
                      "bg-white divide-y divide-gray-200",
                      "dark:text-white dark:bg-gray-800 dark:divide-gray-700"
                    ]
                  },
                  [
                    e.elements.map((l, o) => {
                      const u = F(e.withTr), c = e.type === "striped" && o % 2 !== 0;
                      function f() {
                        function h(d) {
                          return n(
                            eo,
                            Object.assign(
                              {},
                              Object.prototype.toString.call(d) === "[object Object]" && "context" in d ? d.context : {}
                            ),
                            Object.prototype.toString.call(d) === "[object Object]" && "value" in d ? d.value : d
                          );
                        }
                        return "element" in t.slots ? t.slots.element({
                          element: l,
                          index: o,
                          cols: Array.isArray(e.head) ? e.head.length : 0,
                          filled: c
                        }) : Array.isArray(l) ? l.map(h) : h(l);
                      }
                      return u ? n(
                        ao,
                        {
                          filled: c
                        },
                        () => f()
                      ) : [f()];
                    })
                  ]
                ) : "defaultContent" in t.slots ? t.slots.defaultContent() : null
              ])
            ]
          ),
          "default" in t.slots ? n("div", { class: ["bg-white", { "sm:rounded-b-lg": !s }] }, t.slots.default()) : null,
          s ? n(
            "div",
            {
              class: [
                "at-table__footer px-4 py-5 sm:px-6 sm:rounded-b-lg dark:text-white",
                {
                  "border-t border-gray-200 dark:border-gray-700": F(e.borderFooter)
                }
              ]
            },
            [t.slots.footer()]
          ) : null
        ]
      )
    ]
  ) : null;
};
ss.props = {
  head: {
    type: Array,
    default: () => []
  },
  headValuePrint: {
    type: String,
    default: "title"
  },
  elements: {
    type: Array,
    default: () => []
  },
  borderHeader: { type: [Boolean, String, Number], default: !0 },
  borderFooter: { type: [Boolean, String, Number], default: !0 },
  withTr: { type: [Boolean, Number, String], default: !0 },
  type: { type: String, default: "normal" },
  size: {
    type: String,
    default: "lg",
    validator: (e) => e && ["sm", "md", "lg"].includes(e)
  },
  overflow: { type: [Boolean, String, Number], default: !0 }
};
const hu = ss, gu = D({
  name: "AtTabs",
  props: {
    placeholder: { type: String, default: "Выберите значение" },
    modelValue: { type: [String, Number], default: "" },
    items: {
      type: Array,
      required: !0,
      validator: (e) => Array.isArray(e) ? e.every((t) => {
        if (Object.prototype.toString.call(t) === "[object Object]" && "tag" in t && t.tag === "router-link")
          if ("to" in t) {
            if (!it(t.to))
              return !1;
          } else
            return !1;
        return Object.prototype.toString.call(t) === "[object Object]" && "title" in t && "value" in t;
      }) : !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t, slots: r }) {
    let a = $e(e).modelValue;
    return () => n("div", [
      n("div", { class: "sm:hidden" }, [
        n(Vn, {
          options: e.items,
          placeholder: e.placeholder,
          modelValue: a.value,
          "onUpdate:modelValue": (s) => {
            t("update:modelValue", s);
          }
        })
      ]),
      n("div", { class: "hidden sm:block overflow-x-auto" }, [
        n("div", { class: "border-b border-gray-200" }, [
          n("nav", { class: "-mb-px flex space-x-8", "aria-label": "Tabs" }, [
            e.items.map((s) => "item" in r ? r.item({
              item: s,
              selected: a.value,
              select: (i) => t("update:modelValue", i)
            }) : n(qi, {
              item: s,
              selected: a.value,
              onSelect: (i) => t("update:modelValue", i)
            }))
          ])
        ])
      ])
    ]);
  }
});
const ls = (e, { emit: t }) => {
  const r = F(e.disabled);
  return n("div", [
    e.label ? n(
      "label",
      {
        for: e.id,
        class: "block text-sm font-medium text-gray-700 mb-1 dark:text-white"
      },
      e.label
    ) : null,
    n("textarea", {
      id: e.id,
      value: e.modelValue,
      rows: e.rows,
      disabled: r,
      class: [
        "shadow-sm block w-full sm:text-sm border border-gray-300 rounded-md transition duration-200 placeholder-opacity-100 placeholder-gray-600",
        "dark:border-gray-600 dark:placeholder-gray-400",
        ot(F(e.error), F(e.success)),
        {
          "dark:bg-gray-700": !r,
          "bg-gray-50 dark:bg-gray-600 cursor-not-allowed": r
        }
      ],
      onInput: (a) => t("update:modelValue", a.target.value),
      placeholder: e.placeholder
    }),
    e.error || e.helpText ? n(
      Le,
      { type: He(e.error, e.success) },
      { default: () => e.helpText || e.error }
    ) : null
  ]);
};
ls.props = {
  id: { type: String, default: () => re("at-textarea-") },
  modelValue: { type: String, default: "" },
  placeholder: { type: String, default: "" },
  helpText: { type: String, default: "" },
  rows: { type: [Number, String], default: 3 },
  ...Oe.props
};
const pu = ls, St = {
  notifications: y([])
}, Ve = {
  remove(e) {
    const t = St.notifications.value.findIndex((r) => r.id === e);
    St.notifications.value.splice(t, 1);
  },
  show(e = {}) {
    e.title = (e == null ? void 0 : e.title) || "", e.subTitle = (e == null ? void 0 : e.subTitle) || "", e.type = (e == null ? void 0 : e.type) || "info", e.duration = (e == null ? void 0 : e.duration) || 5e3;
    const t = {
      id: Math.random().toString(36) + (/* @__PURE__ */ new Date()).toString(36),
      title: e.title,
      subTitle: e.subTitle,
      type: e.type,
      ...e
    };
    St.notifications.value.push(t), t.duration && setTimeout(() => {
      this.remove(t.id);
    }, t.duration);
  }
}, no = {
  success: {
    icon: "CheckCircle",
    iconColor: "text-green-400",
    textColor: "text-gray-900 dark:text-white"
  },
  error: {
    icon: "ExclamationCircle",
    iconColor: "text-red-400",
    textColor: "text-gray-900 dark:text-white"
  },
  info: {
    icon: "InformationCircle",
    iconColor: "text-blue-400",
    textColor: "text-gray-900 dark:text-white"
  },
  warning: {
    icon: "Exclamation",
    iconColor: "text-yellow-300",
    textColor: "text-gray-900 dark:text-white"
  }
}, is = (e) => {
  const t = no[e.type];
  return n(
    "div",
    {
      class: "max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden dark:bg-gray-700"
    },
    [
      n("div", { class: "p-4" }, [
        n("div", { class: ["flex", e.subTitle ? "items-start" : "items-center"] }, [
          n("div", { class: "flex-shrink-0" }, [
            n(de({ name: t.icon, type: "outline" }).Icon, { class: ["w-6 h-6", t.iconColor] })
          ]),
          n("div", { class: ["ml-3 w-0 flex-1 pt-0.5", t.textColor] }, [
            n(
              "p",
              { class: "text-sm font-medium" },
              {
                default: () => [e.title]
              }
            ),
            n(
              "p",
              { class: "mt-1 text-sm opacity-90" },
              {
                default: () => [e.subTitle]
              }
            )
          ]),
          n("div", { class: "ml-4 flex-shrink-0 flex" }, [
            n(
              "button",
              {
                class: [
                  "rounded-md inline-flex text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500",
                  "dark:text-gray-400 dark:hover:text-gray-200 focus:ring-gray-300"
                ],
                onClick: () => Ve.remove(e.id)
              },
              [
                n(
                  "span",
                  { class: "sr-only" },
                  {
                    default: () => "Close"
                  }
                ),
                n(ya, { class: "h-5 w-5" })
              ]
            )
          ])
        ])
      ])
    ]
  );
};
is.props = {
  title: { type: [String, Array, Object], default: "" },
  subTitle: { type: [String, Array, Object], default: "" },
  id: { type: String, required: !0 },
  type: { type: String, default: "info" },
  duration: { type: Number, default: 0 }
};
const so = is, lo = () => n(
  "div",
  {
    class: "fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start",
    style: {
      zIndex: Ae.high
    }
  },
  [
    n("div", { class: "w-full flex flex-col items-center space-y-4 sm:items-end" }, [
      n(
        Gs,
        {
          enterActiveClass: "transform ease-out duration-400 transition",
          enterFromClass: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
          enterToClass: "translate-y-0 opacity-100 sm:translate-x-0",
          leaveActiveClass: "transition ease-in duration-200",
          leaveFromClass: "opacity-100",
          leaveToClass: "opacity-0"
        },
        {
          default: () => St.notifications.value.map((e) => n(so, { ...e, key: e.id }))
        }
      )
    ])
  ]
), io = lo, mu = {
  install: () => {
    const e = zs(io), t = document.createElement("div");
    document.body.appendChild(t), e.mount(t);
  },
  show: (e) => Ve.show(e),
  remove: (e) => Ve.remove(e),
  success: (e) => Ve.show({ ...e, type: "success" }),
  error: (e) => Ve.show({ ...e, type: "error" }),
  warning: (e) => Ve.show({ ...e, type: "warning" }),
  info: (e) => Ve.show({ ...e, type: "info" })
}, oo = n(
  "svg",
  {
    class: ["h-3", "w-3", "text-gray-400", "dark:text-white"],
    fill: "none",
    viewBox: "0 0 12 12"
  },
  [
    n("path", {
      d: "M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ]
), uo = n(
  "svg",
  {
    class: ["h-3", "w-3", "text-primary-600"],
    fill: "currentColor",
    viewBox: "0 0 12 12"
  },
  [
    n("path", {
      d: "M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z"
    })
  ]
), os = (e, { emit: t }) => {
  const r = C(() => e.modelValue === e.trueValue), a = n(
    mi,
    {
      class: [
        r.value ? "bg-primary-600 dark:bg-primary-500" : "bg-gray-200 dark:bg-gray-600",
        "flex-shrink-0 relative rounded-full cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 dark:ring-offset-gray-900 focus:ring-primary-500",
        e.short ? "group inline-flex items-center justify-center h-5 w-10" : "inline-flex border-2 border-transparent transition-colors ease-in-out duration-200 h-6 w-11",
        e.disabled ? "cursor-not-allowed opacity-50" : ""
      ],
      modelValue: r.value,
      "onUpdate:modelValue": (i) => {
        e.disabled || (i ? (t("update:modelValue", e.trueValue), t("onToggle", e.trueValue)) : (t("update:modelValue", e.falseValue), t("onToggle", e.falseValue)));
      }
    },
    {
      default: () => [
        e.short ? n("span", {
          class: "pointer-events-none absolute bg-white w-full h-full rounded-md dark:bg-gray-900",
          "aria-hidden": !0
        }) : null,
        e.short ? n("span", {
          class: [
            r.value ? "bg-primary-600" : "bg-gray-200 dark:bg-gray-600",
            "pointer-events-none absolute h-4 w-9 mx-auto rounded-full transition-colors ease-in-out duration-200"
          ],
          "aria-hidden": !0
        }) : null,
        n(
          "span",
          {
            class: [
              r.value ? "translate-x-5 dark:bg-white" : "translate-x-0 dark:bg-gray-800",
              "pointer-events-none shadow h-5 w-5 ease-in-out duration-200 transform bg-white ring-0 rounded-full",
              e.short ? "absolute left-0 inline-block border border-gray-200 transition-transform dark:border-gray-700" : "inline-block transition"
            ],
            "aria-hidden": !0
          },
          [
            e.icon ? n("span", { class: "flex h-full w-full items-center justify-center" }, [
              n(de(e.icon).Icon, {
                class: ["h-3 w-3", r.value ? "text-primary-600" : "text-gray-900 dark:text-white"]
              })
            ]) : null,
            !e.icon && e.withIcon ? r.value ? n(
              "span",
              {
                class: [
                  "opacity-100 ease-in duration-200 absolute inset-0 h-full w-full flex items-center justify-center transition-opacity"
                ],
                "aria-hidden": !0
              },
              uo
            ) : n(
              "span",
              {
                class: [
                  "opacity-100 ease-in duration-200 absolute inset-0 h-full w-full flex items-center justify-center transition-opacity"
                ],
                "aria-hidden": !0
              },
              oo
            ) : null
          ]
        )
      ]
    }
  ), s = n(
    pi,
    {
      as: "div",
      class: ["flex items-center", { "justify-between": e.labelPosition === "left" }]
    },
    {
      default: () => [
        e.labelPosition === "right" ? n("span", { class: "mr-3" }, [a]) : null,
        n("span", { class: "flex-grow flex flex-col" }, [
          n(
            bi,
            {
              as: "span",
              class: "text-sm font-medium text-gray-900 dark:text-white pr-3",
              passive: !0
            },
            { default: () => e.label }
          ),
          e.description ? n(
            vi,
            {
              as: "span",
              class: "text-sm text-gray-500 dark:text-gray-300"
            },
            { default: () => e.description }
          ) : null
        ]),
        e.labelPosition === "left" ? a : null
      ]
    }
  );
  return e.label ? s : a;
};
os.props = {
  id: { type: String, default: () => re("at-switch-") },
  label: { type: String, default: "" },
  labelPosition: {
    type: String,
    default: "left",
    validator: (e) => e === "left" || e === "right"
  },
  description: { type: String, default: "" },
  modelValue: { type: [Boolean, String, Number], default: !1 },
  short: { type: Boolean, default: !1 },
  withIcon: { type: Boolean, default: !1 },
  icon: { type: String, default: "" },
  disabled: { type: Boolean, default: !1 },
  trueValue: { type: [String, Number, Boolean], default: !0 },
  falseValue: { type: [String, Number, Boolean], default: !1 }
};
const bu = os;
function co(e) {
  const t = () => ({
    response: null,
    error: null,
    errors: null,
    loading: !1,
    alert: null,
    request: [],
    hasError: !1
  }), r = ka({ ...t() }), a = C(() => !!r.response), s = () => {
    Object.assign(r, { ...t() });
  }, i = (g, p = null) => {
    if (Object.prototype.toString.call(g) === "[object Object]" && "errors" in g) {
      r.errors = g.errors;
      return;
    } else if (Object.prototype.toString.call(g) === "[object Object]" && "message" in g) {
      o({ message: g.message, type: "danger", title: p, dismissible: null }), r.error = { ...g || {} };
      return;
    } else if (Object.prototype.toString.call(g) === "[object Object]") {
      r.errors = { ...g };
      return;
    } else if (Object.prototype.toString.call(g) === "[object String]") {
      o({ message: g, type: "danger", title: p, dismissible: null });
      return;
    } else {
      i("Что-то пошло не так. Попробуйте обновить страницу");
      return;
    }
  }, l = (g, p = null) => {
    o({ message: g, type: "success", title: p, dismissible: null });
  }, o = (g) => {
    r.alert = g;
  }, u = () => {
    r.alert = t().alert;
  }, c = () => {
    r.errors = t().errors, r.error = t().error, r.hasError = t().hasError;
  }, f = (g) => {
    r.response = g;
  }, h = (g) => {
    r.loading = g;
  }, d = (...g) => (s(), h(!0), r.request = [...g], new Promise((p, x) => {
    e(...g).then((m) => (f(m.data), p(m))).catch((m) => (r.hasError = !0, i(m), x(m))).finally(() => {
      h(!1);
    });
  }));
  return {
    ...$e(r),
    execute: d,
    setError: i,
    setAlert: o,
    setSuccess: l,
    setResponse: f,
    setLoading: h,
    hasResponse: a,
    resetState: s,
    resetAlert: u,
    resetErrors: c
  };
}
const fo = (e) => `self.onmessage = event => { const args = event.data; if (args) { (${e}).call(null, self, args) } }`, ho = (e, t) => {
  if (typeof t < "u" && "Worker" in t && ("URL" in t || "webkitURL" in t) && ((t.Worker || Worker) ?? !1) !== !1) {
    const r = t.URL || t.webkitURL, a = fo(e), s = new Blob([a], { type: "application/javascript" }), i = r.createObjectURL(s);
    return new Worker(i);
  }
};
ho(function(e, t) {
  const r = new FileReader();
  r.readAsDataURL(t), r.onload = ({ target: { result: a } }) => {
    e.postMessage(a);
  };
}, window);
function go(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Rr = { exports: {} }, Xe = typeof Reflect == "object" ? Reflect : null, ga = Xe && typeof Xe.apply == "function" ? Xe.apply : function(e, t, r) {
  return Function.prototype.apply.call(e, t, r);
}, _t;
Xe && typeof Xe.ownKeys == "function" ? _t = Xe.ownKeys : Object.getOwnPropertySymbols ? _t = function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : _t = function(e) {
  return Object.getOwnPropertyNames(e);
};
function po(e) {
  console && console.warn && console.warn(e);
}
var us = Number.isNaN || function(e) {
  return e !== e;
};
function z() {
  z.init.call(this);
}
Rr.exports = z;
Rr.exports.once = yo;
z.EventEmitter = z;
z.prototype._events = void 0;
z.prototype._eventsCount = 0;
z.prototype._maxListeners = void 0;
var pa = 10;
function Ht(e) {
  if (typeof e != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
}
Object.defineProperty(z, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return pa;
  },
  set: function(e) {
    if (typeof e != "number" || e < 0 || us(e))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
    pa = e;
  }
});
z.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
z.prototype.setMaxListeners = function(e) {
  if (typeof e != "number" || e < 0 || us(e))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
  return this._maxListeners = e, this;
};
function ds(e) {
  return e._maxListeners === void 0 ? z.defaultMaxListeners : e._maxListeners;
}
z.prototype.getMaxListeners = function() {
  return ds(this);
};
z.prototype.emit = function(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t.push(arguments[r]);
  var a = e === "error", s = this._events;
  if (s !== void 0)
    a = a && s.error === void 0;
  else if (!a)
    return !1;
  if (a) {
    var i;
    if (t.length > 0 && (i = t[0]), i instanceof Error)
      throw i;
    var l = new Error("Unhandled error." + (i ? " (" + i.message + ")" : ""));
    throw l.context = i, l;
  }
  var o = s[e];
  if (o === void 0)
    return !1;
  if (typeof o == "function")
    ga(o, this, t);
  else
    for (var u = o.length, c = ps(o, u), r = 0; r < u; ++r)
      ga(c[r], this, t);
  return !0;
};
function cs(e, t, r, a) {
  var s, i, l;
  if (Ht(r), i = e._events, i === void 0 ? (i = e._events = /* @__PURE__ */ Object.create(null), e._eventsCount = 0) : (i.newListener !== void 0 && (e.emit(
    "newListener",
    t,
    r.listener ? r.listener : r
  ), i = e._events), l = i[t]), l === void 0)
    l = i[t] = r, ++e._eventsCount;
  else if (typeof l == "function" ? l = i[t] = a ? [r, l] : [l, r] : a ? l.unshift(r) : l.push(r), s = ds(e), s > 0 && l.length > s && !l.warned) {
    l.warned = !0;
    var o = new Error("Possible EventEmitter memory leak detected. " + l.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    o.name = "MaxListenersExceededWarning", o.emitter = e, o.type = t, o.count = l.length, po(o);
  }
  return e;
}
z.prototype.addListener = function(e, t) {
  return cs(this, e, t, !1);
};
z.prototype.on = z.prototype.addListener;
z.prototype.prependListener = function(e, t) {
  return cs(this, e, t, !0);
};
function mo() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function fs(e, t, r) {
  var a = { fired: !1, wrapFn: void 0, target: e, type: t, listener: r }, s = mo.bind(a);
  return s.listener = r, a.wrapFn = s, s;
}
z.prototype.once = function(e, t) {
  return Ht(t), this.on(e, fs(this, e, t)), this;
};
z.prototype.prependOnceListener = function(e, t) {
  return Ht(t), this.prependListener(e, fs(this, e, t)), this;
};
z.prototype.removeListener = function(e, t) {
  var r, a, s, i, l;
  if (Ht(t), a = this._events, a === void 0)
    return this;
  if (r = a[e], r === void 0)
    return this;
  if (r === t || r.listener === t)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete a[e], a.removeListener && this.emit("removeListener", e, r.listener || t));
  else if (typeof r != "function") {
    for (s = -1, i = r.length - 1; i >= 0; i--)
      if (r[i] === t || r[i].listener === t) {
        l = r[i].listener, s = i;
        break;
      }
    if (s < 0)
      return this;
    s === 0 ? r.shift() : bo(r, s), r.length === 1 && (a[e] = r[0]), a.removeListener !== void 0 && this.emit("removeListener", e, l || t);
  }
  return this;
};
z.prototype.off = z.prototype.removeListener;
z.prototype.removeAllListeners = function(e) {
  var t, r, a;
  if (r = this._events, r === void 0)
    return this;
  if (r.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : r[e] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete r[e]), this;
  if (arguments.length === 0) {
    var s = Object.keys(r), i;
    for (a = 0; a < s.length; ++a)
      i = s[a], i !== "removeListener" && this.removeAllListeners(i);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (t = r[e], typeof t == "function")
    this.removeListener(e, t);
  else if (t !== void 0)
    for (a = t.length - 1; a >= 0; a--)
      this.removeListener(e, t[a]);
  return this;
};
function hs(e, t, r) {
  var a = e._events;
  if (a === void 0)
    return [];
  var s = a[t];
  return s === void 0 ? [] : typeof s == "function" ? r ? [s.listener || s] : [s] : r ? vo(s) : ps(s, s.length);
}
z.prototype.listeners = function(e) {
  return hs(this, e, !0);
};
z.prototype.rawListeners = function(e) {
  return hs(this, e, !1);
};
z.listenerCount = function(e, t) {
  return typeof e.listenerCount == "function" ? e.listenerCount(t) : gs.call(e, t);
};
z.prototype.listenerCount = gs;
function gs(e) {
  var t = this._events;
  if (t !== void 0) {
    var r = t[e];
    if (typeof r == "function")
      return 1;
    if (r !== void 0)
      return r.length;
  }
  return 0;
}
z.prototype.eventNames = function() {
  return this._eventsCount > 0 ? _t(this._events) : [];
};
function ps(e, t) {
  for (var r = new Array(t), a = 0; a < t; ++a)
    r[a] = e[a];
  return r;
}
function bo(e, t) {
  for (; t + 1 < e.length; t++)
    e[t] = e[t + 1];
  e.pop();
}
function vo(e) {
  for (var t = new Array(e.length), r = 0; r < t.length; ++r)
    t[r] = e[r].listener || e[r];
  return t;
}
function yo(e, t) {
  return new Promise(function(r, a) {
    function s(l) {
      e.removeListener(t, i), a(l);
    }
    function i() {
      typeof e.removeListener == "function" && e.removeListener("error", s), r([].slice.call(arguments));
    }
    ms(e, t, i, { once: !0 }), t !== "error" && xo(e, s, { once: !0 });
  });
}
function xo(e, t, r) {
  typeof e.on == "function" && ms(e, "error", t, r);
}
function ms(e, t, r, a) {
  if (typeof e.on == "function")
    a.once ? e.once(t, r) : e.on(t, r);
  else if (typeof e.addEventListener == "function")
    e.addEventListener(t, function s(i) {
      a.once && e.removeEventListener(t, s), r(i);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
}
var wo = Rr.exports, bs = /* @__PURE__ */ go(wo), Y;
(function(e) {
  e[e.timeout = 1] = "timeout", e[e.transportClosed = 2] = "transportClosed", e[e.clientDisconnected = 3] = "clientDisconnected", e[e.clientClosed = 4] = "clientClosed", e[e.clientConnectToken = 5] = "clientConnectToken", e[e.clientRefreshToken = 6] = "clientRefreshToken", e[e.subscriptionUnsubscribed = 7] = "subscriptionUnsubscribed", e[e.subscriptionSubscribeToken = 8] = "subscriptionSubscribeToken", e[e.subscriptionRefreshToken = 9] = "subscriptionRefreshToken", e[e.transportWriteError = 10] = "transportWriteError", e[e.connectionClosed = 11] = "connectionClosed", e[e.badConfiguration = 12] = "badConfiguration";
})(Y || (Y = {}));
var De;
(function(e) {
  e[e.connectCalled = 0] = "connectCalled", e[e.transportClosed = 1] = "transportClosed", e[e.noPing = 2] = "noPing", e[e.subscribeTimeout = 3] = "subscribeTimeout", e[e.unsubscribeError = 4] = "unsubscribeError";
})(De || (De = {}));
var at;
(function(e) {
  e[e.disconnectCalled = 0] = "disconnectCalled", e[e.unauthorized = 1] = "unauthorized", e[e.badProtocol = 2] = "badProtocol", e[e.messageSizeLimit = 3] = "messageSizeLimit";
})(at || (at = {}));
var Ot;
(function(e) {
  e[e.subscribeCalled = 0] = "subscribeCalled", e[e.transportClosed = 1] = "transportClosed";
})(Ot || (Ot = {}));
var Mt;
(function(e) {
  e[e.unsubscribeCalled = 0] = "unsubscribeCalled", e[e.unauthorized = 1] = "unauthorized", e[e.clientClosed = 2] = "clientClosed";
})(Mt || (Mt = {}));
var J;
(function(e) {
  e.Disconnected = "disconnected", e.Connecting = "connecting", e.Connected = "connected";
})(J || (J = {}));
var oe;
(function(e) {
  e.Unsubscribed = "unsubscribed", e.Subscribing = "subscribing", e.Subscribed = "subscribed";
})(oe || (oe = {}));
function ko(e, t) {
  return e.lastIndexOf(t, 0) === 0;
}
function vs(e) {
  return e == null ? !1 : typeof e == "function";
}
function So(e, t) {
  if (globalThis.console) {
    const r = globalThis.console[e];
    vs(r) && r.apply(globalThis.console, t);
  }
}
function _o(e, t) {
  return Math.floor(Math.random() * (t - e + 1) + e);
}
function Dt(e, t, r) {
  e > 31 && (e = 31);
  const a = _o(0, Math.min(r, t * Math.pow(2, e)));
  return Math.min(r, t + a);
}
function Ao(e) {
  return "error" in e && e.error !== null;
}
function $t(e) {
  return Math.min(e * 1e3, 2147483647);
}
class To extends bs {
  /** Subscription constructor should not be used directly, create subscriptions using Client method. */
  constructor(t, r, a) {
    super(), this._resubscribeTimeout = null, this._refreshTimeout = null, this.channel = r, this.state = oe.Unsubscribed, this._centrifuge = t, this._token = "", this._getToken = null, this._data = null, this._getData = null, this._recover = !1, this._offset = null, this._epoch = null, this._recoverable = !1, this._positioned = !1, this._joinLeave = !1, this._minResubscribeDelay = 500, this._maxResubscribeDelay = 2e4, this._resubscribeTimeout = null, this._resubscribeAttempts = 0, this._promises = {}, this._promiseId = 0, this._inflight = !1, this._refreshTimeout = null, this._setOptions(a), this._centrifuge._debugEnabled ? (this.on("state", (s) => {
      this._centrifuge._debug("subscription state", r, s.oldState, "->", s.newState);
    }), this.on("error", (s) => {
      this._centrifuge._debug("subscription error", r, s);
    })) : this.on("error", function() {
      Function.prototype();
    });
  }
  /** ready returns a Promise which resolves upon subscription goes to Subscribed
   * state and rejects in case of subscription goes to Unsubscribed state.
   * Optional timeout can be passed.*/
  ready(t) {
    return this.state === oe.Unsubscribed ? Promise.reject({ code: Y.subscriptionUnsubscribed, message: this.state }) : this.state === oe.Subscribed ? Promise.resolve() : new Promise((r, a) => {
      const s = {
        resolve: r,
        reject: a
      };
      t && (s.timeout = setTimeout(function() {
        a({ code: Y.timeout, message: "timeout" });
      }, t)), this._promises[this._nextPromiseId()] = s;
    });
  }
  /** subscribe to a channel.*/
  subscribe() {
    this._isSubscribed() || (this._resubscribeAttempts = 0, this._setSubscribing(Ot.subscribeCalled, "subscribe called"));
  }
  /** unsubscribe from a channel, keeping position state.*/
  unsubscribe() {
    this._setUnsubscribed(Mt.unsubscribeCalled, "unsubscribe called", !0);
  }
  /** publish data to a channel.*/
  publish(t) {
    const r = this;
    return this._methodCall().then(function() {
      return r._centrifuge.publish(r.channel, t);
    });
  }
  /** get online presence for a channel.*/
  presence() {
    const t = this;
    return this._methodCall().then(function() {
      return t._centrifuge.presence(t.channel);
    });
  }
  /** presence stats for a channel (num clients and unique users).*/
  presenceStats() {
    const t = this;
    return this._methodCall().then(function() {
      return t._centrifuge.presenceStats(t.channel);
    });
  }
  /** history for a channel. By default it does not return publications (only current
   *  StreamPosition data) – provide an explicit limit > 0 to load publications.*/
  history(t) {
    const r = this;
    return this._methodCall().then(function() {
      return r._centrifuge.history(r.channel, t);
    });
  }
  _methodCall() {
    return this._isSubscribed() ? Promise.resolve() : this._isUnsubscribed() ? Promise.reject({ code: Y.subscriptionUnsubscribed, message: this.state }) : new Promise((t, r) => {
      const a = setTimeout(function() {
        r({ code: Y.timeout, message: "timeout" });
      }, this._centrifuge._config.timeout);
      this._promises[this._nextPromiseId()] = {
        timeout: a,
        resolve: t,
        reject: r
      };
    });
  }
  _nextPromiseId() {
    return ++this._promiseId;
  }
  _needRecover() {
    return this._recover === !0;
  }
  _isUnsubscribed() {
    return this.state === oe.Unsubscribed;
  }
  _isSubscribing() {
    return this.state === oe.Subscribing;
  }
  _isSubscribed() {
    return this.state === oe.Subscribed;
  }
  _setState(t) {
    if (this.state !== t) {
      const r = this.state;
      return this.state = t, this.emit("state", { newState: t, oldState: r, channel: this.channel }), !0;
    }
    return !1;
  }
  _usesToken() {
    return this._token !== "" || this._getToken !== null;
  }
  _clearSubscribingState() {
    this._resubscribeAttempts = 0, this._clearResubscribeTimeout();
  }
  _clearSubscribedState() {
    this._clearRefreshTimeout();
  }
  _setSubscribed(t) {
    if (!this._isSubscribing())
      return;
    this._clearSubscribingState(), t.recoverable && (this._recover = !0, this._offset = t.offset || 0, this._epoch = t.epoch || ""), this._setState(oe.Subscribed);
    const r = this._centrifuge._getSubscribeContext(this.channel, t);
    this.emit("subscribed", r), this._resolvePromises();
    const a = t.publications;
    if (a && a.length > 0)
      for (const s in a)
        a.hasOwnProperty(s) && this._handlePublication(a[s]);
    t.expires === !0 && (this._refreshTimeout = setTimeout(() => this._refresh(), $t(t.ttl)));
  }
  _setSubscribing(t, r) {
    this._isSubscribing() || (this._isSubscribed() && this._clearSubscribedState(), this._setState(oe.Subscribing) && this.emit("subscribing", { channel: this.channel, code: t, reason: r }), this._subscribe(!1, !1));
  }
  _subscribe(t, r) {
    if (this._centrifuge._debug("subscribing on", this.channel), this._centrifuge.state !== J.Connected && !t)
      return this._centrifuge._debug("delay subscribe on", this.channel, "till connected"), null;
    const a = this, s = {
      channel: a.channel
    };
    return !this._usesToken() || this._token ? a._getData ? (a._getData(s).then(function(i) {
      a._isSubscribing() && (a._data = i, a._sendSubscribe(a._token, !1));
    }), null) : a._sendSubscribe(a._token, r) : (t || this._getSubscriptionToken().then(function(i) {
      if (a._isSubscribing()) {
        if (!i) {
          a._failUnauthorized();
          return;
        }
        a._token = i, a._getData ? a._getData(s).then(function(l) {
          a._isSubscribing() && (a._data = l, a._sendSubscribe(i, !1));
        }) : a._sendSubscribe(i, !1);
      }
    }).catch(function(i) {
      if (a._isSubscribing()) {
        if (i instanceof ze) {
          a._failUnauthorized();
          return;
        }
        a.emit("error", {
          type: "subscribeToken",
          channel: a.channel,
          error: {
            code: Y.subscriptionSubscribeToken,
            message: i !== void 0 ? i.toString() : ""
          }
        }), a._scheduleResubscribe();
      }
    }), null);
  }
  _sendSubscribe(t, r) {
    const a = {
      channel: this.channel
    };
    if (t && (a.token = t), this._data && (a.data = this._data), this._positioned && (a.positioned = !0), this._recoverable && (a.recoverable = !0), this._joinLeave && (a.join_leave = !0), this._needRecover()) {
      a.recover = !0;
      const i = this._getOffset();
      i && (a.offset = i);
      const l = this._getEpoch();
      l && (a.epoch = l);
    }
    const s = { subscribe: a };
    return this._inflight = !0, this._centrifuge._call(s, r).then((i) => {
      this._inflight = !1;
      const l = i.reply.subscribe;
      this._handleSubscribeResponse(l), i.next && i.next();
    }, (i) => {
      this._inflight = !1, this._handleSubscribeError(i.error), i.next && i.next();
    }), s;
  }
  _handleSubscribeError(t) {
    if (this._isSubscribing()) {
      if (t.code === Y.timeout) {
        this._centrifuge._disconnect(De.subscribeTimeout, "subscribe timeout", !0);
        return;
      }
      this._subscribeError(t);
    }
  }
  _handleSubscribeResponse(t) {
    this._isSubscribing() && this._setSubscribed(t);
  }
  _setUnsubscribed(t, r, a) {
    this._isUnsubscribed() || (this._isSubscribed() && (a && this._centrifuge._unsubscribe(this), this._clearSubscribedState()), this._isSubscribing() && (this._inflight && a && this._centrifuge._unsubscribe(this), this._clearSubscribingState()), this._setState(oe.Unsubscribed) && this.emit("unsubscribed", { channel: this.channel, code: t, reason: r }), this._rejectPromises({ code: Y.subscriptionUnsubscribed, message: this.state }));
  }
  _handlePublication(t) {
    const r = this._centrifuge._getPublicationContext(this.channel, t);
    this.emit("publication", r), t.offset && (this._offset = t.offset);
  }
  _handleJoin(t) {
    const r = this._centrifuge._getJoinLeaveContext(t.info);
    this.emit("join", { channel: this.channel, info: r });
  }
  _handleLeave(t) {
    const r = this._centrifuge._getJoinLeaveContext(t.info);
    this.emit("leave", { channel: this.channel, info: r });
  }
  _resolvePromises() {
    for (const t in this._promises)
      this._promises.hasOwnProperty(t) && (this._promises[t].timeout && clearTimeout(this._promises[t].timeout), this._promises[t].resolve(), delete this._promises[t]);
  }
  _rejectPromises(t) {
    for (const r in this._promises)
      this._promises.hasOwnProperty(r) && (this._promises[r].timeout && clearTimeout(this._promises[r].timeout), this._promises[r].reject(t), delete this._promises[r]);
  }
  _scheduleResubscribe() {
    const t = this, r = this._getResubscribeDelay();
    this._resubscribeTimeout = setTimeout(function() {
      t._isSubscribing() && t._subscribe(!1, !1);
    }, r);
  }
  _subscribeError(t) {
    if (this._isSubscribing())
      if (t.code < 100 || t.code === 109 || t.temporary === !0) {
        t.code === 109 && (this._token = "");
        const r = {
          channel: this.channel,
          type: "subscribe",
          error: t
        };
        this._centrifuge.state === J.Connected && this.emit("error", r), this._scheduleResubscribe();
      } else
        this._setUnsubscribed(t.code, t.message, !1);
  }
  _getResubscribeDelay() {
    const t = Dt(this._resubscribeAttempts, this._minResubscribeDelay, this._maxResubscribeDelay);
    return this._resubscribeAttempts++, t;
  }
  _setOptions(t) {
    t && (t.since && (this._offset = t.since.offset, this._epoch = t.since.epoch, this._recover = !0), t.data && (this._data = t.data), t.getData && (this._getData = t.getData), t.minResubscribeDelay !== void 0 && (this._minResubscribeDelay = t.minResubscribeDelay), t.maxResubscribeDelay !== void 0 && (this._maxResubscribeDelay = t.maxResubscribeDelay), t.token && (this._token = t.token), t.getToken && (this._getToken = t.getToken), t.positioned === !0 && (this._positioned = !0), t.recoverable === !0 && (this._recoverable = !0), t.joinLeave === !0 && (this._joinLeave = !0));
  }
  _getOffset() {
    const t = this._offset;
    return t !== null ? t : 0;
  }
  _getEpoch() {
    const t = this._epoch;
    return t !== null ? t : "";
  }
  _clearRefreshTimeout() {
    this._refreshTimeout !== null && (clearTimeout(this._refreshTimeout), this._refreshTimeout = null);
  }
  _clearResubscribeTimeout() {
    this._resubscribeTimeout !== null && (clearTimeout(this._resubscribeTimeout), this._resubscribeTimeout = null);
  }
  _getSubscriptionToken() {
    this._centrifuge._debug("get subscription token for channel", this.channel);
    const t = {
      channel: this.channel
    }, r = this._getToken;
    if (r === null)
      throw this.emit("error", {
        type: "configuration",
        channel: this.channel,
        error: {
          code: Y.badConfiguration,
          message: "provide a function to get channel subscription token"
        }
      }), new ze("");
    return r(t);
  }
  _refresh() {
    this._clearRefreshTimeout();
    const t = this;
    this._getSubscriptionToken().then(function(r) {
      if (!t._isSubscribed())
        return;
      if (!r) {
        t._failUnauthorized();
        return;
      }
      t._token = r;
      const a = {
        sub_refresh: {
          channel: t.channel,
          token: r
        }
      };
      t._centrifuge._call(a).then((s) => {
        const i = s.reply.sub_refresh;
        t._refreshResponse(i), s.next && s.next();
      }, (s) => {
        t._refreshError(s.error), s.next && s.next();
      });
    }).catch(function(r) {
      if (r instanceof ze) {
        t._failUnauthorized();
        return;
      }
      t.emit("error", {
        type: "refreshToken",
        channel: t.channel,
        error: {
          code: Y.subscriptionRefreshToken,
          message: r !== void 0 ? r.toString() : ""
        }
      }), t._refreshTimeout = setTimeout(() => t._refresh(), t._getRefreshRetryDelay());
    });
  }
  _refreshResponse(t) {
    this._isSubscribed() && (this._centrifuge._debug("subscription token refreshed, channel", this.channel), this._clearRefreshTimeout(), t.expires === !0 && (this._refreshTimeout = setTimeout(() => this._refresh(), $t(t.ttl))));
  }
  _refreshError(t) {
    this._isSubscribed() && (t.code < 100 || t.temporary === !0 ? (this.emit("error", {
      type: "refresh",
      channel: this.channel,
      error: t
    }), this._refreshTimeout = setTimeout(() => this._refresh(), this._getRefreshRetryDelay())) : this._setUnsubscribed(t.code, t.message, !0));
  }
  _getRefreshRetryDelay() {
    return Dt(0, 1e4, 2e4);
  }
  _failUnauthorized() {
    this._setUnsubscribed(Mt.unauthorized, "unauthorized", !0);
  }
}
class Co {
  constructor(t, r) {
    this.endpoint = t, this.options = r, this._transport = null;
  }
  name() {
    return "sockjs";
  }
  subName() {
    return "sockjs-" + this._transport.transport;
  }
  emulation() {
    return !1;
  }
  supported() {
    return this.options.sockjs !== null;
  }
  initialize(t, r) {
    this._transport = new this.options.sockjs(this.endpoint, null, this.options.sockjsOptions), this._transport.onopen = () => {
      r.onOpen();
    }, this._transport.onerror = (a) => {
      r.onError(a);
    }, this._transport.onclose = (a) => {
      r.onClose(a);
    }, this._transport.onmessage = (a) => {
      r.onMessage(a.data);
    };
  }
  close() {
    this._transport.close();
  }
  send(t) {
    this._transport.send(t);
  }
}
class ma {
  constructor(t, r) {
    this.endpoint = t, this.options = r, this._transport = null;
  }
  name() {
    return "websocket";
  }
  subName() {
    return "websocket";
  }
  emulation() {
    return !1;
  }
  supported() {
    return this.options.websocket !== void 0 && this.options.websocket !== null;
  }
  initialize(t, r) {
    let a = "";
    t === "protobuf" && (a = "centrifuge-protobuf"), a !== "" ? this._transport = new this.options.websocket(this.endpoint, a) : this._transport = new this.options.websocket(this.endpoint), t === "protobuf" && (this._transport.binaryType = "arraybuffer"), this._transport.onopen = () => {
      r.onOpen();
    }, this._transport.onerror = (s) => {
      r.onError(s);
    }, this._transport.onclose = (s) => {
      r.onClose(s);
    }, this._transport.onmessage = (s) => {
      r.onMessage(s.data);
    };
  }
  close() {
    this._transport.close();
  }
  send(t) {
    this._transport.send(t);
  }
}
class Po {
  constructor(t, r) {
    this.endpoint = t, this.options = r, this._abortController = null, this._utf8decoder = new TextDecoder(), this._protocol = "json";
  }
  name() {
    return "http_stream";
  }
  subName() {
    return "http_stream";
  }
  emulation() {
    return !0;
  }
  _handleErrors(t) {
    if (!t.ok)
      throw new Error(t.status);
    return t;
  }
  _fetchEventTarget(t, r, a) {
    const s = new EventTarget(), i = t.options.fetch;
    return i(r, a).then(t._handleErrors).then((l) => {
      s.dispatchEvent(new Event("open"));
      let o = "", u = 0, c = new Uint8Array();
      const f = l.body.getReader();
      return new t.options.readableStream({
        start(h) {
          function d() {
            return f.read().then(({ done: g, value: p }) => {
              if (g) {
                s.dispatchEvent(new Event("close")), h.close();
                return;
              }
              try {
                if (t._protocol === "json")
                  for (o += t._utf8decoder.decode(p); u < o.length; )
                    if (o[u] === `
`) {
                      const x = o.substring(0, u);
                      s.dispatchEvent(new MessageEvent("message", { data: x })), o = o.substring(u + 1), u = 0;
                    } else
                      ++u;
                else {
                  const x = new Uint8Array(c.length + p.length);
                  for (x.set(c), x.set(p, c.length), c = x; ; ) {
                    const m = t.options.decoder.decodeReply(c);
                    if (m.ok) {
                      const b = c.slice(0, m.pos);
                      s.dispatchEvent(new MessageEvent("message", { data: b })), c = c.slice(m.pos);
                      continue;
                    }
                    break;
                  }
                }
              } catch (x) {
                s.dispatchEvent(new Event("error", { detail: x })), s.dispatchEvent(new Event("close")), h.close();
                return;
              }
              d();
            }).catch(function(g) {
              s.dispatchEvent(new Event("error", { detail: g })), s.dispatchEvent(new Event("close")), h.close();
            });
          }
          return d();
        }
      });
    }).catch((l) => {
      s.dispatchEvent(new Event("error", { detail: l })), s.dispatchEvent(new Event("close"));
    }), s;
  }
  supported() {
    return this.options.fetch !== null && this.options.readableStream !== null && typeof TextDecoder < "u" && typeof AbortController < "u" && typeof EventTarget < "u" && typeof Event < "u" && typeof MessageEvent < "u" && typeof Error < "u";
  }
  initialize(t, r, a) {
    this._protocol = t, this._abortController = new AbortController();
    let s, i;
    t === "json" ? (s = {
      Accept: "application/json",
      "Content-Type": "application/json"
    }, i = a) : (s = {
      Accept: "application/octet-stream",
      "Content-Type": "application/octet-stream"
    }, i = a);
    const l = {
      method: "POST",
      headers: s,
      body: i,
      mode: "cors",
      credentials: "same-origin",
      cache: "no-cache",
      signal: this._abortController.signal
    }, o = this._fetchEventTarget(this, this.endpoint, l);
    o.addEventListener("open", () => {
      r.onOpen();
    }), o.addEventListener("error", (u) => {
      this._abortController.abort(), r.onError(u);
    }), o.addEventListener("close", () => {
      this._abortController.abort(), r.onClose({
        code: 4,
        reason: "connection closed"
      });
    }), o.addEventListener("message", (u) => {
      r.onMessage(u.data);
    });
  }
  close() {
    this._abortController.abort();
  }
  send(t, r, a) {
    let s, i;
    const l = {
      session: r,
      node: a,
      data: t
    };
    this._protocol === "json" ? (s = {
      "Content-Type": "application/json"
    }, i = JSON.stringify(l)) : (s = {
      "Content-Type": "application/octet-stream"
    }, i = this.options.encoder.encodeEmulationRequest(l));
    const o = this.options.fetch, u = {
      method: "POST",
      headers: s,
      body: i,
      mode: "cors",
      credentials: "same-origin",
      cache: "no-cache"
    };
    o(this.options.emulationEndpoint, u);
  }
}
class Io {
  constructor(t, r) {
    this.endpoint = t, this.options = r, this._protocol = "json", this._transport = null, this._onClose = null;
  }
  name() {
    return "sse";
  }
  subName() {
    return "sse";
  }
  emulation() {
    return !0;
  }
  supported() {
    return this.options.eventsource !== null && this.options.fetch !== null;
  }
  initialize(t, r, a) {
    let s;
    globalThis && globalThis.document && globalThis.document.baseURI ? s = new URL(this.endpoint, globalThis.document.baseURI) : s = new URL(this.endpoint), s.searchParams.append("cf_connect", a);
    const i = {}, l = new this.options.eventsource(s.toString(), i);
    this._transport = l;
    const o = this;
    l.onopen = function() {
      r.onOpen();
    }, l.onerror = function(u) {
      l.close(), r.onError(u), r.onClose({
        code: 4,
        reason: "connection closed"
      });
    }, l.onmessage = function(u) {
      r.onMessage(u.data);
    }, o._onClose = function() {
      r.onClose({
        code: 4,
        reason: "connection closed"
      });
    };
  }
  close() {
    this._transport.close(), this._onClose !== null && this._onClose();
  }
  send(t, r, a) {
    const s = {
      session: r,
      node: a,
      data: t
    }, i = {
      "Content-Type": "application/json"
    }, l = JSON.stringify(s), o = this.options.fetch, u = {
      method: "POST",
      headers: i,
      body: l,
      mode: "cors",
      credentials: "same-origin",
      cache: "no-cache"
    };
    o(this.options.emulationEndpoint, u);
  }
}
function xt(e, t, r, a) {
  function s(i) {
    return i instanceof r ? i : new r(function(l) {
      l(i);
    });
  }
  return new (r || (r = Promise))(function(i, l) {
    function o(f) {
      try {
        c(a.next(f));
      } catch (h) {
        l(h);
      }
    }
    function u(f) {
      try {
        c(a.throw(f));
      } catch (h) {
        l(h);
      }
    }
    function c(f) {
      f.done ? i(f.value) : s(f.value).then(o, u);
    }
    c((a = a.apply(e, t || [])).next());
  });
}
class Oo {
  constructor(t, r) {
    this.endpoint = t, this.options = r, this._transport = null, this._stream = null, this._writer = null, this._utf8decoder = new TextDecoder(), this._protocol = "json";
  }
  name() {
    return "webtransport";
  }
  subName() {
    return "webtransport";
  }
  emulation() {
    return !1;
  }
  supported() {
    return this.options.webtransport !== void 0 && this.options.webtransport !== null;
  }
  initialize(t, r) {
    return xt(this, void 0, void 0, function* () {
      let a;
      globalThis && globalThis.document && globalThis.document.baseURI ? a = new URL(this.endpoint, globalThis.document.baseURI) : a = new URL(this.endpoint), t === "protobuf" && a.searchParams.append("cf_protocol", "protobuf"), this._protocol = t;
      const s = new EventTarget();
      this._transport = new this.options.webtransport(a.toString()), this._transport.closed.then(() => {
        r.onClose({
          code: 4,
          reason: "connection closed"
        });
      }).catch(() => {
        r.onClose({
          code: 4,
          reason: "connection closed"
        });
      });
      try {
        yield this._transport.ready;
      } catch {
        this.close();
        return;
      }
      let i;
      try {
        i = yield this._transport.createBidirectionalStream();
      } catch {
        this.close();
        return;
      }
      this._stream = i, this._writer = this._stream.writable.getWriter(), s.addEventListener("close", () => {
        r.onClose({
          code: 4,
          reason: "connection closed"
        });
      }), s.addEventListener("message", (l) => {
        r.onMessage(l.data);
      }), this._startReading(s), r.onOpen();
    });
  }
  _startReading(t) {
    return xt(this, void 0, void 0, function* () {
      const r = this._stream.readable.getReader();
      let a = "", s = 0, i = new Uint8Array();
      try {
        for (; ; ) {
          const { done: l, value: o } = yield r.read();
          if (o.length > 0)
            if (this._protocol === "json")
              for (a += this._utf8decoder.decode(o); s < a.length; )
                if (a[s] === `
`) {
                  const u = a.substring(0, s);
                  t.dispatchEvent(new MessageEvent("message", { data: u })), a = a.substring(s + 1), s = 0;
                } else
                  ++s;
            else {
              const u = new Uint8Array(i.length + o.length);
              for (u.set(i), u.set(o, i.length), i = u; ; ) {
                const c = this.options.decoder.decodeReply(i);
                if (c.ok) {
                  const f = i.slice(0, c.pos);
                  t.dispatchEvent(new MessageEvent("message", { data: f })), i = i.slice(c.pos);
                  continue;
                }
                break;
              }
            }
          if (l)
            break;
        }
      } catch {
        t.dispatchEvent(new Event("close"));
      }
    });
  }
  close() {
    return xt(this, void 0, void 0, function* () {
      try {
        this._writer && (yield this._writer.close()), this._transport.close();
      } catch {
      }
    });
  }
  send(t) {
    return xt(this, void 0, void 0, function* () {
      let r;
      this._protocol === "json" ? r = new TextEncoder().encode(t + `
`) : r = t;
      try {
        yield this._writer.write(r);
      } catch {
        this.close();
      }
    });
  }
}
class ba {
  name() {
    return "json";
  }
  encodeCommands(t) {
    return t.map((r) => JSON.stringify(r)).join(`
`);
  }
  decodeReplies(t) {
    return t.trim().split(`
`).map((r) => JSON.parse(r));
  }
}
const Mo = {
  token: "",
  getToken: null,
  data: null,
  getData: null,
  debug: !1,
  name: "js",
  version: "",
  fetch: null,
  readableStream: null,
  websocket: null,
  eventsource: null,
  sockjs: null,
  sockjsOptions: {},
  emulationEndpoint: "/emulation",
  minReconnectDelay: 500,
  maxReconnectDelay: 2e4,
  timeout: 5e3,
  maxServerPingDelay: 1e4,
  networkEventTarget: null
};
class ze extends Error {
  constructor(t) {
    super(t), this.name = this.constructor.name;
  }
}
class Nr extends bs {
  /** Constructs Centrifuge client. Call connect() method to start connecting. */
  constructor(t, r) {
    super(), this._reconnectTimeout = null, this._refreshTimeout = null, this._serverPingTimeout = null, this.state = J.Disconnected, this._endpoint = t, this._emulation = !1, this._transports = [], this._currentTransportIndex = 0, this._triedAllTransports = !1, this._transportWasOpen = !1, this._transport = null, this._transportId = 0, this._deviceWentOffline = !1, this._transportClosed = !0, this._codec = new ba(), this._reconnecting = !1, this._reconnectTimeout = null, this._reconnectAttempts = 0, this._client = null, this._session = "", this._node = "", this._subs = {}, this._serverSubs = {}, this._commandId = 0, this._commands = [], this._batching = !1, this._refreshRequired = !1, this._refreshTimeout = null, this._callbacks = {}, this._token = "", this._data = null, this._dispatchPromise = Promise.resolve(), this._serverPing = 0, this._serverPingTimeout = null, this._sendPong = !1, this._promises = {}, this._promiseId = 0, this._debugEnabled = !1, this._networkEventsSet = !1, this._config = Object.assign(Object.assign({}, Mo), r), this._configure(), this._debugEnabled ? (this.on("state", (a) => {
      this._debug("client state", a.oldState, "->", a.newState);
    }), this.on("error", (a) => {
      this._debug("client error", a);
    })) : this.on("error", function() {
      Function.prototype();
    });
  }
  /** newSubscription allocates new Subscription to a channel. Since server only allows
   * one subscription per channel per client this method throws if client already has
   * channel subscription in internal registry.
   * */
  newSubscription(t, r) {
    if (this.getSubscription(t) !== null)
      throw new Error("Subscription to the channel " + t + " already exists");
    const a = new To(this, t, r);
    return this._subs[t] = a, a;
  }
  /** getSubscription returns Subscription if it's registered in the internal
   * registry or null. */
  getSubscription(t) {
    return this._getSub(t);
  }
  /** removeSubscription allows removing Subcription from the internal registry. Subscrption
   * must be in unsubscribed state. */
  removeSubscription(t) {
    t && (t.state !== oe.Unsubscribed && t.unsubscribe(), this._removeSubscription(t));
  }
  /** Get a map with all current client-side subscriptions. */
  subscriptions() {
    return this._subs;
  }
  /** ready returns a Promise which resolves upon client goes to Connected
   * state and rejects in case of client goes to Disconnected or Failed state.
   * Users can provide optional timeout in milliseconds. */
  ready(t) {
    return this.state === J.Disconnected ? Promise.reject({ code: Y.clientDisconnected, message: "client disconnected" }) : this.state === J.Connected ? Promise.resolve() : new Promise((r, a) => {
      const s = {
        resolve: r,
        reject: a
      };
      t && (s.timeout = setTimeout(function() {
        a({ code: Y.timeout, message: "timeout" });
      }, t)), this._promises[this._nextPromiseId()] = s;
    });
  }
  /** connect to a server. */
  connect() {
    if (this._isConnected()) {
      this._debug("connect called when already connected");
      return;
    }
    if (this._isConnecting()) {
      this._debug("connect called when already connecting");
      return;
    }
    this._debug("connect called"), this._reconnectAttempts = 0, this._startConnecting();
  }
  /** disconnect from a server. */
  disconnect() {
    this._disconnect(at.disconnectCalled, "disconnect called", !1);
  }
  /** setToken allows setting connection token. Or resetting used token to be empty.  */
  setToken(t) {
    this._token = t;
  }
  /** send asynchronous data to a server (without any response from a server
   * expected, see rpc method if you need response). */
  send(t) {
    const r = {
      send: {
        data: t
      }
    }, a = this;
    return this._methodCall().then(function() {
      return a._transportSendCommands([r]) ? Promise.resolve() : Promise.reject(a._createErrorObject(Y.transportWriteError, "transport write error"));
    });
  }
  /** rpc to a server - i.e. a call which waits for a response with data. */
  rpc(t, r) {
    const a = {
      rpc: {
        method: t,
        data: r
      }
    }, s = this;
    return this._methodCall().then(function() {
      return s._callPromise(a, function(i) {
        return {
          data: i.rpc.data
        };
      });
    });
  }
  /** publish data to a channel. */
  publish(t, r) {
    const a = {
      publish: {
        channel: t,
        data: r
      }
    }, s = this;
    return this._methodCall().then(function() {
      return s._callPromise(a, function() {
        return {};
      });
    });
  }
  /** history for a channel. By default it does not return publications (only current
   *  StreamPosition data) – provide an explicit limit > 0 to load publications.*/
  history(t, r) {
    const a = {
      history: this._getHistoryRequest(t, r)
    }, s = this;
    return this._methodCall().then(function() {
      return s._callPromise(a, function(i) {
        const l = i.history, o = [];
        if (l.publications)
          for (let u = 0; u < l.publications.length; u++)
            o.push(s._getPublicationContext(t, l.publications[u]));
        return {
          publications: o,
          epoch: l.epoch || "",
          offset: l.offset || 0
        };
      });
    });
  }
  /** presence for a channel. */
  presence(t) {
    const r = {
      presence: {
        channel: t
      }
    }, a = this;
    return this._methodCall().then(function() {
      return a._callPromise(r, function(s) {
        const i = s.presence.presence;
        for (const l in i)
          if (i.hasOwnProperty(l)) {
            const o = i[l].conn_info, u = i[l].chan_info;
            o && (i[l].connInfo = o), u && (i[l].chanInfo = u);
          }
        return {
          clients: i
        };
      });
    });
  }
  /** presence stats for a channel. */
  presenceStats(t) {
    const r = {
      presence_stats: {
        channel: t
      }
    }, a = this;
    return this._methodCall().then(function() {
      return a._callPromise(r, function(s) {
        const i = s.presence_stats;
        return {
          numUsers: i.num_users,
          numClients: i.num_clients
        };
      });
    });
  }
  /** start command batching (collect into temporary buffer without sending to a server)
   * until stopBatching called.*/
  startBatching() {
    this._batching = !0;
  }
  /** stop batching commands and flush collected commands to the
   * network (all in one request/frame).*/
  stopBatching() {
    const t = this;
    Promise.resolve().then(function() {
      Promise.resolve().then(function() {
        t._batching = !1, t._flush();
      });
    });
  }
  _debug(...t) {
    this._debugEnabled && So("debug", t);
  }
  /** @internal */
  _formatOverride() {
  }
  _configure() {
    if (!("Promise" in globalThis))
      throw new Error("Promise polyfill required");
    if (!this._endpoint)
      throw new Error("endpoint configuration required");
    if (this._config.token !== null && (this._token = this._config.token), this._config.data !== null && (this._data = this._config.data), this._codec = new ba(), this._formatOverride(), (this._config.debug === !0 || typeof localStorage < "u" && localStorage.getItem("centrifuge.debug")) && (this._debugEnabled = !0), this._debug("config", this._config), typeof this._endpoint != "string")
      if (typeof this._endpoint == "object" && this._endpoint instanceof Array) {
        this._transports = this._endpoint, this._emulation = !0;
        for (const t in this._transports)
          if (this._transports.hasOwnProperty(t)) {
            const r = this._transports[t];
            if (!r.endpoint || !r.transport)
              throw new Error("malformed transport configuration");
            const a = r.transport;
            if (["websocket", "http_stream", "sse", "sockjs", "webtransport"].indexOf(a) < 0)
              throw new Error("unsupported transport name: " + a);
          }
      } else
        throw new Error("unsupported url configuration type: only string or array of objects are supported");
  }
  _setState(t) {
    if (this.state !== t) {
      this._reconnecting = !1;
      const r = this.state;
      return this.state = t, this.emit("state", { newState: t, oldState: r }), !0;
    }
    return !1;
  }
  _isDisconnected() {
    return this.state === J.Disconnected;
  }
  _isConnecting() {
    return this.state === J.Connecting;
  }
  _isConnected() {
    return this.state === J.Connected;
  }
  _nextCommandId() {
    return ++this._commandId;
  }
  _setNetworkEvents() {
    if (this._networkEventsSet)
      return;
    let t = null;
    this._config.networkEventTarget !== null ? t = this._config.networkEventTarget : typeof globalThis.addEventListener < "u" && (t = globalThis), t && (t.addEventListener("offline", () => {
      this._debug("offline event triggered"), (this.state === J.Connected || this.state === J.Connecting) && (this._disconnect(De.transportClosed, "transport closed", !0), this._deviceWentOffline = !0);
    }), t.addEventListener("online", () => {
      this._debug("online event triggered"), this.state === J.Connecting && (this._deviceWentOffline && !this._transportClosed && (this._deviceWentOffline = !1, this._transportClosed = !0), this._clearReconnectTimeout(), this._startReconnecting());
    }), this._networkEventsSet = !0);
  }
  _getReconnectDelay() {
    const t = Dt(this._reconnectAttempts, this._config.minReconnectDelay, this._config.maxReconnectDelay);
    return this._reconnectAttempts += 1, t;
  }
  _clearOutgoingRequests() {
    for (const t in this._callbacks)
      if (this._callbacks.hasOwnProperty(t)) {
        const r = this._callbacks[t];
        clearTimeout(r.timeout);
        const a = r.errback;
        if (!a)
          continue;
        a({ error: this._createErrorObject(Y.connectionClosed, "connection closed") });
      }
    this._callbacks = {};
  }
  _clearConnectedState() {
    this._client = null, this._clearServerPingTimeout(), this._clearRefreshTimeout();
    for (const t in this._subs) {
      if (!this._subs.hasOwnProperty(t))
        continue;
      const r = this._subs[t];
      r.state === oe.Subscribed && r._setSubscribing(Ot.transportClosed, "transport closed");
    }
    for (const t in this._serverSubs)
      this._serverSubs.hasOwnProperty(t) && this.emit("subscribing", { channel: t });
  }
  _handleWriteError(t) {
    for (const r of t) {
      const a = r.id;
      if (!(a in this._callbacks))
        continue;
      const s = this._callbacks[a];
      clearTimeout(this._callbacks[a].timeout), delete this._callbacks[a];
      const i = s.errback;
      i({ error: this._createErrorObject(Y.transportWriteError, "transport write error") });
    }
  }
  _transportSendCommands(t) {
    if (!t.length)
      return !0;
    if (!this._transport)
      return !1;
    try {
      this._transport.send(this._codec.encodeCommands(t), this._session, this._node);
    } catch (r) {
      return this._debug("error writing commands", r), this._handleWriteError(t), !1;
    }
    return !0;
  }
  _initializeTransport() {
    let t;
    this._config.websocket !== null ? t = this._config.websocket : typeof globalThis.WebSocket != "function" && typeof globalThis.WebSocket != "object" || (t = globalThis.WebSocket);
    let r = null;
    this._config.sockjs !== null ? r = this._config.sockjs : typeof globalThis.SockJS < "u" && (r = globalThis.SockJS);
    let a = null;
    this._config.eventsource !== null ? a = this._config.eventsource : typeof globalThis.EventSource < "u" && (a = globalThis.EventSource);
    let s = null;
    this._config.fetch !== null ? s = this._config.fetch : typeof globalThis.fetch < "u" && (s = globalThis.fetch);
    let i = null;
    if (this._config.readableStream !== null ? i = this._config.readableStream : typeof globalThis.ReadableStream < "u" && (i = globalThis.ReadableStream), this._emulation) {
      this._currentTransportIndex >= this._transports.length && (this._triedAllTransports = !0, this._currentTransportIndex = 0);
      let p = 0;
      for (; ; ) {
        if (p >= this._transports.length)
          throw new Error("no supported transport found");
        const x = this._transports[this._currentTransportIndex], m = x.transport, b = x.endpoint;
        if (m === "websocket") {
          if (this._debug("trying websocket transport"), this._transport = new ma(b, {
            websocket: t
          }), !this._transport.supported()) {
            this._debug("websocket transport not available"), this._currentTransportIndex++, p++;
            continue;
          }
        } else if (m === "webtransport") {
          if (this._debug("trying webtransport transport"), this._transport = new Oo(b, {
            webtransport: globalThis.WebTransport,
            decoder: this._codec,
            encoder: this._codec
          }), !this._transport.supported()) {
            this._debug("webtransport transport not available"), this._currentTransportIndex++, p++;
            continue;
          }
        } else if (m === "http_stream") {
          if (this._debug("trying http_stream transport"), this._transport = new Po(b, {
            fetch: s,
            readableStream: i,
            emulationEndpoint: this._config.emulationEndpoint,
            decoder: this._codec,
            encoder: this._codec
          }), !this._transport.supported()) {
            this._debug("http_stream transport not available"), this._currentTransportIndex++, p++;
            continue;
          }
        } else if (m === "sse") {
          if (this._debug("trying sse transport"), this._transport = new Io(b, {
            eventsource: a,
            fetch: s,
            emulationEndpoint: this._config.emulationEndpoint
          }), !this._transport.supported()) {
            this._debug("sse transport not available"), this._currentTransportIndex++, p++;
            continue;
          }
        } else if (m === "sockjs") {
          if (this._debug("trying sockjs"), this._transport = new Co(b, {
            sockjs: r,
            sockjsOptions: this._config.sockjsOptions
          }), !this._transport.supported()) {
            this._debug("sockjs transport not available"), this._currentTransportIndex++, p++;
            continue;
          }
        } else
          throw new Error("unknown transport " + m);
        break;
      }
    } else {
      if (ko(this._endpoint, "http"))
        throw new Error("Provide explicit transport endpoints configuration in case of using HTTP (i.e. using array of TransportEndpoint instead of a single string), or use ws(s):// scheme in an endpoint if you aimed using WebSocket transport");
      if (this._debug("client will use websocket"), this._transport = new ma(this._endpoint, {
        websocket: t
      }), !this._transport.supported())
        throw new Error("WebSocket not available");
    }
    const l = this, o = this._transport, u = this._nextTransportId();
    l._debug("id of transport", u);
    let c = !1, f = !0;
    this._transport.name() === "sse" && (f = !1);
    const h = [];
    if (this._transport.emulation()) {
      const p = l._sendConnect(!0);
      if (h.push(p), f) {
        const x = l._sendSubscribeCommands(!0, !0);
        for (const m in x)
          x.hasOwnProperty(m) && h.push(x[m]);
      }
    }
    this._setNetworkEvents();
    const d = this._codec.encodeCommands(h);
    this._transportClosed = !1;
    let g;
    g = setTimeout(function() {
      o.close();
    }, this._config.timeout), this._transport.initialize(this._codec.name(), {
      onOpen: function() {
        if (g && (clearTimeout(g), g = null), l._transportId != u) {
          l._debug("open callback from non-actual transport"), o.close();
          return;
        }
        c = !0, l._debug(o.subName(), "transport open"), l._transportWasOpen = !0, !o.emulation() && (l.startBatching(), l._sendConnect(!1), f && l._sendSubscribeCommands(!0, !1), l.stopBatching());
      },
      onError: function(p) {
        if (l._transportId != u) {
          l._debug("error callback from non-actual transport");
          return;
        }
        l._debug("transport level error", p);
      },
      onClose: function(p) {
        if (g && (clearTimeout(g), g = null), l._transportId != u) {
          l._debug("close callback from non-actual transport");
          return;
        }
        l._debug(o.subName(), "transport closed"), l._transportClosed = !0;
        let x = "connection closed", m = !0, b = 0;
        if (p && "code" in p && p.code && (b = p.code), p && p.reason)
          try {
            const w = JSON.parse(p.reason);
            x = w.reason, m = w.reconnect;
          } catch {
            x = p.reason, (b >= 3500 && b < 4e3 || b >= 4500 && b < 5e3) && (m = !1);
          }
        b < 3e3 ? (b === 1009 ? (b = at.messageSizeLimit, x = "message size limit exceeded", m = !1) : (b = De.transportClosed, x = "transport closed"), l._emulation && !l._transportWasOpen && (l._currentTransportIndex++, l._currentTransportIndex >= l._transports.length && (l._triedAllTransports = !0, l._currentTransportIndex = 0))) : l._transportWasOpen = !0, l._isConnecting() && !c && l.emit("error", {
          type: "transport",
          error: {
            code: Y.transportClosed,
            message: "transport closed"
          },
          transport: o.name()
        }), l._reconnecting = !1, l._disconnect(b, x, m);
      },
      onMessage: function(p) {
        l._dataReceived(p);
      }
    }, d);
  }
  _sendConnect(t) {
    const r = this._constructConnectCommand(), a = this;
    return this._call(r, t).then((s) => {
      const i = s.reply.connect;
      a._connectResponse(i), s.next && s.next();
    }, (s) => {
      a._connectError(s.error), s.next && s.next();
    }), r;
  }
  _startReconnecting() {
    if (this._debug("start reconnecting"), !this._isConnecting()) {
      this._debug("stop reconnecting: client not in connecting state");
      return;
    }
    if (this._reconnecting) {
      this._debug("reconnect already in progress, return from reconnect routine");
      return;
    }
    if (this._transportClosed === !1) {
      this._debug("waiting for transport close");
      return;
    }
    this._reconnecting = !0;
    const t = this, r = this._token === "";
    if (!(this._refreshRequired || r && this._config.getToken !== null)) {
      this._config.getData ? this._config.getData().then(function(a) {
        t._isConnecting() && (t._data = a, t._initializeTransport());
      }) : this._initializeTransport();
      return;
    }
    this._getToken().then(function(a) {
      if (t._isConnecting()) {
        if (a == null || a == null) {
          t._failUnauthorized();
          return;
        }
        t._token = a, t._debug("connection token refreshed"), t._config.getData ? t._config.getData().then(function(s) {
          t._isConnecting() && (t._data = s, t._initializeTransport());
        }) : t._initializeTransport();
      }
    }).catch(function(a) {
      if (!t._isConnecting())
        return;
      if (a instanceof ze) {
        t._failUnauthorized();
        return;
      }
      t.emit("error", {
        type: "connectToken",
        error: {
          code: Y.clientConnectToken,
          message: a !== void 0 ? a.toString() : ""
        }
      });
      const s = t._getReconnectDelay();
      t._debug("error on connection token refresh, reconnect after " + s + " milliseconds", a), t._reconnecting = !1, t._reconnectTimeout = setTimeout(() => {
        t._startReconnecting();
      }, s);
    });
  }
  _connectError(t) {
    this.state === J.Connecting && (t.code === 109 && (this._refreshRequired = !0), t.code < 100 || t.temporary === !0 || t.code === 109 ? (this.emit("error", {
      type: "connect",
      error: t
    }), this._debug("closing transport due to connect error"), this._reconnecting = !1, this._disconnect(t.code, t.message, !0)) : this._disconnect(t.code, t.message, !1));
  }
  _scheduleReconnect() {
    if (!this._isConnecting())
      return;
    let t = !1;
    this._emulation && !this._transportWasOpen && !this._triedAllTransports && (t = !0);
    let r = this._getReconnectDelay();
    t && (r = 0), this._debug("reconnect after " + r + " milliseconds"), this._reconnectTimeout = setTimeout(() => {
      this._startReconnecting();
    }, r);
  }
  _constructConnectCommand() {
    const t = {};
    this._token && (t.token = this._token), this._data && (t.data = this._data), this._config.name && (t.name = this._config.name), this._config.version && (t.version = this._config.version);
    const r = {};
    let a = !1;
    for (const s in this._serverSubs)
      if (this._serverSubs.hasOwnProperty(s) && this._serverSubs[s].recoverable) {
        a = !0;
        const i = {
          recover: !0
        };
        this._serverSubs[s].offset && (i.offset = this._serverSubs[s].offset), this._serverSubs[s].epoch && (i.epoch = this._serverSubs[s].epoch), r[s] = i;
      }
    return a && (t.subs = r), {
      connect: t
    };
  }
  _getHistoryRequest(t, r) {
    const a = {
      channel: t
    };
    return r !== void 0 && (r.since && (a.since = {
      offset: r.since.offset
    }, r.since.epoch && (a.since.epoch = r.since.epoch)), r.limit !== void 0 && (a.limit = r.limit), r.reverse === !0 && (a.reverse = !0)), a;
  }
  _methodCall() {
    return this._isConnected() ? Promise.resolve() : new Promise((t, r) => {
      const a = setTimeout(function() {
        r({ code: Y.timeout, message: "timeout" });
      }, this._config.timeout);
      this._promises[this._nextPromiseId()] = {
        timeout: a,
        resolve: t,
        reject: r
      };
    });
  }
  _callPromise(t, r) {
    return new Promise((a, s) => {
      this._call(t, !1).then((i) => {
        a(r(i.reply)), i.next && i.next();
      }, (i) => {
        s(i.error), i.next && i.next();
      });
    });
  }
  _dataReceived(t) {
    this._serverPing > 0 && this._waitServerPing();
    const r = this._codec.decodeReplies(t);
    this._dispatchPromise = this._dispatchPromise.then(() => {
      let a;
      this._dispatchPromise = new Promise((s) => {
        a = s;
      }), this._dispatchSynchronized(r, a);
    });
  }
  _dispatchSynchronized(t, r) {
    let a = Promise.resolve();
    for (const s in t)
      t.hasOwnProperty(s) && (a = a.then(() => this._dispatchReply(t[s])));
    a = a.then(() => {
      r();
    });
  }
  _dispatchReply(t) {
    let r;
    const a = new Promise((i) => {
      r = i;
    });
    if (t == null)
      return this._debug("dispatch: got undefined or null reply"), r(), a;
    const s = t.id;
    return s && s > 0 ? this._handleReply(t, r) : t.push ? this._handlePush(t.push, r) : this._handleServerPing(r), a;
  }
  _call(t, r) {
    return new Promise((a, s) => {
      t.id = this._nextCommandId(), this._registerCall(t.id, a, s), r || this._addCommand(t);
    });
  }
  _startConnecting() {
    this._debug("start connecting"), this._setState(J.Connecting) && this.emit("connecting", { code: De.connectCalled, reason: "connect called" }), this._client = null, this._startReconnecting();
  }
  _disconnect(t, r, a) {
    if (this._isDisconnected())
      return;
    const s = this.state, i = {
      code: t,
      reason: r
    };
    let l = !1;
    if (a ? l = this._setState(J.Connecting) : (l = this._setState(J.Disconnected), this._rejectPromises({ code: Y.clientDisconnected, message: "disconnected" })), this._clearOutgoingRequests(), s === J.Connecting && this._clearReconnectTimeout(), s === J.Connected && this._clearConnectedState(), l && (this._isConnecting() ? this.emit("connecting", i) : this.emit("disconnected", i)), this._transport) {
      this._debug("closing existing transport");
      const o = this._transport;
      this._transport = null, o.close(), this._transportClosed = !0, this._nextTransportId();
    } else
      this._debug("no transport to close");
    this._scheduleReconnect();
  }
  _failUnauthorized() {
    this._disconnect(at.unauthorized, "unauthorized", !1);
  }
  _getToken() {
    if (this._debug("get connection token"), !this._config.getToken)
      throw this.emit("error", {
        type: "configuration",
        error: {
          code: Y.badConfiguration,
          message: "token expired but no getToken function set in the configuration"
        }
      }), new ze("");
    return this._config.getToken({});
  }
  _refresh() {
    const t = this._client, r = this;
    this._getToken().then(function(a) {
      if (t !== r._client)
        return;
      if (!a) {
        r._failUnauthorized();
        return;
      }
      if (r._token = a, r._debug("connection token refreshed"), !r._isConnected())
        return;
      const s = {
        refresh: { token: r._token }
      };
      r._call(s, !1).then((i) => {
        const l = i.reply.refresh;
        r._refreshResponse(l), i.next && i.next();
      }, (i) => {
        r._refreshError(i.error), i.next && i.next();
      });
    }).catch(function(a) {
      if (r._isConnected()) {
        if (a instanceof ze) {
          r._failUnauthorized();
          return;
        }
        r.emit("error", {
          type: "refreshToken",
          error: {
            code: Y.clientRefreshToken,
            message: a !== void 0 ? a.toString() : ""
          }
        }), r._refreshTimeout = setTimeout(() => r._refresh(), r._getRefreshRetryDelay());
      }
    });
  }
  _refreshError(t) {
    t.code < 100 || t.temporary === !0 ? (this.emit("error", {
      type: "refresh",
      error: t
    }), this._refreshTimeout = setTimeout(() => this._refresh(), this._getRefreshRetryDelay())) : this._disconnect(t.code, t.message, !1);
  }
  _getRefreshRetryDelay() {
    return Dt(0, 5e3, 1e4);
  }
  _refreshResponse(t) {
    this._refreshTimeout && (clearTimeout(this._refreshTimeout), this._refreshTimeout = null), t.expires && (this._client = t.client, this._refreshTimeout = setTimeout(() => this._refresh(), $t(t.ttl)));
  }
  _removeSubscription(t) {
    t !== null && delete this._subs[t.channel];
  }
  _unsubscribe(t) {
    if (!this._isConnected())
      return;
    const r = { unsubscribe: {
      channel: t.channel
    } }, a = this;
    this._call(r, !1).then((s) => {
      s.next && s.next();
    }, (s) => {
      s.next && s.next(), a._disconnect(De.unsubscribeError, "unsubscribe error", !0);
    });
  }
  _getSub(t) {
    return this._subs[t] || null;
  }
  _isServerSub(t) {
    return this._serverSubs[t] !== void 0;
  }
  _sendSubscribeCommands(t, r) {
    const a = [];
    for (const s in this._subs) {
      if (!this._subs.hasOwnProperty(s))
        continue;
      const i = this._subs[s];
      if (i._inflight !== !0 && i.state === oe.Subscribing) {
        const l = i._subscribe(t, r);
        l && a.push(l);
      }
    }
    return a;
  }
  _connectResponse(t) {
    if (this._transportWasOpen = !0, this._reconnectAttempts = 0, this._refreshRequired = !1, this._isConnected())
      return;
    this._client = t.client, this._setState(J.Connected), this._refreshTimeout && clearTimeout(this._refreshTimeout), t.expires && (this._refreshTimeout = setTimeout(() => this._refresh(), $t(t.ttl))), this._session = t.session, this._node = t.node, this.startBatching(), this._sendSubscribeCommands(!1, !1), this.stopBatching();
    const r = {
      client: t.client,
      transport: this._transport.subName()
    };
    t.data && (r.data = t.data), this.emit("connected", r), this._resolvePromises(), this._processServerSubs(t.subs || {}), t.ping && t.ping > 0 ? (this._serverPing = t.ping * 1e3, this._sendPong = t.pong === !0, this._waitServerPing()) : this._serverPing = 0;
  }
  _processServerSubs(t) {
    for (const r in t) {
      if (!t.hasOwnProperty(r))
        continue;
      const a = t[r];
      this._serverSubs[r] = {
        offset: a.offset,
        epoch: a.epoch,
        recoverable: a.recoverable || !1
      };
      const s = this._getSubscribeContext(r, a);
      this.emit("subscribed", s);
    }
    for (const r in t) {
      if (!t.hasOwnProperty(r))
        continue;
      const a = t[r];
      if (a.recovered) {
        const s = a.publications;
        if (s && s.length > 0)
          for (const i in s)
            s.hasOwnProperty(i) && this._handlePublication(r, s[i]);
      }
    }
    for (const r in this._serverSubs)
      this._serverSubs.hasOwnProperty(r) && (t[r] || (this.emit("unsubscribed", { channel: r }), delete this._serverSubs[r]));
  }
  _clearRefreshTimeout() {
    this._refreshTimeout !== null && (clearTimeout(this._refreshTimeout), this._refreshTimeout = null);
  }
  _clearReconnectTimeout() {
    this._reconnectTimeout !== null && (clearTimeout(this._reconnectTimeout), this._reconnectTimeout = null);
  }
  _clearServerPingTimeout() {
    this._serverPingTimeout !== null && (clearTimeout(this._serverPingTimeout), this._serverPingTimeout = null);
  }
  _waitServerPing() {
    this._config.maxServerPingDelay !== 0 && this._isConnected() && (this._clearServerPingTimeout(), this._serverPingTimeout = setTimeout(() => {
      this._isConnected() && this._disconnect(De.noPing, "no ping", !0);
    }, this._serverPing + this._config.maxServerPingDelay));
  }
  _getSubscribeContext(t, r) {
    const a = {
      channel: t,
      positioned: !1,
      recoverable: !1,
      wasRecovering: !1,
      recovered: !1
    };
    r.recovered && (a.recovered = !0), r.positioned && (a.positioned = !0), r.recoverable && (a.recoverable = !0), r.was_recovering && (a.wasRecovering = !0);
    let s = "";
    "epoch" in r && (s = r.epoch);
    let i = 0;
    return "offset" in r && (i = r.offset), (a.positioned || a.recoverable) && (a.streamPosition = {
      offset: i,
      epoch: s
    }), r.data && (a.data = r.data), a;
  }
  _handleReply(t, r) {
    const a = t.id;
    if (!(a in this._callbacks)) {
      r();
      return;
    }
    const s = this._callbacks[a];
    if (clearTimeout(this._callbacks[a].timeout), delete this._callbacks[a], Ao(t)) {
      const i = s.errback;
      if (!i) {
        r();
        return;
      }
      const l = t.error;
      i({ error: l, next: r });
    } else {
      const i = s.callback;
      if (!i)
        return;
      i({ reply: t, next: r });
    }
  }
  _handleJoin(t, r) {
    const a = this._getSub(t);
    if (!a) {
      if (this._isServerSub(t)) {
        const s = { channel: t, info: this._getJoinLeaveContext(r.info) };
        this.emit("join", s);
      }
      return;
    }
    a._handleJoin(r);
  }
  _handleLeave(t, r) {
    const a = this._getSub(t);
    if (!a) {
      if (this._isServerSub(t)) {
        const s = { channel: t, info: this._getJoinLeaveContext(r.info) };
        this.emit("leave", s);
      }
      return;
    }
    a._handleLeave(r);
  }
  _handleUnsubscribe(t, r) {
    const a = this._getSub(t);
    if (!a) {
      this._isServerSub(t) && (delete this._serverSubs[t], this.emit("unsubscribed", { channel: t }));
      return;
    }
    r.code < 2500 ? a._setUnsubscribed(r.code, r.reason, !1) : a._setSubscribing(r.code, r.reason);
  }
  _handleSubscribe(t, r) {
    this._serverSubs[t] = {
      offset: r.offset,
      epoch: r.epoch,
      recoverable: r.recoverable || !1
    }, this.emit("subscribed", this._getSubscribeContext(t, r));
  }
  _handleDisconnect(t) {
    const r = t.code;
    let a = !0;
    (r >= 3500 && r < 4e3 || r >= 4500 && r < 5e3) && (a = !1), this._disconnect(r, t.reason, a);
  }
  _getPublicationContext(t, r) {
    const a = {
      channel: t,
      data: r.data
    };
    return r.offset && (a.offset = r.offset), r.info && (a.info = this._getJoinLeaveContext(r.info)), r.tags && (a.tags = r.tags), a;
  }
  _getJoinLeaveContext(t) {
    const r = {
      client: t.client,
      user: t.user
    };
    return t.conn_info && (r.connInfo = t.conn_info), t.chan_info && (r.chanInfo = t.chan_info), r;
  }
  _handlePublication(t, r) {
    const a = this._getSub(t);
    if (!a) {
      if (this._isServerSub(t)) {
        const s = this._getPublicationContext(t, r);
        this.emit("publication", s), r.offset !== void 0 && (this._serverSubs[t].offset = r.offset);
      }
      return;
    }
    a._handlePublication(r);
  }
  _handleMessage(t) {
    this.emit("message", { data: t.data });
  }
  _handleServerPing(t) {
    if (this._sendPong) {
      const r = {};
      this._transportSendCommands([r]);
    }
    t();
  }
  _handlePush(t, r) {
    const a = t.channel;
    t.pub ? this._handlePublication(a, t.pub) : t.message ? this._handleMessage(t.message) : t.join ? this._handleJoin(a, t.join) : t.leave ? this._handleLeave(a, t.leave) : t.unsubscribe ? this._handleUnsubscribe(a, t.unsubscribe) : t.subscribe ? this._handleSubscribe(a, t.subscribe) : t.disconnect && this._handleDisconnect(t.disconnect), r();
  }
  _flush() {
    const t = this._commands.slice(0);
    this._commands = [], this._transportSendCommands(t);
  }
  _createErrorObject(t, r, a) {
    const s = {
      code: t,
      message: r
    };
    return a && (s.temporary = !0), s;
  }
  _registerCall(t, r, a) {
    this._callbacks[t] = {
      callback: r,
      errback: a,
      timeout: null
    }, this._callbacks[t].timeout = setTimeout(() => {
      delete this._callbacks[t], vs(a) && a({ error: this._createErrorObject(Y.timeout, "timeout") });
    }, this._config.timeout);
  }
  _addCommand(t) {
    this._batching ? this._commands.push(t) : this._transportSendCommands([t]);
  }
  _nextPromiseId() {
    return ++this._promiseId;
  }
  _nextTransportId() {
    return ++this._transportId;
  }
  _resolvePromises() {
    for (const t in this._promises)
      this._promises.hasOwnProperty(t) && (this._promises[t].timeout && clearTimeout(this._promises[t].timeout), this._promises[t].resolve(), delete this._promises[t]);
  }
  _rejectPromises(t) {
    for (const r in this._promises)
      this._promises.hasOwnProperty(r) && (this._promises[r].timeout && clearTimeout(this._promises[r].timeout), this._promises[r].reject(t), delete this._promises[r]);
  }
}
Nr.SubscriptionState = oe;
Nr.State = J;
Nr.UnauthorizedError = ze;
const vu = D({
  name: "AtOptionsAsync",
  props: {
    service: {
      type: Function,
      default: null
    },
    autoload: {
      type: Boolean,
      default: !1
    },
    multiselect: {
      type: Boolean,
      default: !1
    },
    modelValue: { type: [String, Number, Array], default: null },
    currentPagePath: {
      type: [String, Array],
      default: () => ["meta", "current_page"]
    },
    lastPagePath: {
      type: [String, Array],
      default: () => ["meta", "last_page"]
    },
    responsePath: {
      type: [String, Array],
      default: () => ["data", "data"]
    },
    withPagination: {
      type: Boolean,
      default: !0
    },
    prefetchValueSeparator: {
      type: String,
      default: ";"
    },
    prefetchByKey: {
      type: String,
      default: null
    },
    valueType: { type: String, default: "value" },
    valuePrint: { type: String, default: "title" },
    valueToPrint: { type: String, default: "title" },
    clearable: { type: Boolean, default: !1 }
  },
  components: {
    AtDataList: na,
    AtMultiselect: ca
  },
  setup(e, { attrs: t, slots: r }) {
    const { execute: a, response: s, loading: i } = co(e.service), l = y([]), o = y([]), u = C(() => {
      const b = l.value.filter(
        (w) => !o.value.some(
          (k) => w[e.valueType] === k[e.valueType]
        )
      );
      return [...o.value, ...b];
    }), c = C(() => {
      const b = e.multiselect || r.default;
      return {
        ...t,
        [b ? "options" : "data"]: u.value,
        [b ? "valuePrint" : "valueToPrint"]: b ? e.valuePrint : e.valueToPrint,
        loading: i.value,
        modelValue: e.modelValue,
        valueType: e.valueType,
        clearable: e.clearable,
        onScrollToBottom: d,
        onSearch: g,
        onOpen: h
      };
    }), f = y(!1), h = async () => {
      !e.autoload && !f.value && (await x(), f.value = !0);
    }, d = async ({ query: b }) => {
      if (!e.withPagination)
        return;
      const w = Xt(s.value, e.currentPagePath) || 0, k = Xt(s.value, e.lastPagePath) || 1;
      if (w < k) {
        const S = await p({
          page: w + 1,
          q: b
        });
        S != null && S.length && (l.value = [...l.value, ...S]);
      }
    }, g = async (b) => {
      await x({ q: b });
    }, p = async (b) => await a(b).then((w) => Xt(w, e.responsePath)), x = async (b) => {
      if (e.service) {
        const w = await p(b);
        l.value = w || [];
      }
    }, m = () => {
      const b = {
        [e.prefetchByKey]: V(e.modelValue, "array") ? e.modelValue.join(e.prefetchValueSeparator) : e.modelValue
      };
      p(b).then((w) => {
        o.value = w;
      });
    };
    return vr(() => {
      e.modelValue && e.prefetchByKey && m(), e.autoload && x();
    }), {
      loading: i,
      options: l,
      componentProps: c,
      onScrollToBottom: d,
      onSearch: g,
      fetchOptions: x
    };
  },
  render() {
    return "default" in this.$slots ? this.$slots.default({ ...this.componentProps }) : n(this.multiselect ? ca : na, {
      ...this.componentProps
    });
  }
});
export {
  qi as $,
  Lo as A,
  Jo as B,
  Ko as C,
  qo as D,
  Qo as E,
  Ri as F,
  Li as G,
  Ei as H,
  Ai as I,
  eu as J,
  tu as K,
  ru as L,
  au as M,
  nu as N,
  Vn as O,
  su as P,
  iu as Q,
  ou as R,
  Xn as S,
  uu as T,
  du as U,
  Zi as V,
  Xi as W,
  cu as X,
  Ji as Y,
  fu as Z,
  al as _,
  ir as a,
  hu as a0,
  ro as a1,
  eo as a2,
  ao as a3,
  gu as a4,
  pu as a5,
  io as a6,
  mu as a7,
  so as a8,
  bu as a9,
  tr as aa,
  vu as ab,
  sl as ac,
  rr as ad,
  lu as ae,
  Ro as b,
  Bt as c,
  rl as d,
  nl as e,
  No as f,
  na as g,
  Vo as h,
  Fo as i,
  Go as j,
  xi as k,
  Pt as l,
  Ho as m,
  Uo as n,
  st as o,
  or as p,
  ki as q,
  Le as r,
  Si as s,
  Wo as t,
  Zo as u,
  nt as v,
  Yo as w,
  Xo as x,
  Ci as y,
  ca as z
};
